import { createElementBlock as p, openBlock as f, createElementVNode as o, createCommentVNode as E, toDisplayString as F, renderSlot as ie, resolveComponent as A, normalizeClass as z, createVNode as D, withCtx as O, createBlock as P, resolveDynamicComponent as Q, Fragment as X, renderList as oe, withDirectives as k0, withKeys as v0, withModifiers as L1, vModelText as Js, vShow as Jn, useId as Qs, ref as se, useTemplateRef as Qn, computed as _, createTextVNode as he, createStaticVNode as Ct, reactive as a1, normalizeStyle as e0, defineComponent as _e, watch as xe, onMounted as n1, onUnmounted as W1, toRefs as e2, nextTick as ht, unref as C, normalizeProps as mt, mergeProps as y0, inject as xt, toRef as Vt, watchEffect as er, provide as Mt, guardReactiveProps as I1, isRef as lt, resolveDirective as j1, toHandlers as O1, Transition as U1, useSlots as t2 } from "vue";
const x = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [n, s] of t)
    a[n] = s;
  return a;
}, a2 = {
  name: "LuxIconAdd",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function n2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: `M11.5,0C5.159,0,0,5.159,0,11.5S5.159,23,11.5,23S23,17.841,23,11.5S17.841,0,11.5,0z M11.5,22C5.71,22,1,17.29,1,11.5
  		S5.71,1,11.5,1S22,5.71,22,11.5S17.29,22,11.5,22z` }, null, -1),
    o("path", { d: `M17.5,11H12V5.5C12,5.224,11.776,5,11.5,5S11,5.224,11,5.5V11H5.5C5.224,11,5,11.224,5,11.5S5.224,12,5.5,12H11v5.5
  		c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V12h5.5c0.276,0,0.5-0.224,0.5-0.5S17.776,11,17.5,11z` }, null, -1)
  ]));
}
const r2 = /* @__PURE__ */ x(a2, [["render", n2]]), s2 = {
  name: "LuxIconAlert",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function o2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M11.3,24C5.1,24,0.1,19.1,0,12.7c-0.1-3.1,1.1-6,3.3-8.2C5.5,2.3,8.4,1.1,11.5,1c3.1,0,5.9,1.1,8.1,3.2
          c2.1,2.1,3.4,5,3.4,8.1l0,0c0.1,6.3-5,11.6-11.5,11.7C11.4,24,11.4,24,11.3,24z M11.7,2c-0.1,0-0.1,0-0.2,0
          C8.7,2.1,6,3.2,4,5.2c-2,2-3.1,4.7-3,7.5C1.1,18.6,5.7,23.1,11.5,23c5.9-0.1,10.6-4.9,10.5-10.7l0,0c0-2.8-1.2-5.4-3.1-7.4
          C17,3,14.4,2,11.7,2z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M11.5,14.5c-0.3,0-0.5-0.2-0.5-0.5V7c0-0.3,0.2-0.5,0.5-0.5S12,6.7,12,7v7C12,14.3,11.8,14.5,11.5,14.5z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M11.5,18.5c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.1,18.5,11.5,18.5z M11.5,17.5C11.5,17.5,11.5,17.5,11.5,17.5
          l0.5,0L11.5,17.5z` })
    ], -1)
  ]));
}
const tr = /* @__PURE__ */ x(s2, [["render", o2]]), i2 = {
  name: "LuxIconApproved",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function l2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M9.5,16c-0.1,0-0.3,0-0.4-0.1l-2.5-2.5c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l2.2,2.2l7.1-6.7c0.2-0.2,0.5-0.2,0.7,0
          s0.2,0.5,0,0.7l-7.5,7C9.7,16,9.6,16,9.5,16z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,24C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0c6.6,0,12,5.4,12,12C24,18.6,18.6,24,12,24z M12,1C5.9,1,1,5.9,1,12
          s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z` })
    ], -1)
  ]));
}
const ar = /* @__PURE__ */ x(i2, [["render", l2]]), u2 = {
  name: "LuxIconArrowDown",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function c2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", {
      stroke: "currentColor",
      "stroke-width": "3",
      d: `M12,19c-0.1,0-0.3-0.1-0.4-0.2L0.1,5.8c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0L12,17.7L23.1,5.2
              c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-11.5,13C12.3,18.9,12.1,19,12,19z`
    }, null, -1)
  ]));
}
const d2 = /* @__PURE__ */ x(u2, [["render", c2]]), f2 = {
  name: "LuxIconArrowRight",
  status: "ready",
  release: "1.0.0",
  type: "Element"
}, h2 = { transform: "translate(1.2, 0)" };
function v2(e, t, a, n, s, r) {
  return f(), p("g", h2, t[0] || (t[0] = [
    o("path", {
      stroke: "currentColor",
      "stroke-width": "3",
      d: `M5.5,24c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.2-0.5,0-0.7L17.7,12L5.2,0.9C5,0.7,4.9,0.4,5.1,0.2c0.2-0.2,0.5-0.2,0.7,0
              l13,11.5c0.1,0.1,0.2,0.2,0.2,0.4s-0.1,0.3-0.2,0.4l-13,11.5C5.7,24,5.6,24,5.5,24z`
    }, null, -1)
  ]));
}
const p2 = /* @__PURE__ */ x(f2, [["render", v2]]), m2 = {
  name: "LuxIconArrowUp",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function y2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", {
      stroke: "currentColor",
      "stroke-width": "3",
      d: "M11.6,5.1L.1,18.1c-.2.2-.2.5,0,.7s.5.2.7,0L11.9,6.2l11.2,12.6c.2.2.5.2.7,0,.2-.2.2-.5,0-.7L12.3,5.2c0-.1-.3-.2-.4-.2s-.3.1-.3.1Z"
    }, null, -1)
  ]));
}
const g2 = /* @__PURE__ */ x(m2, [["render", y2]]), b2 = {
  name: "LuxIconAscending",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function _2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("circle", {
      class: "st0",
      cx: "12",
      cy: "12",
      r: "2"
    }, null, -1),
    o("polygon", {
      class: "st1",
      points: "17.5,6.5 12,0.5 6.5,6.5 	"
    }, null, -1),
    o("polygon", {
      class: "st2",
      points: "6.5,17.5 12,23.5 17.5,17.5 	"
    }, null, -1)
  ]));
}
const $2 = /* @__PURE__ */ x(b2, [["render", _2], ["__scopeId", "data-v-57d2b728"]]), w2 = {
  name: "LuxIconBase",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The name of the icon to display. Also used as the accessible name of the icon.
     */
    iconName: {
      required: !1,
      type: String,
      default: ""
    },
    /**
     * The width of the icon. For square icons use values of `11px, 13px,
     * 16px, 24px, 36px, 48px, 64px` to follow visual heirachy set by
     * typography.
     */
    width: {
      type: [Number, String],
      default: 24
    },
    /**
     * The height of the icon. For square icons use values of `11px, 13px,
     * 16px, 24px, 36px, 48px, 64px` to follow visual heirachy set by
     * typography.
     */
    height: {
      type: [Number, String],
      default: 24
    },
    /**
     * The fill color of the SVG icon.
     */
    iconColor: {
      type: String,
      default: "currentColor"
    },
    /**
     * If set, put the SVG icon in a circle with the specified color.
     */
    circleColor: {
      type: String
    },
    /**
     * Hides decorative icon from screen readers
     */
    iconHide: {
      type: [String, Boolean],
      default: !1
    }
  },
  computed: {
    // Present the iconName prop in a format suitable for use as an element's ID.
    // Only ASCII letters, digits, '_', and '-' should be used in an id, per
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id
    iconTitleId() {
      return this.iconName.toLowerCase().replace(/[^\w\d\s-_]/g, "").trim().replace(/\s/g, "-");
    }
  }
}, C2 = { class: "lux-icon" }, x2 = ["width", "height", "color", "aria-labelledby", "aria-hidden"], M2 = ["id"], S2 = ["fill"], D2 = ["fill"], k2 = ["fill"];
function L2(e, t, a, n, s, r) {
  return f(), p("div", C2, [
    (f(), p("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: a.width,
      height: a.height,
      color: a.iconColor,
      viewBox: "0 0 24 24",
      overflow: "visible",
      "aria-labelledby": r.iconTitleId,
      "aria-hidden": a.iconHide,
      role: "img"
    }, [
      a.iconName ? (f(), p("title", {
        key: 0,
        id: r.iconTitleId,
        lang: "en"
      }, F(a.iconName), 9, M2)) : E("", !0),
      a.circleColor ? (f(), p("circle", {
        key: 1,
        cx: "50%",
        cy: "50%",
        r: "11.8",
        fill: a.circleColor
      }, null, 8, S2)) : E("", !0),
      a.circleColor ? (f(), p("g", {
        key: 2,
        fill: a.iconColor,
        transform: "translate(4.8, 4.8) scale(0.6)"
      }, [
        ie(e.$slots, "default", {}, void 0, !0)
      ], 8, D2)) : (f(), p("g", {
        key: 3,
        fill: a.iconColor
      }, [
        ie(e.$slots, "default", {}, void 0, !0)
      ], 8, k2))
    ], 8, x2))
  ]);
}
const K0 = /* @__PURE__ */ x(w2, [["render", L2], ["__scopeId", "data-v-015f2ca7"]]), I2 = {
  name: "LuxIconBookmark",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The outline/stroke color for the bookmark icon.  If not specified,
     * it will use the iconColor of the parent LuxIconBase component.
     */
    lineColor: {
      required: !1,
      type: String,
      default: "currentColor"
    }
  }
}, O2 = ["stroke"];
function z2(e, t, a, n, s, r) {
  return f(), p("path", {
    d: `M6 3
  Q5 3 5 4
  L5 20
  Q5 21 6 20
  L11 16
  Q12 15 13 16
  L18 20
  Q19 21 19 19
  L19 4
  Q19 3 18 3
  Z
  `,
    stroke: a.lineColor,
    "stroke-width": 1.5
  }, null, 8, O2);
}
const A2 = /* @__PURE__ */ x(I2, [["render", z2]]), P2 = {
  name: "LuxIconClock",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function T2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M12,24C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0c6.6,0,12,5.4,12,12C24,18.6,18.6,24,12,24z M12,1C5.9,1,1,5.9,1,12
        s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M17.5,18c-0.1,0-0.2,0-0.3-0.1l-6-5.5C11.1,12.3,11,12.1,11,12V6.5C11,6.2,11.2,6,11.5,6S12,6.2,12,6.5v5.3l5.8,5.4
        c0.2,0.2,0.2,0.5,0,0.7C17.8,17.9,17.6,18,17.5,18z` })
    ], -1)
  ]));
}
const E2 = /* @__PURE__ */ x(P2, [["render", T2]]), Y2 = {
  name: "LuxIconClose",
  status: "ready",
  release: "1.0.0",
  type: "Element"
}, H2 = {
  stroke: "currentColor",
  "stroke-width": "3.3",
  "stroke-linecap": "round",
  d: `M2 2
  L22 22
  M22 2
  L2 22`
};
function V2(e, t, a, n, s, r) {
  return f(), p("path", H2);
}
const N2 = /* @__PURE__ */ x(Y2, [["render", V2]]), R2 = {
  name: "LuxIconConsulting",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function F2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M10.5,13c-0.1,0-0.3-0.1-0.4-0.1L7.3,10H6.5C5.7,10,5,9.3,5,8.5v-7C5,0.7,5.7,0,6.5,0h11C18.3,0,19,0.7,19,1.5v7
          c0,0.8-0.7,1.5-1.5,1.5H11v2.5c0,0.2-0.1,0.4-0.3,0.5C10.6,13,10.6,13,10.5,13z M6.5,1C6.2,1,6,1.2,6,1.5v7C6,8.8,6.2,9,6.5,9
          h1C7.6,9,7.8,9,7.9,9.1l2.1,2.1V9.5C10,9.2,10.2,9,10.5,9h7C17.8,9,18,8.8,18,8.5v-7C18,1.2,17.8,1,17.5,1H6.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M19.5,17c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S21.2,17,19.5,17z M19.5,12c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2
          S20.6,12,19.5,12z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M23.5,21h-8c-0.3,0-0.5-0.2-0.5-0.5c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5C24,20.8,23.8,21,23.5,21z M16,20H23
          c-0.2-1.7-1.7-3-3.5-3S16.3,18.3,16,20z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M4.5,17c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S6.2,17,4.5,17z M4.5,12c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2
          S5.6,12,4.5,12z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M8.5,21h-8C0.2,21,0,20.8,0,20.5C0,18,2,16,4.5,16S9,18,9,20.5C9,20.8,8.8,21,8.5,21z M1,20H8c-0.2-1.7-1.7-3-3.5-3
          S1.3,18.3,1,20z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,20c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,20,12,20z M12,15c-1.1,0-2,0.9-2,2s0.9,2,2,2c1.1,0,2-0.9,2-2
          S13.1,15,12,15z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M16,24H8c-0.3,0-0.5-0.2-0.5-0.5c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5C16.5,23.8,16.3,24,16,24z M8.5,23h6.9
          c-0.2-1.7-1.7-3-3.5-3C10.2,20,8.8,21.3,8.5,23z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,3h-7C8.2,3,8,2.8,8,2.5S8.2,2,8.5,2h7C15.7,2,16,2.2,16,2.5S15.7,3,15.5,3z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,5h-7C8.2,5,8,4.8,8,4.5S8.2,4,8.5,4h7C15.7,4,16,4.2,16,4.5S15.7,5,15.5,5z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,7h-7C8.2,7,8,6.8,8,6.5S8.2,6,8.5,6h7C15.7,6,16,6.2,16,6.5S15.7,7,15.5,7z" })
    ], -1)
  ]));
}
const B2 = /* @__PURE__ */ x(R2, [["render", F2]]), W2 = {
  name: "LuxIconDelivery",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function j2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: `M23.9,16.2l-2.5-4C21.3,12.1,21.2,12,21,12h-4V9.5C17,9.2,16.8,9,16.5,9H11v1h5v9l-4.8,0c-0.3-0.6-1-1-1.7-1
            s-1.4,0.4-1.7,1H6v-7H5v7.5C5,19.8,5.2,20,5.5,20h2c0,1.1,0.9,2,2,2s2-0.9,2-2l5,0c0,0,0.1,0,0.1,0h0.9c0,0,0,0,0,0
            c0,1.1,0.9,2,2,2s2-0.9,2-2c0,0,0,0,0,0h2c0.3,0,0.5-0.2,0.5-0.5v-3C24,16.4,24,16.3,23.9,16.2z M9.5,21c-0.6,0-1-0.4-1-1
            s0.4-1,1-1s1,0.4,1,1S10.1,21,9.5,21z M20.7,13l1.9,3H17v-3H20.7z M19.5,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.1,21,19.5,21z
             M21.2,19c-0.4-0.6-1-1-1.7-1c-0.7,0-1.4,0.4-1.7,1H17v-2h6v2L21.2,19L21.2,19z` }, null, -1),
    o("path", { d: "M5,11c2.7,0,5-2.3,5-5S7.7,1,5,1S0,3.3,0,6S2.3,11,5,11z M5,2c2.2,0,4,1.8,4,4s-1.8,4-4,4S1,8.2,1,6S2.8,2,5,2z" }, null, -1),
    o("path", { d: "M4.5,7h2C6.8,7,7,6.8,7,6.5S6.8,6,6.5,6H5V3.5C5,3.2,4.8,3,4.5,3S4,3.2,4,3.5v3C4,6.8,4.2,7,4.5,7z" }, null, -1),
    o("path", { d: "M3.5,14l-3,0h0C0.2,14,0,14.2,0,14.5C0,14.8,0.2,15,0.5,15l3,0h0C3.8,15,4,14.8,4,14.5C4,14.2,3.8,14,3.5,14z" }, null, -1),
    o("path", { d: "M3.5,16L2,16c0,0,0,0,0,0c-0.3,0-0.5,0.2-0.5,0.5S1.7,17,2,17l1.5,0c0,0,0,0,0,0C3.8,17,4,16.8,4,16.5S3.8,16,3.5,16z" }, null, -1),
    o("path", { d: "M3.5,18L3,18c-0.3,0-0.5,0.2-0.5,0.5C2.5,18.8,2.7,19,3,19l0.5,0c0,0,0,0,0,0C3.8,19,4,18.8,4,18.5C4,18.2,3.8,18,3.5,18z" }, null, -1)
  ]));
}
const U2 = /* @__PURE__ */ x(W2, [["render", j2]]), q2 = {
  name: "LuxIconDenied",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Z2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M11.5,23C5.2,23,0,17.8,0,11.5C0,5.2,5.2,0,11.5,0C17.8,0,23,5.2,23,11.5C23,17.8,17.8,23,11.5,23z M11.5,1
          C5.7,1,1,5.7,1,11.5C1,17.3,5.7,22,11.5,22C17.3,22,22,17.3,22,11.5C22,5.7,17.3,1,11.5,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M7.3,16.2c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l8.5-8.5c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7l-8.5,8.5
          C7.5,16.2,7.4,16.2,7.3,16.2z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M15.7,16.2c-0.1,0-0.3,0-0.4-0.1L6.9,7.6c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l8.5,8.5c0.2,0.2,0.2,0.5,0,0.7
          C16,16.2,15.9,16.2,15.7,16.2z` })
    ], -1)
  ]));
}
const nr = /* @__PURE__ */ x(q2, [["render", Z2]]), G2 = {
  name: "LuxIconDerivativesHealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function K2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M14.39,14.83a.44.44,0,0,0,.25.08.46.46,0,0,0,.25-.08c.23-.17,5.73-4.17,5.73-7.31a3.29,3.29,0,0,0-3.18-3.46,3.16,3.16,0,0,0-2.8,1.87,3.16,3.16,0,0,0-2.8-1.87A3.28,3.28,0,0,0,8.66,7.52C8.66,10.66,14.15,14.66,14.39,14.83ZM11.84,4.91c1.13,0,2,.89,2.38,2.37a.44.44,0,0,0,.83,0c.36-1.48,1.26-2.37,2.39-2.37a2.45,2.45,0,0,1,2.32,2.61c0,2.13-3.49,5.2-5.12,6.43C13,12.72,9.51,9.65,9.51,7.52A2.45,2.45,0,0,1,11.84,4.91Z",
      transform: "translate(-0.46 -0.47)"
    }, null, -1),
    o("path", {
      d: "M23.21.47H6.12A.42.42,0,0,0,5.7.9v3H3.56a.43.43,0,0,0-.43.42V20.54a.43.43,0,0,0,.43.43H19.79a.43.43,0,0,0,.43-.43V18.41h3a.42.42,0,0,0,.42-.43V.9A.42.42,0,0,0,23.21.47ZM19.36,20.12H4V4.74H5.7V18a.42.42,0,0,0,.42.43H19.36Zm3.42-2.57H6.55V1.32H22.78Z",
      transform: "translate(-0.46 -0.47)"
    }, null, -1),
    o("polygon", { points: "3.05 7.05 0.5 7.05 0.5 22.38 15.68 22.38 15.68 20.5 3.1 20.5 3.05 7.05" }, null, -1)
  ]));
}
const X2 = /* @__PURE__ */ x(G2, [["render", K2]]), J2 = {
  name: "LuxIconDerivativesUnhealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function Q2(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M23.21.47H6.12A.42.42,0,0,0,5.7.9v3H3.56a.43.43,0,0,0-.43.42V20.54a.43.43,0,0,0,.43.43H19.79a.43.43,0,0,0,.43-.43V18.41h3a.42.42,0,0,0,.42-.43V.9A.42.42,0,0,0,23.21.47ZM19.36,20.12H4V4.74H5.7V18a.42.42,0,0,0,.42.43H19.36Zm3.42-2.57H6.55V1.32H22.78Z",
      transform: "translate(-0.46 -0.47)"
    }, null, -1),
    o("polygon", {
      class: "cls-1",
      points: "3.05 7.05 0.5 7.05 0.5 22.38 15.68 22.38 15.68 20.5 3.1 20.5 3.05 7.05"
    }, null, -1),
    o("path", {
      class: "cls-2",
      d: "M14.38,7.56v4.26a.28.28,0,0,0,.56,0V7.56a.28.28,0,0,0-.56,0Z",
      transform: "translate(-0.46 -0.47)"
    }, null, -1),
    o("path", {
      class: "cls-2",
      d: "M21,15.35,14.91,3.18a.3.3,0,0,0-.5,0L8.29,15.42a.29.29,0,0,0,0,.27.28.28,0,0,0,.23.13H20.79a.28.28,0,0,0,.27-.28A.26.26,0,0,0,21,15.35ZM9,15.26,14.66,3.93l5.67,11.33Z",
      transform: "translate(-0.46 -0.47)"
    }, null, -1),
    o("circle", {
      cx: "14.2",
      cy: "13.12",
      r: "0.56"
    }, null, -1)
  ]));
}
const eo = /* @__PURE__ */ x(J2, [["render", Q2]]), to = {
  name: "LuxIconDescending",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function ao(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("circle", {
      class: "st0",
      cx: "12",
      cy: "12",
      r: "2"
    }, null, -1),
    o("polygon", {
      class: "st1",
      points: "17.5,6.5 12,0.5 6.5,6.5 	"
    }, null, -1),
    o("polygon", {
      class: "st2",
      points: "6.5,17.5 12,23.5 17.5,17.5 	"
    }, null, -1)
  ]));
}
const no = /* @__PURE__ */ x(to, [["render", ao], ["__scopeId", "data-v-03c51988"]]), ro = {
  name: "LuxIconEdit",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function so(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: `M19.9,7L17,4.1C16.9,4.1,16.8,4,16.7,4s-0.3,0.1-0.4,0.1L7.5,13c0,0-0.1,0.1-0.1,0.2l0,0c0,0,0,0,0,0l-2.1,4.9
            c-0.1,0.2,0,0.4,0.1,0.6c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0l4.9-2.1h0l0,0c0.1,0,0.1-0.1,0.2-0.1l8.8-8.8
            C20,7.5,20,7.2,19.9,7z M10.7,15.5l-2.1-2.1L14.8,7L17,9.2L10.7,15.5z M8,14.2L9.8,16l-3.1,1.3L8,14.2z M17.7,8.5l-2.1-2.1l1.1-1.1
            l2.1,2.1L17.7,8.5z` }, null, -1),
    o("path", { d: `M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M12,23C5.9,23,1,18.1,1,12C1,5.9,5.9,1,12,1s11,4.9,11,11
            C23,18.1,18.1,23,12,23z` }, null, -1)
  ]));
}
const oo = /* @__PURE__ */ x(ro, [["render", so]]), io = {
  name: "LuxIconExclamation",
  status: "ready",
  release: "3.1.1",
  type: "Element"
};
function lo(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: `M23.5,1h-23C0.2,1,0,1.2,0,1.5v16C0,17.8,0.2,18,0.5,18H7v3.5c0,0.2,0.1,0.4,0.3,0.5c0.1,0,0.1,0,0.2,0
  		c0.1,0,0.3-0.1,0.4-0.1l3.9-3.9h11.8c0.3,0,0.5-0.2,0.5-0.5v-16C24,1.2,23.8,1,23.5,1z M23,17H11.5c-0.1,0-0.3,0.1-0.4,0.1L8,20.3
  		v-2.8C8,17.2,7.8,17,7.5,17H1V2h22V17z` }, null, -1),
    o("path", { d: "M11.5,11c0.3,0,0.5-0.2,0.5-0.5v-6C12,4.2,11.8,4,11.5,4S11,4.2,11,4.5v6C11,10.8,11.2,11,11.5,11z" }, null, -1),
    o("circle", {
      cx: "11.5",
      cy: "13",
      r: "1"
    }, null, -1)
  ]));
}
const uo = /* @__PURE__ */ x(io, [["render", lo]]), co = {
  name: "LuxIconFile",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function fo(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M20.5,24h-17C3.2,24,3,23.8,3,23.5v-23C3,0.2,3.2,0,3.5,0h11c0.1,0,0.3,0.1,0.4,0.1l6,6C20.9,6.2,21,6.4,21,6.5v17
        C21,23.8,20.8,24,20.5,24z M4,23h16V6.7L14.3,1H4V23z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M20.5,7h-6C14.2,7,14,6.8,14,6.5v-6C14,0.2,14.2,0,14.5,0S15,0.2,15,0.5V6h5.5C20.8,6,21,6.2,21,6.5S20.8,7,20.5,7z" })
    ], -1)
  ]));
}
const rr = /* @__PURE__ */ x(co, [["render", fo]]), ho = {
  name: "LuxIconFileHealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function vo(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: "M3.5,9C3.776,9,4,8.776,4,8.5v-2C4,6.224,3.776,6,3.5,6S3,6.224,3,6.5v2C3,8.776,3.224,9,3.5,9z" }, null, -1),
    o("path", { d: "M10,6.5C10,6.224,9.776,6,9.5,6S9,6.224,9,6.5v2C9,8.776,9.224,9,9.5,9S10,8.776,10,8.5V6.5z" }, null, -1),
    o("path", { d: "M7.5,11C7.224,11,7,11.224,7,11.5v2C7,13.776,7.224,14,7.5,14S8,13.776,8,13.5v-2C8,11.224,7.776,11,7.5,11z" }, null, -1),
    o("path", { d: "M10,11.5c0-0.276-0.224-0.5-0.5-0.5S9,11.224,9,11.5v2C9,13.776,9.224,14,9.5,14s0.5-0.224,0.5-0.5V11.5z" }, null, -1),
    o("path", { d: "M8,8.5v-2C8,6.224,7.776,6,7.5,6h-2C5.224,6,5,6.224,5,6.5v2C5,8.776,5.224,9,5.5,9h2C7.776,9,8,8.776,8,8.5z M7,8H6V7h1V8   z" }, null, -1),
    o("path", { d: "M6,11.5C6,11.224,5.776,11,5.5,11h-2C3.224,11,3,11.224,3,11.5v2C3,13.776,3.224,14,3.5,14h2C5.776,14,6,13.776,6,13.5   V11.5z M5,13H4v-1h1V13z" }, null, -1),
    o("path", { d: "M7.5,19h2c0.276,0,0.5-0.224,0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5h-2C7.224,16,7,16.224,7,16.5v2   C7,18.776,7.224,19,7.5,19z M8,17h1v1H8V17z" }, null, -1),
    o("path", { d: "M3,16.5v2C3,18.776,3.224,19,3.5,19S4,18.776,4,18.5v-2C4,16.224,3.776,16,3.5,16S3,16.224,3,16.5z" }, null, -1),
    o("path", { d: "M5.5,16C5.224,16,5,16.224,5,16.5v2C5,18.776,5.224,19,5.5,19S6,18.776,6,18.5v-2C6,16.224,5.776,16,5.5,16z" }, null, -1),
    o("path", { d: "M20.276,12.5c-0.95,0-2.07,0.491-2.776,1.784c-0.706-1.293-1.826-1.784-2.776-1.784c-1.585,0-3.224,1.323-3.224,3.537   c0,3.181,5.473,7.198,5.706,7.367c0.088,0.063,0.19,0.096,0.294,0.096s0.206-0.032,0.294-0.096   c0.233-0.169,5.706-4.187,5.706-7.367C23.5,13.823,21.861,12.5,20.276,12.5z M17.5,22.376c-1.63-1.246-5-4.253-5-6.339   c0-1.588,1.131-2.537,2.224-2.537c1.086,0,1.942,0.864,2.29,2.313c0.109,0.449,0.863,0.449,0.973,0   c0.348-1.448,1.204-2.313,2.29-2.313c1.093,0,2.224,0.949,2.224,2.537C22.5,18.121,19.13,21.13,17.5,22.376z" }, null, -1),
    o("path", { d: "M1,1h10v4.5C11,5.776,11.224,6,11.5,6H16v5h1V5.5c0-0.066-0.014-0.132-0.039-0.192c-0.025-0.062-0.063-0.115-0.108-0.162   l-4.998-4.999c-0.046-0.045-0.101-0.082-0.162-0.107C11.632,0.014,11.566,0,11.5,0h-11C0.224,0,0,0.224,0,0.5v21   C0,21.776,0.224,22,0.5,22h11.979v-1H1V1z M12,1.707L15.293,5H12V1.707z" }, null, -1)
  ]));
}
const po = /* @__PURE__ */ x(ho, [["render", vo]]), mo = {
  name: "LuxIconFileUnhealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function yo(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: "M3.5,9C3.776,9,4,8.776,4,8.5v-2C4,6.224,3.776,6,3.5,6S3,6.224,3,6.5v2C3,8.776,3.224,9,3.5,9z" }, null, -1),
    o("path", { d: "M10,6.5C10,6.224,9.776,6,9.5,6S9,6.224,9,6.5v2C9,8.776,9.224,9,9.5,9S10,8.776,10,8.5V6.5z" }, null, -1),
    o("path", { d: "M7.5,11C7.224,11,7,11.224,7,11.5v2C7,13.776,7.224,14,7.5,14S8,13.776,8,13.5v-2C8,11.224,7.776,11,7.5,11z" }, null, -1),
    o("path", { d: "M10,11.5c0-0.276-0.224-0.5-0.5-0.5S9,11.224,9,11.5v2C9,13.776,9.224,14,9.5,14s0.5-0.224,0.5-0.5V11.5z" }, null, -1),
    o("path", { d: "M8,8.5v-2C8,6.224,7.776,6,7.5,6h-2C5.224,6,5,6.224,5,6.5v2C5,8.776,5.224,9,5.5,9h2C7.776,9,8,8.776,8,8.5z M7,8H6V7h1V8   z" }, null, -1),
    o("path", { d: "M6,11.5C6,11.224,5.776,11,5.5,11h-2C3.224,11,3,11.224,3,11.5v2C3,13.776,3.224,14,3.5,14h2C5.776,14,6,13.776,6,13.5   V11.5z M5,13H4v-1h1V13z" }, null, -1),
    o("path", { d: "M7.5,19h2c0.276,0,0.5-0.224,0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5h-2C7.224,16,7,16.224,7,16.5v2   C7,18.776,7.224,19,7.5,19z M8,17h1v1H8V17z" }, null, -1),
    o("path", { d: "M3,16.5v2C3,18.776,3.224,19,3.5,19S4,18.776,4,18.5v-2C4,16.224,3.776,16,3.5,16S3,16.224,3,16.5z" }, null, -1),
    o("path", { d: "M5.5,16C5.224,16,5,16.224,5,16.5v2C5,18.776,5.224,19,5.5,19S6,18.776,6,18.5v-2C6,16.224,5.776,16,5.5,16z" }, null, -1),
    o("path", { d: "M23.892,23.166l-5.944-11.89c-0.17-0.338-0.725-0.338-0.895,0l-6,12c-0.077,0.155-0.069,0.339,0.021,0.486   C11.166,23.91,11.327,24,11.5,24h12c0.007,0,0.015,0,0.02,0c0.276,0,0.5-0.224,0.5-0.5C24.02,23.371,23.972,23.254,23.892,23.166z    M12.309,23L17.5,12.618L22.691,23H12.309z" }, null, -1),
    o("path", { d: "M17,16.409v3.272c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-3.272c0-0.276-0.224-0.5-0.5-0.5S17,16.133,17,16.409z" }, null, -1),
    o("circle", {
      cx: "17.5",
      cy: "21.5",
      r: "0.5"
    }, null, -1),
    o("path", { d: "M11.5,6H16v4h1V5.5c0-0.066-0.014-0.132-0.039-0.192c-0.025-0.062-0.063-0.115-0.108-0.162l-4.998-4.999   c-0.046-0.045-0.101-0.082-0.162-0.107C11.632,0.014,11.566,0,11.5,0h-11C0.224,0,0,0.224,0,0.5v21C0,21.776,0.224,22,0.5,22H11v-1   H1V1h10v4.5C11,5.776,11.224,6,11.5,6z M12,1.707L15.293,5H12V1.707z" }, null, -1)
  ]));
}
const go = /* @__PURE__ */ x(mo, [["render", yo]]), bo = {
  name: "LuxIconFilter",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function _o(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", {
      class: "st0",
      d: "M23.5,0.5h-23l10,12.1v10.9l3-3v-7.9L23.5,0.5z"
    }, null, -1)
  ]));
}
const $o = /* @__PURE__ */ x(bo, [["render", _o]]), wo = {
  name: "LuxIconFlower",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Co(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M10,13.5c-3.9,0-7-2.7-7-6c0-1.7,0.8-3.2,2.2-4.4C5.4,3,5.7,3,5.9,3.2C6.1,3.4,6,3.7,5.8,3.9C4.6,4.9,4,6.1,4,7.5
          c0,2.8,2.7,5,6,5s6-2.2,6-5c0-1.4-0.6-2.6-1.8-3.6c-0.2-0.2-0.2-0.5-0.1-0.7C14.3,3,14.6,3,14.8,3.1C16.2,4.3,17,5.8,17,7.5
          C17,10.8,13.9,13.5,10,13.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M10,7.5C7.3,7.5,5.2,5.9,5.2,4c0-1,0.6-1.9,1.6-2.6C7,1.3,7.3,1.3,7.4,1.6c0.2,0.2,0.1,0.5-0.1,0.7
          C6.6,2.7,6.2,3.3,6.2,4c0,1.4,1.8,2.5,3.8,2.5s3.8-1.1,3.8-2.5c0-0.7-0.4-1.3-1.1-1.7c-0.2-0.2-0.3-0.5-0.1-0.7
          c0.2-0.2,0.5-0.3,0.7-0.1c1,0.7,1.6,1.6,1.6,2.6C14.8,5.9,12.7,7.5,10,7.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M13.5,12.5c-0.3,0-0.5-0.2-0.5-0.5v-2c0-2-2.5-2.5-2.6-2.5c-0.3,0-0.5-0.3-0.4-0.6c0-0.3,0.3-0.5,0.6-0.4
          C11.7,6.7,14,7.7,14,10v2C14,12.3,13.8,12.5,13.5,12.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M8,7C7.9,7,7.9,7,7.8,7C7.6,6.9,7.4,6.6,7.5,6.3c0-0.1,0.4-1.2,1.4-2.2C9.1,4,9.4,4,9.6,4.1c0.2,0.2,0.2,0.5,0,0.7
          C8.8,5.6,8.5,6.6,8.5,6.7C8.4,6.9,8.2,7,8,7z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M10,5C8,5,6.5,3.9,6.5,2.5S8,0,10,0s3.5,1.1,3.5,2.5S12,5,10,5z M10,1C8.6,1,7.5,1.7,7.5,2.5S8.6,4,10,4
          s2.5-0.7,2.5-1.5S11.4,1,10,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M10,5C9.7,5,9.5,4.8,9.5,4.5S9.7,4,10,4c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.5-0.7-0.8-1.8-0.8
          C8.7,2.5,8.5,2.3,8.5,2S8.7,1.5,9,1.5c0.9,0,1.5,0.2,2,0.5c0.5,0.3,0.7,0.8,0.7,1.3C11.8,4.2,11,5,10,5z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M10.5,24c-0.3,0-0.5-0.2-0.5-0.5V13c0-0.3,0.2-0.5,0.5-0.5S11,12.7,11,13v10.5C11,23.8,10.8,24,10.5,24z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M12.5,22c-0.8,0-1.6-0.3-2.1-1.1c-0.5-0.7-0.5-1.6,0-2.2c0.5-0.7,1.4-1,2.3-0.7c1,0.3,2.7-0.7,3.2-1.2
          c0.2-0.1,0.4-0.2,0.6,0c0.2,0.1,0.3,0.3,0.2,0.5c-0.1,0.3-0.8,3.1-2.1,4C14,21.7,13.2,22,12.5,22z M12,18.9
          c-0.3,0-0.6,0.2-0.8,0.4c-0.2,0.2-0.3,0.6,0,1c0.7,0.9,1.9,0.8,2.8,0.2c0.5-0.3,0.9-1.2,1.2-2.1c-0.8,0.5-2,0.9-2.9,0.5
          C12.2,18.9,12.1,18.9,12,18.9z` })
    ], -1)
  ]));
}
const xo = /* @__PURE__ */ x(wo, [["render", Co]]), Mo = {
  name: "LuxIconGlobe",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function So(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M12,24c-3.1,0-6.1-1.2-8.5-3.5c-4.7-4.7-4.7-12.3,0-17c4.7-4.7,12.3-4.7,17,0s4.7,12.3,0,17C18.1,22.8,15.1,24,12,24z
        M12,1C9.2,1,6.4,2.1,4.2,4.2c-4.3,4.3-4.3,11.3,0,15.6c4.3,4.3,11.3,4.3,15.6,0c4.3-4.3,4.3-11.3,0-15.6C17.6,2.1,14.8,1,12,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M11,20.5c-1,0-2-2.5-2-3c0-0.4,0.2-0.7,0.3-1c0.1-0.2,0.2-0.4,0.2-0.5c0-0.2-0.4-0.7-0.9-1.1c-0.1-0.1-0.1-0.2-0.1-0.4
        c0-0.4-0.1-0.7-0.2-0.9c-0.3-0.2-0.8-0.2-1.5-0.2c-0.3,0-0.5,0-0.8,0c-1.6,0-2-1.6-2-2.5c0-0.2,0-3.9,2.9-4.5
        c1.3-0.3,2.2-0.2,2.7,0.2C9.8,6.9,9.9,7.1,10,7.2c0.5,0.4,1.5,0.2,2.3,0c0.3-0.1,0.5-0.1,0.8-0.2c0.1-0.8,0.1-1.7,0-2
        c-0.6,0.3-1.2,0.3-1.7,0c-0.5-0.3-0.8-0.8-0.9-1.5c-0.2-1.9,3.9-2.9,4.8-3c0.3-0.1,0.5,0.1,0.6,0.4c0.1,0.3-0.1,0.5-0.4,0.6
        c-1.9,0.4-4,1.3-4,2c0,0.2,0.1,0.5,0.4,0.7c0.2,0.1,0.6,0.1,0.9-0.1c0.3-0.1,0.6-0.1,0.8,0c0.7,0.5,0.6,2.1,0.4,3.5
        C14,7.8,13.7,8,13.5,8c-0.2,0-0.6,0.1-1,0.2C11.4,8.4,10,8.7,9.1,7.9C9.1,7.8,9,7.6,9,7.5c0,0-0.5-0.3-1.9,0C5,7.9,5,11,5,11
        c0,0.1,0,1.5,1,1.5c0.2,0,0.5,0,0.7,0c0.8,0,1.7-0.1,2.2,0.4c0.3,0.3,0.5,0.8,0.5,1.4c0.4,0.4,1,1.1,1,1.7c0,0.4-0.2,0.7-0.3,1
        c-0.1,0.2-0.2,0.4-0.2,0.5c0,0.4,0.7,1.8,1.1,2c1.6,0,2.4-0.7,2.4-2c0-0.2,0.1-0.4,0.3-0.5c0,0,0.7-0.2,1.3-0.9
        c0.1-0.1,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.2-0.2c-0.2-0.2-0.5-0.5-0.5-0.9c0-0.4,0.3-0.6,0.8-1.2c0.7-0.8,1.5-1.6,1.4-2.2
        c-0.5,0.1-1.1,0.2-1.6-0.3c-0.1-0.1-0.1-0.1-0.1-0.2c-0.2-0.7-0.5-1.4-0.6-1.6c-0.2,0-0.3-0.2-0.4-0.3c0-0.1-0.1-0.4,0.1-0.6
        c0.4-0.4,2.1-1.4,3.8-1.1C19.6,6.5,20,4.2,20,4.2c0-0.3,0.3-0.5,0.6-0.4c0.3,0,0.5,0.3,0.4,0.6c0,0.1-0.6,3-2.8,4.1
        c-0.1,0.1-0.2,0.1-0.3,0c-1.1-0.3-2.1,0.1-2.7,0.4c0.2,0.3,0.5,0.8,0.7,1.8c0.2,0.1,0.6,0,0.8-0.1c0.2-0.1,0.4-0.1,0.6,0.1
        c1.2,1.2-0.4,2.8-1.3,3.8c-0.2,0.2-0.4,0.4-0.5,0.5c0,0,0.1,0.1,0.1,0.1c0.2,0.2,0.5,0.5,0.6,0.9c0,0.3-0.1,0.6-0.4,0.8
        c-0.5,0.5-1,0.8-1.4,1C14.3,19.5,13.1,20.5,11,20.5z` })
    ], -1)
  ]));
}
const Do = /* @__PURE__ */ x(Mo, [["render", So]]), ko = {
  name: "LuxIconHospital",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Lo(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: "M17.5,24c-0.3,0-0.5-0.2-0.5-0.5v-13c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v13C18,23.8,17.8,24,17.5,24z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M6.5,24C6.2,24,6,23.8,6,23.5V10.4c0-0.3,0.2-0.5,0.5-0.5S7,10.2,7,10.4v13.1C7,23.8,6.8,24,6.5,24z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M23.5,24c-0.3,0-0.5-0.2-0.5-0.5V13h-5v10.5c0,0.3-0.2,0.5-0.5,0.5S17,23.8,17,23.5v-11c0-0.3,0.2-0.5,0.5-0.5h6
                      c0.3,0,0.5,0.2,0.5,0.5v11C24,23.8,23.8,24,23.5,24z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M6.5,24C6.2,24,6,23.8,6,23.5V13H1v10.5C1,23.8,0.8,24,0.5,24S0,23.8,0,23.5v-11C0,12.2,0.2,12,0.5,12h6
                      C6.8,12,7,12.2,7,12.5v11C7,23.8,6.8,24,6.5,24z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M23.5,24h-23C0.2,24,0,23.8,0,23.5S0.2,23,0.5,23h23c0.3,0,0.5,0.2,0.5,0.5S23.8,24,23.5,24z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,14c-3.9,0-7-3.1-7-7s3.1-7,7-7c3.9,0,7,3.1,7,7S15.9,14,12,14z M12,1C8.7,1,6,3.7,6,7s2.7,6,6,6s6-2.7,6-6
                      S15.3,1,12,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M13.5,11h-3c-0.3,0-0.5-0.2-0.5-0.5V9H8.5C8.2,9,8,8.8,8,8.5v-3C8,5.2,8.2,5,8.5,5H10l0-1.5C10,3.2,10.2,3,10.5,3h3
                      c0.1,0,0.3,0.1,0.4,0.1S14,3.4,14,3.5L14,5h1.5C15.8,5,16,5.2,16,5.5v3C16,8.8,15.8,9,15.5,9H14v1.5C14,10.8,13.8,11,13.5,11z
                       M11,10h2V8.5C13,8.2,13.2,8,13.5,8H15V6h-1.5c-0.1,0-0.3-0.1-0.4-0.1S13,5.6,13,5.5L13,4h-2l0,1.5C11,5.8,10.8,6,10.5,6H9v2
                      h1.5C10.8,8,11,8.2,11,8.5V10z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M4.5,15h-2C2.2,15,2,14.8,2,14.5S2.2,14,2.5,14h2C4.8,14,5,14.2,5,14.5S4.8,15,4.5,15z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M4.5,17h-2C2.2,17,2,16.8,2,16.5S2.2,16,2.5,16h2C4.8,16,5,16.2,5,16.5S4.8,17,4.5,17z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M4.5,19h-2C2.2,19,2,18.8,2,18.5S2.2,18,2.5,18h2C4.8,18,5,18.2,5,18.5S4.8,19,4.5,19z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M4.5,21h-2C2.2,21,2,20.8,2,20.5S2.2,20,2.5,20h2C4.8,20,5,20.2,5,20.5S4.8,21,4.5,21z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M21.5,15h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S21.8,15,21.5,15z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M21.5,17h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S21.8,17,21.5,17z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M21.5,19h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S21.8,19,21.5,19z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M21.5,21h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S21.8,21,21.5,21z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M9.5,16h-1C8.2,16,8,15.8,8,15.5S8.2,15,8.5,15h1c0.3,0,0.5,0.2,0.5,0.5S9.8,16,9.5,16z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M9.5,18h-1C8.2,18,8,17.8,8,17.5S8.2,17,8.5,17h1c0.3,0,0.5,0.2,0.5,0.5S9.8,18,9.5,18z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M9.5,20h-1C8.2,20,8,19.8,8,19.5S8.2,19,8.5,19h1c0.3,0,0.5,0.2,0.5,0.5S9.8,20,9.5,20z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M12.5,16h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S12.8,16,12.5,16z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M12.5,18h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S12.8,18,12.5,18z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M12.5,20h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S12.8,20,12.5,20z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,16h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S15.8,16,15.5,16z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,18h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S15.8,18,15.5,18z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,20h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S15.8,20,15.5,20z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M13.5,24h-3c-0.3,0-0.5-0.2-0.5-0.5v-2c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5v2C14,23.8,13.8,24,13.5,24z
                       M11,23h2v-1h-2V23z` })
    ], -1)
  ]));
}
const Io = /* @__PURE__ */ x(ko, [["render", Lo]]), Oo = {
  name: "LuxIconInfo",
  status: "ready",
  release: "1.0.0",
  type: "Element"
}, zo = { d: `M11.5,1C5.2,1,0,6.2,0,12.5S5.2,24,11.5,24C17.8,24,23,18.8,23,12.5S17.8,1,11.5,1z M11,6c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1
  	c-0.6,0-1-0.4-1-1C10,6.4,10.4,6,11,6z M14.5,20h-6C8.2,20,8,19.8,8,19.5S8.2,19,8.5,19H11v-8H9.5C9.2,11,9,10.8,9,10.5
  	S9.2,10,9.5,10h2c0.3,0,0.5,0.2,0.5,0.5V19h2.5c0.3,0,0.5,0.2,0.5,0.5S14.8,20,14.5,20z` };
function Ao(e, t, a, n, s, r) {
  return f(), p("path", zo);
}
const Po = /* @__PURE__ */ x(Oo, [["render", Ao]]), To = {
  name: "LuxIconLockClose",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function Eo(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: "M12,14c-0.552,0-1,0.449-1,1c0,0.365,0.207,0.672,0.5,0.847V18.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-2.653   C12.793,15.672,13,15.365,13,15C13,14.449,12.552,14,12,14z" }, null, -1),
    o("path", { d: "M20.5,9H18V6c0-3.309-2.691-6-6-6S6,2.691,6,6v3H3.5C3.224,9,3,9.224,3,9.5v14C3,23.776,3.224,24,3.5,24h17   c0.276,0,0.5-0.224,0.5-0.5v-14C21,9.224,20.776,9,20.5,9z M7,6c0-2.757,2.243-5,5-5s5,2.243,5,5v3H7V6z M20,23H4V10h2.5h11H20V23z   " }, null, -1)
  ]));
}
const Yo = /* @__PURE__ */ x(To, [["render", Eo]]), Ho = {
  name: "LuxIconLockOpen",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function Vo(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: "M11.5,15.847V18.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-2.653C12.793,15.672,13,15.365,13,15c0-0.551-0.448-1-1-1   s-1,0.449-1,1C11,15.365,11.207,15.672,11.5,15.847z" }, null, -1),
    o("path", { d: "M20.5,9H18V6c0-3.309-2.691-6-6-6S6,2.691,6,6h1c0-2.757,2.243-5,5-5s5,2.243,5,5v3H3.5C3.224,9,3,9.224,3,9.5v14   C3,23.776,3.224,24,3.5,24h17c0.276,0,0.5-0.224,0.5-0.5v-14C21,9.224,20.776,9,20.5,9z M20,23H4V10h16V23z" }, null, -1)
  ]));
}
const No = /* @__PURE__ */ x(Ho, [["render", Vo]]), Ro = {
  name: "LuxIconNewTab",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Fo(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", {
      class: "cls-2",
      d: "M12.5,13c.3,0,.5-.1.7-.3l5.8-6.2v2.5c0,.6.4,1,1,1s1-.4,1-1V4s0,0,0,0c0-.6-.5-1-1-1h-4.5c-.6,0-1,.4-1,1s.4,1,1,1h2.2l-5.9,6.3c-.4.4-.4,1,0,1.4.2.2.4.3.7.3h0Z"
    }, null, -1),
    o("rect", {
      class: "cls-2",
      x: "1.4",
      y: "5.9",
      width: "11.2",
      height: "2"
    }, null, -1),
    o("rect", {
      class: "cls-2",
      x: "1.4",
      y: "20.2",
      width: "17.9",
      height: "2"
    }, null, -1),
    o("rect", {
      class: "cls-2",
      x: "17.3",
      y: "12.1",
      width: "2",
      height: "8.1"
    }, null, -1),
    o("rect", {
      class: "cls-2",
      x: "1.4",
      y: "7.9",
      width: "2",
      height: "12.3"
    }, null, -1)
  ]));
}
const sr = /* @__PURE__ */ x(Ro, [["render", Fo]]), Bo = {
  name: "LuxIconNote",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Wo(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M7.5,22c-0.1,0-0.1,0-0.2,0C7.1,21.9,7,21.7,7,21.5V18H0.5C0.2,18,0,17.8,0,17.5v-16C0,1.2,0.2,1,0.5,1h23
              C23.8,1,24,1.2,24,1.5v16c0,0.3-0.2,0.5-0.5,0.5H11.7l-3.9,3.9C7.8,21.9,7.6,22,7.5,22z M1,17h6.5C7.8,17,8,17.2,8,17.5v2.8
              l3.1-3.1c0.1-0.1,0.2-0.1,0.4-0.1H23V2H1V17z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M14.5,7h-9C5.2,7,5,6.8,5,6.5S5.2,6,5.5,6h9C14.8,6,15,6.2,15,6.5S14.8,7,14.5,7z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M18.5,10h-13C5.2,10,5,9.8,5,9.5S5.2,9,5.5,9h13C18.8,9,19,9.2,19,9.5S18.8,10,18.5,10z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M18.5,13h-13C5.2,13,5,12.8,5,12.5S5.2,12,5.5,12h13c0.3,0,0.5,0.2,0.5,0.5S18.8,13,18.5,13z" })
    ], -1)
  ]));
}
const jo = /* @__PURE__ */ x(Bo, [["render", Wo]]), Uo = {
  name: "LuxIconPerson",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function qo(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M21.5,23h-19C2.2,23,2,22.8,2,22.5v-1.9c0-1.5,0.9-2.8,2.3-3.3L9,15.6v-2.5h1V16c0,0.2-0.1,0.4-0.3,0.5l-5,1.8
              c-1,0.4-1.7,1.3-1.7,2.4V22h18v-1.4c0-1.1-0.7-2-1.7-2.4l-5-1.8C14.1,16.4,14,16.2,14,16v-2.8h1v2.5l4.7,1.7
              c1.4,0.5,2.3,1.8,2.3,3.3v1.9C22,22.8,21.8,23,21.5,23z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,14.5c-1.5,0-2.9-0.7-3.9-1.9C6,10,6,6,8.1,3.4c1-1.2,2.4-1.9,3.9-1.9l0,0c1.5,0,2.9,0.7,3.9,1.9v0
              C18,6,18,10,15.9,12.6C14.9,13.8,13.5,14.5,12,14.5z M12,2.5c-1.2,0-2.3,0.6-3.2,1.6C7,6.2,7,9.8,8.8,11.9c0.8,1,2,1.6,3.2,1.6
              s2.3-0.6,3.2-1.6c1.8-2.2,1.8-5.7,0-7.8v0C14.3,3.1,13.2,2.5,12,2.5L12,2.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M15.7,8.1c-1.2,0-2.1-0.5-2.9-1.6C11.9,7.3,10.4,8,9,8C8.2,8,7.5,7.8,6.8,7.5l0.5-0.9C7.8,6.9,8.4,7,9,7
              c1.3,0,2.9-0.8,3.3-1.7c0.1-0.2,0.3-0.3,0.4-0.3c0.2,0,0.4,0.1,0.4,0.3c0.9,1.5,1.8,2,3.2,1.7c0.1,0,0.2,0,0.3,0l0.2,0l0.1,1
              c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0C16.3,8.1,16,8.1,15.7,8.1z` })
    ], -1)
  ]));
}
const Zo = /* @__PURE__ */ x(Uo, [["render", qo]]), Go = {
  name: "LuxIconPicture",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Ko(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M23.5,24h-23C0.2,24,0,23.8,0,23.5v-23C0,0.2,0.2,0,0.5,0h23C23.8,0,24,0.2,24,0.5v23C24,23.8,23.8,24,23.5,24z M1,23
					h22V1H1V23z` })
    ], -1),
    o("g", null, [
      o("rect", {
        x: "0.5",
        y: "17",
        width: "23",
        height: "1"
      })
    ], -1),
    o("g", null, [
      o("path", { d: `M9.5,9h-3c-1.1,0-2-0.9-2-2c0-0.7,0.3-1.3,0.9-1.6C5.8,5.1,6.2,5,6.7,5c0.4-1.2,1.5-2,2.8-2c1.7,0,3,1.3,3,3
					S11.2,9,9.5,9z M6.5,6C6.3,6,6.1,6.1,5.9,6.2C5.7,6.4,5.5,6.7,5.5,7c0,0.6,0.4,1,1,1h3c1.1,0,2-0.9,2-2s-0.9-2-2-2
					c-1,0-1.8,0.7-2,1.7C7.5,5.8,7.4,6,7.3,6C7.2,6.1,7,6.1,6.9,6.1C6.7,6,6.6,6,6.5,6z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M21.6,17.7L18,10.7c-0.2-0.4-0.6-0.6-1-0.6c-0.4,0-0.8,0.2-1.1,0.6l-3,5.2c-0.1,0.1-0.2,0.2-0.4,0.2
					c-0.2,0-0.3-0.1-0.4-0.2c0,0-1.9-2.8-4.1-2.8c-1.8,0-3.5,3.4-4,4.7L3,17.3C3.3,16.8,5.2,12,8,12c2,0,3.7,1.7,4.4,2.6l2.6-4.5
					C15.5,9.4,16.2,9,17,9c0.8,0,1.5,0.5,1.9,1.2l3.5,7.1L21.6,17.7z` })
    ], -1)
  ]));
}
const Xo = /* @__PURE__ */ x(Go, [["render", Ko]]), Jo = {
  name: "LuxIconQuestion",
  status: "ready",
  release: "3.1.1",
  type: "Element"
};
function Qo(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: `M23.5,1h-23C0.2,1,0,1.2,0,1.5v16C0,17.8,0.2,18,0.5,18H7v3.5c0,0.2,0.1,0.4,0.3,0.5c0.1,0,0.1,0,0.2,0
  		c0.1,0,0.3-0.1,0.4-0.1l3.9-3.9h11.8c0.3,0,0.5-0.2,0.5-0.5v-16C24,1.2,23.8,1,23.5,1z M23,17H11.5c-0.1,0-0.3,0.1-0.4,0.1L8,20.3
  		v-2.8C8,17.2,7.8,17,7.5,17H1V2h22V17z` }, null, -1),
    o("path", { d: `M9.5,8C9.8,8,10,7.8,10,7.5C10,6.1,11.1,5,12.5,5S15,6.1,15,7.5S13.9,10,12.5,10c-0.3,0-0.5,0.2-0.5,0.5v1
  		c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V11c1.7-0.2,3-1.7,3-3.5C16,5.6,14.4,4,12.5,4S9,5.6,9,7.5C9,7.8,9.2,8,9.5,8z` }, null, -1),
    o("circle", {
      cx: "12.5",
      cy: "14",
      r: "1"
    }, null, -1)
  ]));
}
const ei = /* @__PURE__ */ x(Jo, [["render", Qo]]), ti = {
  name: "LuxIconQuestionFilled",
  status: "ready",
  release: "3.1.1",
  type: "Element"
};
function ai(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: `M23.5,1h-23C0.2,1,0,1.2,0,1.5v16C0,17.8,0.2,18,0.5,18H7v3.5c0,0.2,0.1,0.4,0.3,0.5c0.1,0,0.1,0,0.2,0
	c0.1,0,0.3-0.1,0.4-0.1l3.9-3.9h11.8c0.3,0,0.5-0.2,0.5-0.5v-16C24,1.2,23.8,1,23.5,1z M12.5,15c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1
	s1,0.4,1,1C13.5,14.6,13.1,15,12.5,15z M13,11v0.5c0,0.3-0.2,0.5-0.5,0.5S12,11.8,12,11.5v-1c0-0.3,0.2-0.5,0.5-0.5
	c1.4,0,2.5-1.1,2.5-2.5S13.9,5,12.5,5S10,6.1,10,7.5C10,7.8,9.8,8,9.5,8S9,7.8,9,7.5C9,5.6,10.6,4,12.5,4S16,5.6,16,7.5
	C16,9.3,14.7,10.7,13,11z` }, null, -1)
  ]));
}
const ni = /* @__PURE__ */ x(ti, [["render", ai]]), ri = {
  name: "LuxIconRefresh",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function si(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M4.5,14C4.5,14,4.5,14,4.5,14c-0.2,0-0.3-0.1-0.4-0.2l-3-4.5C0.9,9,1,8.7,1.2,8.6c0.2-0.2,0.5-0.1,0.7,0.1l2.6,4
        l3.1-3.5c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-3.5,4C4.8,13.9,4.6,14,4.5,14z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M14,22c-0.3,0-0.5-0.2-0.5-0.5S13.7,21,14,21c5,0,9-4,9-9c0-5-4-9-9-9c-5,0-9,4-9,9v1.5C5,13.8,4.8,14,4.5,14
        S4,13.8,4,13.5V12C4,6.5,8.5,2,14,2c5.5,0,10,4.5,10,10C24,17.5,19.5,22,14,22z` })
    ], -1)
  ]));
}
const oi = /* @__PURE__ */ x(ri, [["render", si]]), ii = {
  name: "LuxIconRelax",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function li(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M12,24C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0c6.6,0,12,5.4,12,12C24,18.6,18.6,24,12,24z M12,1C5.9,1,1,5.9,1,12
          s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,21c-4.4,0-8-3.6-8-8c0-0.3,0.2-0.5,0.5-0.5S5,12.7,5,13c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7c0-0.3,0.2-0.5,0.5-0.5
          S20,12.7,20,13C20,17.4,16.4,21,12,21z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M16.5,10.5C15.3,10.5,14,9.6,14,8c0-0.3,0.2-0.5,0.5-0.5S15,7.7,15,8c0,1.6,1.8,1.8,2.5,1.1C17.8,8.8,18,8.5,18,8
          c0-0.3,0.2-0.5,0.5-0.5S19,7.7,19,8c0,1-0.4,1.5-0.8,1.9C17.8,10.3,17.1,10.5,16.5,10.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M7.5,10.5c-0.6,0-1.3-0.2-1.7-0.6C5.4,9.5,5,9,5,8c0-0.3,0.2-0.5,0.5-0.5S6,7.7,6,8c0,0.5,0.2,0.8,0.5,1.1
          C7.2,9.8,9,9.6,9,8c0-0.3,0.2-0.5,0.5-0.5S10,7.7,10,8C10,9.6,8.7,10.5,7.5,10.5z` })
    ], -1)
  ]));
}
const ui = /* @__PURE__ */ x(ii, [["render", li]]), ci = {
  name: "LuxIconReportHealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function di(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: "M12,21H2.5C1.673,21,1,20.327,1,19.5V4h3v1H2.5C2.224,5,2,5.224,2,5.5v14C2,19.776,2.224,20,2.5,20h8   c0.276,0,0.5-0.224,0.5-0.5S10.776,19,10.5,19H3V6h1v0.5C4,6.776,4.224,7,4.5,7h8C12.776,7,13,6.776,13,6.5V6h1v5   c0,0.276,0.224,0.5,0.5,0.5S15,11.276,15,11V5.5C15,5.224,14.776,5,14.5,5H13V4h3v7.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5   v-8C17,3.224,16.776,3,16.5,3H13V2.5C13,2.224,12.776,2,12.5,2h-1.545C10.766,0.963,9.98,0,8.5,0S6.234,0.963,6.045,2H4.5   C4.224,2,4,2.224,4,2.5V3H0.5C0.224,3,0,3.224,0,3.5v16C0,20.879,1.122,22,2.5,22H12c0.276,0,0.5-0.224,0.5-0.5S12.276,21,12,21z    M5,3h1.5C6.776,3,7,2.776,7,2.5C7,2.347,7.042,1,8.5,1S10,2.347,10,2.5C10,2.776,10.224,3,10.5,3H12v3H5V3z" }, null, -1),
    o("path", { d: "M10.5,9h-5C5.224,9,5,9.224,5,9.5S5.224,10,5.5,10h5c0.276,0,0.5-0.224,0.5-0.5S10.776,9,10.5,9z" }, null, -1),
    o("path", { d: "M10.5,11h-5C5.224,11,5,11.224,5,11.5S5.224,12,5.5,12h5c0.276,0,0.5-0.224,0.5-0.5S10.776,11,10.5,11z" }, null, -1),
    o("path", { d: "M11,13.5c0-0.276-0.224-0.5-0.5-0.5h-5C5.224,13,5,13.224,5,13.5S5.224,14,5.5,14h5C10.776,14,11,13.776,11,13.5z" }, null, -1),
    o("path", { d: "M5.5,15C5.224,15,5,15.224,5,15.5S5.224,16,5.5,16h3C8.776,16,9,15.776,9,15.5S8.776,15,8.5,15H5.5z" }, null, -1),
    o("path", { d: "M20.414,13.001c-0.951,0-2.071,0.491-2.777,1.784c-0.706-1.293-1.826-1.784-2.777-1.784c-1.584,0-3.223,1.322-3.223,3.536   c0,3.181,5.473,7.198,5.706,7.367C17.43,23.969,17.534,24,17.637,24s0.207-0.031,0.294-0.096c0.233-0.169,5.706-4.187,5.706-7.367   C23.637,14.323,21.998,13.001,20.414,13.001z M17.637,22.876c-1.63-1.246-5-4.253-5-6.339c0-1.588,1.13-2.536,2.223-2.536   c1.086,0,1.942,0.864,2.291,2.313c0.108,0.449,0.864,0.449,0.973,0c0.348-1.448,1.204-2.313,2.291-2.313   c1.093,0,2.223,0.948,2.223,2.536C22.637,18.621,19.267,21.63,17.637,22.876z" }, null, -1)
  ]));
}
const fi = /* @__PURE__ */ x(ci, [["render", di]]), hi = {
  name: "LuxIconReportRemove",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function vi(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("g", null, [
        o("path", { d: `M17.5,24c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5S21.1,24,17.5,24z M17.5,12c-3,0-5.5,2.5-5.5,5.5
          s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5S20.5,12,17.5,12z` })
      ]),
      o("g", null, [
        o("path", { d: `M15,20.5c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l5-5c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7l-5,5
          C15.3,20.5,15.1,20.5,15,20.5z` })
      ]),
      o("g", null, [
        o("path", { d: `M20,20.5c-0.1,0-0.3,0-0.4-0.1l-5-5c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l5,5c0.2,0.2,0.2,0.5,0,0.7
          C20.3,20.5,20.1,20.5,20,20.5z` })
      ])
    ], -1),
    o("g", null, [
      o("g", null, [
        o("path", { d: "M8,7H3.5C3.2,7,3,6.8,3,6.5S3.2,6,3.5,6H8c0.3,0,0.5,0.2,0.5,0.5S8.3,7,8,7z" })
      ]),
      o("g", null, [
        o("path", { d: "M11.5,10h-8C3.2,10,3,9.8,3,9.5S3.2,9,3.5,9h8C11.8,9,12,9.2,12,9.5S11.8,10,11.5,10z" })
      ]),
      o("g", null, [
        o("path", { d: "M9.5,13h-6C3.2,13,3,12.8,3,12.5S3.2,12,3.5,12h6c0.3,0,0.5,0.2,0.5,0.5S9.8,13,9.5,13z" })
      ]),
      o("g", null, [
        o("path", { d: "M8.5,16h-5C3.2,16,3,15.8,3,15.5S3.2,15,3.5,15h5C8.8,15,9,15.2,9,15.5S8.8,16,8.5,16z" })
      ]),
      o("g", null, [
        o("g", null, [
          o("path", { d: `M10.5,22h-10C0.2,22,0,21.8,0,21.5v-21C0,0.2,0.2,0,0.5,0h11c0.1,0,0.3,0.1,0.4,0.1l5,5C16.9,5.2,17,5.4,17,5.5v4
            c0,0.3-0.2,0.5-0.5,0.5S16,9.8,16,9.5V5.7L11.3,1H1v20h9.5c0.3,0,0.5,0.2,0.5,0.5S10.8,22,10.5,22z` })
        ]),
        o("g", null, [
          o("path", { d: "M16.5,6h-5C11.2,6,11,5.8,11,5.5v-5C11,0.2,11.2,0,11.5,0S12,0.2,12,0.5V5h4.5C16.8,5,17,5.2,17,5.5S16.8,6,16.5,6z" })
        ])
      ])
    ], -1)
  ]));
}
const pi = /* @__PURE__ */ x(hi, [["render", vi]]), mi = {
  name: "LuxIconReportUnhealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function yi(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: "M2.5,5C2.224,5,2,5.224,2,5.5v14C2,19.776,2.224,20,2.5,20H11c0.276,0,0.5-0.224,0.5-0.5S11.276,19,11,19H3V6h1v0.5   C4,6.776,4.224,7,4.5,7h8C12.776,7,13,6.776,13,6.5V6h1v7c0,0.276,0.224,0.5,0.5,0.5S15,13.276,15,13V5.5C15,5.224,14.776,5,14.5,5   H13V4h3v6c0,0.276,0.224,0.5,0.5,0.5S17,10.276,17,10V3.5C17,3.224,16.776,3,16.5,3H13V2.5C13,2.224,12.776,2,12.5,2h-1.545   C10.766,0.963,9.98,0,8.5,0S6.234,0.963,6.045,2H4.5C4.224,2,4,2.224,4,2.5V3H0.5C0.224,3,0,3.224,0,3.5v16   C0,20.879,1.122,22,2.5,22H10c0.276,0,0.5-0.224,0.5-0.5S10.276,21,10,21H2.5C1.673,21,1,20.327,1,19.5V4h3v1H2.5z M5,3h1.5   C6.776,3,7,2.776,7,2.5C7,2.347,7.042,1,8.5,1S10,2.347,10,2.5C10,2.776,10.224,3,10.5,3H12v3H5V3z" }, null, -1),
    o("path", { d: "M10.5,9h-5C5.224,9,5,9.224,5,9.5S5.224,10,5.5,10h5c0.276,0,0.5-0.224,0.5-0.5S10.776,9,10.5,9z" }, null, -1),
    o("path", { d: "M10.5,11h-5C5.224,11,5,11.224,5,11.5S5.224,12,5.5,12h5c0.276,0,0.5-0.224,0.5-0.5S10.776,11,10.5,11z" }, null, -1),
    o("path", { d: "M11,13.5c0-0.276-0.224-0.5-0.5-0.5h-5C5.224,13,5,13.224,5,13.5S5.224,14,5.5,14h5C10.776,14,11,13.776,11,13.5z" }, null, -1),
    o("path", { d: "M5.5,15C5.224,15,5,15.224,5,15.5S5.224,16,5.5,16h3C8.776,16,9,15.776,9,15.5S8.776,15,8.5,15H5.5z" }, null, -1),
    o("path", { d: "M23.892,23.166l-5.945-11.89c-0.17-0.338-0.725-0.338-0.895,0l-6,12c-0.078,0.155-0.069,0.339,0.022,0.486   S11.327,24,11.5,24h12c0.007,0,0.013,0,0.02,0c0.276,0,0.5-0.224,0.5-0.5C24.02,23.371,23.972,23.254,23.892,23.166z M12.309,23   L17.5,12.619L22.691,23H12.309z" }, null, -1),
    o("path", { d: "M17,16.409v3.272c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-3.272c0-0.276-0.224-0.5-0.5-0.5S17,16.133,17,16.409z" }, null, -1),
    o("circle", {
      cx: "17.5",
      cy: "21.318",
      r: "0.545"
    }, null, -1)
  ]));
}
const gi = /* @__PURE__ */ x(mi, [["render", yi]]), bi = {
  name: "LuxIconUserHome",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function _i(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M20.5,23h-17C3.2,23,3,22.8,3,22.5v-11C3,11.2,3.2,11,3.5,11S4,11.2,4,11.5V22h16V11c0-0.3,0.2-0.5,0.5-0.5
        S21,10.7,21,11v11.5C21,22.8,20.8,23,20.5,23z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M23.5,11.5c-0.1,0-0.2,0-0.3-0.1L12,1.2L0.8,11.4c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.2-0.2-0.5,0-0.7L11.7,0.1
        c0.2-0.2,0.5-0.2,0.7,0l11.5,10.5c0.2,0.2,0.2,0.5,0,0.7C23.8,11.4,23.6,11.5,23.5,11.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M19.5,5.5C19.2,5.5,19,5.3,19,5V2h-3c-0.3,0-0.5-0.2-0.5-0.5S15.7,1,16,1h3.5C19.8,1,20,1.2,20,1.5V5
        C20,5.3,19.8,5.5,19.5,5.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,15c-1.9,0-3.5-1.6-3.5-3.5S10.1,8,12,8s3.5,1.6,3.5,3.5S13.9,15,12,15z M12,9c-1.4,0-2.5,1.1-2.5,2.5
        S10.6,14,12,14c1.4,0,2.5-1.1,2.5-2.5S13.4,9,12,9z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M17.3,20H6.7c-0.3,0-0.5-0.2-0.5-0.5c0-3.1,2.5-5.5,5.8-5.5s5.8,2.4,5.8,5.5C17.8,19.8,17.6,20,17.3,20z M7.2,19h9.6
        c-0.3-2.3-2.2-4-4.8-4C9.4,15,7.4,16.7,7.2,19z` })
    ], -1)
  ]));
}
const $i = /* @__PURE__ */ x(bi, [["render", _i]]), wi = {
  name: "LuxIconReported",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Ci(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("g", null, [
        o("path", { d: `M17.5,24c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5S21.1,24,17.5,24z M17.5,12c-3,0-5.5,2.5-5.5,5.5
          s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5S20.5,12,17.5,12z` })
      ]),
      o("g", null, [
        o("path", { d: `M16.5,20c-0.1,0-0.3,0-0.4-0.1l-2-2c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l1.6,1.6l3.6-3.6c0.2-0.2,0.5-0.2,0.7,0
          s0.2,0.5,0,0.7l-4,4C16.8,20,16.6,20,16.5,20z` })
      ])
    ], -1),
    o("g", null, [
      o("g", null, [
        o("path", { d: "M8,7H3.5C3.2,7,3,6.8,3,6.5S3.2,6,3.5,6H8c0.3,0,0.5,0.2,0.5,0.5S8.3,7,8,7z" })
      ]),
      o("g", null, [
        o("path", { d: "M11.5,10h-8C3.2,10,3,9.8,3,9.5S3.2,9,3.5,9h8C11.8,9,12,9.2,12,9.5S11.8,10,11.5,10z" })
      ]),
      o("g", null, [
        o("path", { d: "M9.5,13h-6C3.2,13,3,12.8,3,12.5S3.2,12,3.5,12h6c0.3,0,0.5,0.2,0.5,0.5S9.8,13,9.5,13z" })
      ]),
      o("g", null, [
        o("path", { d: "M8.5,16h-5C3.2,16,3,15.8,3,15.5S3.2,15,3.5,15h5C8.8,15,9,15.2,9,15.5S8.8,16,8.5,16z" })
      ]),
      o("g", null, [
        o("g", null, [
          o("path", { d: `M10.5,22h-10C0.2,22,0,21.8,0,21.5v-21C0,0.2,0.2,0,0.5,0h11c0.1,0,0.3,0.1,0.4,0.1l5,5C16.9,5.2,17,5.4,17,5.5v4
            c0,0.3-0.2,0.5-0.5,0.5S16,9.8,16,9.5V5.7L11.3,1H1v20h9.5c0.3,0,0.5,0.2,0.5,0.5S10.8,22,10.5,22z` })
        ]),
        o("g", null, [
          o("path", { d: "M16.5,6h-5C11.2,6,11,5.8,11,5.5v-5C11,0.2,11.2,0,11.5,0S12,0.2,12,0.5V5h4.5C16.8,5,17,5.2,17,5.5S16.8,6,16.5,6z" })
        ])
      ])
    ], -1)
  ]));
}
const xi = /* @__PURE__ */ x(wi, [["render", Ci]]), Mi = {
  name: "LuxIconResearch",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Si(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M8.5,18.9c-0.1,0-0.1,0-0.2,0c-2.1-0.9-5-1.4-7.8-1.4C0.2,17.5,0,17.3,0,17V0.5C0,0.2,0.2,0,0.5,0c4.7,0,9.5,1,11,2.8
          C13,1,17.8,0,22.5,0C22.8,0,23,0.2,23,0.5V17c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-1,0-1,0l0-1c0,0,0.2,0,0.5,0V1c-5.7,0.1-10,1.6-10,3
          c0,0.3-0.2,0.5-0.5,0.5S11,4.3,11,4c0-1.3-4.3-2.9-10-3v15.5c2.8,0.1,5.6,0.6,7.7,1.4C8.9,18,9.1,18.3,9,18.6
          C8.9,18.8,8.7,18.9,8.5,18.9z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M11.5,5C11.2,5,11,4.8,11,4.5V4c0-0.3,0.2-0.5,0.5-0.5S12,3.7,12,4v0.5C12,4.8,11.8,5,11.5,5z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M9,6.7c-0.1,0-0.1,0-0.2,0C7.2,6.1,5,5.7,2.5,5.5C2.2,5.5,2,5.2,2,5s0.3-0.5,0.5-0.5c2.6,0.2,5,0.6,6.6,1.3
          c0.3,0.1,0.4,0.4,0.3,0.6C9.4,6.6,9.2,6.7,9,6.7z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M7,9.1c0,0-0.1,0-0.1,0C5.6,8.8,4.1,8.6,2.5,8.5C2.2,8.5,2,8.2,2,8s0.3-0.5,0.5-0.5c1.7,0.1,3.2,0.3,4.6,0.7
          c0.3,0.1,0.4,0.3,0.4,0.6C7.5,9,7.2,9.1,7,9.1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M5.9,11.9C5.9,11.9,5.9,11.9,5.9,11.9c-1.1-0.2-2.3-0.3-3.5-0.4C2.2,11.5,2,11.2,2,11s0.3-0.5,0.5-0.5
          c1.2,0.1,2.4,0.2,3.5,0.4c0.3,0,0.5,0.3,0.4,0.6C6.4,11.8,6.2,11.9,5.9,11.9z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M6.1,14.9C6.1,14.9,6,14.9,6.1,14.9c-1.2-0.2-2.4-0.4-3.6-0.4C2.2,14.5,2,14.2,2,14s0.3-0.5,0.5-0.5
          c1.3,0.1,2.5,0.2,3.6,0.5c0.3,0.1,0.4,0.3,0.4,0.6C6.5,14.8,6.3,14.9,6.1,14.9z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M16.5,6c-0.2,0-0.4-0.2-0.5-0.4C16,5.4,16.2,5.1,16.4,5c1.2-0.3,2.6-0.4,4-0.5C20.7,4.5,21,4.7,21,5
          c0,0.3-0.2,0.5-0.5,0.5c-1.4,0.1-2.7,0.3-3.9,0.5C16.6,6,16.6,6,16.5,6z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M19.4,8.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.4-0.5c0.4,0,0.7-0.1,1.1-0.1C20.7,7.5,21,7.7,21,8s-0.2,0.5-0.5,0.5
          C20.2,8.5,19.8,8.6,19.4,8.6C19.5,8.6,19.4,8.6,19.4,8.6z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M13.5,19C9.9,19,7,16.1,7,12.5S9.9,6,13.5,6S20,8.9,20,12.5S17.1,19,13.5,19z M13.5,7C10.5,7,8,9.5,8,12.5
          c0,3,2.5,5.5,5.5,5.5c3,0,5.5-2.5,5.5-5.5C19,9.5,16.5,7,13.5,7z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M23.5,23c-0.1,0-0.3,0-0.4-0.1l-5.7-5.7c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l5.7,5.7c0.2,0.2,0.2,0.5,0,0.7
          C23.8,23,23.6,23,23.5,23z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M15.5,13c-0.3,0-0.5-0.2-0.5-0.5V11h-3v1.5c0,0.3-0.2,0.5-0.5,0.5S11,12.8,11,12.5v-2c0-0.3,0.2-0.5,0.5-0.5h4
          c0.3,0,0.5,0.2,0.5,0.5v2C16,12.8,15.8,13,15.5,13z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M13.5,16c-0.3,0-0.5-0.2-0.5-0.5v-5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v5C14,15.8,13.8,16,13.5,16z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15,16h-3c-0.3,0-0.5-0.2-0.5-0.5S11.7,15,12,15h3c0.3,0,0.5,0.2,0.5,0.5S15.3,16,15,16z" })
    ], -1)
  ]));
}
const Di = /* @__PURE__ */ x(Mi, [["render", Si]]), ki = {
  name: "LuxIconScales",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Li(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: "M11.5,22c-0.3,0-0.5-0.2-0.5-0.5V6.4c0-0.3,0.2-0.5,0.5-0.5S12,6.2,12,6.4v15.1C12,21.8,11.8,22,11.5,22z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M14.4,22H8.6c-0.3,0-0.5-0.2-0.5-0.5S8.3,21,8.6,21h5.8c0.3,0,0.5,0.2,0.5,0.5S14.7,22,14.4,22z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M11.5,6.9c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S12.6,6.9,11.5,6.9z M11.5,4c-0.5,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1
          S12,4,11.5,4z` })
    ], -1),
    o("g", null, [
      o("g", null, [
        o("path", { d: `M7.5,13c-0.2,0-0.4-0.1-0.5-0.3L4,5.7l-3,6.9C0.8,13,0.6,13.1,0.3,13C0,12.8-0.1,12.6,0,12.3l3.5-8C3.6,4.1,3.8,4,4,4
            c0,0,0,0,0,0c0.2,0,0.4,0.1,0.5,0.3l3.5,8c0.1,0.3,0,0.5-0.3,0.7C7.6,13,7.6,13,7.5,13z` })
      ]),
      o("g", null, [
        o("path", { d: "M10.1,5H2.5C2.2,5,2,4.8,2,4.5S2.2,4,2.5,4h7.6c0.3,0,0.5,0.2,0.5,0.5S10.4,5,10.1,5z" })
      ]),
      o("g", null, [
        o("path", { d: `M4,16.5c-2.2,0-4-1.8-4-4C0,12.2,0.2,12,0.5,12h7C7.8,12,8,12.2,8,12.5C8,14.7,6.2,16.5,4,16.5z M1,13
            c0.2,1.4,1.5,2.5,3,2.5s2.7-1.1,3-2.5H1z` })
      ])
    ], -1),
    o("g", null, [
      o("g", null, [
        o("path", { d: `M15.5,13c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.7l3.5-8C18.6,4.1,18.8,4,19,4l0,0c0.2,0,0.4,0.1,0.5,0.3l3.5,8
            c0.1,0.3,0,0.5-0.3,0.7c-0.3,0.1-0.5,0-0.7-0.3l-3-6.9l-3,6.9C15.9,12.9,15.7,13,15.5,13z` })
      ]),
      o("g", null, [
        o("path", { d: "M20.5,5h-7.6c-0.3,0-0.5-0.2-0.5-0.5S12.6,4,12.9,4h7.6C20.8,4,21,4.2,21,4.5S20.8,5,20.5,5z" })
      ]),
      o("g", null, [
        o("path", { d: `M19,16.5c-2.2,0-4-1.8-4-4c0-0.3,0.2-0.5,0.5-0.5h7c0.3,0,0.5,0.2,0.5,0.5C23,14.7,21.2,16.5,19,16.5z M16,13
            c0.2,1.4,1.5,2.5,3,2.5s2.7-1.1,3-2.5H16z` })
      ])
    ], -1)
  ]));
}
const Ii = /* @__PURE__ */ x(ki, [["render", Li]]), Oi = {
  name: "LuxIconSearch",
  status: "ready",
  release: "1.0.0",
  type: "Element"
}, zi = {
  class: "lux-search-icon",
  d: "M9.58,16.8c1.65,0,3.25-.57,4.5-1.59l6.14,6.14c.3.32.83.33,1.13.02.32-.31.32-.83.02-1.14,0,0-6.16-6.16-6.16-6.16C19.84,8.26,13.64.15,6.79,2.98-.39,6.12,1.74,16.7,9.58,16.8ZM9.58,4.01c3.92-.07,6.78,4.2,5.16,7.77-1.86,4.54-8.47,4.54-10.32,0-1.62-3.57,1.24-7.84,5.16-7.77Z"
};
function Ai(e, t, a, n, s, r) {
  return f(), p("path", zi);
}
const or = /* @__PURE__ */ x(Oi, [["render", Ai]]), Pi = {
  name: "LuxIconUnsorted",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Ti(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("circle", {
      class: "st0",
      cx: "12",
      cy: "12",
      r: "2"
    }, null, -1),
    o("polygon", {
      class: "st1",
      points: "17.5,6.5 12,0.5 6.5,6.5 	"
    }, null, -1),
    o("polygon", {
      class: "st1",
      points: "6.5,17.5 12,23.5 17.5,17.5 	"
    }, null, -1)
  ]));
}
const Ei = /* @__PURE__ */ x(Pi, [["render", Ti], ["__scopeId", "data-v-686d33cc"]]), Yi = {
  name: "LuxIconVacation",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Hi(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M18.4,24H0.5C0.2,24,0,23.8,0,23.5c0-3.7,4.9-5,9.5-5c4.6,0,9.5,1.3,9.5,5C18.9,23.8,18.7,24,18.4,24z M1,23h16.8
          c-0.5-2.6-4.7-3.5-8.4-3.5C5.8,19.5,1.5,20.4,1,23z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M6.5,19.5L5.6,19l5.9-10.8C11.7,8.1,11.9,8,12.1,8s0.4,0.3,0.4,0.5L12,19.1l-1,0l0.4-8.5L6.5,19.5z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M3.7,11.4c-0.9,0-1.8,0-2.7-0.1c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.3,0-0.5c2.1-5,8.7-4.8,11.7-3.6
          c0.2,0.1,0.3,0.3,0.3,0.5v1c0,0.2-0.1,0.3-0.2,0.4C9.5,10.9,6.7,11.4,3.7,11.4z M1.7,10.3c3.6,0.2,6.7,0,9.8-2.1V7.9
          C9.3,7.1,3.9,6.6,1.7,10.3z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,8c-0.1,0-0.1,0-0.2,0L4.3,5C4.1,4.9,4,4.7,4,4.6c0-0.2,0.1-0.4,0.2-0.5C6,2.9,8.1,2.8,9.9,3.8
          c1.6,0.8,2.6,2.3,2.6,3.7c0,0.2-0.1,0.3-0.2,0.4C12.2,8,12.1,8,12,8z M5.7,4.4l5.7,2.3c-0.3-0.8-1-1.6-1.9-2.1
          C8.2,4,6.9,3.9,5.7,4.4z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M19.1,11.5c-2.9,0-5.6-0.5-7.5-2.6c-0.1-0.1-0.1-0.2-0.1-0.3v-1c0-0.2,0.1-0.4,0.3-0.5c3-1.2,9.6-1.4,11.7,3.6
          c0.1,0.1,0.1,0.3,0,0.5c-0.1,0.1-0.2,0.2-0.4,0.2l-0.9,0C21.2,11.4,20.1,11.5,19.1,11.5z M12.5,8.3c2.2,2.5,6,2.2,9.7,2l0.1,0
          c-2.2-3.7-7.6-3.2-9.8-2.5V8.3z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,8c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.4c0-1.4,1-2.9,2.6-3.7c1.8-1,3.9-0.9,5.7,0.3
          C19.9,4.2,20,4.4,20,4.6c0,0.2-0.1,0.3-0.3,0.4l-7.5,3C12.1,8,12.1,8,12,8z M16.7,4.1c-0.7,0-1.4,0.2-2.1,0.5
          c-0.9,0.5-1.6,1.3-1.9,2.1l5.7-2.3C17.8,4.2,17.2,4.1,16.7,4.1z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M11.6,17.5H10c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.6c0.3,0,0.5,0.2,0.5,0.5S11.9,17.5,11.6,17.5z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M11.7,15.5h-1.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.2c0.3,0,0.5,0.2,0.5,0.5S12,15.5,11.7,15.5z" })
    ], -1)
  ]));
}
const Vi = /* @__PURE__ */ x(Yi, [["render", Hi]]), Ni = {
  name: "LuxIconView",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Ri(e, t, a, n, s, r) {
  return f(), p("g", null, t[0] || (t[0] = [
    o("path", { d: `M1.4,7.5c0.1,0,0.1,0.1,0.2,0.1c0.2,0,0.4-0.1,0.5-0.3c1-2.2,2.8-4,4.9-5.1c0.2-0.1,0.3-0.4,0.2-0.7
  		C7.1,1.3,6.8,1.2,6.5,1.3C4.2,2.5,2.3,4.5,1.2,6.8C1.1,7.1,1.2,7.4,1.4,7.5z` }, null, -1),
    o("path", { d: `M9.5,1.3c2.3-0.5,4.8-0.3,7,0.7c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.5-0.3c0.1-0.3,0-0.5-0.2-0.7C14.6,0,11.8-0.3,9.3,0.3
  		C9,0.4,8.9,0.6,8.9,0.9S9.2,1.3,9.5,1.3z` }, null, -1),
    o("path", { d: `M22.7,9.3c0.1,0.2,0.3,0.4,0.5,0.4c0,0,0.1,0,0.1,0c0.3-0.1,0.4-0.3,0.4-0.6c-0.6-2.5-2.1-4.8-4.2-6.5
  		c-0.2-0.2-0.5-0.1-0.7,0.1s-0.1,0.5,0.1,0.7C20.7,4.9,22.1,7,22.7,9.3z` }, null, -1),
    o("path", { d: `M1,12c0-0.7,0.1-1.5,0.2-2.2c0.1-0.3-0.1-0.5-0.4-0.6C0.6,9.2,0.3,9.3,0.2,9.6C0.1,10.4,0,11.2,0,12c0,1.8,0.4,3.6,1.2,5.2
  		c0.1,0.2,0.3,0.3,0.4,0.3c0.1,0,0.1,0,0.2,0c0.2-0.1,0.4-0.4,0.2-0.7C1.4,15.3,1,13.7,1,12z` }, null, -1),
    o("path", { d: `M18.9,20.6c-1.9,1.5-4.2,2.4-6.6,2.4c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0c2.7-0.1,5.2-1,7.2-2.6
  		c0.2-0.2,0.2-0.5,0.1-0.7C19.4,20.5,19.1,20.4,18.9,20.6z` }, null, -1),
    o("path", { d: `M23.5,11.5c-0.3,0-0.5,0.2-0.5,0.5c0,2.4-0.8,4.7-2.3,6.7c-0.2,0.2-0.1,0.5,0.1,0.7c0.1,0.1,0.2,0.1,0.3,0.1
  		c0.1,0,0.3-0.1,0.4-0.2c1.6-2.1,2.5-4.6,2.5-7.3v0C24,11.7,23.8,11.5,23.5,11.5z` }, null, -1),
    o("path", { d: `M9.6,22.7c-2.3-0.5-4.5-1.8-6-3.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.2,0.2-0.2,0.5-0.1,0.7c1.7,2,4,3.4,6.6,4c0,0,0.1,0,0.1,0
  		c0.2,0,0.4-0.2,0.5-0.4C10,23.1,9.8,22.8,9.6,22.7z` }, null, -1),
    o("path", { d: `M12,7c-4.6,0-8.2,4.5-8.4,4.7c-0.1,0.2-0.1,0.4,0,0.6C3.8,12.5,7.4,17,12,17c4.6,0,8.2-4.5,8.4-4.7c0.1-0.2,0.1-0.4,0-0.6
  		C20.2,11.5,16.5,7,12,7z M12,16c-3.4,0-6.4-3-7.3-4c0.9-1,3.9-4,7.3-4c3.4,0,6.4,3,7.3,4C18.4,13,15.4,16,12,16z` }, null, -1),
    o("path", { d: "M12,9c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S13.6,9,12,9z M12,14c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.1,14,12,14z" }, null, -1)
  ]));
}
const Fi = /* @__PURE__ */ x(Ni, [["render", Ri]]), Bi = {
  name: "LuxInputButton",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  data: function() {
    return {
      label: "Submit"
    };
  },
  props: {
    /**
     * The button's variations `solid, outline, text, dropdown, icon`
     */
    variation: {
      type: String,
      default: "solid",
      validator: (e) => e.match(/(solid|outline|text|dropdown|icon|icon-prepend)/)
    },
    /**
     * The button's type attribute `button, submit`
     */
    type: {
      type: String,
      default: "button",
      validator: (e) => e.match(/(|button|submit)/)
    },
    /**
     * Sets the size of the button `small, medium, large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * Whether the button extends the full available width or not
     */
    block: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the button is disabled or not
     * `true, false`
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the button is focused or not
     * `true, false`
     */
    focused: {
      type: Boolean,
      default: !1
    },
    /**
     * Clicking this button can emit a custom event that should trigger an alert.
     * You must supply an alertStatus and alertMessage, like so:
     * { 'alertStatus': 'success', 'alertMessage': 'This is my message.'}
     */
    customAlertEvent: {
      type: Object,
      default: null
    },
    /**
     * Visually hides the button text.
     */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
     * Indicates what icon to use. Values should be hyphenated and do not use the "lux-icon-" prefix.
     * For example, instead of `lux-icon-search`, simply use `search`.
     */
    icon: {
      type: String,
      default: ""
    }
  },
  computed: {
    iconComponent() {
      return "lux-icon-" + this.icon;
    }
  },
  emits: ["button-clicked", "system-alert"],
  methods: {
    buttonClicked(e) {
      this.customAlertEvent && this.$emit("system-alert", {
        event: e,
        alertStatus: this.customAlertEvent.alertStatus,
        alertMessage: this.customAlertEvent.alertMessage
      }), this.$emit("button-clicked", e);
    }
  },
  mounted() {
    let e = this;
    e.$nextTick(function() {
      e.focused && this.$refs.inputButton.focus();
    });
  },
  components: {
    LuxIconBase: K0
  }
}, Wi = ["type", "disabled"], ji = {
  key: 0,
  class: "prepend-icon"
}, Ui = {
  key: 1,
  class: "append-icon"
};
function qi(e, t, a, n, s, r) {
  const i = A("lux-icon-base");
  return f(), p("button", {
    ref: "inputButton",
    type: a.type ? a.type : !1,
    class: z(["lux-button", a.variation, a.size, { "lux-expanded": a.block == !0 }]),
    disabled: a.disabled,
    onClick: t[0] || (t[0] = (l) => r.buttonClicked(l))
  }, [
    a.variation === "icon-prepend" ? (f(), p("div", ji, [
      D(i, {
        width: "18",
        height: "18",
        "icon-name": a.icon
      }, {
        default: O(() => [
          (f(), P(Q(r.iconComponent)))
        ]),
        _: 1
      }, 8, ["icon-name"])
    ])) : E("", !0),
    ie(e.$slots, "default", {}, void 0, !0),
    a.variation === "icon" ? (f(), p("div", Ui, [
      D(i, {
        width: "18",
        height: "18",
        "icon-name": a.icon
      }, {
        default: O(() => [
          (f(), P(Q(r.iconComponent)))
        ]),
        _: 1
      }, 8, ["icon-name"])
    ])) : E("", !0)
  ], 10, Wi);
}
const St = /* @__PURE__ */ x(Bi, [["render", qi], ["__scopeId", "data-v-2093a38a"]]), Zi = {
  name: "LuxInputCheckbox",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  model: {
    prop: "checked",
    event: "change"
  },
  emits: ["change", "inputblur"],
  data: function() {
    return {
      wrapper: this.groupLabel.length ? "fieldset" : "div"
    };
  },
  props: {
    /**
     * If true, the checkboxes will be stacked vertically. Otherwise they will be horizontal (inline).
     */
    vertical: {
      type: Boolean,
      default: !1
    },
    /**
     * The available options to check. Option properties are: id, value, disabled, required, checked
     */
    options: {
      required: !0,
      type: Array
    },
    /**
     * The label of the form input field.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * The validation message a user should get.
     */
    errormessage: {
      type: String,
      default: ""
    },
    /**
     * The html element name used for the wrapper.
     * `div, section`
     */
    groupLabel: {
      type: String,
      default: ""
    },
    /**
     * Whether the form input field is disabled or not.
     * `true, false`
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s hover state.
     * `true, false`
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s focus state.
     * `true, false`
     */
    focus: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    change(e) {
      this.$emit("change", e.target.checked);
    },
    inputblur(e) {
      this.$emit("inputblur", e);
    }
  }
}, Gi = { key: 0 }, Ki = ["id", "name", "value", "checked", "disabled", "required"], Xi = ["for"], Ji = ["for"], Qi = {
  key: 1,
  role: "alert",
  class: "lux-error"
};
function el(e, t, a, n, s, r) {
  return f(), P(Q(e.wrapper), { class: "lux-input" }, {
    default: O(() => [
      a.groupLabel ? (f(), p("legend", Gi, F(a.groupLabel), 1)) : E("", !0),
      (f(!0), p(X, null, oe(a.options, (i) => (f(), p("div", {
        class: z(["lux-checkbox", { "lux-inline": !a.vertical }]),
        key: i.id
      }, [
        o("input", {
          type: "checkbox",
          id: i.id,
          name: a.label,
          value: i.value,
          checked: i.checked,
          disabled: i.disabled,
          required: i.required,
          onChange: t[0] || (t[0] = (l) => r.change(l)),
          onBlur: t[1] || (t[1] = (l) => r.inputblur(l.target))
        }, null, 40, Ki),
        i.label ? (f(), p("label", {
          key: 0,
          for: i.id
        }, F(i.label), 9, Xi)) : (f(), p("label", {
          key: 1,
          for: i.id
        }, F(i.value), 9, Ji))
      ], 2))), 128)),
      a.errormessage ? (f(), p("div", Qi, F(a.errormessage), 1)) : E("", !0)
    ]),
    _: 1
  });
}
const tl = /* @__PURE__ */ x(Zi, [["render", el], ["__scopeId", "data-v-42b6a3db"]]), al = {
  name: "LuxAutocompleteInput",
  status: "prototype",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The available items in the autocomplete. This can be a simple array of strings
     * or an array of objects with an id and a label, if id is needed.
     */
    items: {
      type: Array,
      required: !1,
      default() {
        return [""];
      }
    },
    /**
     * The placeholder value for the form input field.
     */
    placeholder: {
      type: String,
      default: null
    },
    /**
     * The default value for the form input field.
     */
    defaultValue: {
      type: String,
      default: ""
    },
    /**
     * The label of the form input field.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Visually hides the label of the form input field.
     */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
     * The id of the form input field.
     */
    id: {
      type: String,
      default: ""
    },
    /**
     * The name of the form input field.
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Is the data given by an outside ajax request?
     */
    isAsync: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the input is focused or not
     * `true, false`
     */
    focused: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["input", "selected"],
  data() {
    return {
      isOpen: !1,
      results: [],
      search: "",
      inputValue: "",
      isLoading: !1,
      arrowCounter: -1
    };
  },
  methods: {
    onChange() {
      this.$emit("input", this.search), this.isAsync ? this.isLoading = !0 : (this.filterResults(), this.isOpen = !0);
    },
    filterResults() {
      if (this.items.length && typeof this.items[0] == "object") {
        let e = this.items.filter(
          (t) => t.label.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
        this.results = e.map((t) => t.label);
      } else
        this.results = this.items.filter(
          (e) => e.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
    },
    setResult(e, t = (a) => {
    }) {
      if (this.search = e, this.inputValue = e, this.isOpen = !1, this.items.length && typeof this.items[0] == "object") {
        let a = this.items.find((n) => n.label === e);
        typeof a < "u" && (this.inputValue = a.id, t(a.id));
      }
    },
    onArrowDown() {
      this.arrowCounter < this.results.length && (this.arrowCounter = this.arrowCounter + 1);
    },
    onArrowUp() {
      this.arrowCounter > 0 && (this.arrowCounter = this.arrowCounter - 1);
    },
    onEnter() {
      this.setResult(this.results[this.arrowCounter], this.emitSelectedId), this.isOpen = !1, this.arrowCounter = -1;
    },
    onEscape() {
      this.setResult(this.search), this.isOpen = !1;
    },
    handleClickOutside(e) {
      this.$el.contains(e.target) || (this.setResult(this.search), this.isOpen = !1, this.arrowCounter = -1);
    },
    onClickResult(e) {
      this.setResult(e, this.emitSelectedId);
    },
    emitSelectedId(e) {
      this.$emit("selected", e);
    }
  },
  watch: {
    // Once the items content changes, it means the parent component
    // provided the needed data
    items: function(e, t) {
      this.isAsync && (this.results = e.map(
        (a) => typeof a == "object" ? a.label : a.toString()
      ), this.isOpen = !0, this.isLoading = !1);
    }
  },
  computed: {
    ariaActiveDescendant() {
      return this.arrowCounter < 0 ? null : `lux-autocomplete-${this.componentId}result-${this.arrowCounter}`;
    }
  },
  created() {
    this.setResult(this.defaultValue);
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    let e = this;
    e.$nextTick(function() {
      e.focused && this.$refs.autoComplete.focus();
    });
  },
  unmounted() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  setup() {
    return { componentId: Qs() };
  }
}, nl = { class: "lux-autocomplete" }, rl = ["for"], sl = { class: "lux-autocomplete-input" }, ol = ["id", "required", "aria-activedescendant", "placeholder"], il = { class: "lux-autocomplete-results" }, ll = {
  key: 0,
  class: "loading"
}, ul = ["onMousedown", "id"], cl = ["name", "id", "value"];
function dl(e, t, a, n, s, r) {
  return f(), p("div", nl, [
    a.label ? (f(), p("label", {
      key: 0,
      class: z({ "lux-hidden": a.hideLabel }),
      for: "displayInput-" + this.componentId
    }, F(a.label), 11, rl)) : E("", !0),
    o("div", sl, [
      k0(o("input", {
        id: "displayInput-" + this.componentId,
        role: "combobox",
        autocomplete: "off",
        ref: "autoComplete",
        type: "text",
        onInput: t[0] || (t[0] = (...i) => r.onChange && r.onChange(...i)),
        onClick: t[1] || (t[1] = (...i) => r.onChange && r.onChange(...i)),
        onFocus: t[2] || (t[2] = (...i) => r.onChange && r.onChange(...i)),
        "onUpdate:modelValue": t[3] || (t[3] = (i) => s.search = i),
        onKeydown: [
          t[4] || (t[4] = v0(L1((...i) => r.onArrowDown && r.onArrowDown(...i), ["prevent"]), ["down"])),
          t[5] || (t[5] = v0(L1((...i) => r.onArrowUp && r.onArrowUp(...i), ["prevent"]), ["up"])),
          t[6] || (t[6] = v0((...i) => r.onEnter && r.onEnter(...i), ["enter"])),
          t[7] || (t[7] = v0((...i) => r.onEscape && r.onEscape(...i), ["esc"])),
          t[8] || (t[8] = v0((...i) => r.onEscape && r.onEscape(...i), ["tab"]))
        ],
        onBlur: t[9] || (t[9] = (...i) => r.onEscape && r.onEscape(...i)),
        required: a.required,
        "aria-activedescendant": r.ariaActiveDescendant,
        placeholder: a.placeholder,
        class: "displayInput"
      }, null, 40, ol), [
        [Js, s.search]
      ]),
      k0(o("ul", il, [
        s.isLoading ? (f(), p("li", ll, "Loading results...")) : (f(!0), p(X, { key: 1 }, oe(s.results, (i, l) => (f(), p("li", {
          key: l,
          onMousedown: (u) => r.onClickResult(i),
          class: z(["lux-autocomplete-result", { "is-active": l === s.arrowCounter }]),
          id: "lux-autocomplete-" + this.componentId + "result-" + l
        }, F(i), 43, ul))), 128))
      ], 512), [
        [Jn, s.isOpen]
      ]),
      o("input", {
        name: a.name,
        id: a.id,
        type: "hidden",
        value: s.inputValue,
        "data-input-value": ""
      }, null, 8, cl)
    ])
  ]);
}
const ir = /* @__PURE__ */ x(al, [["render", dl]]), fl = { class: "autocomplete-container" }, hl = { class: "selected-items-frame" }, vl = {
  key: 0,
  class: "selected-items-label"
}, pl = { class: "selected-items" }, ml = {
  key: 0,
  class: "selected-item"
}, yl = { class: "info" }, gl = { class: "info-text" }, bl = { class: "info" }, _l = { class: "badge-text" }, $l = { class: "item-text" }, wl = /* @__PURE__ */ Object.assign({ name: "LuxInputMultiselect" }, {
  __name: "LuxInputMultiselect",
  props: {
    /**
     * An array of items.  Each item should be an object with (at minimum) an id and label property.
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * A function to load items asynchronously on user input. It should return an item list in the format [{id: "", label: ""}].
     */
    asyncLoadItemsFunction: {
      type: Function,
      default: null
    },
    /**
     * Placeholder text to display
     */
    placeholder: String,
    /**
     * The label of the form input field.
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Visually hides the label of the form input field.
     */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
     * Text to display if the user hasn't selected anything yet
     */
    noneSelectedLabel: {
      type: String,
      default: "None selected"
    },
    /**
     * Label for the summary of items that the user has selected so far
     */
    selectedItemsLabel: String
  },
  setup(e) {
    const t = se([]), a = e, n = Qn("autocomplete"), s = se(a.items), r = _(
      () => s.value.filter((d) => !t.value.includes(d))
    ), i = _(
      () => a.asyncLoadItemsFunction !== void 0 && a.asyncLoadItemsFunction !== null
    );
    function l(d) {
      const v = s.value.find((y) => y.id === d);
      t.value.push(v), n.value.setResult("");
    }
    function u(d) {
      const v = t.value.indexOf(d);
      v > -1 && t.value.splice(v, 1);
    }
    async function c(d) {
      if (a.asyncLoadItemsFunction !== void 0 && a.asyncLoadItemsFunction !== null) {
        let v = await a.asyncLoadItemsFunction(d), y = JSON.parse(JSON.stringify(v));
        s.value = y;
      }
    }
    return (d, v) => {
      const y = A("lux-badge");
      return f(), p(X, null, [
        o("div", fl, [
          D(ir, {
            items: r.value,
            onSelected: v[0] || (v[0] = (m) => l(m)),
            onInput: v[1] || (v[1] = (m) => c(m)),
            ref: "autocomplete",
            placeholder: e.placeholder,
            label: e.label,
            "hide-label": e.hideLabel,
            isAsync: i.value
          }, null, 8, ["items", "placeholder", "label", "hide-label", "isAsync"]),
          D(K0, { class: "search-icon" }, {
            default: O(() => [
              D(or)
            ]),
            _: 1
          })
        ]),
        o("div", hl, [
          e.selectedItemsLabel ? (f(), p("span", vl, F(e.selectedItemsLabel), 1)) : E("", !0),
          o("ul", pl, [
            t.value.length == 0 ? (f(), p("li", ml, [
              o("div", yl, [
                o("div", gl, F(e.noneSelectedLabel), 1)
              ])
            ])) : (f(!0), p(X, { key: 1 }, oe(t.value, (m) => (f(), p("li", {
              key: m,
              class: "selected-item"
            }, [
              ie(d.$slots, "item", { itemProps: m }, () => [
                o("div", bl, [
                  D(y, { class: "badge" }, {
                    default: O(() => [
                      o("div", _l, F(m.id), 1)
                    ]),
                    _: 2
                  }, 1024),
                  o("div", $l, F(m.label), 1)
                ])
              ]),
              D(St, {
                onButtonClicked: (g) => u(m),
                type: "button",
                variation: "icon",
                icon: "close",
                size: "small",
                class: "remove-item"
              }, null, 8, ["onButtonClicked"])
            ]))), 128))
          ])
        ]),
        ie(d.$slots, "hiddenInput", { selectedItems: t.value })
      ], 64);
    };
  }
}), Cl = {
  name: "LuxInputRadio",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  model: {
    prop: "checked",
    event: "change"
  },
  emits: ["change", "inputblur"],
  data: function() {
    return {
      wrapper: this.groupLabel.length ? "fieldset" : "div"
    };
  },
  props: {
    /**
     * If true, the radio buttons will be stacked vertically. Otherwise they will be horizontal (inline).
     */
    vertical: {
      type: Boolean,
      default: !1
    },
    /**
     * The available options to check. Option properties are: id, value, disabled, required, checked
     */
    options: {
      required: !0,
      type: Array
    },
    /**
     * The label of the form input field.
     */
    groupLabel: {
      type: String,
      default: ""
    },
    /**
     * The validation message a user should get.
     */
    errormessage: {
      type: String,
      default: ""
    },
    /**
     * Unique identifier of the form input field.
     */
    id: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * Whether the form input field is disabled or not.
     * `true, false`
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s hover state.
     * `true, false`
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s focus state.
     * `true, false`
     */
    focus: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    change(e) {
      this.$emit("change", e);
    },
    inputblur(e) {
      this.$emit("inputblur", e);
    }
  }
}, xl = { key: 0 }, Ml = ["id", "name", "value", "checked", "disabled", "required"], Sl = ["for"], Dl = ["for"], kl = {
  key: 1,
  role: "alert",
  class: "lux-error"
};
function Ll(e, t, a, n, s, r) {
  return f(), P(Q(e.wrapper), { class: "lux-input" }, {
    default: O(() => [
      a.groupLabel ? (f(), p("legend", xl, F(a.groupLabel), 1)) : E("", !0),
      (f(!0), p(X, null, oe(a.options, (i) => (f(), p("div", {
        class: z(["lux-radio", { "lux-inline": !a.vertical }]),
        key: i.id
      }, [
        o("input", {
          type: "radio",
          id: i.id,
          name: i.name,
          value: i.value,
          checked: i.checked,
          disabled: i.disabled,
          required: i.required,
          onChange: t[0] || (t[0] = (l) => r.change(l.target.value)),
          onBlur: t[1] || (t[1] = (l) => r.inputblur(l.target))
        }, null, 40, Ml),
        i.label ? (f(), p("label", {
          key: 0,
          for: i.id
        }, F(i.label), 9, Sl)) : (f(), p("label", {
          key: 1,
          for: i.id
        }, F(i.value), 9, Dl))
      ], 2))), 128)),
      a.errormessage ? (f(), p("div", kl, F(a.errormessage), 1)) : E("", !0)
    ]),
    _: 1
  });
}
const Il = /* @__PURE__ */ x(Cl, [["render", Ll], ["__scopeId", "data-v-39d16c92"]]), Ol = {
  name: "LuxInputSelect",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  model: {
    event: "change"
  },
  computed: {
    hasError() {
      return this.errormessage.length;
    }
  },
  emits: ["change", "inputblur"],
  props: {
    /**
     * Sets the value of the selected option.
     */
    value: {
      type: String
    },
    /**
     * Determines whether the user can select multiple options.
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * The available options to check.
     */
    options: {
      required: !0,
      type: Array
    },
    /**
     * The label of the input select field.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Visually hides the label of the form input field.
     */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
     * The validation message a user should get.
     */
    errormessage: {
      type: String,
      default: ""
    },
    /**
     * The html element name used for the wrapper.
     * `div, section`
     */
    wrapper: {
      type: String,
      default: "div",
      validator: (e) => e.match(/(div|section)/)
    },
    /**
     * Unique identifier of the input select field.
     */
    id: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The name attribute for the form input field.
     */
    name: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The width of the input select field.
     * `auto, expand`
     */
    width: {
      type: String,
      default: "auto",
      validator: (e) => e.match(/(auto|expand)/)
    },
    /**
     * Sets the size of the input area `small, medium, large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * Whether the form input field is disabled or not.
     * `true, false`
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s hover state.
     * `true, false`
     */
    hover: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    change(e) {
      this.$emit("change", e.target.value);
    },
    inputblur(e) {
      this.$emit("inputblur", e);
    },
    focusSelect() {
      this.$nextTick(() => {
        this.$refs.select.focus();
      });
    }
  }
}, zl = ["for"], Al = ["id", "disabled", "required", "multiple", "errormessage", "value", "name"], Pl = ["value", "disabled"], Tl = {
  key: 1,
  role: "alert",
  class: "lux-error"
};
function El(e, t, a, n, s, r) {
  return f(), P(Q(a.wrapper), { class: "lux-select" }, {
    default: O(() => [
      a.label ? (f(), p("label", {
        key: 0,
        for: a.id,
        class: z({ "lux-hidden": a.hideLabel })
      }, F(a.label), 11, zl)) : E("", !0),
      o("select", {
        id: a.id,
        class: z([
          "lux-select",
          { "lux-select-error": r.hasError },
          { "lux-select-expand": a.width === "expand" },
          a.size
        ]),
        disabled: a.disabled,
        required: a.required,
        multiple: a.multiple,
        errormessage: a.errormessage,
        value: a.value,
        ref: "select",
        name: a.name,
        onChange: t[0] || (t[0] = (i) => r.change(i)),
        onBlur: t[1] || (t[1] = (i) => r.inputblur(i.target))
      }, [
        (f(!0), p(X, null, oe(a.options, (i, l) => (f(), p("option", {
          key: l,
          value: i.value,
          disabled: i.disabled
        }, F(i.label), 9, Pl))), 128))
      ], 42, Al),
      a.errormessage ? (f(), p("div", Tl, F(a.errormessage), 1)) : E("", !0)
    ]),
    _: 1
  });
}
const Yl = /* @__PURE__ */ x(Ol, [["render", El], ["__scopeId", "data-v-1cc1b664"]]), Hl = {
  name: "LuxInputText",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  emits: [
    "inputvaluechange",
    "inputblur",
    "inputfocus",
    "update:value",
    "input",
    "keyup",
    "change",
    "blur",
    "focus"
  ],
  computed: {
    hasError() {
      return this.errormessage.length;
    }
  },
  props: {
    /**
     * The type of the form input field.
     * `text, number, email`
     */
    type: {
      type: String,
      default: "text",
      validator: (e) => e.match(/(text|number|email|textarea)/)
    },
    /**
     * Text value of the form input field.
     */
    value: {
      type: [String, Number],
      default: ""
    },
    /**
     * The placeholder value for the form input field.
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * The label of the form input field.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Visually hides the label of the form input field.
     */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
     * The validation message a user should get.
     */
    errormessage: {
      type: String,
      default: ""
    },
    /**
     * The helper text a user should get.
     */
    helper: {
      type: String,
      default: ""
    },
    /**
     * The html element name used for the wrapper.
     * `div, section`
     */
    wrapper: {
      type: String,
      default: "div",
      validator: (e) => e.match(/(div|section)/)
    },
    /**
     * Unique identifier of the form input field.
     */
    id: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The name attribute for the form input field.
     */
    name: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The width of the form input field.
     * `auto, expand`
     */
    width: {
      type: String,
      default: "auto",
      validator: (e) => e.match(/(auto|expand)/)
    },
    /**
     * Sets the size of the input area `small, medium, large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * The number of visible text lines for textarea.
     */
    rows: {
      type: String,
      default: "5"
    },
    /**
     * The maximum number of characters that the user can enter in textarea.
     */
    maxlength: {
      type: Number,
      default: 256
    },
    /**
     * Whether the form input field is disabled or not.
     * `true, false`
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the form input field is readonly or not.
     * `true, false`
     */
    readonly: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s hover state.
     * `true, false`
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s focus state.
     * `true, false`
     */
    focused: {
      type: Boolean,
      default: !1
    },
    /**
     * Appends icon inside container. Option:
     * `alert`, `approved`, `denied`
     */
    icon: {
      type: String,
      default: ""
    }
  },
  methods: {
    inputFired(e) {
      this.$emit("input", e), this.inputvaluechange(e.target.value);
    },
    inputvaluechange(e) {
      this.$emit("update:value", e);
    },
    inputblur(e) {
      this.$emit("inputblur", e);
    },
    focusFired(e) {
      this.$emit("focus", e), this.inputfocus(e.target.value);
    },
    inputfocus(e) {
      this.$emit("inputfocus", e);
    }
  },
  mounted: function() {
    let e = this;
    e.$nextTick(function() {
      e.focused && (e.type == "text" && this.$refs.textInput.focus(), e.type == "textarea" && this.$refs.textArea.focus());
    });
  },
  components: {
    LuxIconAlert: tr,
    LuxIconApproved: ar,
    LuxIconDenied: nr,
    LuxIconBase: K0
  }
}, Vl = ["for"], Nl = ["name", "value", "id", "readonly", "disabled", "required", "type", "maxlength", "hover", "placeholder", "errormessage"], Rl = ["name", "id", "disabled", "readonly", "required", "rows", "maxlength", "hover", "value", "placeholder", "errormessage"], Fl = {
  key: 2,
  class: "append-icon"
}, Bl = {
  key: 1,
  role: "alert",
  class: "lux-error"
}, Wl = {
  key: 2,
  class: "lux-helper"
};
function jl(e, t, a, n, s, r) {
  const i = A("lux-icon-alert"), l = A("lux-icon-approved"), u = A("lux-icon-denied"), c = A("lux-icon-base");
  return f(), P(Q(a.wrapper), {
    class: z(["lux-input", { "lux-has-icon": a.icon }])
  }, {
    default: O(() => [
      a.label ? (f(), p("label", {
        key: 0,
        for: a.id,
        class: z({ "lux-hidden": a.hideLabel })
      }, F(a.label), 11, Vl)) : E("", !0),
      o("div", {
        class: z(["lux-input-field", [{ "lux-input-expand": a.width === "expand" }, { disabled: a.disabled }, a.size]])
      }, [
        a.type !== "textarea" ? (f(), p("input", {
          key: 0,
          autocomplete: "off",
          ref: "textInput",
          name: a.name,
          value: a.value,
          id: a.id,
          readonly: a.readonly,
          disabled: a.disabled,
          required: a.required,
          type: a.type,
          maxlength: a.maxlength,
          hover: a.hover,
          placeholder: a.placeholder,
          errormessage: a.errormessage,
          class: z(["lux-input", { "lux-input-error": r.hasError }]),
          onInput: t[0] || (t[0] = (d) => r.inputFired(d)),
          onChange: t[1] || (t[1] = (...d) => e.$emit("change", ...d)),
          onKeyup: t[2] || (t[2] = (...d) => e.$emit("keyup", ...d)),
          onBlur: t[3] || (t[3] = (...d) => e.$emit("blur", ...d)),
          onFocus: t[4] || (t[4] = (d) => r.focusFired(d))
        }, null, 42, Nl)) : (f(), p("textarea", {
          key: 1,
          autocomplete: "off",
          ref: "textArea",
          name: a.name,
          id: a.id,
          disabled: a.disabled,
          readonly: a.readonly,
          required: a.required,
          rows: a.rows,
          maxlength: a.maxlength,
          hover: a.hover,
          value: a.value,
          placeholder: a.placeholder,
          errormessage: a.errormessage,
          class: z([
            "lux-input",
            { "lux-input-error": r.hasError },
            { "lux-input-expand": a.width === "expand" }
          ]),
          onInput: t[5] || (t[5] = (d) => r.inputvaluechange(d.target.value)),
          onBlur: t[6] || (t[6] = (d) => r.inputblur(d)),
          onFocus: t[7] || (t[7] = (d) => r.inputfocus(d))
        }, null, 42, Rl)),
        a.icon ? (f(), p("div", Fl, [
          D(c, {
            width: "24",
            height: "24"
          }, {
            default: O(() => [
              a.icon === "alert" ? (f(), P(i, { key: 0 })) : E("", !0),
              a.icon === "approved" ? (f(), P(l, { key: 1 })) : E("", !0),
              a.icon === "denied" ? (f(), P(u, { key: 2 })) : E("", !0)
            ]),
            _: 1
          })
        ])) : E("", !0)
      ], 2),
      a.errormessage ? (f(), p("div", Bl, F(a.errormessage), 1)) : E("", !0),
      a.helper ? (f(), p("div", Wl, F(a.helper), 1)) : E("", !0)
    ]),
    _: 1
  }, 8, ["class"]);
}
const q1 = /* @__PURE__ */ x(Hl, [["render", jl], ["__scopeId", "data-v-bc042a76"]]), Ul = {
  name: "LuxCardContent",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
};
function ql(e, t, a, n, s, r) {
  return f(), P(Q(a.type), { class: "lux-card-content" }, {
    default: O(() => [
      ie(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  });
}
const Zl = /* @__PURE__ */ x(Ul, [["render", ql], ["__scopeId", "data-v-1ac57255"]]), Gl = {
  name: "LuxCardHeader",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
};
function Kl(e, t, a, n, s, r) {
  return f(), P(Q(a.type), { class: "lux-card-header" }, {
    default: O(() => [
      ie(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  });
}
const Xl = /* @__PURE__ */ x(Gl, [["render", Kl], ["__scopeId", "data-v-0185aee7"]]), Jl = {
  name: "LuxCardMedia",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
};
function Ql(e, t, a, n, s, r) {
  return f(), P(Q(a.type), { class: "lux-card-media" }, {
    default: O(() => [
      ie(e.$slots, "default")
    ]),
    _: 3
  });
}
const eu = /* @__PURE__ */ x(Jl, [["render", Ql], ["__scopeId", "data-v-aef1f826"]]), tu = {
  name: "LuxHamburger",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
}, au = { class: "hamburger-box" };
function nu(e, t, a, n, s, r) {
  return f(), p("span", au, t[0] || (t[0] = [
    o("span", { class: "hamburger-inner" }, null, -1)
  ]));
}
const lr = /* @__PURE__ */ x(tu, [["render", nu], ["__scopeId", "data-v-d93a1c53"]]), ru = ["innerHTML"], ur = {
  __name: "_LuxMenuBarLabel",
  props: {
    item: Object
  },
  setup(e) {
    return (t, a) => e.item.unsafe_name ? (f(), p("span", {
      key: 0,
      innerHTML: e.item.unsafe_name
    }, null, 8, ru)) : (f(), p(X, { key: 1 }, [
      he(F(e.item.name), 1)
    ], 64));
  }
}, su = {
  name: "LuxSubscribeNewsletter",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    },
    buttonLabel: {
      type: String,
      default: "Subscribe"
    }
  },
  components: {
    LuxInputButton: St,
    LuxInputText: q1
  }
}, ou = {
  id: "mc-embedded-subscribe-form",
  action: "https://princeton.us4.list-manage.com/subscribe/post?u=f1159e2c2a8bc35d62147f282&id=6c19fe9a37",
  method: "post",
  name: "mc-embedded-subscribe-form",
  class: "validate",
  target: "_blank",
  novalidate: ""
}, iu = {
  id: "mc_embed_signup_scroll",
  class: "newsletter-signup"
};
function lu(e, t, a, n, s, r) {
  const i = A("lux-input-text"), l = A("lux-input-button");
  return f(), P(Q(a.type), { class: "lux-subscribe-newsletter" }, {
    default: O(() => [
      o("form", ou, [
        o("div", iu, [
          D(i, {
            id: "mce-EMAIL",
            type: "email",
            name: "EMAIL",
            label: "Email address",
            hideLabel: !0
          }),
          D(l, {
            id: "mc-embedded-subscribe",
            type: "submit",
            name: "subscribe",
            class: "lux-subscribe-newsletter",
            variation: "outline",
            "aria-describedby": "describe-mailchimp-form"
          }, {
            default: O(() => [
              he(F(a.buttonLabel), 1)
            ]),
            _: 1
          }),
          t[0] || (t[0] = o("div", { id: "describe-mailchimp-form" }, "Opens the form in a new tab", -1)),
          t[1] || (t[1] = o("div", {
            style: { position: "absolute", left: "-5000px" },
            "aria-hidden": "true"
          }, [
            o("input", {
              type: "text",
              name: "b_f1159e2c2a8bc35d62147f282_6c19fe9a37",
              tabindex: "-1",
              value: ""
            })
          ], -1))
        ])
      ])
    ]),
    _: 1
  });
}
const cr = /* @__PURE__ */ x(su, [["render", lu], ["__scopeId", "data-v-102d5e24"]]), uu = {
  name: "LuxHyperlink",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The href value of the link.
     */
    href: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * Whether the link appears as text or as a button. Options include `button solid`
     * and `button outline`.
     */
    variation: {
      type: String,
      default: "link",
      validator: (e) => e.match(/(link|button)/)
    },
    /**
     * Sets the size of the button `small`, `medium`, `large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * Should the link open in a new tab?  This can be
     * disconcerting, so don't use it unless necessary.
     */
    newTab: {
      type: Boolean,
      default: !1
    },
    /**
     * Should the link have an underline?
     */
    underline: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    LuxIconBase: K0,
    LuxIconNewTab: sr
  }
}, cu = ["href", "target"];
function du(e, t, a, n, s, r) {
  const i = A("lux-icon-new-tab"), l = A("lux-icon-base");
  return f(), p("a", {
    href: a.href,
    class: z(["lux-link", a.variation, a.size, a.underline ? "lux-link-underline" : ""]),
    target: a.newTab ? "_blank" : null
  }, [
    ie(e.$slots, "default", {}, void 0, !0),
    a.newTab ? (f(), P(l, {
      key: 0,
      width: "14",
      height: "14",
      "icon-name": "(opens in new tab)"
    }, {
      default: O(() => [
        D(i)
      ]),
      _: 1
    })) : E("", !0)
  ], 10, cu);
}
const Z1 = /* @__PURE__ */ x(uu, [["render", du], ["__scopeId", "data-v-d02cc921"]]), fu = {
  name: "LuxUniversityAccessibility",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "span"
    },
    theme: {
      type: String,
      default: "dark"
    }
  },
  components: {
    LuxHyperlink: Z1
  }
};
function hu(e, t, a, n, s, r) {
  const i = A("LuxHyperlink");
  return f(), P(Q(a.type), {
    class: z(["lux-accessibility", a.theme])
  }, {
    default: O(() => [
      D(i, {
        href: "https://accessibility.princeton.edu/help",
        newTab: !0
      }, {
        default: O(() => t[0] || (t[0] = [
          he("Accessibility Help")
        ])),
        _: 1,
        __: [0]
      })
    ]),
    _: 1
  }, 8, ["class"]);
}
const vu = /* @__PURE__ */ x(fu, [["render", hu], ["__scopeId", "data-v-88f7846b"]]), pu = {
  name: "LuxUniversityAccessibilityOld",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "span"
    }
  }
};
function mu(e, t, a, n, s, r) {
  return f(), P(Q(a.type), { class: "lux-accessibility" }, {
    default: O(() => t[0] || (t[0] = [
      o("a", { href: "https://accessibility.princeton.edu/help" }, "Accessibility", -1)
    ])),
    _: 1,
    __: [0]
  });
}
const dr = /* @__PURE__ */ x(pu, [["render", mu], ["__scopeId", "data-v-18a88cf9"]]), yu = {
  name: "LuxLibraryContactInfo",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    },
    theme: {
      type: String,
      default: "dark"
    }
  }
};
function gu(e, t, a, n, s, r) {
  return f(), P(Q(a.type), {
    class: z(["lux-library-contact", a.theme])
  }, {
    default: O(() => t[0] || (t[0] = [
      o("div", {
        itemscope: "",
        itemtype: "http://schema.org/Organization"
      }, [
        o("div", {
          itemscope: "",
          itemtype: "http://schema.org/PostalAddress"
        }, [
          o("span", { itemprop: "streetAddress" }, "One Washington Road"),
          he(),
          o("br"),
          o("span", { itemprop: "addressLocality" }, "Princeton"),
          he(", "),
          o("span", { itemprop: "addressRegion" }, "NJ"),
          o("span", { itemprop: "postalCode" }, " 08544-2098"),
          he(),
          o("span", { itemprop: "addressCountry" }, "USA")
        ]),
        o("div", { class: "phone" }, [
          o("span", { itemprop: "telephone" }, [
            o("a", { href: "tel:1-609-258-1470" }, "(609) 258-1470")
          ])
        ])
      ], -1)
    ])),
    _: 1,
    __: [0]
  }, 8, ["class"]);
}
const fr = /* @__PURE__ */ x(yu, [["render", gu], ["__scopeId", "data-v-953883de"]]), bu = {
  name: "LuxLogoFacebook",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 24
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 24
    }
  }
}, _u = ["width", "height"];
function $u(e, t, a, n, s, r) {
  return f(), p("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: a.width,
    height: a.height,
    viewBox: "0 0 25 25",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "logo-facebook",
    role: "img",
    fill: "currentColor",
    class: "lux-logo-facebook"
  }, t[0] || (t[0] = [
    o("title", {
      id: "logo-facebook",
      lang: "en"
    }, "PUL Facebook", -1),
    o("g", null, [
      o("path", { d: "M18.768 7.465H14.5V5.56c0-.896.594-1.105 1.012-1.105H18.5V.513L14.171.5C10.244.5 9.5 3.438 9.5 5.32v2.144h-3v4h3v12h5v-12h3.851l.417-3.999z" }),
      o("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
      })
    ], -1)
  ]), 8, _u);
}
const G1 = /* @__PURE__ */ x(bu, [["render", $u]]), wu = {
  name: "LuxLogoX",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 24
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 24
    }
  }
}, Cu = ["width", "height"];
function xu(e, t, a, n, s, r) {
  return f(), p("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: a.width,
    height: a.height,
    viewBox: "0 0 18 18",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "logo-x",
    role: "img",
    fill: "currentColor"
  }, t[0] || (t[0] = [
    o("title", {
      id: "logo-x",
      lang: "en"
    }, "PUL X", -1),
    o("g", null, [
      o("path", { d: "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" })
    ], -1)
  ]), 8, Cu);
}
const K1 = /* @__PURE__ */ x(wu, [["render", xu]]), Mu = {
  name: "LuxLogoGovDocs",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 32
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 32
    }
  }
}, Su = ["width", "height"];
function Du(e, t, a, n, s, r) {
  return f(), p("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: a.width,
    height: a.height,
    viewBox: "0 0 32 32",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "logo-gov-docs",
    role: "img",
    class: "lux-logo-gov-docs"
  }, t[0] || (t[0] = [
    Ct('<title id="logo-gov-docs" lang="en">Government Docs</title><g><path fill="#002C64" d="M15.1 30.2c-1.2-.1-1.9-.2-2.7-.4-2.8-.7-5.1-2.1-7.2-4.1-3-3-4.8-6.9-5.1-11.5-.1-.6-.1-3.4-.1-6.7V1.8h32v.4c.1.7.1 11 0 11.9-.3 3.1-.9 5.4-2.3 7.8-2.6 4.8-7.2 7.8-12.3 8.3-.8 0-1.7.1-2.3 0z"></path><path fill="#FFF" d="M17.2 29.5c1.8-.1 4.4-1 6-1.9 2.7-1.6 4.9-3.9 6.3-6.9.8-1.6 1.2-4 1.2-7 0-1.4 0-1.7-.2-2.6-.5-2.7-1.8-5.2-3.7-7-.4-.4-.5-.5-.5-.8 0-.5 0-.5-3.5-.5-2.7 0-3.2 0-3.4.1-.4.2-.5.7-.1.7s.7.1 1 .3c.4.3.7.3 1.2.1.5-.2.7-.2.9 0 .1.1.2.2.2.5 0 .4-.1.5-.7.5-.5 0-.9-.2-1.7-.7-.6-.4-.8-.4-2.2 0-1.1.3-1.2.4-1.3.6-.3.4-.3.8 0 1.6.2.4.3.8.3.9 0 .1.1.2.2.2.2 0 .2 0 .4-.2.2-.4.6-.4 1.1-.3.8.2 1.4.5 2.3 1.4.5.5 1.1 1.9 1.2 3.2.1.9.1 2.3-.1 3.1-.5 2-1.7 3.9-3.2 4.9-.3.2-1.2.7-1.6.8-.5.2-1.8.2-2.4.1-1.2-.3-2.7-1.3-3.6-2.5-.3-.4-.7-1.4-.8-2.2-.1-.7 0-1.9.1-2.4.4-1.4 1.6-2.7 3.2-3.5.9-.4 1.1-.7 1-1.3-.1-.4-.3-.7-.6-1l-.3-.2H.7v2.6l.3.2.3.2h8s-.2.2-.4.5c-1 1.8-1.3 3.8-.8 6 .2.8.9 2.2 1.6 3.2 1.1 1.4 2.8 2.5 4.4 2.8.8.2 2.1.2 3 .1l.5-.1-.3.4c-.5.7-1 2-1.2 3.5-.1.8-.5 1.8-.8 2.2-.1.2-.2.3-.2.4 0 0 .2.1.5.1h.7s.5 0 .9-.1z"></path><path fill="#FFF" d="M14 29.2c.3-.1.7-.5.9-.8.1-.2.2-.7.3-1.2.2-.9.5-1.7.9-2.6.1-.3.2-.5.2-.5h-.4c-.2 0-.7-.1-1-.1-.3-.1-.7-.1-.8-.1-.4.1-1.5 1.3-2.3 2.5-.4.6-1 1.1-1.8 1.4-.3 0-.5.2-.4.2.1.2 1.8.8 3.3 1.1.8.2.8.2 1.1.1zm-4.6-2.1c.8-.4 1.2-.8 1.6-1.5.5-.7.7-1 1.5-1.6.3-.2.5-.4.5-.4s-.2-.1-.3-.2c-.4-.2-1.1-.6-1.7-1-.4-.3-.8-.3-1.5-.1-.4.1-1.6.7-2.2 1.1-.9.6-1.5.8-2.1.8h-.5c0 .3.9 1.2 2.1 2 1.1.8 1.6 1.1 1.9 1.1.1.1.4 0 .7-.2zm-4-3.6c.1-.1.5-.3.8-.5 1.2-.8 2.4-1.3 3.2-1.4.3 0 .5-.1.5-.1s-1.8-2.3-2-2.6c-.4-.5-1.6-.5-2.6 0-.7.3-1.5.5-2.3.5-.5 0-.8 0-.9-.1-.2-.1-.2-.1-.2 0 0 .2 1.5 3.2 1.8 3.5.5.7 1.1 1 1.7.7zm-2.5-4.8c1.4-.3 3.1-.6 3.5-.7.3 0 .5 0 .7.1.1.1.2.1.3.1 0 0 0-.2-.1-.4s-.2-.8-.3-1.3c-.1-.5-.1-.9-.2-1 0-.1-.2-.2-.4-.3-.3-.2-.4-.2-2.6-.2-2.1 0-2.4-.1-2.6-.2-.2-.1-.3-.1-.4-.1l.4 3c.1.7.2.8.4 1 .3.1.6.2 1.3 0zm12.7-.4c.3-.3.8-.3 1.1 0 .1.1.2.1 1.6.1h1.5v-6.6h-1v-.6c0-.7 0-.7-.8-.5-.6.2-1.1.4-1.5.8l-.3.3-.3-.3c-.4-.4-.9-.7-1.5-.8-.8-.2-.7-.2-.8.5v.6h-1v6.5h3z"></path><path fill="#C30035" d="M13.2 15.3c0-2.5 0-2.6.1-2.6s.1 0 .1 2.2v2.2h.4c.2 0 .5.1.7.1.3.1 1.2.6 1.2.6h-2.6v-2.5zm3.4 2.4c.7-.4 1.1-.6 1.6-.6h.5v-4.4h.4v5.2h-2.8l.3-.2z"></path><path fill="#C30035" d="M15.6 16.8c-.3-.2-1-.5-1.2-.5h-.2v-4.6l.3.1c.4.1.9.4 1.1.6l.2.2v2.1c-.1 2.2-.1 2.2-.2 2.1zm1-2c0-1.9 0-2.2.1-2.3.2-.3.7-.6 1.1-.7l.3-.1v4.6h-.2c-.2 0-.8.3-1.1.5l-.2.1v-2.1z"></path><path fill="#FFF" d="M6.9 14.3c0-.3.2-1.4.3-1.8.1-.3.1-.4 0-.7-.2-.6-.1-.6-3.1-.6H1.5L1 11l-.5-.2v.6c.1 1.2.3 2.2.4 2.4.1.1.2.3.3.3.1.1.9.1 2.4.1 2.3 0 2.9.1 3.1.3.1.1.2 0 .2-.2z"></path></g>', 2)
  ]), 8, Su);
}
const X1 = /* @__PURE__ */ x(Mu, [["render", Du]]), ku = {
  name: "LuxLogoFriends",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 115
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 31
    }
  }
}, Lu = ["width", "height"];
function Iu(e, t, a, n, s, r) {
  return f(), p("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: a.width,
    height: a.height,
    viewBox: "0 0 115.7 31.1",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "logo-friends",
    role: "img",
    class: "lux-logo-friends"
  }, t[0] || (t[0] = [
    Ct('<title id="logo-friends" lang="en" data-v-a2d5b1e6>Friends of Princeton University Library</title><g data-v-a2d5b1e6><path d="M.5 27.1A3.54 3.54 0 0 0 4 30.6h107.7a3.54 3.54 0 0 0 3.5-3.5V4a3.54 3.54 0 0 0-3.5-3.5H4.1A3.54 3.54 0 0 0 .6 4v23.1z" data-v-a2d5b1e6></path><path d="M.5 27.1A3.54 3.54 0 0 0 4 30.6h107.7a3.54 3.54 0 0 0 3.5-3.5V4a3.54 3.54 0 0 0-3.5-3.5H4.1A3.54 3.54 0 0 0 .6 4v23.1z" stroke-miterlimit="10" stroke="#000" data-v-a2d5b1e6></path><path class="friends-b" d="M24.3 9.3a1.39 1.39 0 0 0-1.4-1.1v15.3a37 37 0 0 1-3.8-1.4 4.24 4.24 0 0 0-3.9.2 4.32 4.32 0 0 0-3.9-.2 37 37 0 0 1-3.8 1.4V8.1a1.38 1.38 0 0 0-1.3 1.1v15.5h18.1V9.3z" data-v-a2d5b1e6></path><path class="friends-b" d="M10.7 17.3a11 11 0 0 0 1.4 2.1l3.1-3 3.1 3c.5-.7 1-1.4 1.4-2.1L15.2 13zm11.1-9.2a4.68 4.68 0 0 1-1.7.2 5.46 5.46 0 0 1-4.8-2.7 5.72 5.72 0 0 1-4.8 2.7 9.85 9.85 0 0 1-1.7-.2 17.53 17.53 0 0 0 .3 4.6h12.5a23.63 23.63 0 0 0 .2-4.6" data-v-a2d5b1e6></path><path d="M40.82 12.85a.24.24 0 0 1-.15 0h-.28a9.76 9.76 0 0 0-.66-1.19 8.14 8.14 0 0 0-.62-.83 4.1 4.1 0 0 0-.56-.55 6.93 6.93 0 0 0-.49-.39 1.15 1.15 0 0 0-.71-.19h-3.59c-.2 0-.32 0-.35.06s0 .14 0 .3v6h1.52a3.19 3.19 0 0 0 .6-.12 2.21 2.21 0 0 0 .55-.23 1.19 1.19 0 0 0 .43-.37 1.82 1.82 0 0 0 .25-.46 3.3 3.3 0 0 0 .13-.52c0-.18.06-.34.08-.51s0-.29 0-.38h.45l.14.07v6.05a.49.49 0 0 1-.32.08h-.27c0-.07 0-.2-.06-.38s-.06-.39-.09-.63a1.9 1.9 0 0 0-.28-.77 2.77 2.77 0 0 0-.66-.72 1.54 1.54 0 0 0-.62-.25 5.14 5.14 0 0 0-1.15-.11 3.36 3.36 0 0 0-.63.06v.56a5.55 5.55 0 0 0 0 .65v4.13a2.45 2.45 0 0 0 .41.93 1.59 1.59 0 0 0 .52.45 2 2 0 0 0 .31.05h.5l.5.05a2.85 2.85 0 0 0 .37 0 .8.8 0 0 1 .06.3.49.49 0 0 1 0 .12.65.65 0 0 1 0 .15h-7.71a.48.48 0 0 1-.1-.27.5.5 0 0 1 .08-.27c.32 0 .68-.08 1.07-.15l.91-.15a2.55 2.55 0 0 0 .36-.76 7 7 0 0 0 .24-1.34v-9.43a5 5 0 0 0-.06-.73 1.73 1.73 0 0 0-.24-.66 3.86 3.86 0 0 0-.47-.58 1.43 1.43 0 0 0-.68-.17l-1-.1a.51.51 0 0 1-.07-.3v-.14l.07-.13H40.6l.07.14v.24l.19 3.28a.31.31 0 0 0-.04.11zm12.49 11.08a1.12 1.12 0 0 1-.05.27h-3a.41.41 0 0 1-.38-.18 1.14 1.14 0 0 1-.14-.45l-.16-.81c-.06-.29-.14-.57-.22-.85a8.11 8.11 0 0 0-.36-.81 3.26 3.26 0 0 0-.34-.62l-.57-.66a1.8 1.8 0 0 0-.76-.51 2.17 2.17 0 0 0-.69-.11h-1v2.86a1.7 1.7 0 0 0 .28 1.11 1 1 0 0 0 .5.36 3.31 3.31 0 0 0 .84.14.7.7 0 0 1 .13.3.12.12 0 0 1 0 .11.58.58 0 0 0-.07.14h-5.48a1 1 0 0 1-.05-.17.49.49 0 0 1 0-.12.34.34 0 0 1 0-.11 1.26 1.26 0 0 1 .05-.15h.38l.43-.06a2.11 2.11 0 0 0 .4-.11.65.65 0 0 0 .24-.12 1 1 0 0 0 .22-.38 3.9 3.9 0 0 0 .12-.46v-6.33a8 8 0 0 0-.09-.81 1 1 0 0 0-.47-.73 3.06 3.06 0 0 0-1.33-.3.76.76 0 0 1 0-.29v-.11l.06-.12h6.97a4 4 0 0 1 .88.14 2.54 2.54 0 0 1 1.48 1 2.7 2.7 0 0 1 .48 1.57 2.24 2.24 0 0 1-.67 1.62 3.56 3.56 0 0 1-2.25.86v.11a3 3 0 0 1 1 .31 2.74 2.74 0 0 1 .6.44 4.32 4.32 0 0 1 .51.65 8.53 8.53 0 0 1 .46.95l.32.81.33.89a1.45 1.45 0 0 0 .12.19.53.53 0 0 0 .19.15h.19l.33.05h.32a1 1 0 0 0 .21 0 .51.51 0 0 1 .04.34zm-3.89-7.5a2.82 2.82 0 0 0-.08-.68 1.45 1.45 0 0 0-.32-.58 1.49 1.49 0 0 0-.42-.41 1.51 1.51 0 0 0-.53-.24 3.53 3.53 0 0 0-.71-.11h-.94a1.53 1.53 0 0 0-.64.08.33.33 0 0 0-.12.3v3.78h1.57a4.85 4.85 0 0 0 .8-.08 1.67 1.67 0 0 0 .58-.29 1.62 1.62 0 0 0 .42-.48 2.48 2.48 0 0 0 .27-.62 2.57 2.57 0 0 0 .12-.67zm10.86 7.5a.54.54 0 0 1-.09.27h-5.52a.6.6 0 0 1-.05-.14.28.28 0 0 1 0-.09.8.8 0 0 1 .06-.3 7.23 7.23 0 0 0 1.13-.22.82.82 0 0 0 .53-.47 2.09 2.09 0 0 0 .07-.54c0-.31 0-.65.05-1s0-.72 0-1.05v-4.22c0-.26 0-.55-.06-.85a.74.74 0 0 0-.46-.71 5.86 5.86 0 0 0-1.24-.2.88.88 0 0 1-.06-.29.23.23 0 0 1 0-.13.81.81 0 0 0 .08-.12h5.29a.43.43 0 0 1 .12.25 1 1 0 0 1-.06.29l-.93.14a.71.71 0 0 0-.6.43 1.1 1.1 0 0 0-.07.31v6.33a7.46 7.46 0 0 0 .09 1.21.81.81 0 0 0 .56.72 2.06 2.06 0 0 0 .5.06h.6l.05.13.01.19zm12.39.28a1.4 1.4 0 0 1-.42.05h-9.97a.53.53 0 0 1-.06-.23v-.15a.28.28 0 0 1 0-.15 6.51 6.51 0 0 0 1-.13 1.22 1.22 0 0 0 .53-.2 1.14 1.14 0 0 0 .22-.53 6.77 6.77 0 0 0 .11-1.07v-6.12a1.66 1.66 0 0 0-.11-.67 1 1 0 0 0-.33-.36 1.32 1.32 0 0 0-.53-.16l-.77-.09a.83.83 0 0 1-.06-.27.5.5 0 0 1 0-.14.26.26 0 0 1 .07-.13h8.97a.82.82 0 0 1 .27 0c.06 0 .09.09.09.2l.32 2.43-.14.07h-.38a7.4 7.4 0 0 0-.46-.73 4.22 4.22 0 0 0-.39-.47 3.46 3.46 0 0 0-.35-.33l-.37-.28a1.85 1.85 0 0 0-.91-.27h-2.28a1.14 1.14 0 0 0-.35 0h-.11v.36a2.2 2.2 0 0 1 0 .23v3.21h1.03a1.82 1.82 0 0 0 .5-.1 1.87 1.87 0 0 0 .61-.28 1.52 1.52 0 0 0 .46-.45 1.21 1.21 0 0 0 .13-.42c0-.21.08-.36.1-.46a.82.82 0 0 1 .34-.07.34.34 0 0 1 .27.09c0 .21 0 .51-.06.89s0 .83 0 1.33v2.08l-.14.07h-.15a1.92 1.92 0 0 1-.3 0 4.89 4.89 0 0 0-.25-1.13 1.21 1.21 0 0 0-.73-.68 3.16 3.16 0 0 0-.59-.17 3.48 3.48 0 0 0-.57 0h-.69v2.73a4 4 0 0 0 .12 1.22 1.69 1.69 0 0 0 .24.35.68.68 0 0 0 .39.24h3.11a1 1 0 0 0 .49-.14 2 2 0 0 0 .37-.31c.16-.16.32-.34.49-.54a7 7 0 0 0 .47-.66 3.89 3.89 0 0 0 .35-.71l.16-.06h.15a.52.52 0 0 1 .29.09V24c-.06.09-.1.18-.18.21zM87.24 14.1a.45.45 0 0 1 0 .11.34.34 0 0 1 0 .14 2.39 2.39 0 0 0-.76.15 1.74 1.74 0 0 0-.63.39 1.85 1.85 0 0 0-.43.7 3.32 3.32 0 0 0-.15 1.07v7.67a1 1 0 0 1-.23.12.63.63 0 0 1-.19 0 .68.68 0 0 1-.27-.16l-7.35-7.92.08 1.63v3.44c0 .24 0 .46.06.65a1.77 1.77 0 0 0 .18.71 1.35 1.35 0 0 0 .35.4 1.7 1.7 0 0 0 .69.33c.27.06.51.11.72.14a.53.53 0 0 1 .06.23.89.89 0 0 1 0 .11l-.06.16h-4.58a.68.68 0 0 1 0-.23v-.11a1.16 1.16 0 0 1 .06-.16c.12 0 .27 0 .43-.08a2.54 2.54 0 0 0 .47-.14 4.32 4.32 0 0 0 .43-.22 1.87 1.87 0 0 0 .33-.28 1.53 1.53 0 0 0 .13-.54v-5.9a1.85 1.85 0 0 0-.35-1.13 2.71 2.71 0 0 1-.19-.21l-.34-.34a1.35 1.35 0 0 0-.54-.29l-.64-.23a.58.58 0 0 1 0-.14.44.44 0 0 1 0-.09.6.6 0 0 1 .06-.27h2.99a.78.78 0 0 1 .33.21L83.23 20l.66.76c.23.26.43.49.58.69v-5.46a2.65 2.65 0 0 0-.32-1.11.5.5 0 0 0-.26-.19 2.37 2.37 0 0 0-.45-.15 4.51 4.51 0 0 0-.53-.1l-.46-.09a.94.94 0 0 1-.06-.31.53.53 0 0 1 0-.23h4.81a.57.57 0 0 1 .04.29zm13.29 5.12a5.36 5.36 0 0 1-.22 1.51 4.55 4.55 0 0 1-.66 1.43 6 6 0 0 1-.91 1 3.62 3.62 0 0 1-1.07.64 6.47 6.47 0 0 1-1.33.34 12.2 12.2 0 0 1-1.69.1H88.8a.47.47 0 0 1-.07-.25v-.11a1.16 1.16 0 0 1 .06-.16 4.22 4.22 0 0 0 1.21-.18 1 1 0 0 0 .53-.43 2.84 2.84 0 0 0 .13-.41 4.08 4.08 0 0 0 .1-1.08v-4.86c0-.51 0-.85-.07-1a3.78 3.78 0 0 0-.06-.47.9.9 0 0 0-.21-.44 1.21 1.21 0 0 0-.52-.31 3 3 0 0 0-1-.13.83.83 0 0 1 0-.15.39.39 0 0 1 0-.14.51.51 0 0 1 .09-.25h3.61l1.09-.05h1a8 8 0 0 1 1.92.22 6.64 6.64 0 0 1 1.46.56 4 4 0 0 1 1.16.86 5.43 5.43 0 0 1 .81 1.15 5.86 5.86 0 0 1 .48 1.31 6.37 6.37 0 0 1 .01 1.3zm-2.26-.1a5.58 5.58 0 0 0-.39-2.2 3.72 3.72 0 0 0-1.27-1.56 4.76 4.76 0 0 0-1.36-.71 5.6 5.6 0 0 0-1.73-.24 2.36 2.36 0 0 0-.44 0l-.36.06v7.41a1.8 1.8 0 0 0 .28 1.25 1.79 1.79 0 0 0 .47.38 1.34 1.34 0 0 0 .6.12 4.8 4.8 0 0 0 1.74-.29 3.15 3.15 0 0 0 1.28-1 4.36 4.36 0 0 0 .91-1.42 5.07 5.07 0 0 0 .27-1.8zm12.53 2.22a2.87 2.87 0 0 1-.3 1.31 3 3 0 0 1-.81 1 3.34 3.34 0 0 1-1.16.63 4.36 4.36 0 0 1-1.4.22 4.25 4.25 0 0 1-1.31-.2 6 6 0 0 1-1.11-.43.53.53 0 0 0-.19-.06h-.18a.79.79 0 0 0-.32.1 3 3 0 0 0-.46.3.81.81 0 0 1-.37-.09.42.42 0 0 1-.24-.23 2.9 2.9 0 0 1 .09-.56 2.88 2.88 0 0 0 .1-.72v-1.33a2.66 2.66 0 0 1 0-.35.54.54 0 0 1 .46-.23h.17c0 .1.12.24.19.42l.25.57.26.58a2.84 2.84 0 0 0 .26.45 2.94 2.94 0 0 0 1.13.83 3.33 3.33 0 0 0 1.18.26 2.29 2.29 0 0 0 1.68-.5 2.13 2.13 0 0 0 .47-.62 1.56 1.56 0 0 0 .12-.64 1.48 1.48 0 0 0-.29-.95 1.92 1.92 0 0 0-.41-.4l-.69-.38a4.5 4.5 0 0 0-.51-.18l-.75-.24-.77-.25a2.82 2.82 0 0 1-.61-.25 4.17 4.17 0 0 1-.85-.49 5 5 0 0 1-.6-.54 2.26 2.26 0 0 1-.46-.93 3.8 3.8 0 0 1-.13-1 2.93 2.93 0 0 1 .23-1.16 2.68 2.68 0 0 1 .66-.93 3.26 3.26 0 0 1 1-.61 3.78 3.78 0 0 1 1.28-.22 6.78 6.78 0 0 1 1.21.12 2.79 2.79 0 0 1 1.27.6 3.84 3.84 0 0 1 .28-.3l.33-.29a.74.74 0 0 1 .38.09c.09.07.15.13.16.18s0 .33-.09.61a4.62 4.62 0 0 0-.07.82 3.1 3.1 0 0 0 0 .34l.06.47v.45a1.8 1.8 0 0 1 0 .27l-.17.1a.54.54 0 0 1-.22 0 .54.54 0 0 1-.19 0 4.66 4.66 0 0 1-.43-.92 4.9 4.9 0 0 0-.45-.89 2 2 0 0 0-.88-.69 3.1 3.1 0 0 0-1.18-.21 2.12 2.12 0 0 0-1.34.44 1.35 1.35 0 0 0-.55 1.11 1.22 1.22 0 0 0 .42 1 3.62 3.62 0 0 0 .86.54l.72.27c.26.1.54.19.85.29a13.82 13.82 0 0 1 1.66.63 3.17 3.17 0 0 1 1.31 1.14 3 3 0 0 1 .45 1.65z" stroke="#fff" stroke-width=".5" fill="#fff" stroke-miterlimit="10" data-v-a2d5b1e6></path></g>', 2)
  ]), 8, Lu);
}
const J1 = /* @__PURE__ */ x(ku, [["render", Iu], ["__scopeId", "data-v-a2d5b1e6"]]), Ou = {
  name: "LibraryContactInfoOld",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  components: {
    LuxLogoFacebook: G1,
    LuxLogoX: K1,
    LuxLogoGovDocs: X1,
    LuxLogoFriends: J1
  },
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
}, zu = { class: "icons" }, Au = { href: "http://www.facebook.com/PULibrary" }, Pu = { href: "https://x.com/PULibrary" }, Tu = { href: "https://libguides.princeton.edu/usgovdocs" }, Eu = { href: "https://fpul.princeton.edu/" };
function Yu(e, t, a, n, s, r) {
  const i = A("lux-logo-facebook"), l = A("lux-logo-x"), u = A("lux-logo-gov-docs"), c = A("lux-logo-friends");
  return f(), P(Q(a.type), { class: "lux-library-contact" }, {
    default: O(() => [
      t[0] || (t[0] = o("div", {
        itemscope: "",
        itemtype: "http://schema.org/Organization"
      }, [
        o("h2", { itemprop: "name" }, "Princeton University Library"),
        o("div", {
          itemscope: "",
          itemtype: "http://schema.org/PostalAddress"
        }, [
          o("span", { itemprop: "streetAddress" }, "One Washington Road"),
          he(),
          o("br"),
          o("span", { itemprop: "addressLocality" }, "Princeton"),
          he(", "),
          o("span", { itemprop: "addressRegion" }, "NJ"),
          o("span", { itemprop: "postalCode" }, "08544"),
          he(),
          o("span", { itemprop: "addressCountry" }, "USA")
        ]),
        o("span", { itemprop: "telephone" }, [
          o("a", { href: "tel:1-609-258-1470" }, "(609) 258-1470")
        ])
      ], -1)),
      o("ul", zu, [
        o("li", null, [
          o("a", Au, [
            D(i, {
              width: "24",
              height: "24"
            })
          ])
        ]),
        o("li", null, [
          o("a", Pu, [
            D(l, {
              width: "24",
              height: "24"
            })
          ])
        ]),
        o("li", null, [
          o("a", Tu, [
            D(u, {
              width: "24",
              height: "24"
            })
          ])
        ]),
        o("li", null, [
          o("a", Eu, [
            D(c, {
              width: "87",
              height: "24"
            })
          ])
        ])
      ])
    ]),
    _: 1,
    __: [0]
  });
}
const hr = /* @__PURE__ */ x(Ou, [["render", Yu], ["__scopeId", "data-v-2e74db5d"]]), Hu = {
  name: "LuxUniversityCopyright",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "span"
    },
    theme: {
      type: String,
      default: "dark"
    }
  }
};
function Vu(e, t, a, n, s, r) {
  return f(), P(Q(a.type), {
    class: z(["lux-copyright", a.theme])
  }, {
    default: O(() => [
      he(" © " + F((/* @__PURE__ */ new Date()).getFullYear()) + " The Trustees of Princeton University ", 1)
    ]),
    _: 1
  }, 8, ["class"]);
}
const Q1 = /* @__PURE__ */ x(Hu, [["render", Vu], ["__scopeId", "data-v-69740eed"]]), Nu = {
  name: "LuxUniversityCopyrightOld",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "span"
    }
  }
};
function Ru(e, t, a, n, s, r) {
  return f(), P(Q(a.type), { class: "lux-copyright" }, {
    default: O(() => [
      he(" © " + F((/* @__PURE__ */ new Date()).getFullYear()) + " The Trustees of Princeton University ", 1)
    ]),
    _: 1
  });
}
const Fu = /* @__PURE__ */ x(Nu, [["render", Ru], ["__scopeId", "data-v-59c3fc85"]]), Bu = {
  name: "LuxUniversityPrivacyNotice",
  status: "ready",
  release: "5.5.1",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "span"
    },
    theme: {
      type: String,
      default: "dark"
    }
  },
  components: {
    LuxHyperlink: Z1
  }
};
function Wu(e, t, a, n, s, r) {
  const i = A("LuxHyperlink");
  return f(), P(Q(a.type), {
    class: z(["lux-privacy-notice", a.theme])
  }, {
    default: O(() => [
      D(i, {
        href: "https://www.princeton.edu/privacy-notice",
        newTab: !0
      }, {
        default: O(() => t[0] || (t[0] = [
          he("Princeton University Privacy Notice")
        ])),
        _: 1,
        __: [0]
      })
    ]),
    _: 1
  }, 8, ["class"]);
}
const vr = /* @__PURE__ */ x(Bu, [["render", Wu], ["__scopeId", "data-v-4d74b6cf"]]);
var Ia = {
  expireTimes: "1d",
  path: "; path=/",
  domain: "",
  secure: !1,
  sameSite: "; SameSite=Lax"
}, ju = (
  /** @class */
  function() {
    function e() {
      this.current_default_config = Ia;
    }
    return e.prototype.config = function(t) {
      for (var a in this.current_default_config)
        this.current_default_config[a] = t[a] ? t[a] : Ia[a];
    }, e.prototype.get = function(t) {
      var a = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(t).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
      if (a && a.substring(0, 1) === "{" && a.substring(a.length - 1, a.length) === "}")
        try {
          a = JSON.parse(a);
        } catch {
          return a;
        }
      return a;
    }, e.prototype.set = function(t, a, n, s, r, i, l) {
      if (t) {
        if (/^(?:expires|max-age|path|domain|secure|SameSite)$/i.test(t))
          throw new Error('Cookie name illegality. Cannot be set to ["expires","max-age","path","domain","secure","SameSite"]	 current key name: ' + t);
      } else throw new Error("Cookie name is not found in the first argument.");
      a && a.constructor === Object && (a = JSON.stringify(a));
      var u = "";
      if (n == null && (n = this.current_default_config.expireTimes ? this.current_default_config.expireTimes : ""), n && n != 0)
        switch (n.constructor) {
          case Number:
            n === 1 / 0 || n === -1 ? u = "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : u = "; max-age=" + n;
            break;
          case String:
            if (/^(?:\d+(y|m|d|h|min|s))$/i.test(n)) {
              var c = n.replace(/^(\d+)(?:y|m|d|h|min|s)$/i, "$1");
              switch (n.replace(/^(?:\d+)(y|m|d|h|min|s)$/i, "$1").toLowerCase()) {
                // Frequency sorting
                case "m":
                  u = "; max-age=" + +c * 2592e3;
                  break;
                // 60 * 60 * 24 * 30
                case "d":
                  u = "; max-age=" + +c * 86400;
                  break;
                // 60 * 60 * 24
                case "h":
                  u = "; max-age=" + +c * 3600;
                  break;
                // 60 * 60
                case "min":
                  u = "; max-age=" + +c * 60;
                  break;
                // 60
                case "s":
                  u = "; max-age=" + c;
                  break;
                case "y":
                  u = "; max-age=" + +c * 31104e3;
                  break;
              }
            } else
              u = "; expires=" + n;
            break;
          case Date:
            u = "; expires=" + n.toUTCString();
            break;
        }
      return document.cookie = encodeURIComponent(t) + "=" + encodeURIComponent(a) + u + (r ? "; domain=" + r : this.current_default_config.domain ? this.current_default_config.domain : "") + (s ? "; path=" + s : this.current_default_config.path ? this.current_default_config.path : "; path=/") + (i == null ? this.current_default_config.secure ? "; Secure" : "" : i ? "; Secure" : "") + (l == null ? this.current_default_config.sameSite ? "; SameSute=" + this.current_default_config.sameSite : "" : l ? "; SameSite=" + l : ""), this;
    }, e.prototype.remove = function(t, a, n) {
      return !t || !this.isKey(t) ? !1 : (document.cookie = encodeURIComponent(t) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (n ? "; domain=" + n : this.current_default_config.domain ? this.current_default_config.domain : "") + (a ? "; path=" + a : this.current_default_config.path ? this.current_default_config.path : "; path=/") + "; SameSite=Lax", !0);
    }, e.prototype.isKey = function(t) {
      return new RegExp("(?:^|;\\s*)" + encodeURIComponent(t).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
    }, e.prototype.keys = function() {
      if (!document.cookie)
        return [];
      for (var t = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/), a = 0; a < t.length; a++)
        t[a] = decodeURIComponent(t[a]);
      return t;
    }, e;
  }()
), b1 = null;
function Uu() {
  b1 == null && (b1 = new ju());
  var e = a1(b1);
  return { cookies: e };
}
const qu = {
  name: "LuxBanner",
  status: "prototype",
  release: "2.16.3",
  type: "Element",
  metaInfo: {
    title: "Global alert message to user.",
    htmlAttrs: {
      lang: "en"
    }
  },
  setup() {
    const { cookies: e } = Uu();
    return { cookies: e };
  },
  data: function() {
    return {
      bannerMessage: "This is the announcement description.",
      show: !0
    };
  },
  computed: {
    isFullScreen() {
      return this.fullscreen === "true";
    }
  },
  props: {
    /**
     * Allows the banner to act as an overlay, near the top of the screen.
     */
    fullscreen: {
      type: Boolean,
      default: !1
    },
    /**
     * User can manually hide the notification.
     */
    dismissible: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    hideBanner() {
      this.show = !1, this.cookies.set("showBanner", !1);
    }
  },
  created: function() {
    this.cookies.isKey("showBanner") && (this.show = this.cookies.get("showBanner") === "true");
  }
}, Zu = {
  class: "lux-announcement open",
  role: "alert"
};
function Gu(e, t, a, n, s, r) {
  const i = A("lux-wrapper");
  return e.show ? (f(), p("div", {
    key: 0,
    class: z(["lux-banner", { "lux-banner-fullscreen": r.isFullScreen }])
  }, [
    o("div", Zu, [
      D(i, { maxWidth: "1125" }, {
        default: O(() => [
          a.dismissible ? (f(), p("button", {
            key: 0,
            type: "button",
            class: "lux-announcement__close",
            "data-dismiss": "alert",
            "aria-label": "Close",
            onClick: t[0] || (t[0] = (l) => r.hideBanner())
          }, t[1] || (t[1] = [
            o("span", { "aria-hidden": "true" }, "×", -1)
          ]))) : E("", !0),
          ie(e.$slots, "default", {}, () => [
            he(F(e.bannerMessage), 1)
          ])
        ]),
        _: 3
      })
    ])
  ], 2)) : E("", !0);
}
const Ku = /* @__PURE__ */ x(qu, [["render", Gu]]), Xu = {
  name: "LuxCard",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * Sets the id to reference this card with.
     */
    id: {
      type: String,
      default: ""
    },
    /**
     * Sets the URL linking to the card content
     */
    cardUrl: {
      type: String,
      default: ""
    },
    /**
     * Sets arbitrary card width. It's recommended to use size over this setting.
     */
    cardPixelWidth: {
      default: ""
    },
    /**
     * Sets the size of the card `small, medium, large, full-width`
     */
    size: {
      type: String,
      default: "medium"
      // validator: (value) => {
      //   return value.match(/(small|medium|large|full-width)/);
      // },
    },
    /**
     * Indicates whether the card is selected.
     */
    selected: {
      type: Boolean,
      default: !1
    },
    /**
     * Indicates whether the object a card represents has been altered from its persisted form.
     */
    edited: {
      type: Boolean,
      default: !1
    },
    /**
     * Indicates the user cannot interact with the card.
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Indicates the user cannot interact with the card.
     */
    cardTitle: {
      type: String,
      default: ""
    }
  },
  methods: {
    select: function(e) {
      this.$emit("card-click", e);
    }
  }
}, Ju = ["id"];
function Qu(e, t, a, n, s, r) {
  return f(), p("article", {
    id: a.id,
    onClickCapture: t[0] || (t[0] = (i) => r.select(i)),
    class: z(["lux-card", [
      a.size,
      { "lux-card-selected": a.selected },
      { "lux-card-edited": a.edited },
      { "lux-card-disabled": a.disabled }
    ]]),
    style: e0({ "max-width": a.cardPixelWidth + "px" })
  }, [
    ie(e.$slots, "default")
  ], 46, Ju);
}
const ec = /* @__PURE__ */ x(Xu, [["render", Qu]]), tc = {
  name: "LuxDataTable",
  status: "ready",
  release: "3.1.4",
  type: "Element",
  data() {
    return {
      rows: this.jsonData,
      parsedColumns: []
    };
  },
  props: {
    /**
     * caption provides context for the data that is helpful to users, particularly those who use screenreaders.
     * `e.g. [name, title, age]`
     */
    caption: {
      required: !0,
      type: String
    },
    /**
     * summaryLabel provides context to the data values in tfoot element cells.
     */
    summaryLabel: {
      required: !1,
      type: String
    },
    /**
     * columns define the columns and order for which the data should be displayed.
     * Columns entries can be simple strings, or they may be more complicated objects
     * that can define `name`, `display_name`,`align`, `sortable`, and `checkbox` properties.
     * Sorting on `numeric` or `currency` values requires a column to have
     * a `datatype='number'` or `datatype='currency'` property.
     * Sorting on `date` values requires a column to have
     * a `datatype='date'` property.
     * Use `checkbox=true` to create a checkbox whose value is the value for that
     * column value for the row in the table.
     * `e.g. ['name', 'email', 'age']`
     */
    columns: {
      required: !0,
      type: Array
    },
    /**
     * jsonData is supplied via Array with an object representing each row.
     * Applying links to data cell content can be achieved by supplying an object
     * that contains a `value` and `link` property. Date sorting uses the JavaScript
     * `datestring` parameter. Shorthand dates are supported in most browsers, but can be implementation-specific.
     * (e.g., `{ value: 'content', link: 'https://url.com'}`)
     * See above example for exact structure.
     */
    jsonData: {
      required: !0,
      type: Array
    }
  },
  created: function() {
    let e = this.columns.map((a) => this.isObject(a) ? (a.name = a.name.toLowerCase(), a.sortable && typeof a.ascending > "u" && (a.ascending = null), a) : { name: a.toLowerCase(), ascending: null });
    this.parsedColumns = e;
    let t = this.jsonData.length;
    for (let a = 0; a < t; a++)
      for (let n in this.jsonData[a])
        this.jsonData[a].hasOwnProperty(n) && (this.isObject(this.jsonData[a][n]) || (this.jsonData[a][n] = { value: this.jsonData[a][n], link: null }));
    this.rows = this.jsonData;
  },
  computed: {
    footerColumns() {
      let e = this.columns;
      return e.shift(), e;
    }
  },
  methods: {
    getAriaLabel(e) {
      let t = [];
      for (const [a, n] of Object.entries(e))
        t.push(`${a}: ${n.value}`);
      return t.join(", ");
    },
    iconLabel(e) {
      if (e === !0)
        return "ascending";
      if (e === !1)
        return "descending";
      if (e === null)
        return "unsorted";
    },
    displayName(e) {
      return e.hasOwnProperty("display_name") ? e.display_name : e.name;
    },
    sortTable(e) {
      e.ascending ? e.datatype === "number" || e.datatype === "currency" ? this.rows.sort((t, a) => a[e.name].value - t[e.name].value) : e.datatype === "date" ? this.rows.sort((t, a) => new Date(a[e.name].value) - new Date(t[e.name].value)) : this.rows.sort(function(t, a) {
        let n = t[e.name.toLowerCase()].value.toString().toLowerCase(), s = a[e.name.toLowerCase()].value.toString().toLowerCase();
        return n < s ? 1 : n > s ? -1 : 0;
      }) : e.datatype === "number" || e.datatype === "currency" ? this.rows.sort((t, a) => t[e.name].value - a[e.name].value) : e.datatype === "date" ? this.rows.sort((t, a) => new Date(t[e.name].value) - new Date(a[e.name].value)) : this.rows.sort(function(t, a) {
        let n = t[e.name.toLowerCase()].value.toString().toLowerCase(), s = a[e.name.toLowerCase()].value.toString().toLowerCase();
        return n < s ? -1 : n > s ? 1 : 0;
      }), e.ascending = !e.ascending, this.parsedColumns = this.parsedColumns.map(function(t) {
        return e.name != t.name && (t.ascending = null), t;
      });
    },
    isObject(e) {
      return e && typeof e == "object" && e.constructor === Object;
    },
    isCurrency(e) {
      return e === "currency";
    },
    isNum(e) {
      return e === "number";
    },
    isLeft(e) {
      return e === "left";
    },
    isCenter(e) {
      return e === "center";
    },
    isRight(e) {
      return e === "right";
    }
  }
}, ac = {
  border: "1px",
  class: /* @__PURE__ */ z(["lux-data-table"])
}, nc = { key: 1 }, rc = ["id", "aria-label", "name", "value"], sc = { key: 2 }, oc = { key: 0 }, ic = { scope: "row" };
function lc(e, t, a, n, s, r) {
  const i = A("lux-icon-ascending"), l = A("lux-icon-descending"), u = A("lux-icon-unsorted"), c = A("lux-icon-base"), d = A("lux-input-button"), v = A("lux-hyperlink");
  return f(), p("table", ac, [
    o("caption", null, F(a.caption), 1),
    o("thead", null, [
      o("tr", null, [
        (f(!0), p(X, null, oe(s.parsedColumns, (y, m) => (f(), p("th", {
          scope: "col",
          key: m,
          nowrap: ""
        }, [
          y.sortable ? (f(), P(d, {
            key: 0,
            type: "button",
            onButtonClicked: (g) => r.sortTable(y),
            variation: "text"
          }, {
            default: O(() => [
              y.sortable ? (f(), P(c, {
                key: 0,
                width: "16",
                height: "16",
                "icon-name": r.iconLabel(y.ascending)
              }, {
                default: O(() => [
                  y.ascending ? (f(), P(i, { key: 0 })) : E("", !0),
                  y.ascending === !1 ? (f(), P(l, { key: 1 })) : E("", !0),
                  y.ascending === null ? (f(), P(u, { key: 2 })) : E("", !0)
                ]),
                _: 2
              }, 1032, ["icon-name"])) : E("", !0),
              he(" " + F(r.displayName(y)), 1)
            ]),
            _: 2
          }, 1032, ["onButtonClicked"])) : (f(), p("span", nc, F(r.displayName(y)), 1))
        ]))), 128))
      ])
    ]),
    o("tbody", null, [
      (f(!0), p(X, null, oe(s.rows, (y, m) => (f(), p("tr", {
        class: "row",
        key: m
      }, [
        (f(!0), p(X, null, oe(s.parsedColumns, (g, S) => (f(), p("td", {
          key: S,
          class: z([
            { "lux-data-table-left": r.isLeft(g.align) },
            { "lux-data-table-center": r.isCenter(g.align) },
            { "lux-data-table-right": r.isRight(g.align) },
            { "lux-data-table-number": r.isNum(g.datatype) },
            { "lux-data-table-currency": r.isCurrency(g.datatype) }
          ])
        }, [
          g.checkbox ? (f(), p("input", {
            key: 0,
            id: y[g.name].value,
            type: "checkbox",
            "aria-label": r.getAriaLabel(y),
            name: g.name,
            value: y[g.name].value
          }, null, 8, rc)) : y[g.name].link ? (f(), P(v, {
            key: 1,
            href: y[g.name].link
          }, {
            default: O(() => [
              he(F(y[g.name].value), 1)
            ]),
            _: 2
          }, 1032, ["href"])) : (f(), p("span", sc, F(y[g.name].value), 1))
        ], 2))), 128))
      ]))), 128))
    ]),
    a.summaryLabel ? (f(), p("tfoot", oc, [
      o("tr", null, [
        o("th", ic, F(a.summaryLabel), 1),
        (f(!0), p(X, null, oe(r.footerColumns, (y, m) => (f(), p("td", {
          key: m,
          class: z([
            { "lux-data-table-left": r.isLeft(y.align) },
            { "lux-data-table-center": r.isCenter(y.align) },
            { "lux-data-table-right": r.isRight(y.align) },
            { "lux-data-table-number": r.isNum(y.datatype) },
            { "lux-data-table-currency": r.isCurrency(y.datatype) }
          ])
        }, [
          o("span", null, F(y.summary_value), 1)
        ], 2))), 128))
      ])
    ])) : E("", !0)
  ]);
}
const uc = /* @__PURE__ */ x(tc, [["render", lc], ["__scopeId", "data-v-c372dd16"]]);
var ke = "top", He = "bottom", Ve = "right", Le = "left", ea = "auto", Dt = [ke, He, Ve, Le], B0 = "start", bt = "end", cc = "clippingParents", pr = "viewport", ut = "popper", dc = "reference", Oa = /* @__PURE__ */ Dt.reduce(function(e, t) {
  return e.concat([t + "-" + B0, t + "-" + bt]);
}, []), mr = /* @__PURE__ */ [].concat(Dt, [ea]).reduce(function(e, t) {
  return e.concat([t, t + "-" + B0, t + "-" + bt]);
}, []), fc = "beforeRead", hc = "read", vc = "afterRead", pc = "beforeMain", mc = "main", yc = "afterMain", gc = "beforeWrite", bc = "write", _c = "afterWrite", $c = [fc, hc, vc, pc, mc, yc, gc, bc, _c];
function Ge(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function ze(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function L0(e) {
  var t = ze(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ee(e) {
  var t = ze(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function ta(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = ze(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function wc(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(a) {
    var n = t.styles[a] || {}, s = t.attributes[a] || {}, r = t.elements[a];
    !Ee(r) || !Ge(r) || (Object.assign(r.style, n), Object.keys(s).forEach(function(i) {
      var l = s[i];
      l === !1 ? r.removeAttribute(i) : r.setAttribute(i, l === !0 ? "" : l);
    }));
  });
}
function Cc(e) {
  var t = e.state, a = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, a.popper), t.styles = a, t.elements.arrow && Object.assign(t.elements.arrow.style, a.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var s = t.elements[n], r = t.attributes[n] || {}, i = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : a[n]), l = i.reduce(function(u, c) {
        return u[c] = "", u;
      }, {});
      !Ee(s) || !Ge(s) || (Object.assign(s.style, l), Object.keys(r).forEach(function(u) {
        s.removeAttribute(u);
      }));
    });
  };
}
const xc = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: wc,
  effect: Cc,
  requires: ["computeStyles"]
};
function Ze(e) {
  return e.split("-")[0];
}
var D0 = Math.max, jt = Math.min, W0 = Math.round;
function z1() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function yr() {
  return !/^((?!chrome|android).)*safari/i.test(z1());
}
function j0(e, t, a) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  var n = e.getBoundingClientRect(), s = 1, r = 1;
  t && Ee(e) && (s = e.offsetWidth > 0 && W0(n.width) / e.offsetWidth || 1, r = e.offsetHeight > 0 && W0(n.height) / e.offsetHeight || 1);
  var i = L0(e) ? ze(e) : window, l = i.visualViewport, u = !yr() && a, c = (n.left + (u && l ? l.offsetLeft : 0)) / s, d = (n.top + (u && l ? l.offsetTop : 0)) / r, v = n.width / s, y = n.height / r;
  return {
    width: v,
    height: y,
    top: d,
    right: c + v,
    bottom: d + y,
    left: c,
    x: c,
    y: d
  };
}
function aa(e) {
  var t = j0(e), a = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - a) <= 1 && (a = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: a,
    height: n
  };
}
function gr(e, t) {
  var a = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (a && ta(a)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function t0(e) {
  return ze(e).getComputedStyle(e);
}
function Mc(e) {
  return ["table", "td", "th"].indexOf(Ge(e)) >= 0;
}
function b0(e) {
  return ((L0(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function r1(e) {
  return Ge(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ta(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    b0(e)
  );
}
function za(e) {
  return !Ee(e) || // https://github.com/popperjs/popper-core/issues/837
  t0(e).position === "fixed" ? null : e.offsetParent;
}
function Sc(e) {
  var t = /firefox/i.test(z1()), a = /Trident/i.test(z1());
  if (a && Ee(e)) {
    var n = t0(e);
    if (n.position === "fixed")
      return null;
  }
  var s = r1(e);
  for (ta(s) && (s = s.host); Ee(s) && ["html", "body"].indexOf(Ge(s)) < 0; ) {
    var r = t0(s);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || t && r.willChange === "filter" || t && r.filter && r.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function kt(e) {
  for (var t = ze(e), a = za(e); a && Mc(a) && t0(a).position === "static"; )
    a = za(a);
  return a && (Ge(a) === "html" || Ge(a) === "body" && t0(a).position === "static") ? t : a || Sc(e) || t;
}
function na(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function yt(e, t, a) {
  return D0(e, jt(t, a));
}
function Dc(e, t, a) {
  var n = yt(e, t, a);
  return n > a ? a : n;
}
function br() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function _r(e) {
  return Object.assign({}, br(), e);
}
function $r(e, t) {
  return t.reduce(function(a, n) {
    return a[n] = e, a;
  }, {});
}
var kc = function(t, a) {
  return t = typeof t == "function" ? t(Object.assign({}, a.rects, {
    placement: a.placement
  })) : t, _r(typeof t != "number" ? t : $r(t, Dt));
};
function Lc(e) {
  var t, a = e.state, n = e.name, s = e.options, r = a.elements.arrow, i = a.modifiersData.popperOffsets, l = Ze(a.placement), u = na(l), c = [Le, Ve].indexOf(l) >= 0, d = c ? "height" : "width";
  if (!(!r || !i)) {
    var v = kc(s.padding, a), y = aa(r), m = u === "y" ? ke : Le, g = u === "y" ? He : Ve, S = a.rects.reference[d] + a.rects.reference[u] - i[u] - a.rects.popper[d], $ = i[u] - a.rects.reference[u], b = kt(r), Y = b ? u === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, V = S / 2 - $ / 2, L = v[m], T = Y - y[d] - v[g], j = Y / 2 - y[d] / 2 + V, H = yt(L, j, T), U = u;
    a.modifiersData[n] = (t = {}, t[U] = H, t.centerOffset = H - j, t);
  }
}
function Ic(e) {
  var t = e.state, a = e.options, n = a.element, s = n === void 0 ? "[data-popper-arrow]" : n;
  s != null && (typeof s == "string" && (s = t.elements.popper.querySelector(s), !s) || gr(t.elements.popper, s) && (t.elements.arrow = s));
}
const Oc = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Lc,
  effect: Ic,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function U0(e) {
  return e.split("-")[1];
}
var zc = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ac(e, t) {
  var a = e.x, n = e.y, s = t.devicePixelRatio || 1;
  return {
    x: W0(a * s) / s || 0,
    y: W0(n * s) / s || 0
  };
}
function Aa(e) {
  var t, a = e.popper, n = e.popperRect, s = e.placement, r = e.variation, i = e.offsets, l = e.position, u = e.gpuAcceleration, c = e.adaptive, d = e.roundOffsets, v = e.isFixed, y = i.x, m = y === void 0 ? 0 : y, g = i.y, S = g === void 0 ? 0 : g, $ = typeof d == "function" ? d({
    x: m,
    y: S
  }) : {
    x: m,
    y: S
  };
  m = $.x, S = $.y;
  var b = i.hasOwnProperty("x"), Y = i.hasOwnProperty("y"), V = Le, L = ke, T = window;
  if (c) {
    var j = kt(a), H = "clientHeight", U = "clientWidth";
    if (j === ze(a) && (j = b0(a), t0(j).position !== "static" && l === "absolute" && (H = "scrollHeight", U = "scrollWidth")), j = j, s === ke || (s === Le || s === Ve) && r === bt) {
      L = He;
      var G = v && j === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        j[H]
      );
      S -= G - n.height, S *= u ? 1 : -1;
    }
    if (s === Le || (s === ke || s === He) && r === bt) {
      V = Ve;
      var K = v && j === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        j[U]
      );
      m -= K - n.width, m *= u ? 1 : -1;
    }
  }
  var J = Object.assign({
    position: l
  }, c && zc), N = d === !0 ? Ac({
    x: m,
    y: S
  }, ze(a)) : {
    x: m,
    y: S
  };
  if (m = N.x, S = N.y, u) {
    var q;
    return Object.assign({}, J, (q = {}, q[L] = Y ? "0" : "", q[V] = b ? "0" : "", q.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + S + "px)" : "translate3d(" + m + "px, " + S + "px, 0)", q));
  }
  return Object.assign({}, J, (t = {}, t[L] = Y ? S + "px" : "", t[V] = b ? m + "px" : "", t.transform = "", t));
}
function Pc(e) {
  var t = e.state, a = e.options, n = a.gpuAcceleration, s = n === void 0 ? !0 : n, r = a.adaptive, i = r === void 0 ? !0 : r, l = a.roundOffsets, u = l === void 0 ? !0 : l, c = {
    placement: Ze(t.placement),
    variation: U0(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: s,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Aa(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Aa(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Tc = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Pc,
  data: {}
};
var Tt = {
  passive: !0
};
function Ec(e) {
  var t = e.state, a = e.instance, n = e.options, s = n.scroll, r = s === void 0 ? !0 : s, i = n.resize, l = i === void 0 ? !0 : i, u = ze(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return r && c.forEach(function(d) {
    d.addEventListener("scroll", a.update, Tt);
  }), l && u.addEventListener("resize", a.update, Tt), function() {
    r && c.forEach(function(d) {
      d.removeEventListener("scroll", a.update, Tt);
    }), l && u.removeEventListener("resize", a.update, Tt);
  };
}
const Yc = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Ec,
  data: {}
};
var Hc = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Nt(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Hc[t];
  });
}
var Vc = {
  start: "end",
  end: "start"
};
function Pa(e) {
  return e.replace(/start|end/g, function(t) {
    return Vc[t];
  });
}
function ra(e) {
  var t = ze(e), a = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: a,
    scrollTop: n
  };
}
function sa(e) {
  return j0(b0(e)).left + ra(e).scrollLeft;
}
function Nc(e, t) {
  var a = ze(e), n = b0(e), s = a.visualViewport, r = n.clientWidth, i = n.clientHeight, l = 0, u = 0;
  if (s) {
    r = s.width, i = s.height;
    var c = yr();
    (c || !c && t === "fixed") && (l = s.offsetLeft, u = s.offsetTop);
  }
  return {
    width: r,
    height: i,
    x: l + sa(e),
    y: u
  };
}
function Rc(e) {
  var t, a = b0(e), n = ra(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, r = D0(a.scrollWidth, a.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), i = D0(a.scrollHeight, a.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), l = -n.scrollLeft + sa(e), u = -n.scrollTop;
  return t0(s || a).direction === "rtl" && (l += D0(a.clientWidth, s ? s.clientWidth : 0) - r), {
    width: r,
    height: i,
    x: l,
    y: u
  };
}
function oa(e) {
  var t = t0(e), a = t.overflow, n = t.overflowX, s = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(a + s + n);
}
function wr(e) {
  return ["html", "body", "#document"].indexOf(Ge(e)) >= 0 ? e.ownerDocument.body : Ee(e) && oa(e) ? e : wr(r1(e));
}
function gt(e, t) {
  var a;
  t === void 0 && (t = []);
  var n = wr(e), s = n === ((a = e.ownerDocument) == null ? void 0 : a.body), r = ze(n), i = s ? [r].concat(r.visualViewport || [], oa(n) ? n : []) : n, l = t.concat(i);
  return s ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(gt(r1(i)))
  );
}
function A1(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Fc(e, t) {
  var a = j0(e, !1, t === "fixed");
  return a.top = a.top + e.clientTop, a.left = a.left + e.clientLeft, a.bottom = a.top + e.clientHeight, a.right = a.left + e.clientWidth, a.width = e.clientWidth, a.height = e.clientHeight, a.x = a.left, a.y = a.top, a;
}
function Ta(e, t, a) {
  return t === pr ? A1(Nc(e, a)) : L0(t) ? Fc(t, a) : A1(Rc(b0(e)));
}
function Bc(e) {
  var t = gt(r1(e)), a = ["absolute", "fixed"].indexOf(t0(e).position) >= 0, n = a && Ee(e) ? kt(e) : e;
  return L0(n) ? t.filter(function(s) {
    return L0(s) && gr(s, n) && Ge(s) !== "body";
  }) : [];
}
function Wc(e, t, a, n) {
  var s = t === "clippingParents" ? Bc(e) : [].concat(t), r = [].concat(s, [a]), i = r[0], l = r.reduce(function(u, c) {
    var d = Ta(e, c, n);
    return u.top = D0(d.top, u.top), u.right = jt(d.right, u.right), u.bottom = jt(d.bottom, u.bottom), u.left = D0(d.left, u.left), u;
  }, Ta(e, i, n));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function Cr(e) {
  var t = e.reference, a = e.element, n = e.placement, s = n ? Ze(n) : null, r = n ? U0(n) : null, i = t.x + t.width / 2 - a.width / 2, l = t.y + t.height / 2 - a.height / 2, u;
  switch (s) {
    case ke:
      u = {
        x: i,
        y: t.y - a.height
      };
      break;
    case He:
      u = {
        x: i,
        y: t.y + t.height
      };
      break;
    case Ve:
      u = {
        x: t.x + t.width,
        y: l
      };
      break;
    case Le:
      u = {
        x: t.x - a.width,
        y: l
      };
      break;
    default:
      u = {
        x: t.x,
        y: t.y
      };
  }
  var c = s ? na(s) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (r) {
      case B0:
        u[c] = u[c] - (t[d] / 2 - a[d] / 2);
        break;
      case bt:
        u[c] = u[c] + (t[d] / 2 - a[d] / 2);
        break;
    }
  }
  return u;
}
function _t(e, t) {
  t === void 0 && (t = {});
  var a = t, n = a.placement, s = n === void 0 ? e.placement : n, r = a.strategy, i = r === void 0 ? e.strategy : r, l = a.boundary, u = l === void 0 ? cc : l, c = a.rootBoundary, d = c === void 0 ? pr : c, v = a.elementContext, y = v === void 0 ? ut : v, m = a.altBoundary, g = m === void 0 ? !1 : m, S = a.padding, $ = S === void 0 ? 0 : S, b = _r(typeof $ != "number" ? $ : $r($, Dt)), Y = y === ut ? dc : ut, V = e.rects.popper, L = e.elements[g ? Y : y], T = Wc(L0(L) ? L : L.contextElement || b0(e.elements.popper), u, d, i), j = j0(e.elements.reference), H = Cr({
    reference: j,
    element: V,
    placement: s
  }), U = A1(Object.assign({}, V, H)), G = y === ut ? U : j, K = {
    top: T.top - G.top + b.top,
    bottom: G.bottom - T.bottom + b.bottom,
    left: T.left - G.left + b.left,
    right: G.right - T.right + b.right
  }, J = e.modifiersData.offset;
  if (y === ut && J) {
    var N = J[s];
    Object.keys(K).forEach(function(q) {
      var ae = [Ve, He].indexOf(q) >= 0 ? 1 : -1, W = [ke, He].indexOf(q) >= 0 ? "y" : "x";
      K[q] += N[W] * ae;
    });
  }
  return K;
}
function jc(e, t) {
  t === void 0 && (t = {});
  var a = t, n = a.placement, s = a.boundary, r = a.rootBoundary, i = a.padding, l = a.flipVariations, u = a.allowedAutoPlacements, c = u === void 0 ? mr : u, d = U0(n), v = d ? l ? Oa : Oa.filter(function(g) {
    return U0(g) === d;
  }) : Dt, y = v.filter(function(g) {
    return c.indexOf(g) >= 0;
  });
  y.length === 0 && (y = v);
  var m = y.reduce(function(g, S) {
    return g[S] = _t(e, {
      placement: S,
      boundary: s,
      rootBoundary: r,
      padding: i
    })[Ze(S)], g;
  }, {});
  return Object.keys(m).sort(function(g, S) {
    return m[g] - m[S];
  });
}
function Uc(e) {
  if (Ze(e) === ea)
    return [];
  var t = Nt(e);
  return [Pa(e), t, Pa(t)];
}
function qc(e) {
  var t = e.state, a = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var s = a.mainAxis, r = s === void 0 ? !0 : s, i = a.altAxis, l = i === void 0 ? !0 : i, u = a.fallbackPlacements, c = a.padding, d = a.boundary, v = a.rootBoundary, y = a.altBoundary, m = a.flipVariations, g = m === void 0 ? !0 : m, S = a.allowedAutoPlacements, $ = t.options.placement, b = Ze($), Y = b === $, V = u || (Y || !g ? [Nt($)] : Uc($)), L = [$].concat(V).reduce(function(ne, pe) {
      return ne.concat(Ze(pe) === ea ? jc(t, {
        placement: pe,
        boundary: d,
        rootBoundary: v,
        padding: c,
        flipVariations: g,
        allowedAutoPlacements: S
      }) : pe);
    }, []), T = t.rects.reference, j = t.rects.popper, H = /* @__PURE__ */ new Map(), U = !0, G = L[0], K = 0; K < L.length; K++) {
      var J = L[K], N = Ze(J), q = U0(J) === B0, ae = [ke, He].indexOf(N) >= 0, W = ae ? "width" : "height", te = _t(t, {
        placement: J,
        boundary: d,
        rootBoundary: v,
        altBoundary: y,
        padding: c
      }), le = ae ? q ? Ve : Le : q ? He : ke;
      T[W] > j[W] && (le = Nt(le));
      var ye = Nt(le), de = [];
      if (r && de.push(te[N] <= 0), l && de.push(te[le] <= 0, te[ye] <= 0), de.every(function(ne) {
        return ne;
      })) {
        G = J, U = !1;
        break;
      }
      H.set(J, de);
    }
    if (U)
      for (var k = g ? 3 : 1, ee = function(pe) {
        var ge = L.find(function(me) {
          var be = H.get(me);
          if (be)
            return be.slice(0, pe).every(function(Ie) {
              return Ie;
            });
        });
        if (ge)
          return G = ge, "break";
      }, B = k; B > 0; B--) {
        var ve = ee(B);
        if (ve === "break") break;
      }
    t.placement !== G && (t.modifiersData[n]._skip = !0, t.placement = G, t.reset = !0);
  }
}
const Zc = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: qc,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ea(e, t, a) {
  return a === void 0 && (a = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - a.y,
    right: e.right - t.width + a.x,
    bottom: e.bottom - t.height + a.y,
    left: e.left - t.width - a.x
  };
}
function Ya(e) {
  return [ke, Ve, He, Le].some(function(t) {
    return e[t] >= 0;
  });
}
function Gc(e) {
  var t = e.state, a = e.name, n = t.rects.reference, s = t.rects.popper, r = t.modifiersData.preventOverflow, i = _t(t, {
    elementContext: "reference"
  }), l = _t(t, {
    altBoundary: !0
  }), u = Ea(i, n), c = Ea(l, s, r), d = Ya(u), v = Ya(c);
  t.modifiersData[a] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: c,
    isReferenceHidden: d,
    hasPopperEscaped: v
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": v
  });
}
const Kc = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Gc
};
function Xc(e, t, a) {
  var n = Ze(e), s = [Le, ke].indexOf(n) >= 0 ? -1 : 1, r = typeof a == "function" ? a(Object.assign({}, t, {
    placement: e
  })) : a, i = r[0], l = r[1];
  return i = i || 0, l = (l || 0) * s, [Le, Ve].indexOf(n) >= 0 ? {
    x: l,
    y: i
  } : {
    x: i,
    y: l
  };
}
function Jc(e) {
  var t = e.state, a = e.options, n = e.name, s = a.offset, r = s === void 0 ? [0, 0] : s, i = mr.reduce(function(d, v) {
    return d[v] = Xc(v, t.rects, r), d;
  }, {}), l = i[t.placement], u = l.x, c = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += c), t.modifiersData[n] = i;
}
const Qc = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Jc
};
function e5(e) {
  var t = e.state, a = e.name;
  t.modifiersData[a] = Cr({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const t5 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: e5,
  data: {}
};
function a5(e) {
  return e === "x" ? "y" : "x";
}
function n5(e) {
  var t = e.state, a = e.options, n = e.name, s = a.mainAxis, r = s === void 0 ? !0 : s, i = a.altAxis, l = i === void 0 ? !1 : i, u = a.boundary, c = a.rootBoundary, d = a.altBoundary, v = a.padding, y = a.tether, m = y === void 0 ? !0 : y, g = a.tetherOffset, S = g === void 0 ? 0 : g, $ = _t(t, {
    boundary: u,
    rootBoundary: c,
    padding: v,
    altBoundary: d
  }), b = Ze(t.placement), Y = U0(t.placement), V = !Y, L = na(b), T = a5(L), j = t.modifiersData.popperOffsets, H = t.rects.reference, U = t.rects.popper, G = typeof S == "function" ? S(Object.assign({}, t.rects, {
    placement: t.placement
  })) : S, K = typeof G == "number" ? {
    mainAxis: G,
    altAxis: G
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, G), J = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, N = {
    x: 0,
    y: 0
  };
  if (j) {
    if (r) {
      var q, ae = L === "y" ? ke : Le, W = L === "y" ? He : Ve, te = L === "y" ? "height" : "width", le = j[L], ye = le + $[ae], de = le - $[W], k = m ? -U[te] / 2 : 0, ee = Y === B0 ? H[te] : U[te], B = Y === B0 ? -U[te] : -H[te], ve = t.elements.arrow, ne = m && ve ? aa(ve) : {
        width: 0,
        height: 0
      }, pe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : br(), ge = pe[ae], me = pe[W], be = yt(0, H[te], ne[te]), Ie = V ? H[te] / 2 - k - be - ge - K.mainAxis : ee - be - ge - K.mainAxis, Je = V ? -H[te] / 2 + k + be + me + K.mainAxis : B + be + me + K.mainAxis, Ne = t.elements.arrow && kt(t.elements.arrow), Ae = Ne ? L === "y" ? Ne.clientTop || 0 : Ne.clientLeft || 0 : 0, Pe = (q = J == null ? void 0 : J[L]) != null ? q : 0, o0 = le + Ie - Pe - Ae, P0 = le + Je - Pe, je = yt(m ? jt(ye, o0) : ye, le, m ? D0(de, P0) : de);
      j[L] = je, N[L] = je - le;
    }
    if (l) {
      var $0, w0 = L === "x" ? ke : Le, C0 = L === "x" ? He : Ve, Re = j[T], i0 = T === "y" ? "height" : "width", l0 = Re + $[w0], u0 = Re - $[C0], c0 = [ke, Le].indexOf(b) !== -1, d0 = ($0 = J == null ? void 0 : J[T]) != null ? $0 : 0, f0 = c0 ? l0 : Re - H[i0] - U[i0] - d0 + K.altAxis, x0 = c0 ? Re + H[i0] + U[i0] - d0 - K.altAxis : u0, T0 = m && c0 ? Dc(f0, Re, x0) : yt(m ? f0 : l0, Re, m ? x0 : u0);
      j[T] = T0, N[T] = T0 - Re;
    }
    t.modifiersData[n] = N;
  }
}
const r5 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: n5,
  requiresIfExists: ["offset"]
};
function s5(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function o5(e) {
  return e === ze(e) || !Ee(e) ? ra(e) : s5(e);
}
function i5(e) {
  var t = e.getBoundingClientRect(), a = W0(t.width) / e.offsetWidth || 1, n = W0(t.height) / e.offsetHeight || 1;
  return a !== 1 || n !== 1;
}
function l5(e, t, a) {
  a === void 0 && (a = !1);
  var n = Ee(t), s = Ee(t) && i5(t), r = b0(t), i = j0(e, s, a), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (n || !n && !a) && ((Ge(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  oa(r)) && (l = o5(t)), Ee(t) ? (u = j0(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : r && (u.x = sa(r))), {
    x: i.left + l.scrollLeft - u.x,
    y: i.top + l.scrollTop - u.y,
    width: i.width,
    height: i.height
  };
}
function u5(e) {
  var t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(r) {
    t.set(r.name, r);
  });
  function s(r) {
    a.add(r.name);
    var i = [].concat(r.requires || [], r.requiresIfExists || []);
    i.forEach(function(l) {
      if (!a.has(l)) {
        var u = t.get(l);
        u && s(u);
      }
    }), n.push(r);
  }
  return e.forEach(function(r) {
    a.has(r.name) || s(r);
  }), n;
}
function c5(e) {
  var t = u5(e);
  return $c.reduce(function(a, n) {
    return a.concat(t.filter(function(s) {
      return s.phase === n;
    }));
  }, []);
}
function d5(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(a) {
      Promise.resolve().then(function() {
        t = void 0, a(e());
      });
    })), t;
  };
}
function f5(e) {
  var t = e.reduce(function(a, n) {
    var s = a[n.name];
    return a[n.name] = s ? Object.assign({}, s, n, {
      options: Object.assign({}, s.options, n.options),
      data: Object.assign({}, s.data, n.data)
    }) : n, a;
  }, {});
  return Object.keys(t).map(function(a) {
    return t[a];
  });
}
var Ha = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Va() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function h5(e) {
  e === void 0 && (e = {});
  var t = e, a = t.defaultModifiers, n = a === void 0 ? [] : a, s = t.defaultOptions, r = s === void 0 ? Ha : s;
  return function(l, u, c) {
    c === void 0 && (c = r);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ha, r),
      modifiersData: {},
      elements: {
        reference: l,
        popper: u
      },
      attributes: {},
      styles: {}
    }, v = [], y = !1, m = {
      state: d,
      setOptions: function(b) {
        var Y = typeof b == "function" ? b(d.options) : b;
        S(), d.options = Object.assign({}, r, d.options, Y), d.scrollParents = {
          reference: L0(l) ? gt(l) : l.contextElement ? gt(l.contextElement) : [],
          popper: gt(u)
        };
        var V = c5(f5([].concat(n, d.options.modifiers)));
        return d.orderedModifiers = V.filter(function(L) {
          return L.enabled;
        }), g(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!y) {
          var b = d.elements, Y = b.reference, V = b.popper;
          if (Va(Y, V)) {
            d.rects = {
              reference: l5(Y, kt(V), d.options.strategy === "fixed"),
              popper: aa(V)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(K) {
              return d.modifiersData[K.name] = Object.assign({}, K.data);
            });
            for (var L = 0; L < d.orderedModifiers.length; L++) {
              if (d.reset === !0) {
                d.reset = !1, L = -1;
                continue;
              }
              var T = d.orderedModifiers[L], j = T.fn, H = T.options, U = H === void 0 ? {} : H, G = T.name;
              typeof j == "function" && (d = j({
                state: d,
                options: U,
                name: G,
                instance: m
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: d5(function() {
        return new Promise(function($) {
          m.forceUpdate(), $(d);
        });
      }),
      destroy: function() {
        S(), y = !0;
      }
    };
    if (!Va(l, u))
      return m;
    m.setOptions(c).then(function($) {
      !y && c.onFirstUpdate && c.onFirstUpdate($);
    });
    function g() {
      d.orderedModifiers.forEach(function($) {
        var b = $.name, Y = $.options, V = Y === void 0 ? {} : Y, L = $.effect;
        if (typeof L == "function") {
          var T = L({
            state: d,
            name: b,
            instance: m,
            options: V
          }), j = function() {
          };
          v.push(T || j);
        }
      });
    }
    function S() {
      v.forEach(function($) {
        return $();
      }), v = [];
    }
    return m;
  };
}
var v5 = [Yc, t5, Tc, xc, Qc, Zc, r5, Oc, Kc], p5 = /* @__PURE__ */ h5({
  defaultModifiers: v5
}), m5 = Object.defineProperty, y5 = (e, t, a) => t in e ? m5(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, R = (e, t, a) => (y5(e, typeof t != "symbol" ? t + "" : t, a), a), Et = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var g5 = Object.prototype, b5 = g5.hasOwnProperty;
function _5(e, t) {
  return e != null && b5.call(e, t);
}
var $5 = _5, w5 = Array.isArray, Be = w5, C5 = typeof Et == "object" && Et && Et.Object === Object && Et, Mr = C5, x5 = Mr, M5 = typeof self == "object" && self && self.Object === Object && self, S5 = x5 || M5 || Function("return this")(), Ke = S5, D5 = Ke, k5 = D5.Symbol, s1 = k5, Na = s1, Sr = Object.prototype, L5 = Sr.hasOwnProperty, I5 = Sr.toString, ct = Na ? Na.toStringTag : void 0;
function O5(e) {
  var t = L5.call(e, ct), a = e[ct];
  try {
    e[ct] = void 0;
    var n = !0;
  } catch {
  }
  var s = I5.call(e);
  return n && (t ? e[ct] = a : delete e[ct]), s;
}
var z5 = O5, A5 = Object.prototype, P5 = A5.toString;
function T5(e) {
  return P5.call(e);
}
var E5 = T5, Ra = s1, Y5 = z5, H5 = E5, V5 = "[object Null]", N5 = "[object Undefined]", Fa = Ra ? Ra.toStringTag : void 0;
function R5(e) {
  return e == null ? e === void 0 ? N5 : V5 : Fa && Fa in Object(e) ? Y5(e) : H5(e);
}
var Xe = R5;
function F5(e) {
  return e != null && typeof e == "object";
}
var We = F5, B5 = Xe, W5 = We, j5 = "[object Symbol]";
function U5(e) {
  return typeof e == "symbol" || W5(e) && B5(e) == j5;
}
var ia = U5, q5 = Be, Z5 = ia, G5 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, K5 = /^\w*$/;
function X5(e, t) {
  if (q5(e))
    return !1;
  var a = typeof e;
  return a == "number" || a == "symbol" || a == "boolean" || e == null || Z5(e) ? !0 : K5.test(e) || !G5.test(e) || t != null && e in Object(t);
}
var la = X5;
function J5(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var r0 = J5, Q5 = Xe, e3 = r0, t3 = "[object AsyncFunction]", a3 = "[object Function]", n3 = "[object GeneratorFunction]", r3 = "[object Proxy]";
function s3(e) {
  if (!e3(e))
    return !1;
  var t = Q5(e);
  return t == a3 || t == n3 || t == t3 || t == r3;
}
var O0 = s3, o3 = Ke, i3 = o3["__core-js_shared__"], l3 = i3, _1 = l3, Ba = function() {
  var e = /[^.]+$/.exec(_1 && _1.keys && _1.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function u3(e) {
  return !!Ba && Ba in e;
}
var c3 = u3, d3 = Function.prototype, f3 = d3.toString;
function h3(e) {
  if (e != null) {
    try {
      return f3.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Dr = h3, v3 = O0, p3 = c3, m3 = r0, y3 = Dr, g3 = /[\\^$.*+?()[\]{}|]/g, b3 = /^\[object .+?Constructor\]$/, _3 = Function.prototype, $3 = Object.prototype, w3 = _3.toString, C3 = $3.hasOwnProperty, x3 = RegExp(
  "^" + w3.call(C3).replace(g3, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function M3(e) {
  if (!m3(e) || p3(e))
    return !1;
  var t = v3(e) ? x3 : b3;
  return t.test(y3(e));
}
var S3 = M3;
function D3(e, t) {
  return e == null ? void 0 : e[t];
}
var k3 = D3, L3 = S3, I3 = k3;
function O3(e, t) {
  var a = I3(e, t);
  return L3(a) ? a : void 0;
}
var z0 = O3, z3 = z0, A3 = z3(Object, "create"), o1 = A3, Wa = o1;
function P3() {
  this.__data__ = Wa ? Wa(null) : {}, this.size = 0;
}
var T3 = P3;
function E3(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Y3 = E3, H3 = o1, V3 = "__lodash_hash_undefined__", N3 = Object.prototype, R3 = N3.hasOwnProperty;
function F3(e) {
  var t = this.__data__;
  if (H3) {
    var a = t[e];
    return a === V3 ? void 0 : a;
  }
  return R3.call(t, e) ? t[e] : void 0;
}
var B3 = F3, W3 = o1, j3 = Object.prototype, U3 = j3.hasOwnProperty;
function q3(e) {
  var t = this.__data__;
  return W3 ? t[e] !== void 0 : U3.call(t, e);
}
var Z3 = q3, G3 = o1, K3 = "__lodash_hash_undefined__";
function X3(e, t) {
  var a = this.__data__;
  return this.size += this.has(e) ? 0 : 1, a[e] = G3 && t === void 0 ? K3 : t, this;
}
var J3 = X3, Q3 = T3, e4 = Y3, t4 = B3, a4 = Z3, n4 = J3;
function X0(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
X0.prototype.clear = Q3;
X0.prototype.delete = e4;
X0.prototype.get = t4;
X0.prototype.has = a4;
X0.prototype.set = n4;
var r4 = X0;
function s4() {
  this.__data__ = [], this.size = 0;
}
var o4 = s4;
function i4(e, t) {
  return e === t || e !== e && t !== t;
}
var J0 = i4, l4 = J0;
function u4(e, t) {
  for (var a = e.length; a--; )
    if (l4(e[a][0], t))
      return a;
  return -1;
}
var i1 = u4, c4 = i1, d4 = Array.prototype, f4 = d4.splice;
function h4(e) {
  var t = this.__data__, a = c4(t, e);
  if (a < 0)
    return !1;
  var n = t.length - 1;
  return a == n ? t.pop() : f4.call(t, a, 1), --this.size, !0;
}
var v4 = h4, p4 = i1;
function m4(e) {
  var t = this.__data__, a = p4(t, e);
  return a < 0 ? void 0 : t[a][1];
}
var y4 = m4, g4 = i1;
function b4(e) {
  return g4(this.__data__, e) > -1;
}
var _4 = b4, $4 = i1;
function w4(e, t) {
  var a = this.__data__, n = $4(a, e);
  return n < 0 ? (++this.size, a.push([e, t])) : a[n][1] = t, this;
}
var C4 = w4, x4 = o4, M4 = v4, S4 = y4, D4 = _4, k4 = C4;
function Q0(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Q0.prototype.clear = x4;
Q0.prototype.delete = M4;
Q0.prototype.get = S4;
Q0.prototype.has = D4;
Q0.prototype.set = k4;
var l1 = Q0, L4 = z0, I4 = Ke, O4 = L4(I4, "Map"), ua = O4, ja = r4, z4 = l1, A4 = ua;
function P4() {
  this.size = 0, this.__data__ = {
    hash: new ja(),
    map: new (A4 || z4)(),
    string: new ja()
  };
}
var T4 = P4;
function E4(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Y4 = E4, H4 = Y4;
function V4(e, t) {
  var a = e.__data__;
  return H4(t) ? a[typeof t == "string" ? "string" : "hash"] : a.map;
}
var u1 = V4, N4 = u1;
function R4(e) {
  var t = N4(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var F4 = R4, B4 = u1;
function W4(e) {
  return B4(this, e).get(e);
}
var j4 = W4, U4 = u1;
function q4(e) {
  return U4(this, e).has(e);
}
var Z4 = q4, G4 = u1;
function K4(e, t) {
  var a = G4(this, e), n = a.size;
  return a.set(e, t), this.size += a.size == n ? 0 : 1, this;
}
var X4 = K4, J4 = T4, Q4 = F4, ed = j4, td = Z4, ad = X4;
function et(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
et.prototype.clear = J4;
et.prototype.delete = Q4;
et.prototype.get = ed;
et.prototype.has = td;
et.prototype.set = ad;
var ca = et, kr = ca, nd = "Expected a function";
function da(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(nd);
  var a = function() {
    var n = arguments, s = t ? t.apply(this, n) : n[0], r = a.cache;
    if (r.has(s))
      return r.get(s);
    var i = e.apply(this, n);
    return a.cache = r.set(s, i) || r, i;
  };
  return a.cache = new (da.Cache || kr)(), a;
}
da.Cache = kr;
var rd = da, sd = rd, od = 500;
function id(e) {
  var t = sd(e, function(n) {
    return a.size === od && a.clear(), n;
  }), a = t.cache;
  return t;
}
var ld = id, ud = ld, cd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, dd = /\\(\\)?/g, fd = ud(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(cd, function(a, n, s, r) {
    t.push(s ? r.replace(dd, "$1") : n || a);
  }), t;
}), hd = fd;
function vd(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length, s = Array(n); ++a < n; )
    s[a] = t(e[a], a, e);
  return s;
}
var pd = vd, Ua = s1, md = pd, yd = Be, gd = ia, qa = Ua ? Ua.prototype : void 0, Za = qa ? qa.toString : void 0;
function Lr(e) {
  if (typeof e == "string")
    return e;
  if (yd(e))
    return md(e, Lr) + "";
  if (gd(e))
    return Za ? Za.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var bd = Lr, _d = bd;
function $d(e) {
  return e == null ? "" : _d(e);
}
var wd = $d, Cd = Be, xd = la, Md = hd, Sd = wd;
function Dd(e, t) {
  return Cd(e) ? e : xd(e, t) ? [e] : Md(Sd(e));
}
var Ir = Dd, kd = Xe, Ld = We, Id = "[object Arguments]";
function Od(e) {
  return Ld(e) && kd(e) == Id;
}
var zd = Od, Ga = zd, Ad = We, Or = Object.prototype, Pd = Or.hasOwnProperty, Td = Or.propertyIsEnumerable, Ed = Ga(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ga : function(e) {
  return Ad(e) && Pd.call(e, "callee") && !Td.call(e, "callee");
}, fa = Ed, Yd = 9007199254740991, Hd = /^(?:0|[1-9]\d*)$/;
function Vd(e, t) {
  var a = typeof e;
  return t = t ?? Yd, !!t && (a == "number" || a != "symbol" && Hd.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var ha = Vd, Nd = 9007199254740991;
function Rd(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Nd;
}
var va = Rd, Fd = ia;
function Bd(e) {
  if (typeof e == "string" || Fd(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var c1 = Bd, Wd = Ir, jd = fa, Ud = Be, qd = ha, Zd = va, Gd = c1;
function Kd(e, t, a) {
  t = Wd(t, e);
  for (var n = -1, s = t.length, r = !1; ++n < s; ) {
    var i = Gd(t[n]);
    if (!(r = e != null && a(e, i)))
      break;
    e = e[i];
  }
  return r || ++n != s ? r : (s = e == null ? 0 : e.length, !!s && Zd(s) && qd(i, s) && (Ud(e) || jd(e)));
}
var zr = Kd, Xd = $5, Jd = zr;
function Qd(e, t) {
  return e != null && Jd(e, t, Xd);
}
var Ar = Qd, e7 = Xe, t7 = We, a7 = "[object Date]";
function n7(e) {
  return t7(e) && e7(e) == a7;
}
var r7 = n7;
function s7(e) {
  return function(t) {
    return e(t);
  };
}
var Pr = s7, $t = {}, o7 = {
  get exports() {
    return $t;
  },
  set exports(e) {
    $t = e;
  }
};
(function(e, t) {
  var a = Mr, n = t && !t.nodeType && t, s = n && !0 && e && !e.nodeType && e, r = s && s.exports === n, i = r && a.process, l = function() {
    try {
      var u = s && s.require && s.require("util").types;
      return u || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = l;
})(o7, $t);
var i7 = r7, l7 = Pr, Ka = $t, Xa = Ka && Ka.isDate, u7 = Xa ? l7(Xa) : i7, c7 = u7, d7 = Xe, f7 = Be, h7 = We, v7 = "[object String]";
function p7(e) {
  return typeof e == "string" || !f7(e) && h7(e) && d7(e) == v7;
}
var Ue = p7;
function m7(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length; ++a < n; )
    if (t(e[a], a, e))
      return !0;
  return !1;
}
var Tr = m7, y7 = l1;
function g7() {
  this.__data__ = new y7(), this.size = 0;
}
var b7 = g7;
function _7(e) {
  var t = this.__data__, a = t.delete(e);
  return this.size = t.size, a;
}
var $7 = _7;
function w7(e) {
  return this.__data__.get(e);
}
var C7 = w7;
function x7(e) {
  return this.__data__.has(e);
}
var M7 = x7, S7 = l1, D7 = ua, k7 = ca, L7 = 200;
function I7(e, t) {
  var a = this.__data__;
  if (a instanceof S7) {
    var n = a.__data__;
    if (!D7 || n.length < L7 - 1)
      return n.push([e, t]), this.size = ++a.size, this;
    a = this.__data__ = new k7(n);
  }
  return a.set(e, t), this.size = a.size, this;
}
var O7 = I7, z7 = l1, A7 = b7, P7 = $7, T7 = C7, E7 = M7, Y7 = O7;
function tt(e) {
  var t = this.__data__ = new z7(e);
  this.size = t.size;
}
tt.prototype.clear = A7;
tt.prototype.delete = P7;
tt.prototype.get = T7;
tt.prototype.has = E7;
tt.prototype.set = Y7;
var pa = tt, H7 = "__lodash_hash_undefined__";
function V7(e) {
  return this.__data__.set(e, H7), this;
}
var N7 = V7;
function R7(e) {
  return this.__data__.has(e);
}
var F7 = R7, B7 = ca, W7 = N7, j7 = F7;
function Ut(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.__data__ = new B7(); ++t < a; )
    this.add(e[t]);
}
Ut.prototype.add = Ut.prototype.push = W7;
Ut.prototype.has = j7;
var U7 = Ut;
function q7(e, t) {
  return e.has(t);
}
var Z7 = q7, G7 = U7, K7 = Tr, X7 = Z7, J7 = 1, Q7 = 2;
function e6(e, t, a, n, s, r) {
  var i = a & J7, l = e.length, u = t.length;
  if (l != u && !(i && u > l))
    return !1;
  var c = r.get(e), d = r.get(t);
  if (c && d)
    return c == t && d == e;
  var v = -1, y = !0, m = a & Q7 ? new G7() : void 0;
  for (r.set(e, t), r.set(t, e); ++v < l; ) {
    var g = e[v], S = t[v];
    if (n)
      var $ = i ? n(S, g, v, t, e, r) : n(g, S, v, e, t, r);
    if ($ !== void 0) {
      if ($)
        continue;
      y = !1;
      break;
    }
    if (m) {
      if (!K7(t, function(b, Y) {
        if (!X7(m, Y) && (g === b || s(g, b, a, n, r)))
          return m.push(Y);
      })) {
        y = !1;
        break;
      }
    } else if (!(g === S || s(g, S, a, n, r))) {
      y = !1;
      break;
    }
  }
  return r.delete(e), r.delete(t), y;
}
var Er = e6, t6 = Ke, a6 = t6.Uint8Array, Yr = a6;
function n6(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(n, s) {
    a[++t] = [s, n];
  }), a;
}
var r6 = n6;
function s6(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(n) {
    a[++t] = n;
  }), a;
}
var o6 = s6, Ja = s1, Qa = Yr, i6 = J0, l6 = Er, u6 = r6, c6 = o6, d6 = 1, f6 = 2, h6 = "[object Boolean]", v6 = "[object Date]", p6 = "[object Error]", m6 = "[object Map]", y6 = "[object Number]", g6 = "[object RegExp]", b6 = "[object Set]", _6 = "[object String]", $6 = "[object Symbol]", w6 = "[object ArrayBuffer]", C6 = "[object DataView]", en = Ja ? Ja.prototype : void 0, $1 = en ? en.valueOf : void 0;
function x6(e, t, a, n, s, r, i) {
  switch (a) {
    case C6:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case w6:
      return !(e.byteLength != t.byteLength || !r(new Qa(e), new Qa(t)));
    case h6:
    case v6:
    case y6:
      return i6(+e, +t);
    case p6:
      return e.name == t.name && e.message == t.message;
    case g6:
    case _6:
      return e == t + "";
    case m6:
      var l = u6;
    case b6:
      var u = n & d6;
      if (l || (l = c6), e.size != t.size && !u)
        return !1;
      var c = i.get(e);
      if (c)
        return c == t;
      n |= f6, i.set(e, t);
      var d = l6(l(e), l(t), n, s, r, i);
      return i.delete(e), d;
    case $6:
      if ($1)
        return $1.call(e) == $1.call(t);
  }
  return !1;
}
var M6 = x6;
function S6(e, t) {
  for (var a = -1, n = t.length, s = e.length; ++a < n; )
    e[s + a] = t[a];
  return e;
}
var D6 = S6, k6 = D6, L6 = Be;
function I6(e, t, a) {
  var n = t(e);
  return L6(e) ? n : k6(n, a(e));
}
var O6 = I6;
function z6(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length, s = 0, r = []; ++a < n; ) {
    var i = e[a];
    t(i, a, e) && (r[s++] = i);
  }
  return r;
}
var A6 = z6;
function P6() {
  return [];
}
var T6 = P6, E6 = A6, Y6 = T6, H6 = Object.prototype, V6 = H6.propertyIsEnumerable, tn = Object.getOwnPropertySymbols, N6 = tn ? function(e) {
  return e == null ? [] : (e = Object(e), E6(tn(e), function(t) {
    return V6.call(e, t);
  }));
} : Y6, R6 = N6;
function F6(e, t) {
  for (var a = -1, n = Array(e); ++a < e; )
    n[a] = t(a);
  return n;
}
var B6 = F6, q0 = {}, W6 = {
  get exports() {
    return q0;
  },
  set exports(e) {
    q0 = e;
  }
};
function j6() {
  return !1;
}
var U6 = j6;
(function(e, t) {
  var a = Ke, n = U6, s = t && !t.nodeType && t, r = s && !0 && e && !e.nodeType && e, i = r && r.exports === s, l = i ? a.Buffer : void 0, u = l ? l.isBuffer : void 0, c = u || n;
  e.exports = c;
})(W6, q0);
var q6 = Xe, Z6 = va, G6 = We, K6 = "[object Arguments]", X6 = "[object Array]", J6 = "[object Boolean]", Q6 = "[object Date]", e8 = "[object Error]", t8 = "[object Function]", a8 = "[object Map]", n8 = "[object Number]", r8 = "[object Object]", s8 = "[object RegExp]", o8 = "[object Set]", i8 = "[object String]", l8 = "[object WeakMap]", u8 = "[object ArrayBuffer]", c8 = "[object DataView]", d8 = "[object Float32Array]", f8 = "[object Float64Array]", h8 = "[object Int8Array]", v8 = "[object Int16Array]", p8 = "[object Int32Array]", m8 = "[object Uint8Array]", y8 = "[object Uint8ClampedArray]", g8 = "[object Uint16Array]", b8 = "[object Uint32Array]", ce = {};
ce[d8] = ce[f8] = ce[h8] = ce[v8] = ce[p8] = ce[m8] = ce[y8] = ce[g8] = ce[b8] = !0;
ce[K6] = ce[X6] = ce[u8] = ce[J6] = ce[c8] = ce[Q6] = ce[e8] = ce[t8] = ce[a8] = ce[n8] = ce[r8] = ce[s8] = ce[o8] = ce[i8] = ce[l8] = !1;
function _8(e) {
  return G6(e) && Z6(e.length) && !!ce[q6(e)];
}
var $8 = _8, w8 = $8, C8 = Pr, an = $t, nn = an && an.isTypedArray, x8 = nn ? C8(nn) : w8, ma = x8, M8 = B6, S8 = fa, D8 = Be, k8 = q0, L8 = ha, I8 = ma, O8 = Object.prototype, z8 = O8.hasOwnProperty;
function A8(e, t) {
  var a = D8(e), n = !a && S8(e), s = !a && !n && k8(e), r = !a && !n && !s && I8(e), i = a || n || s || r, l = i ? M8(e.length, String) : [], u = l.length;
  for (var c in e)
    (t || z8.call(e, c)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    L8(c, u))) && l.push(c);
  return l;
}
var Hr = A8, P8 = Object.prototype;
function T8(e) {
  var t = e && e.constructor, a = typeof t == "function" && t.prototype || P8;
  return e === a;
}
var ya = T8;
function E8(e, t) {
  return function(a) {
    return e(t(a));
  };
}
var Vr = E8, Y8 = Vr, H8 = Y8(Object.keys, Object), V8 = H8, N8 = ya, R8 = V8, F8 = Object.prototype, B8 = F8.hasOwnProperty;
function W8(e) {
  if (!N8(e))
    return R8(e);
  var t = [];
  for (var a in Object(e))
    B8.call(e, a) && a != "constructor" && t.push(a);
  return t;
}
var j8 = W8, U8 = O0, q8 = va;
function Z8(e) {
  return e != null && q8(e.length) && !U8(e);
}
var Lt = Z8, G8 = Hr, K8 = j8, X8 = Lt;
function J8(e) {
  return X8(e) ? G8(e) : K8(e);
}
var ga = J8, Q8 = O6, ef = R6, tf = ga;
function af(e) {
  return Q8(e, tf, ef);
}
var nf = af, rn = nf, rf = 1, sf = Object.prototype, of = sf.hasOwnProperty;
function lf(e, t, a, n, s, r) {
  var i = a & rf, l = rn(e), u = l.length, c = rn(t), d = c.length;
  if (u != d && !i)
    return !1;
  for (var v = u; v--; ) {
    var y = l[v];
    if (!(i ? y in t : of.call(t, y)))
      return !1;
  }
  var m = r.get(e), g = r.get(t);
  if (m && g)
    return m == t && g == e;
  var S = !0;
  r.set(e, t), r.set(t, e);
  for (var $ = i; ++v < u; ) {
    y = l[v];
    var b = e[y], Y = t[y];
    if (n)
      var V = i ? n(Y, b, y, t, e, r) : n(b, Y, y, e, t, r);
    if (!(V === void 0 ? b === Y || s(b, Y, a, n, r) : V)) {
      S = !1;
      break;
    }
    $ || ($ = y == "constructor");
  }
  if (S && !$) {
    var L = e.constructor, T = t.constructor;
    L != T && "constructor" in e && "constructor" in t && !(typeof L == "function" && L instanceof L && typeof T == "function" && T instanceof T) && (S = !1);
  }
  return r.delete(e), r.delete(t), S;
}
var uf = lf, cf = z0, df = Ke, ff = cf(df, "DataView"), hf = ff, vf = z0, pf = Ke, mf = vf(pf, "Promise"), yf = mf, gf = z0, bf = Ke, _f = gf(bf, "Set"), $f = _f, wf = z0, Cf = Ke, xf = wf(Cf, "WeakMap"), Mf = xf, P1 = hf, T1 = ua, E1 = yf, Y1 = $f, H1 = Mf, Nr = Xe, at = Dr, sn = "[object Map]", Sf = "[object Object]", on = "[object Promise]", ln = "[object Set]", un = "[object WeakMap]", cn = "[object DataView]", Df = at(P1), kf = at(T1), Lf = at(E1), If = at(Y1), Of = at(H1), M0 = Nr;
(P1 && M0(new P1(new ArrayBuffer(1))) != cn || T1 && M0(new T1()) != sn || E1 && M0(E1.resolve()) != on || Y1 && M0(new Y1()) != ln || H1 && M0(new H1()) != un) && (M0 = function(e) {
  var t = Nr(e), a = t == Sf ? e.constructor : void 0, n = a ? at(a) : "";
  if (n)
    switch (n) {
      case Df:
        return cn;
      case kf:
        return sn;
      case Lf:
        return on;
      case If:
        return ln;
      case Of:
        return un;
    }
  return t;
});
var zf = M0, w1 = pa, Af = Er, Pf = M6, Tf = uf, dn = zf, fn = Be, hn = q0, Ef = ma, Yf = 1, vn = "[object Arguments]", pn = "[object Array]", Yt = "[object Object]", Hf = Object.prototype, mn = Hf.hasOwnProperty;
function Vf(e, t, a, n, s, r) {
  var i = fn(e), l = fn(t), u = i ? pn : dn(e), c = l ? pn : dn(t);
  u = u == vn ? Yt : u, c = c == vn ? Yt : c;
  var d = u == Yt, v = c == Yt, y = u == c;
  if (y && hn(e)) {
    if (!hn(t))
      return !1;
    i = !0, d = !1;
  }
  if (y && !d)
    return r || (r = new w1()), i || Ef(e) ? Af(e, t, a, n, s, r) : Pf(e, t, u, a, n, s, r);
  if (!(a & Yf)) {
    var m = d && mn.call(e, "__wrapped__"), g = v && mn.call(t, "__wrapped__");
    if (m || g) {
      var S = m ? e.value() : e, $ = g ? t.value() : t;
      return r || (r = new w1()), s(S, $, a, n, r);
    }
  }
  return y ? (r || (r = new w1()), Tf(e, t, a, n, s, r)) : !1;
}
var Nf = Vf, Rf = Nf, yn = We;
function Rr(e, t, a, n, s) {
  return e === t ? !0 : e == null || t == null || !yn(e) && !yn(t) ? e !== e && t !== t : Rf(e, t, a, n, Rr, s);
}
var Fr = Rr, Ff = pa, Bf = Fr, Wf = 1, jf = 2;
function Uf(e, t, a, n) {
  var s = a.length, r = s, i = !n;
  if (e == null)
    return !r;
  for (e = Object(e); s--; ) {
    var l = a[s];
    if (i && l[2] ? l[1] !== e[l[0]] : !(l[0] in e))
      return !1;
  }
  for (; ++s < r; ) {
    l = a[s];
    var u = l[0], c = e[u], d = l[1];
    if (i && l[2]) {
      if (c === void 0 && !(u in e))
        return !1;
    } else {
      var v = new Ff();
      if (n)
        var y = n(c, d, u, e, t, v);
      if (!(y === void 0 ? Bf(d, c, Wf | jf, n, v) : y))
        return !1;
    }
  }
  return !0;
}
var qf = Uf, Zf = r0;
function Gf(e) {
  return e === e && !Zf(e);
}
var Br = Gf, Kf = Br, Xf = ga;
function Jf(e) {
  for (var t = Xf(e), a = t.length; a--; ) {
    var n = t[a], s = e[n];
    t[a] = [n, s, Kf(s)];
  }
  return t;
}
var Qf = Jf;
function eh(e, t) {
  return function(a) {
    return a == null ? !1 : a[e] === t && (t !== void 0 || e in Object(a));
  };
}
var Wr = eh, th = qf, ah = Qf, nh = Wr;
function rh(e) {
  var t = ah(e);
  return t.length == 1 && t[0][2] ? nh(t[0][0], t[0][1]) : function(a) {
    return a === e || th(a, e, t);
  };
}
var sh = rh, oh = Ir, ih = c1;
function lh(e, t) {
  t = oh(t, e);
  for (var a = 0, n = t.length; e != null && a < n; )
    e = e[ih(t[a++])];
  return a && a == n ? e : void 0;
}
var jr = lh, uh = jr;
function ch(e, t, a) {
  var n = e == null ? void 0 : uh(e, t);
  return n === void 0 ? a : n;
}
var S0 = ch;
function dh(e, t) {
  return e != null && t in Object(e);
}
var fh = dh, hh = fh, vh = zr;
function ph(e, t) {
  return e != null && vh(e, t, hh);
}
var mh = ph, yh = Fr, gh = S0, bh = mh, _h = la, $h = Br, wh = Wr, Ch = c1, xh = 1, Mh = 2;
function Sh(e, t) {
  return _h(e) && $h(t) ? wh(Ch(e), t) : function(a) {
    var n = gh(a, e);
    return n === void 0 && n === t ? bh(a, e) : yh(t, n, xh | Mh);
  };
}
var Dh = Sh;
function kh(e) {
  return e;
}
var ba = kh;
function Lh(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Ih = Lh, Oh = jr;
function zh(e) {
  return function(t) {
    return Oh(t, e);
  };
}
var Ah = zh, Ph = Ih, Th = Ah, Eh = la, Yh = c1;
function Hh(e) {
  return Eh(e) ? Ph(Yh(e)) : Th(e);
}
var Vh = Hh, Nh = sh, Rh = Dh, Fh = ba, Bh = Be, Wh = Vh;
function jh(e) {
  return typeof e == "function" ? e : e == null ? Fh : typeof e == "object" ? Bh(e) ? Rh(e[0], e[1]) : Nh(e) : Wh(e);
}
var Ur = jh;
function Uh(e) {
  return function(t, a, n) {
    for (var s = -1, r = Object(t), i = n(t), l = i.length; l--; ) {
      var u = i[e ? l : ++s];
      if (a(r[u], u, r) === !1)
        break;
    }
    return t;
  };
}
var qh = Uh, Zh = qh, Gh = Zh(), qr = Gh, Kh = qr, Xh = ga;
function Jh(e, t) {
  return e && Kh(e, t, Xh);
}
var Zr = Jh, Qh = Lt;
function ev(e, t) {
  return function(a, n) {
    if (a == null)
      return a;
    if (!Qh(a))
      return e(a, n);
    for (var s = a.length, r = t ? s : -1, i = Object(a); (t ? r-- : ++r < s) && n(i[r], r, i) !== !1; )
      ;
    return a;
  };
}
var tv = ev, av = Zr, nv = tv, rv = nv(av), sv = rv, ov = sv;
function iv(e, t) {
  var a;
  return ov(e, function(n, s, r) {
    return a = t(n, s, r), !a;
  }), !!a;
}
var lv = iv, uv = J0, cv = Lt, dv = ha, fv = r0;
function hv(e, t, a) {
  if (!fv(a))
    return !1;
  var n = typeof t;
  return (n == "number" ? cv(a) && dv(t, a.length) : n == "string" && t in a) ? uv(a[t], e) : !1;
}
var _a = hv, vv = Tr, pv = Ur, mv = lv, yv = Be, gv = _a;
function bv(e, t, a) {
  var n = yv(e) ? vv : mv;
  return a && gv(e, t, a) && (t = void 0), n(e, pv(t));
}
var _v = bv, $v = Xe, wv = We, Cv = "[object Boolean]";
function xv(e) {
  return e === !0 || e === !1 || wv(e) && $v(e) == Cv;
}
var Mv = xv, Sv = Xe, Dv = We, kv = "[object Number]";
function Lv(e) {
  return typeof e == "number" || Dv(e) && Sv(e) == kv;
}
var Fe = Lv, Iv = z0, Ov = function() {
  try {
    var e = Iv(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Gr = Ov, gn = Gr;
function zv(e, t, a) {
  t == "__proto__" && gn ? gn(e, t, {
    configurable: !0,
    enumerable: !0,
    value: a,
    writable: !0
  }) : e[t] = a;
}
var d1 = zv, Av = d1, Pv = J0, Tv = Object.prototype, Ev = Tv.hasOwnProperty;
function Yv(e, t, a) {
  var n = e[t];
  (!(Ev.call(e, t) && Pv(n, a)) || a === void 0 && !(t in e)) && Av(e, t, a);
}
var Hv = Yv, Vv = d1, Nv = Zr, Rv = Ur;
function Fv(e, t) {
  var a = {};
  return t = Rv(t), Nv(e, function(n, s, r) {
    Vv(a, s, t(n, s, r));
  }), a;
}
var Bv = Fv;
function Wv(e, t, a) {
  switch (a.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, a[0]);
    case 2:
      return e.call(t, a[0], a[1]);
    case 3:
      return e.call(t, a[0], a[1], a[2]);
  }
  return e.apply(t, a);
}
var Kr = Wv, jv = Kr, bn = Math.max;
function Uv(e, t, a) {
  return t = bn(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, s = -1, r = bn(n.length - t, 0), i = Array(r); ++s < r; )
      i[s] = n[t + s];
    s = -1;
    for (var l = Array(t + 1); ++s < t; )
      l[s] = n[s];
    return l[t] = a(i), jv(e, this, l);
  };
}
var qv = Uv;
function Zv(e) {
  return function() {
    return e;
  };
}
var Gv = Zv, Kv = Gv, _n = Gr, Xv = ba, Jv = _n ? function(e, t) {
  return _n(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Kv(t),
    writable: !0
  });
} : Xv, Qv = Jv, ep = 800, tp = 16, ap = Date.now;
function np(e) {
  var t = 0, a = 0;
  return function() {
    var n = ap(), s = tp - (n - a);
    if (a = n, s > 0) {
      if (++t >= ep)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var rp = np, sp = Qv, op = rp, ip = op(sp), lp = ip, up = ba, cp = qv, dp = lp;
function fp(e, t) {
  return dp(cp(e, t, up), e + "");
}
var $a = fp;
function hp(e) {
  var t = [];
  if (e != null)
    for (var a in Object(e))
      t.push(a);
  return t;
}
var vp = hp, pp = r0, mp = ya, yp = vp, gp = Object.prototype, bp = gp.hasOwnProperty;
function _p(e) {
  if (!pp(e))
    return yp(e);
  var t = mp(e), a = [];
  for (var n in e)
    n == "constructor" && (t || !bp.call(e, n)) || a.push(n);
  return a;
}
var $p = _p, wp = Hr, Cp = $p, xp = Lt;
function Mp(e) {
  return xp(e) ? wp(e, !0) : Cp(e);
}
var wa = Mp, Sp = $a, Dp = J0, kp = _a, Lp = wa, Xr = Object.prototype, Ip = Xr.hasOwnProperty, Op = Sp(function(e, t) {
  e = Object(e);
  var a = -1, n = t.length, s = n > 2 ? t[2] : void 0;
  for (s && kp(t[0], t[1], s) && (n = 1); ++a < n; )
    for (var r = t[a], i = Lp(r), l = -1, u = i.length; ++l < u; ) {
      var c = i[l], d = e[c];
      (d === void 0 || Dp(d, Xr[c]) && !Ip.call(e, c)) && (e[c] = r[c]);
    }
  return e;
}), $n = Op, zp = d1, Ap = J0;
function Pp(e, t, a) {
  (a !== void 0 && !Ap(e[t], a) || a === void 0 && !(t in e)) && zp(e, t, a);
}
var Jr = Pp, qt = {}, Tp = {
  get exports() {
    return qt;
  },
  set exports(e) {
    qt = e;
  }
};
(function(e, t) {
  var a = Ke, n = t && !t.nodeType && t, s = n && !0 && e && !e.nodeType && e, r = s && s.exports === n, i = r ? a.Buffer : void 0, l = i ? i.allocUnsafe : void 0;
  function u(c, d) {
    if (d)
      return c.slice();
    var v = c.length, y = l ? l(v) : new c.constructor(v);
    return c.copy(y), y;
  }
  e.exports = u;
})(Tp, qt);
var wn = Yr;
function Ep(e) {
  var t = new e.constructor(e.byteLength);
  return new wn(t).set(new wn(e)), t;
}
var Yp = Ep, Hp = Yp;
function Vp(e, t) {
  var a = t ? Hp(e.buffer) : e.buffer;
  return new e.constructor(a, e.byteOffset, e.length);
}
var Np = Vp;
function Rp(e, t) {
  var a = -1, n = e.length;
  for (t || (t = Array(n)); ++a < n; )
    t[a] = e[a];
  return t;
}
var Fp = Rp, Bp = r0, Cn = Object.create, Wp = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Bp(t))
      return {};
    if (Cn)
      return Cn(t);
    e.prototype = t;
    var a = new e();
    return e.prototype = void 0, a;
  };
}(), jp = Wp, Up = Vr, qp = Up(Object.getPrototypeOf, Object), Qr = qp, Zp = jp, Gp = Qr, Kp = ya;
function Xp(e) {
  return typeof e.constructor == "function" && !Kp(e) ? Zp(Gp(e)) : {};
}
var Jp = Xp, Qp = Lt, e9 = We;
function t9(e) {
  return e9(e) && Qp(e);
}
var a9 = t9, n9 = Xe, r9 = Qr, s9 = We, o9 = "[object Object]", i9 = Function.prototype, l9 = Object.prototype, es = i9.toString, u9 = l9.hasOwnProperty, c9 = es.call(Object);
function d9(e) {
  if (!s9(e) || n9(e) != o9)
    return !1;
  var t = r9(e);
  if (t === null)
    return !0;
  var a = u9.call(t, "constructor") && t.constructor;
  return typeof a == "function" && a instanceof a && es.call(a) == c9;
}
var f9 = d9;
function h9(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var ts = h9, v9 = Hv, p9 = d1;
function m9(e, t, a, n) {
  var s = !a;
  a || (a = {});
  for (var r = -1, i = t.length; ++r < i; ) {
    var l = t[r], u = n ? n(a[l], e[l], l, a, e) : void 0;
    u === void 0 && (u = e[l]), s ? p9(a, l, u) : v9(a, l, u);
  }
  return a;
}
var y9 = m9, g9 = y9, b9 = wa;
function _9(e) {
  return g9(e, b9(e));
}
var $9 = _9, xn = Jr, w9 = qt, C9 = Np, x9 = Fp, M9 = Jp, Mn = fa, Sn = Be, S9 = a9, D9 = q0, k9 = O0, L9 = r0, I9 = f9, O9 = ma, Dn = ts, z9 = $9;
function A9(e, t, a, n, s, r, i) {
  var l = Dn(e, a), u = Dn(t, a), c = i.get(u);
  if (c) {
    xn(e, a, c);
    return;
  }
  var d = r ? r(l, u, a + "", e, t, i) : void 0, v = d === void 0;
  if (v) {
    var y = Sn(u), m = !y && D9(u), g = !y && !m && O9(u);
    d = u, y || m || g ? Sn(l) ? d = l : S9(l) ? d = x9(l) : m ? (v = !1, d = w9(u, !0)) : g ? (v = !1, d = C9(u, !0)) : d = [] : I9(u) || Mn(u) ? (d = l, Mn(l) ? d = z9(l) : (!L9(l) || k9(l)) && (d = M9(u))) : v = !1;
  }
  v && (i.set(u, d), s(d, u, n, r, i), i.delete(u)), xn(e, a, d);
}
var P9 = A9, T9 = pa, E9 = Jr, Y9 = qr, H9 = P9, V9 = r0, N9 = wa, R9 = ts;
function as(e, t, a, n, s) {
  e !== t && Y9(t, function(r, i) {
    if (s || (s = new T9()), V9(r))
      H9(e, t, i, a, as, n, s);
    else {
      var l = n ? n(R9(e, i), r, i + "", e, t, s) : void 0;
      l === void 0 && (l = r), E9(e, i, l);
    }
  }, N9);
}
var ns = as, F9 = ns, kn = r0;
function rs(e, t, a, n, s, r) {
  return kn(e) && kn(t) && (r.set(t, e), F9(e, t, void 0, rs, r), r.delete(t)), e;
}
var B9 = rs, W9 = $a, j9 = _a;
function U9(e) {
  return W9(function(t, a) {
    var n = -1, s = a.length, r = s > 1 ? a[s - 1] : void 0, i = s > 2 ? a[2] : void 0;
    for (r = e.length > 3 && typeof r == "function" ? (s--, r) : void 0, i && j9(a[0], a[1], i) && (r = s < 3 ? void 0 : r, s = 1), t = Object(t); ++n < s; ) {
      var l = a[n];
      l && e(t, l, n, r);
    }
    return t;
  });
}
var q9 = U9, Z9 = ns, G9 = q9, K9 = G9(function(e, t, a, n) {
  Z9(e, t, a, n);
}), X9 = K9, J9 = Kr, Q9 = $a, em = B9, tm = X9, am = Q9(function(e) {
  return e.push(void 0, em), J9(tm, void 0, e);
}), Z0 = am;
function nm(e) {
  return e && e.length ? e[0] : void 0;
}
var ss = nm;
function rm(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var V0 = rm;
const sm = (e) => Object.prototype.toString.call(e).slice(8, -1), N0 = (e) => c7(e) && !isNaN(e.getTime()), a0 = (e) => sm(e) === "Object", os = Ar, Ln = (e, t) => _v(t, (a) => Ar(e, a)), re = (e, t, a = "0") => {
  for (e = e != null ? String(e) : "", t = t || 2; e.length < t; )
    e = `${a}${e}`;
  return e;
}, Ye = (e) => Array.isArray(e), Qe = (e) => Ye(e) && e.length > 0, Zt = (e) => e == null ? null : document && Ue(e) ? document.querySelector(e) : e.$el ?? e, p0 = (e, t, a, n = void 0) => {
  e.removeEventListener(t, a, n);
}, m0 = (e, t, a, n = void 0) => (e.addEventListener(t, a, n), () => p0(e, t, a, n)), Rt = (e, t) => !!e && !!t && (e === t || e.contains(t)), Ht = (e, t) => {
  (e.key === " " || e.key === "Enter") && (t(e), e.preventDefault());
}, is = (e, ...t) => {
  const a = {};
  let n;
  for (n in e)
    t.includes(n) || (a[n] = e[n]);
  return a;
}, ls = (e, t) => {
  const a = {};
  return t.forEach((n) => {
    n in e && (a[n] = e[n]);
  }), a;
};
function om(e, t, a) {
  return Math.min(Math.max(e, t), a);
}
var Gt = {}, im = {
  get exports() {
    return Gt;
  },
  set exports(e) {
    Gt = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(n) {
    if (n === null || n === !0 || n === !1)
      return NaN;
    var s = Number(n);
    return isNaN(s) ? s : s < 0 ? Math.ceil(s) : Math.floor(s);
  }
  e.exports = t.default;
})(im, Gt);
const lm = /* @__PURE__ */ xr(Gt);
var Kt = {}, um = {
  get exports() {
    return Kt;
  },
  set exports(e) {
    Kt = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(n) {
    var s = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
    return s.setUTCFullYear(n.getFullYear()), n.getTime() - s.getTime();
  }
  e.exports = t.default;
})(um, Kt);
const In = /* @__PURE__ */ xr(Kt);
function cm(e, t) {
  var a = vm(t);
  return a.formatToParts ? fm(a, e) : hm(a, e);
}
var dm = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function fm(e, t) {
  try {
    for (var a = e.formatToParts(t), n = [], s = 0; s < a.length; s++) {
      var r = dm[a[s].type];
      r >= 0 && (n[r] = parseInt(a[s].value, 10));
    }
    return n;
  } catch (i) {
    if (i instanceof RangeError)
      return [NaN];
    throw i;
  }
}
function hm(e, t) {
  var a = e.format(t).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
var C1 = {};
function vm(e) {
  if (!C1[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), a = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    C1[e] = a ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return C1[e];
}
function us(e, t, a, n, s, r, i) {
  var l = /* @__PURE__ */ new Date(0);
  return l.setUTCFullYear(e, t, a), l.setUTCHours(n, s, r, i), l;
}
var On = 36e5, pm = 6e4, x1 = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function mm(e, t, a) {
  var n, s;
  if (!e || (n = x1.timezoneZ.exec(e), n))
    return 0;
  var r;
  if (n = x1.timezoneHH.exec(e), n)
    return r = parseInt(n[1], 10), zn(r) ? -(r * On) : NaN;
  if (n = x1.timezoneHHMM.exec(e), n) {
    r = parseInt(n[1], 10);
    var i = parseInt(n[2], 10);
    return zn(r, i) ? (s = Math.abs(r) * On + i * pm, r > 0 ? -s : s) : NaN;
  }
  if (bm(e)) {
    t = new Date(t || Date.now());
    var l = ym(t), u = V1(l, e), c = gm(t, u, e);
    return -c;
  }
  return NaN;
}
function ym(e) {
  return us(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function V1(e, t) {
  var a = cm(e, t), n = us(
    a[0],
    a[1] - 1,
    a[2],
    a[3] % 24,
    a[4],
    a[5],
    0
  ).getTime(), s = e.getTime(), r = s % 1e3;
  return s -= r >= 0 ? r : 1e3 + r, n - s;
}
function gm(e, t, a) {
  var n = e.getTime(), s = n - t, r = V1(new Date(s), a);
  if (t === r)
    return t;
  s -= r - t;
  var i = V1(new Date(s), a);
  return r === i ? r : Math.max(r, i);
}
function zn(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var An = {};
function bm(e) {
  if (An[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), An[e] = !0, !0;
  } catch {
    return !1;
  }
}
var _m = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const $m = _m;
var M1 = 36e5, Pn = 6e4, wm = 2, Se = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: $m
};
function Cm(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = t || {}, n = a.additionalDigits == null ? wm : lm(a.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var s = xm(e), r = Mm(s.date, n), i = r.year, l = r.restDateString, u = Sm(l, i);
  if (isNaN(u))
    return /* @__PURE__ */ new Date(NaN);
  if (u) {
    var c = u.getTime(), d = 0, v;
    if (s.time && (d = Dm(s.time), isNaN(d)))
      return /* @__PURE__ */ new Date(NaN);
    if (s.timeZone || a.timeZone) {
      if (v = mm(s.timeZone || a.timeZone, new Date(c + d)), isNaN(v))
        return /* @__PURE__ */ new Date(NaN);
    } else
      v = In(new Date(c + d)), v = In(new Date(c + d + v));
    return new Date(c + d + v);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function xm(e) {
  var t = {}, a = Se.dateTimePattern.exec(e), n;
  if (a ? (t.date = a[1], n = a[3]) : (a = Se.datePattern.exec(e), a ? (t.date = a[1], n = a[2]) : (t.date = null, n = e)), n) {
    var s = Se.timeZone.exec(n);
    s ? (t.time = n.replace(s[1], ""), t.timeZone = s[1].trim()) : t.time = n;
  }
  return t;
}
function Mm(e, t) {
  var a = Se.YYY[t], n = Se.YYYYY[t], s;
  if (s = Se.YYYY.exec(e) || n.exec(e), s) {
    var r = s[1];
    return {
      year: parseInt(r, 10),
      restDateString: e.slice(r.length)
    };
  }
  if (s = Se.YY.exec(e) || a.exec(e), s) {
    var i = s[1];
    return {
      year: parseInt(i, 10) * 100,
      restDateString: e.slice(i.length)
    };
  }
  return {
    year: null
  };
}
function Sm(e, t) {
  if (t === null)
    return null;
  var a, n, s, r;
  if (e.length === 0)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  if (a = Se.MM.exec(e), a)
    return n = /* @__PURE__ */ new Date(0), s = parseInt(a[1], 10) - 1, En(t, s) ? (n.setUTCFullYear(t, s), n) : /* @__PURE__ */ new Date(NaN);
  if (a = Se.DDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0);
    var i = parseInt(a[1], 10);
    return Im(t, i) ? (n.setUTCFullYear(t, 0, i), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = Se.MMDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0), s = parseInt(a[1], 10) - 1;
    var l = parseInt(a[2], 10);
    return En(t, s, l) ? (n.setUTCFullYear(t, s, l), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = Se.Www.exec(e), a)
    return r = parseInt(a[1], 10) - 1, Yn(t, r) ? Tn(t, r) : /* @__PURE__ */ new Date(NaN);
  if (a = Se.WwwD.exec(e), a) {
    r = parseInt(a[1], 10) - 1;
    var u = parseInt(a[2], 10) - 1;
    return Yn(t, r, u) ? Tn(t, r, u) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Dm(e) {
  var t, a, n;
  if (t = Se.HH.exec(e), t)
    return a = parseFloat(t[1].replace(",", ".")), S1(a) ? a % 24 * M1 : NaN;
  if (t = Se.HHMM.exec(e), t)
    return a = parseInt(t[1], 10), n = parseFloat(t[2].replace(",", ".")), S1(a, n) ? a % 24 * M1 + n * Pn : NaN;
  if (t = Se.HHMMSS.exec(e), t) {
    a = parseInt(t[1], 10), n = parseInt(t[2], 10);
    var s = parseFloat(t[3].replace(",", "."));
    return S1(a, n, s) ? a % 24 * M1 + n * Pn + s * 1e3 : NaN;
  }
  return null;
}
function Tn(e, t, a) {
  t = t || 0, a = a || 0;
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  var s = n.getUTCDay() || 7, r = t * 7 + a + 1 - s;
  return n.setUTCDate(n.getUTCDate() + r), n;
}
var km = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Lm = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function cs(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function En(e, t, a) {
  if (t < 0 || t > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    var n = cs(e);
    if (n && a > Lm[t] || !n && a > km[t])
      return !1;
  }
  return !0;
}
function Im(e, t) {
  if (t < 1)
    return !1;
  var a = cs(e);
  return !(a && t > 366 || !a && t > 365);
}
function Yn(e, t, a) {
  return !(t < 0 || t > 52 || a != null && (a < 0 || a > 6));
}
function S1(e, t, a) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || a != null && (a < 0 || a >= 60));
}
function we(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Ft(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ft = function(a) {
    return typeof a;
  } : Ft = function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, Ft(e);
}
function s0(e) {
  we(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Ft(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function nt(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
var Om = {};
function Ca() {
  return Om;
}
function I0(e, t) {
  var a, n, s, r, i, l, u, c;
  we(1, arguments);
  var d = Ca(), v = nt((a = (n = (s = (r = t == null ? void 0 : t.weekStartsOn) !== null && r !== void 0 ? r : t == null || (i = t.locale) === null || i === void 0 || (l = i.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && s !== void 0 ? s : d.weekStartsOn) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(v >= 0 && v <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var y = s0(e), m = y.getDay(), g = (m < v ? 7 : 0) + m - v;
  return y.setDate(y.getDate() - g), y.setHours(0, 0, 0, 0), y;
}
function Hn(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var zm = 6048e5;
function Am(e, t, a) {
  we(2, arguments);
  var n = I0(e, a), s = I0(t, a), r = n.getTime() - Hn(n), i = s.getTime() - Hn(s);
  return Math.round((r - i) / zm);
}
function Pm(e) {
  we(1, arguments);
  var t = s0(e), a = t.getMonth();
  return t.setFullYear(t.getFullYear(), a + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function Tm(e) {
  we(1, arguments);
  var t = s0(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Em(e, t) {
  return we(1, arguments), Am(Pm(e), Tm(e), t) + 1;
}
function Ym(e, t) {
  var a, n, s, r, i, l, u, c;
  we(1, arguments);
  var d = s0(e), v = d.getFullYear(), y = Ca(), m = nt((a = (n = (s = (r = t == null ? void 0 : t.firstWeekContainsDate) !== null && r !== void 0 ? r : t == null || (i = t.locale) === null || i === void 0 || (l = i.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && s !== void 0 ? s : y.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = y.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var g = /* @__PURE__ */ new Date(0);
  g.setFullYear(v + 1, 0, m), g.setHours(0, 0, 0, 0);
  var S = I0(g, t), $ = /* @__PURE__ */ new Date(0);
  $.setFullYear(v, 0, m), $.setHours(0, 0, 0, 0);
  var b = I0($, t);
  return d.getTime() >= S.getTime() ? v + 1 : d.getTime() >= b.getTime() ? v : v - 1;
}
function Hm(e, t) {
  var a, n, s, r, i, l, u, c;
  we(1, arguments);
  var d = Ca(), v = nt((a = (n = (s = (r = t == null ? void 0 : t.firstWeekContainsDate) !== null && r !== void 0 ? r : t == null || (i = t.locale) === null || i === void 0 || (l = i.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && s !== void 0 ? s : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && a !== void 0 ? a : 1), y = Ym(e, t), m = /* @__PURE__ */ new Date(0);
  m.setFullYear(y, 0, v), m.setHours(0, 0, 0, 0);
  var g = I0(m, t);
  return g;
}
var Vm = 6048e5;
function Nm(e, t) {
  we(1, arguments);
  var a = s0(e), n = I0(a, t).getTime() - Hm(a, t).getTime();
  return Math.round(n / Vm) + 1;
}
function Xt(e) {
  return we(1, arguments), I0(e, {
    weekStartsOn: 1
  });
}
function Rm(e) {
  we(1, arguments);
  var t = s0(e), a = t.getFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(a + 1, 0, 4), n.setHours(0, 0, 0, 0);
  var s = Xt(n), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(a, 0, 4), r.setHours(0, 0, 0, 0);
  var i = Xt(r);
  return t.getTime() >= s.getTime() ? a + 1 : t.getTime() >= i.getTime() ? a : a - 1;
}
function Fm(e) {
  we(1, arguments);
  var t = Rm(e), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0);
  var n = Xt(a);
  return n;
}
var Bm = 6048e5;
function Wm(e) {
  we(1, arguments);
  var t = s0(e), a = Xt(t).getTime() - Fm(t).getTime();
  return Math.round(a / Bm) + 1;
}
function Me(e, t) {
  we(2, arguments);
  var a = s0(e), n = nt(t);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && a.setDate(a.getDate() + n), a);
}
function Jt(e, t) {
  we(2, arguments);
  var a = s0(e), n = nt(t);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return a;
  var s = a.getDate(), r = new Date(a.getTime());
  r.setMonth(a.getMonth() + n + 1, 0);
  var i = r.getDate();
  return s >= i ? r : (a.setFullYear(r.getFullYear(), r.getMonth(), s), a);
}
function Vn(e, t) {
  we(2, arguments);
  var a = nt(t);
  return Jt(e, a * 12);
}
const jm = {
  daily: ["year", "month", "day"],
  weekly: ["year", "month", "week"],
  monthly: ["year", "month"]
};
function Um({
  monthComps: e,
  prevMonthComps: t,
  nextMonthComps: a
}, n) {
  const s = [], {
    firstDayOfWeek: r,
    firstWeekday: i,
    isoWeeknumbers: l,
    weeknumbers: u,
    numDays: c,
    numWeeks: d
  } = e, v = i + (i < r ? $e : 0) - r;
  let y = !0, m = !1, g = !1, S = 0;
  const $ = new Intl.DateTimeFormat(n.id, {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  let b = t.numDays - v + 1, Y = t.numDays - b + 1, V = Math.floor((b - 1) / $e + 1), L = 1, T = t.numWeeks, j = 1, H = t.month, U = t.year;
  const G = /* @__PURE__ */ new Date(), K = G.getDate(), J = G.getMonth() + 1, N = G.getFullYear();
  for (let q = 1; q <= Vy; q++) {
    for (let ae = 1, W = r; ae <= $e; ae++, W += W === $e ? 1 - $e : 1) {
      y && W === i && (b = 1, Y = e.numDays, V = Math.floor((b - 1) / $e + 1), L = Math.floor((c - b) / $e + 1), T = 1, j = d, H = e.month, U = e.year, y = !1, m = !0);
      const te = n.getDateFromParams(U, H, b, 0, 0, 0, 0), le = n.getDateFromParams(U, H, b, 12, 0, 0, 0), ye = n.getDateFromParams(
        U,
        H,
        b,
        23,
        59,
        59,
        999
      ), de = te, k = `${re(U, 4)}-${re(H, 2)}-${re(b, 2)}`, ee = ae, B = $e - ae, ve = u[q - 1], ne = l[q - 1], pe = b === K && H === J && U === N, ge = m && b === 1, me = m && b === c, be = q === 1, Ie = q === d, Je = ae === 1, Ne = ae === $e, Ae = ws(U, H, b);
      s.push({
        locale: n,
        id: k,
        position: ++S,
        label: b.toString(),
        ariaLabel: $.format(new Date(U, H - 1, b)),
        day: b,
        dayFromEnd: Y,
        weekday: W,
        weekdayPosition: ee,
        weekdayPositionFromEnd: B,
        weekdayOrdinal: V,
        weekdayOrdinalFromEnd: L,
        week: T,
        weekFromEnd: j,
        weekPosition: q,
        weeknumber: ve,
        isoWeeknumber: ne,
        month: H,
        year: U,
        date: de,
        startDate: te,
        endDate: ye,
        noonDate: le,
        dayIndex: Ae,
        isToday: pe,
        isFirstDay: ge,
        isLastDay: me,
        isDisabled: !m,
        isFocusable: !m,
        isFocused: !1,
        inMonth: m,
        inPrevMonth: y,
        inNextMonth: g,
        onTop: be,
        onBottom: Ie,
        onLeft: Je,
        onRight: Ne,
        classes: [
          `id-${k}`,
          `day-${b}`,
          `day-from-end-${Y}`,
          `weekday-${W}`,
          `weekday-position-${ee}`,
          `weekday-ordinal-${V}`,
          `weekday-ordinal-from-end-${L}`,
          `week-${T}`,
          `week-from-end-${j}`,
          {
            "is-today": pe,
            "is-first-day": ge,
            "is-last-day": me,
            "in-month": m,
            "in-prev-month": y,
            "in-next-month": g,
            "on-top": be,
            "on-bottom": Ie,
            "on-left": Je,
            "on-right": Ne
          }
        ]
      }), m && me ? (m = !1, g = !0, b = 1, Y = c, V = 1, L = Math.floor((c - b) / $e + 1), T = 1, j = a.numWeeks, H = a.month, U = a.year) : (b++, Y--, V = Math.floor((b - 1) / $e + 1), L = Math.floor((c - b) / $e + 1));
    }
    T++, j--;
  }
  return s;
}
function qm(e, t, a, n) {
  const s = e.reduce((r, i, l) => {
    const u = Math.floor(l / 7);
    let c = r[u];
    return c || (c = {
      id: `week-${u + 1}`,
      title: "",
      week: i.week,
      weekPosition: i.weekPosition,
      weeknumber: i.weeknumber,
      isoWeeknumber: i.isoWeeknumber,
      weeknumberDisplay: t ? i.weeknumber : a ? i.isoWeeknumber : void 0,
      days: []
    }, r[u] = c), c.days.push(i), r;
  }, Array(e.length / $e));
  return s.forEach((r) => {
    const i = r.days[0], l = r.days[r.days.length - 1];
    i.month === l.month ? r.title = `${n.formatDate(i.date, "MMMM YYYY")}` : i.year === l.year ? r.title = `${n.formatDate(
      i.date,
      "MMM"
    )} - ${n.formatDate(l.date, "MMM YYYY")}` : r.title = `${n.formatDate(
      i.date,
      "MMM YYYY"
    )} - ${n.formatDate(l.date, "MMM YYYY")}`;
  }), s;
}
function Zm(e, t) {
  return e.days.map((a) => ({
    label: t.formatDate(a.date, t.masks.weekdays),
    weekday: a.weekday
  }));
}
function Gm(e, t) {
  return `${t}.${re(e, 2)}`;
}
function ds(e, t, a) {
  return ls(
    a.getDateParts(a.toDate(e)),
    jm[t]
  );
}
function fs({ day: e, week: t, month: a, year: n }, s, r, i) {
  if (r === "daily" && e) {
    const l = new Date(n, a - 1, e), u = Me(l, s);
    return {
      day: u.getDate(),
      month: u.getMonth() + 1,
      year: u.getFullYear()
    };
  } else if (r === "weekly" && t) {
    const u = i.getMonthParts(a, n).firstDayOfMonth, c = Me(u, (t - 1 + s) * 7), d = i.getDateParts(c);
    return {
      week: d.week,
      month: d.month,
      year: d.year
    };
  } else {
    const l = new Date(n, a - 1, 1), u = Jt(l, s);
    return {
      month: u.getMonth() + 1,
      year: u.getFullYear()
    };
  }
}
function qe(e) {
  return e != null && e.month != null && e.year != null;
}
function N1(e, t) {
  return !qe(e) || !qe(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year < t.year : e.month && t.month && e.month !== t.month ? e.month < t.month : e.week && t.week && e.week !== t.week ? e.week < t.week : e.day && t.day && e.day !== t.day ? e.day < t.day : !1);
}
function Qt(e, t) {
  return !qe(e) || !qe(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year > t.year : e.month && t.month && e.month !== t.month ? e.month > t.month : e.week && t.week && e.week !== t.week ? e.week > t.week : e.day && t.day && e.day !== t.day ? e.day > t.day : !1);
}
function Km(e, t, a) {
  return (e || !1) && !N1(e, t) && !Qt(e, a);
}
function Xm(e, t) {
  return !e && t || e && !t ? !1 : !e && !t ? !0 : (e = e, t = t, e.year === t.year && e.month === t.month && e.week === t.week && e.day === t.day);
}
function Jm(e, t, a, n) {
  if (!qe(e) || !qe(t))
    return [];
  const s = [];
  for (; !Qt(e, t); )
    s.push(e), e = fs(e, 1, a, n);
  return s;
}
function hs(e) {
  const { day: t, week: a, month: n, year: s } = e;
  let r = `${s}-${re(n, 2)}`;
  return a && (r = `${r}-w${a}`), t && (r = `${r}-${re(t, 2)}`), r;
}
function Qm(e, t) {
  const { month: a, year: n, showWeeknumbers: s, showIsoWeeknumbers: r } = e, i = new Date(n, a - 1, 15), l = t.getMonthParts(a, n), u = t.getPrevMonthParts(a, n), c = t.getNextMonthParts(a, n), d = Um({ monthComps: l, prevMonthComps: u, nextMonthComps: c }, t), v = qm(d, s, r, t), y = Zm(v[0], t);
  return {
    id: hs(e),
    month: a,
    year: n,
    monthTitle: t.formatDate(i, t.masks.title),
    shortMonthLabel: t.formatDate(i, "MMM"),
    monthLabel: t.formatDate(i, "MMMM"),
    shortYearLabel: n.toString().substring(2),
    yearLabel: n.toString(),
    monthComps: l,
    prevMonthComps: u,
    nextMonthComps: c,
    days: d,
    weeks: v,
    weekdays: y
  };
}
function ey(e, t) {
  const { day: a, week: n, view: s, trimWeeks: r } = e, i = {
    ...t,
    ...e,
    title: "",
    viewDays: [],
    viewWeeks: []
  };
  switch (s) {
    case "daily": {
      let l = i.days.find((c) => c.inMonth);
      a ? l = i.days.find((c) => c.day === a && c.inMonth) || l : n && (l = i.days.find((c) => c.week === n && c.inMonth));
      const u = i.weeks[l.week - 1];
      i.viewWeeks = [u], i.viewDays = [l], i.week = l.week, i.weekTitle = u.title, i.day = l.day, i.dayTitle = l.ariaLabel, i.title = i.dayTitle;
      break;
    }
    case "weekly": {
      i.week = n || 1;
      const l = i.weeks[i.week - 1];
      i.viewWeeks = [l], i.viewDays = l.days, i.weekTitle = l.title, i.title = i.weekTitle;
      break;
    }
    default: {
      i.title = i.monthTitle, i.viewWeeks = i.weeks.slice(
        0,
        r ? i.monthComps.numWeeks : void 0
      ), i.viewDays = i.days;
      break;
    }
  }
  return i;
}
class Nn {
  constructor(t, a, n) {
    R(this, "keys", []), R(this, "store", {}), this.size = t, this.createKey = a, this.createItem = n;
  }
  get(...t) {
    const a = this.createKey(...t);
    return this.store[a];
  }
  getOrSet(...t) {
    const a = this.createKey(...t);
    if (this.store[a])
      return this.store[a];
    const n = this.createItem(...t);
    if (this.keys.length >= this.size) {
      const s = this.keys.shift();
      s != null && delete this.store[s];
    }
    return this.keys.push(a), this.store[a] = n, n;
  }
}
class R0 {
  constructor(t, a = new e1()) {
    R(this, "order"), R(this, "locale"), R(this, "start", null), R(this, "end", null), R(this, "repeat", null);
    var n;
    this.locale = a;
    const { start: s, end: r, span: i, order: l, repeat: u } = t;
    N0(s) && (this.start = a.getDateParts(s)), N0(r) ? this.end = a.getDateParts(r) : this.start != null && i && (this.end = a.getDateParts(Me(this.start.date, i - 1))), this.order = l ?? 0, u && (this.repeat = new t1(
      {
        from: (n = this.start) == null ? void 0 : n.date,
        ...u
      },
      {
        locale: this.locale
      }
    ));
  }
  static fromMany(t, a) {
    return (Ye(t) ? t : [t]).filter((n) => n).map((n) => R0.from(n, a));
  }
  static from(t, a) {
    if (t instanceof R0)
      return t;
    const n = {
      start: null,
      end: null
    };
    return t != null && (Ye(t) ? (n.start = t[0] ?? null, n.end = t[1] ?? null) : a0(t) ? Object.assign(n, t) : (n.start = t, n.end = t)), n.start != null && (n.start = new Date(n.start)), n.end != null && (n.end = new Date(n.end)), new R0(n, a);
  }
  get opts() {
    const { order: t, locale: a } = this;
    return { order: t, locale: a };
  }
  get hasRepeat() {
    return !!this.repeat;
  }
  get isSingleDay() {
    const { start: t, end: a } = this;
    return t && a && t.year === a.year && t.month === a.month && t.day === a.day;
  }
  get isMultiDay() {
    return !this.isSingleDay;
  }
  get daySpan() {
    return this.start == null || this.end == null ? this.hasRepeat ? 1 : 1 / 0 : this.end.dayIndex - this.start.dayIndex;
  }
  startsOnDay(t) {
    var a, n;
    return ((a = this.start) == null ? void 0 : a.dayIndex) === t.dayIndex || !!((n = this.repeat) != null && n.passes(t));
  }
  intersectsDay(t) {
    return this.intersectsDayRange(t, t);
  }
  intersectsRange(t) {
    var a, n;
    return this.intersectsDayRange(
      ((a = t.start) == null ? void 0 : a.dayIndex) ?? -1 / 0,
      ((n = t.end) == null ? void 0 : n.dayIndex) ?? 1 / 0
    );
  }
  intersectsDayRange(t, a) {
    return !(this.start && this.start.dayIndex > a || this.end && this.end.dayIndex < t);
  }
}
class ty {
  constructor() {
    R(this, "records", {});
  }
  render(t, a, n) {
    var s, r, i, l;
    let u = null;
    const c = n[0].dayIndex, d = n[n.length - 1].dayIndex;
    return a.hasRepeat ? n.forEach((v) => {
      var y, m;
      if (a.startsOnDay(v)) {
        const g = a.daySpan < 1 / 0 ? a.daySpan : 1;
        u = {
          startDay: v.dayIndex,
          startTime: ((y = a.start) == null ? void 0 : y.time) ?? 0,
          endDay: v.dayIndex + g - 1,
          endTime: ((m = a.end) == null ? void 0 : m.time) ?? Bt
        }, this.getRangeRecords(t).push(u);
      }
    }) : a.intersectsDayRange(c, d) && (u = {
      startDay: ((s = a.start) == null ? void 0 : s.dayIndex) ?? -1 / 0,
      startTime: ((r = a.start) == null ? void 0 : r.time) ?? -1 / 0,
      endDay: ((i = a.end) == null ? void 0 : i.dayIndex) ?? 1 / 0,
      endTime: ((l = a.end) == null ? void 0 : l.time) ?? 1 / 0
    }, this.getRangeRecords(t).push(u)), u;
  }
  getRangeRecords(t) {
    let a = this.records[t.key];
    return a || (a = {
      ranges: [],
      data: t
    }, this.records[t.key] = a), a.ranges;
  }
  getCell(t, a) {
    return this.getCells(a).find((r) => r.data.key === t);
  }
  cellExists(t, a) {
    const n = this.records[t];
    return n == null ? !1 : n.ranges.some(
      (s) => s.startDay <= a && s.endDay >= a
    );
  }
  getCells(t) {
    const a = Object.values(this.records), n = [], { dayIndex: s } = t;
    return a.forEach(({ data: r, ranges: i }) => {
      i.filter((l) => l.startDay <= s && l.endDay >= s).forEach((l) => {
        const u = s === l.startDay, c = s === l.endDay, d = u ? l.startTime : 0, v = new Date(t.startDate.getTime() + d), y = c ? l.endTime : Bt, m = new Date(t.endDate.getTime() + y), g = d === 0 && y === Bt, S = r.order || 0;
        n.push({
          ...l,
          data: r,
          onStart: u,
          onEnd: c,
          startTime: d,
          startDate: v,
          endTime: y,
          endDate: m,
          allDay: g,
          order: S
        });
      });
    }), n.sort((r, i) => r.order - i.order), n;
  }
}
const n0 = {
  // Arabic
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  // Bulgarian
  bg: { dow: 2, L: "D.MM.YYYY" },
  // Catalan
  ca: { dow: 2, L: "DD/MM/YYYY" },
  // Chinese (China)
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  // Chinese (Taiwan)
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  // Croatian
  hr: { dow: 2, L: "DD.MM.YYYY" },
  // Czech
  cs: { dow: 2, L: "DD.MM.YYYY" },
  // Danish
  da: { dow: 2, L: "DD.MM.YYYY" },
  // Dutch
  nl: { dow: 2, L: "DD-MM-YYYY" },
  // English (US)
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  // English (Australia)
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  // English (Canada)
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  // English (Great Britain)
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  // English (Ireland)
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  // English (New Zealand)
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  // English (South Africa)
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  // Esperanto
  eo: { dow: 2, L: "YYYY-MM-DD" },
  // Estonian
  et: { dow: 2, L: "DD.MM.YYYY" },
  // Finnish
  fi: { dow: 2, L: "DD.MM.YYYY" },
  // French
  fr: { dow: 2, L: "DD/MM/YYYY" },
  // French (Canada)
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  // French (Switzerland)
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  // German
  de: { dow: 2, L: "DD.MM.YYYY" },
  // Hebrew
  he: { dow: 1, L: "DD.MM.YYYY" },
  // Indonesian
  id: { dow: 2, L: "DD/MM/YYYY" },
  // Italian
  it: { dow: 2, L: "DD/MM/YYYY" },
  // Japanese
  ja: { dow: 1, L: "YYYY年M月D日" },
  // Korean
  ko: { dow: 1, L: "YYYY.MM.DD" },
  // Latvian
  lv: { dow: 2, L: "DD.MM.YYYY" },
  // Lithuanian
  lt: { dow: 2, L: "DD.MM.YYYY" },
  // Macedonian
  mk: { dow: 2, L: "D.MM.YYYY" },
  // Norwegian
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  // Polish
  pl: { dow: 2, L: "DD.MM.YYYY" },
  // Portuguese
  pt: { dow: 2, L: "DD/MM/YYYY" },
  // Romanian
  ro: { dow: 2, L: "DD.MM.YYYY" },
  // Russian
  ru: { dow: 2, L: "DD.MM.YYYY" },
  // Slovak
  sk: { dow: 2, L: "DD.MM.YYYY" },
  // Spanish (Spain)
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  // Spanish (Mexico)
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  // Swedish
  sv: { dow: 2, L: "YYYY-MM-DD" },
  // Thai
  th: { dow: 1, L: "DD/MM/YYYY" },
  // Turkish
  tr: { dow: 2, L: "DD.MM.YYYY" },
  // Ukrainian
  uk: { dow: 2, L: "DD.MM.YYYY" },
  // Vietnam
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
n0.en = n0["en-US"];
n0.es = n0["es-ES"];
n0.no = n0.nb;
n0.zh = n0["zh-CN"];
const ay = Object.entries(n0).reduce(
  (e, [t, { dow: a, L: n }]) => (e[t] = {
    id: t,
    firstDayOfWeek: a,
    masks: { L: n }
  }, e),
  {}
), ny = "MMMM YYYY", ry = "W", sy = "MMM", oy = "h A", iy = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], ly = [
  "L h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/MM/DD h:mm A"
], uy = [
  "L HH:mm",
  "YYYY-MM-DD HH:mm",
  "YYYY/MM/DD HH:mm"
], cy = [
  "h:mm A"
], dy = [
  "HH:mm"
], fy = "WWW, MMM D, YYYY", hy = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], vy = "iso", py = "YYYY-MM-DDTHH:mm:ss.SSSZ", my = {
  title: ny,
  weekdays: ry,
  navMonths: sy,
  hours: oy,
  input: iy,
  inputDateTime: ly,
  inputDateTime24hr: uy,
  inputTime: cy,
  inputTime24hr: dy,
  dayPopover: fy,
  data: hy,
  model: vy,
  iso: py
}, yy = 300, gy = 60, by = 80, _y = {
  maxSwipeTime: yy,
  minHorizontalSwipeDistance: gy,
  maxVerticalSwipeDistance: by
}, $y = {
  componentPrefix: "V",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: _y,
  masks: my,
  locales: ay,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      isInteractive: !0
    }
  }
}, F0 = a1($y), wy = _(() => Bv(F0.locales, (e) => (e.masks = Z0(e.masks, F0.masks), e))), g0 = (e) => typeof window < "u" && os(window.__vcalendar__, e) ? S0(window.__vcalendar__, e) : S0(F0, e), Cy = (e, t) => (e.config.globalProperties.$VCalendar = F0, Object.assign(F0, Z0(t, F0))), xy = 12, My = 5;
function Sy(e, t) {
  const a = new Intl.DateTimeFormat().resolvedOptions().locale;
  let n;
  Ue(e) ? n = e : os(e, "id") && (n = e.id), n = (n || a).toLowerCase();
  const s = Object.keys(t), r = (u) => s.find((c) => c.toLowerCase() === u);
  n = r(n) || r(n.substring(0, 2)) || a;
  const i = {
    ...t["en-IE"],
    ...t[n],
    id: n,
    monthCacheSize: xy,
    pageCacheSize: My
  };
  return a0(e) ? Z0(e, i) : i;
}
class e1 {
  constructor(t = void 0, a) {
    R(this, "id"), R(this, "daysInWeek"), R(this, "firstDayOfWeek"), R(this, "masks"), R(this, "timezone"), R(this, "hourLabels"), R(this, "dayNames"), R(this, "dayNamesShort"), R(this, "dayNamesShorter"), R(this, "dayNamesNarrow"), R(this, "monthNames"), R(this, "monthNamesShort"), R(this, "relativeTimeNames"), R(this, "amPm", ["am", "pm"]), R(this, "monthCache"), R(this, "pageCache");
    const { id: n, firstDayOfWeek: s, masks: r, monthCacheSize: i, pageCacheSize: l } = Sy(t, wy.value);
    this.monthCache = new Nn(
      i,
      Zy,
      Gy
    ), this.pageCache = new Nn(l, hs, Qm), this.id = n, this.daysInWeek = $e, this.firstDayOfWeek = om(s, 1, $e), this.masks = r, this.timezone = a || void 0, this.hourLabels = this.getHourLabels(), this.dayNames = D1("long", this.id), this.dayNamesShort = D1("short", this.id), this.dayNamesShorter = this.dayNamesShort.map((u) => u.substring(0, 2)), this.dayNamesNarrow = D1("narrow", this.id), this.monthNames = Un("long", this.id), this.monthNamesShort = Un("short", this.id), this.relativeTimeNames = Jy(this.id);
  }
  formatDate(t, a) {
    return ng(t, a, this);
  }
  parseDate(t, a) {
    return qn(t, a, this);
  }
  toDate(t, a = {}) {
    const n = /* @__PURE__ */ new Date(NaN);
    let s = n;
    const { fillDate: r, mask: i, patch: l, rules: u } = a;
    if (Fe(t) ? (a.type = "number", s = /* @__PURE__ */ new Date(+t)) : Ue(t) ? (a.type = "string", s = t ? qn(t, i || "iso", this) : n) : N0(t) ? (a.type = "date", s = new Date(t.getTime())) : xa(t) && (a.type = "object", s = this.getDateFromParts(t)), s && (l || u)) {
      let c = this.getDateParts(s);
      if (l && r != null) {
        const d = this.getDateParts(this.toDate(r));
        c = this.getDateParts(
          this.toDate({ ...d, ...ls(c, Hy[l]) })
        );
      }
      u && (c = ag(c, u)), s = this.getDateFromParts(c);
    }
    return s || n;
  }
  toDateOrNull(t, a = {}) {
    const n = this.toDate(t, a);
    return isNaN(n.getTime()) ? null : n;
  }
  fromDate(t, { type: a, mask: n } = {}) {
    switch (a) {
      case "number":
        return t ? t.getTime() : NaN;
      case "string":
        return t ? this.formatDate(t, n || "iso") : "";
      case "object":
        return t ? this.getDateParts(t) : null;
      default:
        return t ? new Date(t) : null;
    }
  }
  range(t) {
    return R0.from(t, this);
  }
  ranges(t) {
    return R0.fromMany(t, this);
  }
  getDateParts(t) {
    return qy(t, this);
  }
  getDateFromParts(t) {
    return xs(t, this.timezone);
  }
  getDateFromParams(t, a, n, s, r, i, l) {
    return this.getDateFromParts({
      year: t,
      month: a,
      day: n,
      hours: s,
      minutes: r,
      seconds: i,
      milliseconds: l
    });
  }
  getPage(t) {
    const a = this.pageCache.getOrSet(t, this);
    return ey(t, a);
  }
  getMonthParts(t, a) {
    const { firstDayOfWeek: n } = this;
    return this.monthCache.getOrSet(t, a, n);
  }
  getThisMonthParts() {
    const t = /* @__PURE__ */ new Date();
    return this.getMonthParts(
      t.getMonth() + 1,
      t.getFullYear()
    );
  }
  getPrevMonthParts(t, a) {
    return t === 1 ? this.getMonthParts(12, a - 1) : this.getMonthParts(t - 1, a);
  }
  getNextMonthParts(t, a) {
    return t === 12 ? this.getMonthParts(1, a + 1) : this.getMonthParts(t + 1, a);
  }
  getHourLabels() {
    return Xy().map((t) => this.formatDate(t, this.masks.hours));
  }
  getDayId(t) {
    return this.formatDate(t, "YYYY-MM-DD");
  }
}
var H0 = /* @__PURE__ */ ((e) => (e.Any = "any", e.All = "all", e))(H0 || {}), vs = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(vs || {}), ps = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weekdays = "weekdays", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(ps || {}), ms = /* @__PURE__ */ ((e) => (e.OrdinalWeekdays = "ordinalWeekdays", e))(ms || {});
class Dy {
  constructor(t, a, n) {
    R(this, "validated", !0), this.type = t, this.interval = a, this.from = n, this.from || (console.error(
      'A valid "from" date is required for date interval rule. This rule will be skipped.'
    ), this.validated = !1);
  }
  passes(t) {
    if (!this.validated)
      return !0;
    const { date: a } = t;
    switch (this.type) {
      case "days":
        return Ma(this.from.date, a) % this.interval === 0;
      case "weeks":
        return jy(this.from.date, a) % this.interval === 0;
      case "months":
        return Uy(this.from.date, a) % this.interval === 0;
      case "years":
        return Cs(this.from.date, a) % this.interval === 0;
      default:
        return !1;
    }
  }
}
class rt {
  constructor(t, a, n, s) {
    R(this, "components", []), this.type = t, this.validator = n, this.getter = s, this.components = this.normalizeComponents(a);
  }
  static create(t, a) {
    switch (t) {
      case "days":
        return new ky(a);
      case "weekdays":
        return new Ly(a);
      case "weeks":
        return new Iy(a);
      case "months":
        return new Oy(a);
      case "years":
        return new zy(a);
    }
  }
  normalizeComponents(t) {
    if (this.validator(t))
      return [t];
    if (!Ye(t))
      return [];
    const a = [];
    return t.forEach((n) => {
      if (!this.validator(n)) {
        console.error(
          `Component value ${n} in invalid for "${this.type}" rule. This rule will be skipped.`
        );
        return;
      }
      a.push(n);
    }), a;
  }
  passes(t) {
    return this.getter(t).some((s) => this.components.includes(s));
  }
}
class ky extends rt {
  constructor(t) {
    super(
      "days",
      t,
      Ty,
      ({ day: a, dayFromEnd: n }) => [a, -n]
    );
  }
}
class Ly extends rt {
  constructor(t) {
    super(
      "weekdays",
      t,
      R1,
      ({ weekday: a }) => [a]
    );
  }
}
class Iy extends rt {
  constructor(t) {
    super(
      "weeks",
      t,
      Ey,
      ({ week: a, weekFromEnd: n }) => [a, -n]
    );
  }
}
class Oy extends rt {
  constructor(t) {
    super("months", t, Yy, ({ month: a }) => [
      a
    ]);
  }
}
class zy extends rt {
  constructor(t) {
    super("years", t, Fe, ({ year: a }) => [a]);
  }
}
class Ay {
  constructor(t, a) {
    R(this, "components"), this.type = t, this.components = this.normalizeComponents(a);
  }
  normalizeArrayConfig(t) {
    const a = [];
    return t.forEach((n, s) => {
      if (Fe(n)) {
        if (s === 0)
          return;
        if (!Rn(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!R1(n)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        a.push([t[0], n]);
      } else Ye(n) && a.push(...this.normalizeArrayConfig(n));
    }), a;
  }
  normalizeComponents(t) {
    const a = [];
    return t.forEach((n, s) => {
      if (Fe(n)) {
        if (s === 0)
          return;
        if (!Rn(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!R1(n)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        a.push([t[0], n]);
      } else Ye(n) && a.push(...this.normalizeArrayConfig(n));
    }), a;
  }
  passes(t) {
    const { weekday: a, weekdayOrdinal: n, weekdayOrdinalFromEnd: s } = t;
    return this.components.some(
      ([r, i]) => (r === n || r === -s) && a === i
    );
  }
}
class Py {
  constructor(t) {
    R(this, "type", "function"), R(this, "validated", !0), this.fn = t, O0(t) || (console.error(
      "The function rule requires a valid function. This rule will be skipped."
    ), this.validated = !1);
  }
  passes(t) {
    return this.validated ? this.fn(t) : !0;
  }
}
class t1 {
  constructor(t, a = {}, n) {
    R(this, "validated", !0), R(this, "config"), R(this, "type", H0.Any), R(this, "from"), R(this, "until"), R(this, "rules", []), R(this, "locale", new e1()), this.parent = n, a.locale && (this.locale = a.locale), this.config = t, O0(t) ? (this.type = H0.All, this.rules = [new Py(t)]) : Ye(t) ? (this.type = H0.Any, this.rules = t.map((s) => new t1(s, a, this))) : a0(t) ? (this.type = H0.All, this.from = t.from ? this.locale.getDateParts(t.from) : n == null ? void 0 : n.from, this.until = t.until ? this.locale.getDateParts(t.until) : n == null ? void 0 : n.until, this.rules = this.getObjectRules(t)) : (console.error("Rule group configuration must be an object or an array."), this.validated = !1);
  }
  getObjectRules(t) {
    const a = [];
    if (t.every && (Ue(t.every) && (t.every = [1, `${t.every}s`]), Ye(t.every))) {
      const [n = 1, s = vs.Days] = t.every;
      a.push(new Dy(s, n, this.from));
    }
    return Object.values(ps).forEach((n) => {
      n in t && a.push(rt.create(n, t[n]));
    }), Object.values(ms).forEach((n) => {
      n in t && a.push(new Ay(n, t[n]));
    }), t.on != null && (Ye(t.on) || (t.on = [t.on]), a.push(
      new t1(t.on, { locale: this.locale }, this.parent)
    )), a;
  }
  passes(t) {
    return this.validated ? this.from && t.dayIndex <= this.from.dayIndex || this.until && t.dayIndex >= this.until.dayIndex ? !1 : this.type === H0.Any ? this.rules.some((a) => a.passes(t)) : this.rules.every((a) => a.passes(t)) : !0;
  }
}
function Ty(e) {
  return Fe(e) ? e >= 1 && e <= 31 : !1;
}
function R1(e) {
  return Fe(e) ? e >= 1 && e <= 7 : !1;
}
function Ey(e) {
  return Fe(e) ? e >= -6 && e <= -1 || e >= 1 && e <= 6 : !1;
}
function Yy(e) {
  return Fe(e) ? e >= 1 && e <= 12 : !1;
}
function Rn(e) {
  return !(!Fe(e) || e < -5 || e > 5 || e === 0);
}
const Hy = {
  dateTime: [
    "year",
    "month",
    "day",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ],
  date: ["year", "month", "day"],
  time: ["hours", "minutes", "seconds", "milliseconds"]
}, $e = 7, Vy = 6, ys = 1e3, gs = ys * 60, bs = gs * 60, Bt = bs * 24, Ny = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ry = ["L", "iso"], vt = {
  milliseconds: [0, 999, 3],
  seconds: [0, 59, 2],
  minutes: [0, 59, 2],
  hours: [0, 23, 2]
}, _s = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, Fy = /\[([^]*?)\]/gm, Fn = {
  D(e) {
    return e.day;
  },
  DD(e) {
    return re(e.day, 2);
  },
  // Do(d: DateParts, l: Locale) {
  //   return l.DoFn(d.day);
  // },
  d(e) {
    return e.weekday - 1;
  },
  dd(e) {
    return re(e.weekday - 1, 2);
  },
  W(e, t) {
    return t.dayNamesNarrow[e.weekday - 1];
  },
  WW(e, t) {
    return t.dayNamesShorter[e.weekday - 1];
  },
  WWW(e, t) {
    return t.dayNamesShort[e.weekday - 1];
  },
  WWWW(e, t) {
    return t.dayNames[e.weekday - 1];
  },
  M(e) {
    return e.month;
  },
  MM(e) {
    return re(e.month, 2);
  },
  MMM(e, t) {
    return t.monthNamesShort[e.month - 1];
  },
  MMMM(e, t) {
    return t.monthNames[e.month - 1];
  },
  YY(e) {
    return String(e.year).substr(2);
  },
  YYYY(e) {
    return re(e.year, 4);
  },
  h(e) {
    return e.hours % 12 || 12;
  },
  hh(e) {
    return re(e.hours % 12 || 12, 2);
  },
  H(e) {
    return e.hours;
  },
  HH(e) {
    return re(e.hours, 2);
  },
  m(e) {
    return e.minutes;
  },
  mm(e) {
    return re(e.minutes, 2);
  },
  s(e) {
    return e.seconds;
  },
  ss(e) {
    return re(e.seconds, 2);
  },
  S(e) {
    return Math.round(e.milliseconds / 100);
  },
  SS(e) {
    return re(Math.round(e.milliseconds / 10), 2);
  },
  SSS(e) {
    return re(e.milliseconds, 3);
  },
  a(e, t) {
    return e.hours < 12 ? t.amPm[0] : t.amPm[1];
  },
  A(e, t) {
    return e.hours < 12 ? t.amPm[0].toUpperCase() : t.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${re(Math.floor(Math.abs(t) / 60), 2)}`;
  },
  ZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${re(
      Math.floor(Math.abs(t) / 60) * 100 + Math.abs(t) % 60,
      4
    )}`;
  },
  ZZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${re(Math.floor(Math.abs(t) / 60), 2)}:${re(
      Math.abs(t) % 60,
      2
    )}`;
  }
}, h0 = /\d\d?/, By = /\d{3}/, Wy = /\d{4}/, dt = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, Bn = () => {
}, Wn = (e) => (t, a, n) => {
  const s = n[e].indexOf(
    a.charAt(0).toUpperCase() + a.substr(1).toLowerCase()
  );
  ~s && (t.month = s);
}, ue = {
  D: [
    h0,
    (e, t) => {
      e.day = t;
    }
  ],
  Do: [
    new RegExp(h0.source + dt.source),
    (e, t) => {
      e.day = parseInt(t, 10);
    }
  ],
  d: [h0, Bn],
  W: [dt, Bn],
  M: [
    h0,
    (e, t) => {
      e.month = t - 1;
    }
  ],
  MMM: [dt, Wn("monthNamesShort")],
  MMMM: [dt, Wn("monthNames")],
  YY: [
    h0,
    (e, t) => {
      const n = +(/* @__PURE__ */ new Date()).getFullYear().toString().substr(0, 2);
      e.year = +`${t > 68 ? n - 1 : n}${t}`;
    }
  ],
  YYYY: [
    Wy,
    (e, t) => {
      e.year = t;
    }
  ],
  S: [
    /\d/,
    (e, t) => {
      e.milliseconds = t * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (e, t) => {
      e.milliseconds = t * 10;
    }
  ],
  SSS: [
    By,
    (e, t) => {
      e.milliseconds = t;
    }
  ],
  h: [
    h0,
    (e, t) => {
      e.hours = t;
    }
  ],
  m: [
    h0,
    (e, t) => {
      e.minutes = t;
    }
  ],
  s: [
    h0,
    (e, t) => {
      e.seconds = t;
    }
  ],
  a: [
    dt,
    (e, t, a) => {
      const n = t.toLowerCase();
      n === a.amPm[0] ? e.isPm = !1 : n === a.amPm[1] && (e.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (e, t) => {
      t === "Z" && (t = "+00:00");
      const a = `${t}`.match(/([+-]|\d\d)/gi);
      if (a) {
        const n = +a[1] * 60 + parseInt(a[2], 10);
        e.timezoneOffset = a[0] === "+" ? n : -n;
      }
    }
  ]
};
ue.DD = ue.D;
ue.dd = ue.d;
ue.WWWW = ue.WWW = ue.WW = ue.W;
ue.MM = ue.M;
ue.mm = ue.m;
ue.hh = ue.H = ue.HH = ue.h;
ue.ss = ue.s;
ue.A = ue.a;
ue.ZZZZ = ue.ZZZ = ue.ZZ = ue.Z;
function $s(e, t) {
  return (Qe(e) && e || [
    Ue(e) && e || "YYYY-MM-DD"
  ]).map(
    (a) => Ry.reduce(
      (n, s) => n.replace(s, t.masks[s] || ""),
      a
    )
  );
}
function xa(e) {
  return a0(e) && "year" in e && "month" in e && "day" in e;
}
function jn(e, t = 1) {
  const a = e.getDay() + 1, n = a >= t ? t - a : -(7 - (t - a));
  return Me(e, n);
}
function ws(e, t, a) {
  const n = Date.UTC(e, t - 1, a);
  return Ma(/* @__PURE__ */ new Date(0), new Date(n));
}
function Ma(e, t) {
  return Math.round((t.getTime() - e.getTime()) / Bt);
}
function jy(e, t) {
  return Math.ceil(Ma(jn(e), jn(t)) / 7);
}
function Cs(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}
function Uy(e, t) {
  return Cs(e, t) * 12 + (t.getMonth() - e.getMonth());
}
function xs(e, t = "") {
  const a = /* @__PURE__ */ new Date(), {
    year: n = a.getFullYear(),
    month: s = a.getMonth() + 1,
    day: r = a.getDate(),
    hours: i = 0,
    minutes: l = 0,
    seconds: u = 0,
    milliseconds: c = 0
  } = e;
  if (t) {
    const d = `${re(n, 4)}-${re(s, 2)}-${re(r, 2)}T${re(
      i,
      2
    )}:${re(l, 2)}:${re(u, 2)}.${re(c, 3)}`;
    return Cm(d, { timeZone: t });
  }
  return new Date(n, s - 1, r, i, l, u, c);
}
function qy(e, t) {
  let a = new Date(e.getTime());
  t.timezone && (a = new Date(
    e.toLocaleString("en-US", { timeZone: t.timezone })
  ), a.setMilliseconds(e.getMilliseconds()));
  const n = a.getMilliseconds(), s = a.getSeconds(), r = a.getMinutes(), i = a.getHours(), l = n + s * ys + r * gs + i * bs, u = a.getMonth() + 1, c = a.getFullYear(), d = t.getMonthParts(u, c), v = a.getDate(), y = d.numDays - v + 1, m = a.getDay() + 1, g = Math.floor((v - 1) / 7 + 1), S = Math.floor((d.numDays - v) / 7 + 1), $ = Math.ceil(
    (v + Math.abs(d.firstWeekday - d.firstDayOfWeek)) / 7
  ), b = d.numWeeks - $ + 1, Y = d.weeknumbers[$], V = ws(c, u, v);
  return {
    milliseconds: n,
    seconds: s,
    minutes: r,
    hours: i,
    time: l,
    day: v,
    dayFromEnd: y,
    weekday: m,
    weekdayOrdinal: g,
    weekdayOrdinalFromEnd: S,
    week: $,
    weekFromEnd: b,
    weeknumber: Y,
    month: u,
    year: c,
    date: a,
    dateTime: a.getTime(),
    dayIndex: V,
    timezoneOffset: 0,
    isValid: !0
  };
}
function Zy(e, t, a) {
  return `${t}-${e}-${a}`;
}
function Gy(e, t, a) {
  const n = t % 4 === 0 && t % 100 !== 0 || t % 400 === 0, s = new Date(t, e - 1, 1), r = s.getDay() + 1, i = e === 2 && n ? 29 : Ny[e - 1], l = a - 1, u = Em(s, {
    weekStartsOn: l
  }), c = [], d = [];
  for (let v = 0; v < u; v++) {
    const y = Me(s, v * 7);
    c.push(Nm(y, { weekStartsOn: l })), d.push(Wm(y));
  }
  return {
    firstDayOfWeek: a,
    firstDayOfMonth: s,
    inLeapYear: n,
    firstWeekday: r,
    numDays: i,
    numWeeks: u,
    month: e,
    year: t,
    weeknumbers: c,
    isoWeeknumbers: d
  };
}
function Ky() {
  const e = [];
  for (let s = 0; s < $e; s++)
    e.push(
      xs({
        year: 2020,
        month: 1,
        day: 5 + s,
        hours: 12
      })
    );
  return e;
}
function D1(e, t = void 0) {
  const a = new Intl.DateTimeFormat(t, {
    weekday: e
  });
  return Ky().map((n) => a.format(n));
}
function Xy() {
  const e = [];
  for (let t = 0; t <= 24; t++)
    e.push(new Date(2e3, 0, 1, t));
  return e;
}
function Jy(e = void 0) {
  const t = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
  ], a = new Intl.RelativeTimeFormat(e);
  return t.reduce((n, s) => {
    const r = a.formatToParts(100, s);
    return n[s] = r[1].unit, n;
  }, {});
}
function Ms() {
  const e = [];
  for (let t = 0; t < 12; t++)
    e.push(new Date(2e3, t, 15));
  return e;
}
function Un(e, t = void 0) {
  const a = new Intl.DateTimeFormat(t, {
    month: e,
    timeZone: "UTC"
  });
  return Ms().map((n) => a.format(n));
}
function Qy(e, t, a) {
  return Fe(t) ? t === e : Ye(t) ? t.includes(e) : O0(t) ? t(e, a) : !(t.min != null && t.min > e || t.max != null && t.max < e || t.interval != null && e % t.interval !== 0);
}
function pt(e, t, a) {
  const n = [], [s, r, i] = t;
  for (let l = s; l <= r; l++)
    (a == null || Qy(l, a, e)) && n.push({
      value: l,
      label: re(l, i)
    });
  return n;
}
function eg(e, t) {
  return {
    milliseconds: pt(
      e,
      vt.milliseconds,
      t.milliseconds
    ),
    seconds: pt(e, vt.seconds, t.seconds),
    minutes: pt(e, vt.minutes, t.minutes),
    hours: pt(e, vt.hours, t.hours)
  };
}
function tg(e, t, a, n) {
  const r = pt(e, t, n).reduce((i, l) => {
    if (l.disabled)
      return i;
    if (isNaN(i))
      return l.value;
    const u = Math.abs(i - a);
    return Math.abs(l.value - a) < u ? l.value : i;
  }, NaN);
  return isNaN(r) ? a : r;
}
function ag(e, t) {
  const a = { ...e };
  return Object.entries(t).forEach(([n, s]) => {
    const r = vt[n], i = e[n];
    a[n] = tg(
      e,
      r,
      i,
      s
    );
  }), a;
}
function qn(e, t, a) {
  return $s(t, a).map((s) => {
    if (typeof s != "string")
      throw new Error("Invalid mask");
    let r = e;
    if (r.length > 1e3)
      return !1;
    let i = !0;
    const l = {};
    if (s.replace(_s, (d) => {
      if (ue[d]) {
        const v = ue[d], y = r.search(v[0]);
        ~y ? r.replace(v[0], (m) => (v[1](l, m, a), r = r.substr(y + m.length), m)) : i = !1;
      }
      return ue[d] ? "" : d.slice(1, d.length - 1);
    }), !i)
      return !1;
    const u = /* @__PURE__ */ new Date();
    l.hours != null && (l.isPm === !0 && +l.hours != 12 ? l.hours = +l.hours + 12 : l.isPm === !1 && +l.hours == 12 && (l.hours = 0));
    let c;
    return l.timezoneOffset != null ? (l.minutes = +(l.minutes || 0) - +l.timezoneOffset, c = new Date(
      Date.UTC(
        l.year || u.getFullYear(),
        l.month || 0,
        l.day || 1,
        l.hours || 0,
        l.minutes || 0,
        l.seconds || 0,
        l.milliseconds || 0
      )
    )) : c = a.getDateFromParts({
      year: l.year || u.getFullYear(),
      month: (l.month || 0) + 1,
      day: l.day || 1,
      hours: l.hours || 0,
      minutes: l.minutes || 0,
      seconds: l.seconds || 0,
      milliseconds: l.milliseconds || 0
    }), c;
  }).find((s) => s) || new Date(e);
}
function ng(e, t, a) {
  if (e == null)
    return "";
  let n = $s(t, a)[0];
  /Z$/.test(n) && (a.timezone = "utc");
  const s = [];
  n = n.replace(Fy, (i, l) => (s.push(l), "??"));
  const r = a.getDateParts(e);
  return n = n.replace(
    _s,
    (i) => i in Fn ? Fn[i](r, a) : i.slice(1, i.length - 1)
  ), n.replace(/\?\?/g, () => s.shift());
}
let rg = 0;
class Ss {
  constructor(t, a, n) {
    R(this, "key", ""), R(this, "hashcode", ""), R(this, "highlight", null), R(this, "content", null), R(this, "dot", null), R(this, "bar", null), R(this, "event", null), R(this, "popover", null), R(this, "customData", null), R(this, "ranges"), R(this, "hasRanges", !1), R(this, "order", 0), R(this, "pinPage", !1), R(this, "maxRepeatSpan", 0), R(this, "locale");
    const { dates: s } = Object.assign(
      this,
      { hashcode: "", order: 0, pinPage: !1 },
      t
    );
    this.key || (this.key = ++rg), this.locale = n, a.normalizeGlyphs(this), this.ranges = n.ranges(s ?? []), this.hasRanges = !!Qe(this.ranges), this.maxRepeatSpan = this.ranges.filter((r) => r.hasRepeat).map((r) => r.daySpan).reduce((r, i) => Math.max(r, i), 0);
  }
  intersectsRange({ start: t, end: a }) {
    if (t == null || a == null)
      return !1;
    const n = this.ranges.filter((i) => !i.hasRepeat);
    for (const i of n)
      if (i.intersectsDayRange(t.dayIndex, a.dayIndex))
        return !0;
    const s = this.ranges.filter((i) => i.hasRepeat);
    if (!s.length)
      return !1;
    let r = t;
    for (this.maxRepeatSpan > 1 && (r = this.locale.getDateParts(Me(r.date, -this.maxRepeatSpan))); r.dayIndex <= a.dayIndex; ) {
      for (const i of s)
        if (i.startsOnDay(r))
          return !0;
      r = this.locale.getDateParts(Me(r.date, 1));
    }
    return !1;
  }
}
function F1(e) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: e
    })
  );
}
function wt(e) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: e
    })
  );
}
function Ds(e) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: e
    })
  );
}
function ks(e) {
  const { visibility: t } = e, a = t === "click", n = t === "hover", s = t === "hover-focus", r = t === "focus";
  e.autoHide = !a;
  let i = !1, l = !1;
  const u = (g) => {
    a && (Ds({
      ...e,
      target: e.target || g.currentTarget
    }), g.stopPropagation());
  }, c = (g) => {
    i || (i = !0, (n || s) && F1({
      ...e,
      target: e.target || g.currentTarget
    }));
  }, d = () => {
    i && (i = !1, (n || s && !l) && wt(e));
  }, v = (g) => {
    l || (l = !0, (r || s) && F1({
      ...e,
      target: e.target || g.currentTarget
    }));
  }, y = (g) => {
    l && !Rt(g.currentTarget, g.relatedTarget) && (l = !1, (r || s && !i) && wt(e));
  }, m = {};
  switch (e.visibility) {
    case "click":
      m.click = u;
      break;
    case "hover":
      m.mousemove = c, m.mouseleave = d;
      break;
    case "focus":
      m.focusin = v, m.focusout = y;
      break;
    case "hover-focus":
      m.mousemove = c, m.mouseleave = d, m.focusin = v, m.focusout = y;
      break;
  }
  return m;
}
const Zn = (e) => {
  const t = Zt(e);
  if (t == null)
    return;
  const a = t.popoverHandlers;
  !a || !a.length || (a.forEach((n) => n()), delete t.popoverHandlers);
}, Gn = (e, t) => {
  const a = Zt(e);
  if (a == null)
    return;
  const n = [], s = ks(t);
  Object.entries(s).forEach(([r, i]) => {
    n.push(m0(a, r, i));
  }), a.popoverHandlers = n;
}, Ls = {
  mounted(e, t) {
    const { value: a } = t;
    a && Gn(e, a);
  },
  updated(e, t) {
    const { oldValue: a, value: n } = t, s = a == null ? void 0 : a.visibility, r = n == null ? void 0 : n.visibility;
    s !== r && (s && (Zn(e), r || wt(a)), r && Gn(e, n));
  },
  unmounted(e) {
    Zn(e);
  }
}, sg = (e, t, {
  maxSwipeTime: a,
  minHorizontalSwipeDistance: n,
  maxVerticalSwipeDistance: s
}) => {
  if (!e || !e.addEventListener || !O0(t))
    return null;
  let r = 0, i = 0, l = null, u = !1;
  function c(v) {
    const y = v.changedTouches[0];
    r = y.screenX, i = y.screenY, l = (/* @__PURE__ */ new Date()).getTime(), u = !0;
  }
  function d(v) {
    if (!u || !l)
      return;
    u = !1;
    const y = v.changedTouches[0], m = y.screenX - r, g = y.screenY - i;
    if ((/* @__PURE__ */ new Date()).getTime() - l < a && Math.abs(m) >= n && Math.abs(g) <= s) {
      const $ = { toLeft: !1, toRight: !1 };
      m < 0 ? $.toLeft = !0 : $.toRight = !0, t($);
    }
  }
  return m0(e, "touchstart", c, { passive: !0 }), m0(e, "touchend", d, { passive: !0 }), () => {
    p0(e, "touchstart", c), p0(e, "touchend", d);
  };
}, Wt = {}, og = (e, t = 10) => {
  Wt[e] = Date.now() + t;
}, ig = (e, t) => {
  if (e in Wt) {
    const a = Wt[e];
    if (Date.now() < a)
      return;
    delete Wt[e];
  }
  t();
};
function Is() {
  return typeof window < "u";
}
function lg(e) {
  return Is() && e in window;
}
function ug(e) {
  const t = se(!1), a = _(() => t.value ? "dark" : "light");
  let n, s;
  function r(m) {
    t.value = m.matches;
  }
  function i() {
    lg("matchMedia") && (n = window.matchMedia("(prefers-color-scheme: dark)"), n.addEventListener("change", r), t.value = n.matches);
  }
  function l() {
    const { selector: m = ":root", darkClass: g = "dark" } = e.value, S = document.querySelector(m);
    t.value = S.classList.contains(g);
  }
  function u(m) {
    const { selector: g = ":root", darkClass: S = "dark" } = m;
    if (Is() && g && S) {
      const $ = document.querySelector(g);
      $ && (s = new MutationObserver(l), s.observe($, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t.value = $.classList.contains(S));
    }
  }
  function c() {
    v();
    const m = typeof e.value;
    m === "string" && e.value.toLowerCase() === "system" ? i() : m === "object" ? u(e.value) : t.value = !!e.value;
  }
  const d = xe(() => e.value, () => c(), {
    immediate: !0
  });
  function v() {
    n && (n.removeEventListener("change", r), n = void 0), s && (s.disconnect(), s = void 0);
  }
  function y() {
    v(), d();
  }
  return W1(() => y()), {
    isDark: t,
    displayMode: a,
    cleanup: y
  };
}
const cg = ["base", "start", "end", "startEnd"], dg = [
  "class",
  "wrapperClass",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], fg = { base: {}, start: {}, end: {} };
function Sa(e, t, a = fg) {
  let n = e, s = {};
  t === !0 || Ue(t) ? (n = Ue(t) ? t : n, s = { ...a }) : a0(t) && (Ln(t, cg) ? s = { ...t } : s = {
    base: { ...t },
    start: { ...t },
    end: { ...t }
  });
  const r = Z0(
    s,
    { start: s.startEnd, end: s.startEnd },
    a
  );
  return Object.entries(r).forEach(([i, l]) => {
    let u = n;
    l === !0 || Ue(l) ? (u = Ue(l) ? l : u, r[i] = { color: u }) : a0(l) && (Ln(l, dg) ? r[i] = { ...l } : r[i] = {}), Z0(r[i], { color: u });
  }), r;
}
class hg {
  constructor() {
    R(this, "type", "highlight");
  }
  normalizeConfig(t, a) {
    return Sa(t, a, {
      base: { fillMode: "light" },
      start: { fillMode: "solid" },
      end: { fillMode: "solid" }
    });
  }
  prepareRender(t) {
    t.highlights = [], t.content || (t.content = []);
  }
  render({ data: t, onStart: a, onEnd: n }, s) {
    const { key: r, highlight: i } = t;
    if (!i)
      return;
    const { highlights: l } = s, { base: u, start: c, end: d } = i;
    a && n ? l.push({
      ...c,
      key: r,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [`vc-highlight vc-highlight-bg-${c.fillMode}`, c.class],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    }) : a ? (l.push({
      ...u,
      key: `${r}-base`,
      wrapperClass: `vc-day-layer vc-day-box-right-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-start vc-highlight-bg-${u.fillMode}`,
        u.class
      ]
    }), l.push({
      ...c,
      key: r,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [`vc-highlight vc-highlight-bg-${c.fillMode}`, c.class],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    })) : n ? (l.push({
      ...u,
      key: `${r}-base`,
      wrapperClass: `vc-day-layer vc-day-box-left-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-end vc-highlight-bg-${u.fillMode}`,
        u.class
      ]
    }), l.push({
      ...d,
      key: r,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${d.color}`,
      class: [`vc-highlight vc-highlight-bg-${d.fillMode}`, d.class],
      contentClass: [
        `vc-attr vc-highlight-content-${d.fillMode} vc-${d.color}`,
        d.contentClass
      ]
    })) : l.push({
      ...u,
      key: `${r}-middle`,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-middle vc-highlight-bg-${u.fillMode}`,
        u.class
      ],
      contentClass: [
        `vc-attr vc-highlight-content-${u.fillMode} vc-${u.color}`,
        u.contentClass
      ]
    });
  }
}
class Da {
  constructor(t, a) {
    R(this, "type", ""), R(this, "collectionType", ""), this.type = t, this.collectionType = a;
  }
  normalizeConfig(t, a) {
    return Sa(t, a);
  }
  prepareRender(t) {
    t[this.collectionType] = [];
  }
  render({ data: t, onStart: a, onEnd: n }, s) {
    const { key: r } = t, i = t[this.type];
    if (!r || !i)
      return;
    const l = s[this.collectionType], { base: u, start: c, end: d } = i;
    a ? l.push({
      ...c,
      key: r,
      class: [
        `vc-${this.type} vc-${this.type}-start vc-${c.color} vc-attr`,
        c.class
      ]
    }) : n ? l.push({
      ...d,
      key: r,
      class: [
        `vc-${this.type} vc-${this.type}-end vc-${d.color} vc-attr`,
        d.class
      ]
    }) : l.push({
      ...u,
      key: r,
      class: [
        `vc-${this.type} vc-${this.type}-base vc-${u.color} vc-attr`,
        u.class
      ]
    });
  }
}
class vg extends Da {
  constructor() {
    super("content", "content");
  }
  normalizeConfig(t, a) {
    return Sa("base", a);
  }
}
class pg extends Da {
  constructor() {
    super("dot", "dots");
  }
}
class mg extends Da {
  constructor() {
    super("bar", "bars");
  }
}
class yg {
  constructor(t) {
    R(this, "color"), R(this, "renderers", [
      new vg(),
      new hg(),
      new pg(),
      new mg()
    ]), this.color = t;
  }
  normalizeGlyphs(t) {
    this.renderers.forEach((a) => {
      const n = a.type;
      t[n] != null && (t[n] = a.normalizeConfig(this.color, t[n]));
    });
  }
  prepareRender(t = {}) {
    return this.renderers.forEach((a) => {
      a.prepareRender(t);
    }), t;
  }
  render(t, a) {
    this.renderers.forEach((n) => {
      n.render(t, a);
    });
  }
}
const Os = Symbol("__vc_base_context__"), zs = {
  color: {
    type: String,
    default: () => g0("color")
  },
  isDark: {
    type: [Boolean, String, Object],
    default: () => g0("isDark")
  },
  firstDayOfWeek: Number,
  masks: Object,
  locale: [String, Object],
  timezone: String,
  minDate: null,
  maxDate: null,
  disabledDates: null
};
function As(e) {
  const t = _(() => e.color ?? ""), a = _(() => e.isDark ?? !1), { displayMode: n } = ug(a), s = _(() => new yg(t.value)), r = _(() => {
    if (e.locale instanceof e1)
      return e.locale;
    const y = a0(e.locale) ? e.locale : {
      id: e.locale,
      firstDayOfWeek: e.firstDayOfWeek,
      masks: e.masks
    };
    return new e1(y, e.timezone);
  }), i = _(() => r.value.masks), l = _(() => e.minDate), u = _(() => e.maxDate), c = _(() => {
    const y = e.disabledDates ? [...e.disabledDates] : [];
    return l.value != null && y.push({
      start: null,
      end: Me(r.value.toDate(l.value), -1)
    }), u.value != null && y.push({
      start: Me(r.value.toDate(u.value), 1),
      end: null
    }), r.value.ranges(y);
  }), d = _(() => new Ss(
    {
      key: "disabled",
      dates: c.value,
      order: 100
    },
    s.value,
    r.value
  )), v = {
    color: t,
    isDark: a,
    displayMode: n,
    theme: s,
    locale: r,
    masks: i,
    minDate: l,
    maxDate: u,
    disabledDates: c,
    disabledAttribute: d
  };
  return Mt(Os, v), v;
}
function gg(e) {
  return xt(Os, () => As(e), !0);
}
function Ps(e) {
  return `__vc_slot_${e}__`;
}
function Ts(e, t = {}) {
  Object.keys(e).forEach((a) => {
    Mt(Ps(t[a] ?? a), e[a]);
  });
}
function Es(e) {
  return xt(Ps(e), null);
}
const bg = {
  ...zs,
  view: {
    type: String,
    default: "monthly",
    validator(e) {
      return ["daily", "weekly", "monthly"].includes(e);
    }
  },
  rows: {
    type: Number,
    default: 1
  },
  columns: {
    type: Number,
    default: 1
  },
  step: Number,
  titlePosition: {
    type: String,
    default: () => g0("titlePosition")
  },
  navVisibility: {
    type: String,
    default: () => g0("navVisibility")
  },
  showWeeknumbers: [Boolean, String],
  showIsoWeeknumbers: [Boolean, String],
  expanded: Boolean,
  borderless: Boolean,
  transparent: Boolean,
  initialPage: Object,
  initialPagePosition: { type: Number, default: 1 },
  minPage: Object,
  maxPage: Object,
  transition: String,
  attributes: Array,
  trimWeeks: Boolean,
  disablePageSwipe: Boolean
}, _g = [
  "dayclick",
  "daymouseenter",
  "daymouseleave",
  "dayfocusin",
  "dayfocusout",
  "daykeydown",
  "weeknumberclick",
  "transition-start",
  "transition-end",
  "did-move",
  "update:view",
  "update:pages"
], Ys = Symbol("__vc_calendar_context__");
function $g(e, { slots: t, emit: a }) {
  const n = se(null), s = se(null), r = se((/* @__PURE__ */ new Date()).getDate()), i = se(!1), l = se(Symbol()), u = se(Symbol()), c = se(e.view), d = se([]), v = se("");
  let y = null, m = null;
  Ts(t);
  const {
    theme: g,
    color: S,
    displayMode: $,
    locale: b,
    masks: Y,
    minDate: V,
    maxDate: L,
    disabledAttribute: T,
    disabledDates: j
  } = gg(e), H = _(() => e.rows * e.columns), U = _(() => e.step || H.value), G = _(() => ss(d.value) ?? null), K = _(() => V0(d.value) ?? null), J = _(
    () => e.minPage || (V.value ? B(V.value) : null)
  ), N = _(
    () => e.maxPage || (L.value ? B(L.value) : null)
  ), q = _(() => e.navVisibility), ae = _(() => !!e.showWeeknumbers), W = _(() => !!e.showIsoWeeknumbers), te = _(() => c.value === "monthly"), le = _(() => c.value === "weekly"), ye = _(() => c.value === "daily"), de = () => {
    i.value = !0, a("transition-start");
  }, k = () => {
    i.value = !1, a("transition-end"), y && (y.resolve(!0), y = null);
  }, ee = (M, h, w = c.value) => fs(M, h, w, b.value), B = (M) => ds(M, c.value, b.value), ve = (M) => {
    !T.value || !Ie.value || (M.isDisabled = Ie.value.cellExists(
      T.value.key,
      M.dayIndex
    ));
  }, ne = (M) => {
    M.isFocusable = M.inMonth && M.day === r.value;
  }, pe = (M, h) => {
    for (const w of M)
      for (const I of w.days)
        if (h(I) === !1)
          return;
  }, ge = _(
    () => d.value.reduce((M, h) => (M.push(...h.viewDays), M), [])
  ), me = _(() => {
    const M = [];
    return (e.attributes || []).forEach((h, w) => {
      !h || !h.dates || M.push(
        new Ss(
          {
            ...h,
            order: h.order || 0
          },
          g.value,
          b.value
        )
      );
    }), T.value && M.push(T.value), M;
  }), be = _(() => Qe(me.value)), Ie = _(() => {
    const M = new ty();
    return me.value.forEach((h) => {
      h.ranges.forEach((w) => {
        M.render(h, w, ge.value);
      });
    }), M;
  }), Je = _(() => ge.value.reduce((M, h) => (M[h.dayIndex] = { day: h, cells: [] }, M[h.dayIndex].cells.push(...Ie.value.getCells(h)), M), {})), Ne = (M, h) => {
    const w = e.showWeeknumbers || e.showIsoWeeknumbers;
    return w == null ? "" : Mv(w) ? w ? "left" : "" : w.startsWith("right") ? h > 1 ? "right" : w : M > 1 ? "left" : w;
  }, Ae = () => {
    var M, h;
    if (!be.value)
      return null;
    const w = me.value.find((fe) => fe.pinPage) || me.value[0];
    if (!w || !w.hasRanges)
      return null;
    const [I] = w.ranges, Z = ((M = I.start) == null ? void 0 : M.date) || ((h = I.end) == null ? void 0 : h.date);
    return Z ? B(Z) : null;
  }, Pe = () => {
    if (qe(G.value))
      return G.value;
    const M = Ae();
    return qe(M) ? M : B(/* @__PURE__ */ new Date());
  }, o0 = (M, h = {}) => {
    const { view: w = c.value, position: I = 1, force: Z } = h, fe = I > 0 ? 1 - I : -(H.value + I);
    let Ce = ee(M, fe, w), Oe = ee(Ce, H.value - 1, w);
    return Z || (N1(Ce, J.value) ? Ce = J.value : Qt(Oe, N.value) && (Ce = ee(N.value, 1 - H.value)), Oe = ee(Ce, H.value - 1)), { fromPage: Ce, toPage: Oe };
  }, P0 = (M, h, w = "") => {
    if (w === "none" || w === "fade")
      return w;
    if ((M == null ? void 0 : M.view) !== (h == null ? void 0 : h.view))
      return "fade";
    const I = Qt(h, M), Z = N1(h, M);
    return !I && !Z ? "fade" : w === "slide-v" ? Z ? "slide-down" : "slide-up" : Z ? "slide-right" : "slide-left";
  }, je = (M = {}) => new Promise((h, w) => {
    const { position: I = 1, force: Z = !1, transition: fe } = M, Ce = qe(M.page) ? M.page : Pe(), { fromPage: Oe } = o0(Ce, {
      position: I,
      force: Z
    }), E0 = [];
    for (let Y0 = 0; Y0 < H.value; Y0++) {
      const y1 = ee(Oe, Y0), De = Y0 + 1, g1 = Math.ceil(De / e.columns), Pt = e.rows - g1 + 1, ot = De % e.columns || e.columns, it = e.columns - ot + 1, Xs = Ne(ot, it);
      E0.push(
        b.value.getPage({
          ...y1,
          view: c.value,
          titlePosition: e.titlePosition,
          trimWeeks: e.trimWeeks,
          position: De,
          row: g1,
          rowFromEnd: Pt,
          column: ot,
          columnFromEnd: it,
          showWeeknumbers: ae.value,
          showIsoWeeknumbers: W.value,
          weeknumberPosition: Xs
        })
      );
    }
    v.value = P0(
      d.value[0],
      E0[0],
      fe
    ), d.value = E0, v.value && v.value !== "none" ? y = {
      resolve: h,
      reject: w
    } : h(!0);
  }), $0 = (M) => {
    const h = G.value ?? B(/* @__PURE__ */ new Date());
    return ee(h, M);
  }, w0 = (M, h = {}) => {
    const w = qe(M) ? M : B(M);
    return Object.assign(
      h,
      o0(w, {
        ...h,
        force: !0
      })
    ), Jm(
      h.fromPage,
      h.toPage,
      c.value,
      b.value
    ).map((Z) => Km(Z, J.value, N.value)).some((Z) => Z);
  }, C0 = (M, h = {}) => w0($0(M), h), Re = _(() => C0(-U.value)), i0 = _(() => C0(U.value)), l0 = async (M, h = {}) => !h.force && !w0(M, h) ? !1 : (h.fromPage && !Xm(h.fromPage, G.value) && (wt({ id: l.value, hideDelay: 0 }), h.view && (og("view", 10), c.value = h.view), await je({
    ...h,
    page: h.fromPage,
    position: 1,
    force: !0
  }), a("did-move", d.value)), !0), u0 = (M, h = {}) => l0($0(M), h), c0 = () => u0(-U.value), d0 = () => u0(U.value), f0 = (M) => {
    const h = te.value ? ".in-month" : "", w = `.id-${b.value.getDayId(M)}${h}`, I = `${w}.vc-focusable, ${w} .vc-focusable`, Z = n.value;
    if (Z) {
      const fe = Z.querySelector(I);
      if (fe)
        return fe.focus(), !0;
    }
    return !1;
  }, x0 = async (M, h = {}) => f0(M) ? !0 : (await l0(M, h), f0(M)), T0 = (M, h) => {
    r.value = M.day, a("dayclick", M, h);
  }, v1 = (M, h) => {
    a("daymouseenter", M, h);
  }, st = (M, h) => {
    a("daymouseleave", M, h);
  }, p1 = (M, h) => {
    r.value = M.day, s.value = M, M.isFocused = !0, a("dayfocusin", M, h);
  }, It = (M, h) => {
    s.value = null, M.isFocused = !1, a("dayfocusout", M, h);
  }, Ot = (M, h) => {
    a("daykeydown", M, h);
    const w = M.noonDate;
    let I = null;
    switch (h.key) {
      case "ArrowLeft": {
        I = Me(w, -1);
        break;
      }
      case "ArrowRight": {
        I = Me(w, 1);
        break;
      }
      case "ArrowUp": {
        I = Me(w, -7);
        break;
      }
      case "ArrowDown": {
        I = Me(w, 7);
        break;
      }
      case "Home": {
        I = Me(w, -M.weekdayPosition + 1);
        break;
      }
      case "End": {
        I = Me(w, M.weekdayPositionFromEnd);
        break;
      }
      case "PageUp": {
        h.altKey ? I = Vn(w, -1) : I = Jt(w, -1);
        break;
      }
      case "PageDown": {
        h.altKey ? I = Vn(w, 1) : I = Jt(w, 1);
        break;
      }
    }
    I && (h.preventDefault(), x0(I).catch());
  }, m1 = (M) => {
    const h = s.value;
    h != null && Ot(h, M);
  }, zt = (M, h) => {
    a("weeknumberclick", M, h);
  };
  je({
    page: e.initialPage,
    position: e.initialPagePosition
  }), n1(() => {
    !e.disablePageSwipe && n.value && (m = sg(
      n.value,
      ({ toLeft: M = !1, toRight: h = !1 }) => {
        M ? d0() : h && c0();
      },
      g0("touch")
    ));
  }), W1(() => {
    d.value = [], m && m();
  }), xe(
    () => b.value,
    () => {
      je();
    }
  ), xe(
    () => H.value,
    () => je()
  ), xe(
    () => e.view,
    () => c.value = e.view
  ), xe(
    () => c.value,
    () => {
      ig("view", () => {
        je();
      }), a("update:view", c.value);
    }
  ), xe(
    () => r.value,
    () => {
      pe(d.value, (M) => ne(M));
    }
  ), er(() => {
    a("update:pages", d.value), pe(d.value, (M) => {
      ve(M), ne(M);
    });
  });
  const At = {
    emit: a,
    containerRef: n,
    focusedDay: s,
    inTransition: i,
    navPopoverId: l,
    dayPopoverId: u,
    view: c,
    pages: d,
    transitionName: v,
    theme: g,
    color: S,
    displayMode: $,
    locale: b,
    masks: Y,
    attributes: me,
    disabledAttribute: T,
    disabledDates: j,
    attributeContext: Ie,
    days: ge,
    dayCells: Je,
    count: H,
    step: U,
    firstPage: G,
    lastPage: K,
    canMovePrev: Re,
    canMoveNext: i0,
    minPage: J,
    maxPage: N,
    isMonthly: te,
    isWeekly: le,
    isDaily: ye,
    navVisibility: q,
    showWeeknumbers: ae,
    showIsoWeeknumbers: W,
    getDateAddress: B,
    canMove: w0,
    canMoveBy: C0,
    move: l0,
    moveBy: u0,
    movePrev: c0,
    moveNext: d0,
    onTransitionBeforeEnter: de,
    onTransitionAfterEnter: k,
    tryFocusDate: f0,
    focusDate: x0,
    onKeydown: m1,
    onDayKeydown: Ot,
    onDayClick: T0,
    onDayMouseenter: v1,
    onDayMouseleave: st,
    onDayFocusin: p1,
    onDayFocusout: It,
    onWeeknumberClick: zt
  };
  return Mt(Ys, At), At;
}
function A0() {
  const e = xt(Ys);
  if (e)
    return e;
  throw new Error(
    "Calendar context missing. Please verify this component is nested within a valid context provider."
  );
}
const wg = _e({
  inheritAttrs: !1,
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  props: {
    id: { type: [Number, String, Symbol], required: !0 },
    showDelay: { type: Number, default: 0 },
    hideDelay: { type: Number, default: 110 },
    boundarySelector: { type: String }
  },
  setup(e, { emit: t }) {
    let a;
    const n = se();
    let s = null, r = null;
    const i = a1({
      isVisible: !1,
      target: null,
      data: null,
      transition: "slide-fade",
      placement: "bottom",
      direction: "",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !0,
      visibility: "click",
      isHovered: !1,
      isFocused: !1,
      autoHide: !1,
      force: !1
    });
    function l(k) {
      k && (i.direction = k.split("-")[0]);
    }
    function u({ placement: k, options: ee }) {
      l(k || (ee == null ? void 0 : ee.placement));
    }
    const c = _(() => ({
      placement: i.placement,
      strategy: i.positionFixed ? "fixed" : "absolute",
      boundary: "",
      modifiers: [
        {
          name: "onUpdate",
          enabled: !0,
          phase: "afterWrite",
          fn: u
        },
        ...i.modifiers || []
      ],
      onFirstUpdate: u
    })), d = _(() => {
      const k = i.direction === "left" || i.direction === "right";
      let ee = "";
      if (i.placement) {
        const B = i.placement.split("-");
        B.length > 1 && (ee = B[1]);
      }
      return ["start", "top", "left"].includes(ee) ? k ? "top" : "left" : ["end", "bottom", "right"].includes(ee) ? k ? "bottom" : "right" : k ? "middle" : "center";
    });
    function v() {
      r && (r.destroy(), r = null);
    }
    function y() {
      ht(() => {
        const k = Zt(i.target);
        !k || !n.value || (r && r.state.elements.reference !== k && v(), r ? r.update() : r = p5(
          k,
          n.value,
          c.value
        ));
      });
    }
    function m(k) {
      Object.assign(i, is(k, "force"));
    }
    function g(k, ee) {
      clearTimeout(a), k > 0 ? a = setTimeout(ee, k) : ee();
    }
    function S(k) {
      return !k || !r ? !1 : Zt(k) === r.state.elements.reference;
    }
    async function $(k = {}) {
      i.force || (k.force && (i.force = !0), g(k.showDelay ?? e.showDelay, () => {
        i.isVisible && (i.force = !1), m({
          ...k,
          isVisible: !0
        }), y();
      }));
    }
    function b(k = {}) {
      r && (k.target && !S(k.target) || i.force || (k.force && (i.force = !0), g(k.hideDelay ?? e.hideDelay, () => {
        i.isVisible || (i.force = !1), i.isVisible = !1;
      })));
    }
    function Y(k = {}) {
      k.target != null && (i.isVisible && S(k.target) ? b(k) : $(k));
    }
    function V(k) {
      if (!r)
        return;
      const ee = r.state.elements.reference;
      if (!n.value || !ee)
        return;
      const B = k.target;
      Rt(n.value, B) || Rt(ee, B) || b({ force: !0 });
    }
    function L(k) {
      (k.key === "Esc" || k.key === "Escape") && b();
    }
    function T({ detail: k }) {
      !k.id || k.id !== e.id || $(k);
    }
    function j({ detail: k }) {
      !k.id || k.id !== e.id || b(k);
    }
    function H({ detail: k }) {
      !k.id || k.id !== e.id || Y(k);
    }
    function U() {
      m0(document, "keydown", L), m0(document, "click", V), m0(document, "show-popover", T), m0(document, "hide-popover", j), m0(document, "toggle-popover", H);
    }
    function G() {
      p0(document, "keydown", L), p0(document, "click", V), p0(document, "show-popover", T), p0(document, "hide-popover", j), p0(document, "toggle-popover", H);
    }
    function K(k) {
      t("before-show", k);
    }
    function J(k) {
      i.force = !1, t("after-show", k);
    }
    function N(k) {
      t("before-hide", k);
    }
    function q(k) {
      i.force = !1, v(), t("after-hide", k);
    }
    function ae(k) {
      k.stopPropagation();
    }
    function W() {
      i.isHovered = !0, i.isInteractive && ["hover", "hover-focus"].includes(i.visibility) && $();
    }
    function te() {
      if (i.isHovered = !1, !r)
        return;
      const k = r.state.elements.reference;
      i.autoHide && !i.isFocused && (!k || k !== document.activeElement) && ["hover", "hover-focus"].includes(i.visibility) && b();
    }
    function le() {
      i.isFocused = !0, i.isInteractive && ["focus", "hover-focus"].includes(i.visibility) && $();
    }
    function ye(k) {
      ["focus", "hover-focus"].includes(i.visibility) && (!k.relatedTarget || !Rt(n.value, k.relatedTarget)) && (i.isFocused = !1, !i.isHovered && i.autoHide && b());
    }
    function de() {
      s != null && (s.disconnect(), s = null);
    }
    return xe(
      () => n.value,
      (k) => {
        de(), k && (s = new ResizeObserver(() => {
          r && r.update();
        }), s.observe(k));
      }
    ), xe(() => i.placement, l, {
      immediate: !0
    }), n1(() => {
      U();
    }), W1(() => {
      v(), de(), G();
    }), {
      ...e2(i),
      popoverRef: n,
      alignment: d,
      hide: b,
      setupPopper: y,
      beforeEnter: K,
      afterEnter: J,
      beforeLeave: N,
      afterLeave: q,
      onClick: ae,
      onMouseOver: W,
      onMouseLeave: te,
      onFocusIn: le,
      onFocusOut: ye
    };
  }
}), _0 = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [n, s] of t)
    a[n] = s;
  return a;
};
function Cg(e, t, a, n, s, r) {
  return f(), p("div", {
    class: z(["vc-popover-content-wrapper", { "is-interactive": e.isInteractive }]),
    ref: "popoverRef",
    onClick: t[0] || (t[0] = (...i) => e.onClick && e.onClick(...i)),
    onMouseover: t[1] || (t[1] = (...i) => e.onMouseOver && e.onMouseOver(...i)),
    onMouseleave: t[2] || (t[2] = (...i) => e.onMouseLeave && e.onMouseLeave(...i)),
    onFocusin: t[3] || (t[3] = (...i) => e.onFocusIn && e.onFocusIn(...i)),
    onFocusout: t[4] || (t[4] = (...i) => e.onFocusOut && e.onFocusOut(...i))
  }, [
    D(U1, {
      name: `vc-${e.transition}`,
      appear: "",
      onBeforeEnter: e.beforeEnter,
      onAfterEnter: e.afterEnter,
      onBeforeLeave: e.beforeLeave,
      onAfterLeave: e.afterLeave
    }, {
      default: O(() => [
        e.isVisible ? (f(), p("div", y0({
          key: 0,
          tabindex: "-1",
          class: `vc-popover-content direction-${e.direction}`
        }, e.$attrs), [
          ie(e.$slots, "default", {
            direction: e.direction,
            alignment: e.alignment,
            data: e.data,
            hide: e.hide
          }, () => [
            he(F(e.data), 1)
          ]),
          o("span", {
            class: z([
              "vc-popover-caret",
              `direction-${e.direction}`,
              `align-${e.alignment}`
            ])
          }, null, 2)
        ], 16)) : E("", !0)
      ]),
      _: 3
    }, 8, ["name", "onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])
  ], 34);
}
const f1 = /* @__PURE__ */ _0(wg, [["render", Cg]]), xg = { class: "vc-day-popover-row" }, Mg = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, Sg = { class: "vc-day-popover-row-label" }, Hs = /* @__PURE__ */ _e({
  __name: "PopoverRow",
  props: {
    attribute: null
  },
  setup(e) {
    const t = e, a = _(() => {
      const { content: n, highlight: s, dot: r, bar: i, popover: l } = t.attribute;
      return l && l.hideIndicator ? null : n ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${n.base.color}`
      } : s ? {
        class: `vc-highlight-bg-solid vc-day-popover-row-highlight vc-attr vc-${s.base.color}`
      } : r ? {
        class: `vc-dot vc-attr vc-${r.base.color}`
      } : i ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${i.base.color}`
      } : null;
    });
    return (n, s) => (f(), p("div", xg, [
      C(a) ? (f(), p("div", Mg, [
        o("span", {
          class: z(C(a).class)
        }, null, 2)
      ])) : E("", !0),
      o("div", Sg, [
        ie(n.$slots, "default", {}, () => [
          he(F(e.attribute.popover ? e.attribute.popover.label : "No content provided"), 1)
        ])
      ])
    ]));
  }
}), Dg = {
  inheritAttrs: !1
}, Te = /* @__PURE__ */ _e({
  ...Dg,
  __name: "CalendarSlot",
  props: {
    name: null
  },
  setup(e) {
    const a = Es(e.name);
    return (n, s) => C(a) ? (f(), P(Q(C(a)), mt(y0({ key: 0 }, n.$attrs)), null, 16)) : ie(n.$slots, "default", { key: 1 });
  }
}), kg = { class: "vc-day-popover-container" }, Lg = {
  key: 0,
  class: "vc-day-popover-header"
}, Ig = /* @__PURE__ */ _e({
  __name: "CalendarDayPopover",
  setup(e) {
    const { dayPopoverId: t, displayMode: a, color: n, masks: s, locale: r } = A0();
    function i(u, c) {
      return r.value.formatDate(u, c);
    }
    function l(u) {
      return r.value.formatDate(u.date, s.value.dayPopover);
    }
    return (u, c) => (f(), P(f1, {
      id: C(t),
      class: z([`vc-${C(n)}`, `vc-${C(a)}`])
    }, {
      default: O(({ data: { day: d, attributes: v }, hide: y }) => [
        D(Te, {
          name: "day-popover",
          day: d,
          "day-title": l(d),
          attributes: v,
          format: i,
          masks: C(s),
          hide: y
        }, {
          default: O(() => [
            o("div", kg, [
              C(s).dayPopover ? (f(), p("div", Lg, F(l(d)), 1)) : E("", !0),
              (f(!0), p(X, null, oe(v, (m) => (f(), P(Hs, {
                key: m.key,
                attribute: m
              }, null, 8, ["attribute"]))), 128))
            ])
          ]),
          _: 2
        }, 1032, ["day", "day-title", "attributes", "masks", "hide"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), Og = {}, zg = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, Ag = /* @__PURE__ */ o("polyline", { points: "9 18 15 12 9 6" }, null, -1), Pg = [
  Ag
];
function Tg(e, t) {
  return f(), p("svg", zg, Pg);
}
const Eg = /* @__PURE__ */ _0(Og, [["render", Tg]]), Yg = {}, Hg = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, Vg = /* @__PURE__ */ o("polyline", { points: "15 18 9 12 15 6" }, null, -1), Ng = [
  Vg
];
function Rg(e, t) {
  return f(), p("svg", Hg, Ng);
}
const Fg = /* @__PURE__ */ _0(Yg, [["render", Rg]]), Bg = {}, Wg = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, jg = /* @__PURE__ */ o("polyline", { points: "6 9 12 15 18 9" }, null, -1), Ug = [
  jg
];
function qg(e, t) {
  return f(), p("svg", Wg, Ug);
}
const Zg = /* @__PURE__ */ _0(Bg, [["render", qg]]), Gg = {}, Kg = {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, Xg = /* @__PURE__ */ o("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" }, null, -1), Jg = [
  Xg
];
function Qg(e, t) {
  return f(), p("svg", Kg, Jg);
}
const eb = /* @__PURE__ */ _0(Gg, [["render", Qg]]), tb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconChevronDown: Zg,
  IconChevronLeft: Fg,
  IconChevronRight: Eg,
  IconClock: eb
}, Symbol.toStringTag, { value: "Module" })), G0 = /* @__PURE__ */ _e({
  __name: "BaseIcon",
  props: {
    name: { type: String, required: !0 },
    width: { type: String },
    height: { type: String },
    size: { type: String, default: "26" },
    viewBox: { type: String }
  },
  setup(e) {
    const t = e, a = _(() => t.width || t.size), n = _(() => t.height || t.size), s = _(() => tb[`Icon${t.name}`]);
    return (r, i) => (f(), P(Q(C(s)), {
      width: C(a),
      height: C(n),
      class: "vc-base-icon"
    }, null, 8, ["width", "height"]));
  }
}), ab = ["disabled"], nb = {
  key: 1,
  class: "vc-title-wrapper"
}, rb = {
  type: "button",
  class: "vc-title"
}, sb = ["disabled"], Vs = /* @__PURE__ */ _e({
  __name: "CalendarHeader",
  props: {
    page: null,
    layout: null,
    isLg: { type: Boolean },
    isXl: { type: Boolean },
    is2xl: { type: Boolean },
    hideTitle: { type: Boolean },
    hideArrows: { type: Boolean }
  },
  setup(e) {
    const t = e, {
      navPopoverId: a,
      navVisibility: n,
      canMovePrev: s,
      movePrev: r,
      canMoveNext: i,
      moveNext: l
    } = A0(), u = _(() => {
      switch (t.page.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    }), c = _(() => {
      const { page: S } = t;
      return {
        id: a.value,
        visibility: n.value,
        placement: u.value,
        modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom"] } }],
        data: { page: S },
        isInteractive: !0
      };
    }), d = _(() => t.page.titlePosition.includes("left")), v = _(() => t.page.titlePosition.includes("right")), y = _(() => t.layout ? t.layout : d.value ? "tu-pn" : v.value ? "pn-tu" : "p-tu-n;"), m = _(() => ({
      prev: y.value.includes("p") && !t.hideArrows,
      title: y.value.includes("t") && !t.hideTitle,
      next: y.value.includes("n") && !t.hideArrows
    })), g = _(() => ({ gridTemplateColumns: y.value.split("").map(($) => {
      switch ($) {
        case "p":
          return "[prev] auto";
        case "n":
          return "[next] auto";
        case "t":
          return "[title] auto";
        case "-":
          return "1fr";
        default:
          return "";
      }
    }).join(" ") }));
    return (S, $) => (f(), p("div", {
      class: z(["vc-header", { "is-lg": e.isLg, "is-xl": e.isXl, "is-2xl": e.is2xl }]),
      style: e0(C(g))
    }, [
      C(m).prev ? (f(), p("button", {
        key: 0,
        type: "button",
        class: "vc-arrow vc-prev vc-focus",
        disabled: !C(s),
        onClick: $[0] || ($[0] = //@ts-ignore
        (...b) => C(r) && C(r)(...b)),
        onKeydown: $[1] || ($[1] = v0(
          //@ts-ignore
          (...b) => C(r) && C(r)(...b),
          ["space", "enter"]
        ))
      }, [
        D(Te, {
          name: "header-prev-button",
          disabled: !C(s)
        }, {
          default: O(() => [
            D(G0, {
              name: "ChevronLeft",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, ab)) : E("", !0),
      C(m).title ? (f(), p("div", nb, [
        D(Te, { name: "header-title-wrapper" }, {
          default: O(() => [
            k0((f(), p("button", rb, [
              D(Te, {
                name: "header-title",
                title: e.page.title
              }, {
                default: O(() => [
                  o("span", null, F(e.page.title), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ])), [
              [C(Ls), C(c)]
            ])
          ]),
          _: 1
        })
      ])) : E("", !0),
      C(m).next ? (f(), p("button", {
        key: 2,
        type: "button",
        class: "vc-arrow vc-next vc-focus",
        disabled: !C(i),
        onClick: $[2] || ($[2] = //@ts-ignore
        (...b) => C(l) && C(l)(...b)),
        onKeydown: $[3] || ($[3] = v0(
          //@ts-ignore
          (...b) => C(l) && C(l)(...b),
          ["space", "enter"]
        ))
      }, [
        D(Te, {
          name: "header-next-button",
          disabled: !C(i)
        }, {
          default: O(() => [
            D(G0, {
              name: "ChevronRight",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, sb)) : E("", !0)
    ], 6));
  }
}), Ns = Symbol("__vc_page_context__");
function ob(e) {
  const { locale: t, getDateAddress: a, canMove: n } = A0();
  function s(l, u) {
    const { month: c, year: d } = a(/* @__PURE__ */ new Date());
    return Ms().map((v, y) => {
      const m = y + 1;
      return {
        month: m,
        year: l,
        id: Gm(m, l),
        label: t.value.formatDate(v, u),
        ariaLabel: t.value.formatDate(v, "MMMM"),
        isActive: m === e.value.month && l === e.value.year,
        isCurrent: m === c && l === d,
        isDisabled: !n(
          { month: m, year: l },
          { position: e.value.position }
        )
      };
    });
  }
  function r(l, u) {
    const { year: c } = a(/* @__PURE__ */ new Date()), { position: d } = e.value, v = [];
    for (let y = l; y <= u; y += 1) {
      const m = [...Array(12).keys()].some(
        (g) => n({ month: g + 1, year: y }, { position: d })
      );
      v.push({
        year: y,
        id: y.toString(),
        label: y.toString(),
        ariaLabel: y.toString(),
        isActive: y === e.value.year,
        isCurrent: y === c,
        isDisabled: !m
      });
    }
    return v;
  }
  const i = { page: e, getMonthItems: s, getYearItems: r };
  return Mt(Ns, i), i;
}
function Rs() {
  const e = xt(Ns);
  if (e)
    return e;
  throw new Error(
    "Page context missing. Please verify this component is nested within a valid context provider."
  );
}
const ib = { class: "vc-nav-header" }, lb = ["disabled"], ub = ["disabled"], cb = { class: "vc-nav-items" }, db = ["data-id", "aria-label", "disabled", "onClick", "onKeydown"], fb = /* @__PURE__ */ _e({
  __name: "CalendarNav",
  setup(e) {
    const { masks: t, move: a } = A0(), { page: n, getMonthItems: s, getYearItems: r } = Rs(), i = se(!0), l = 12, u = se(n.value.year), c = se(y(n.value.year)), d = se(null);
    function v() {
      setTimeout(() => {
        if (d.value == null)
          return;
        const B = d.value.querySelector(
          ".vc-nav-item:not(:disabled)"
        );
        B && B.focus();
      }, 10);
    }
    function y(B) {
      return Math.floor(B / l);
    }
    function m() {
      i.value = !i.value;
    }
    function g(B) {
      return B * l;
    }
    function S(B) {
      return l * (B + 1) - 1;
    }
    function $() {
      le.value && (i.value && Y(), L());
    }
    function b() {
      ye.value && (i.value && V(), T());
    }
    function Y() {
      u.value--;
    }
    function V() {
      u.value++;
    }
    function L() {
      c.value--;
    }
    function T() {
      c.value++;
    }
    const j = _(
      () => s(u.value, t.value.navMonths).map((B) => ({
        ...B,
        click: () => a(
          { month: B.month, year: B.year },
          { position: n.value.position }
        )
      }))
    ), H = _(
      () => s(u.value - 1, t.value.navMonths)
    ), U = _(
      () => H.value.some((B) => !B.isDisabled)
    ), G = _(
      () => s(u.value + 1, t.value.navMonths)
    ), K = _(
      () => G.value.some((B) => !B.isDisabled)
    ), J = _(
      () => r(
        g(c.value),
        S(c.value)
      ).map((B) => ({
        ...B,
        click: () => {
          u.value = B.year, i.value = !0, v();
        }
      }))
    ), N = _(
      () => r(
        g(c.value - 1),
        S(c.value - 1)
      )
    ), q = _(
      () => N.value.some((B) => !B.isDisabled)
    ), ae = _(
      () => r(
        g(c.value + 1),
        S(c.value + 1)
      )
    ), W = _(
      () => ae.value.some((B) => !B.isDisabled)
    ), te = _(
      () => i.value ? j.value : J.value
    ), le = _(
      () => i.value ? U.value : q.value
    ), ye = _(
      () => i.value ? K.value : W.value
    ), de = _(() => ss(J.value.map((B) => B.year))), k = _(() => V0(J.value.map((B) => B.year))), ee = _(() => i.value ? u.value : `${de.value} - ${k.value}`);
    return er(() => {
      u.value = n.value.year, v();
    }), xe(
      () => u.value,
      (B) => c.value = y(B)
    ), n1(() => v()), (B, ve) => (f(), p("div", {
      class: "vc-nav-container",
      ref_key: "navContainer",
      ref: d
    }, [
      o("div", ib, [
        o("button", {
          type: "button",
          class: "vc-nav-arrow is-left vc-focus",
          disabled: !C(le),
          onClick: $,
          onKeydown: ve[0] || (ve[0] = (ne) => C(Ht)(ne, $))
        }, [
          D(Te, {
            name: "nav-prev-button",
            move: $,
            disabled: !C(le)
          }, {
            default: O(() => [
              D(G0, {
                name: "ChevronLeft",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, lb),
        o("button", {
          type: "button",
          class: "vc-nav-title vc-focus",
          onClick: m,
          onKeydown: ve[1] || (ve[1] = (ne) => C(Ht)(ne, m))
        }, F(C(ee)), 33),
        o("button", {
          type: "button",
          class: "vc-nav-arrow is-right vc-focus",
          disabled: !C(ye),
          onClick: b,
          onKeydown: ve[2] || (ve[2] = (ne) => C(Ht)(ne, b))
        }, [
          D(Te, {
            name: "nav-next-button",
            move: b,
            disabled: !C(ye)
          }, {
            default: O(() => [
              D(G0, {
                name: "ChevronRight",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, ub)
      ]),
      o("div", cb, [
        (f(!0), p(X, null, oe(C(te), (ne) => (f(), p("button", {
          key: ne.label,
          type: "button",
          "data-id": ne.id,
          "aria-label": ne.ariaLabel,
          class: z(["vc-nav-item vc-focus", [
            ne.isActive ? "is-active" : ne.isCurrent ? "is-current" : ""
          ]]),
          disabled: ne.isDisabled,
          onClick: ne.click,
          onKeydown: (pe) => C(Ht)(pe, ne.click)
        }, F(ne.label), 43, db))), 128))
      ])
    ], 512));
  }
}), Fs = /* @__PURE__ */ _e({
  __name: "CalendarPageProvider",
  props: {
    page: null
  },
  setup(e) {
    return ob(Vt(e, "page")), (a, n) => ie(a.$slots, "default");
  }
}), hb = /* @__PURE__ */ _e({
  __name: "CalendarNavPopover",
  setup(e) {
    const { navPopoverId: t, color: a, displayMode: n } = A0();
    return (s, r) => (f(), P(f1, {
      id: C(t),
      class: z(["vc-nav-popover-container", `vc-${C(a)}`, `vc-${C(n)}`])
    }, {
      default: O(({ data: i }) => [
        D(Fs, {
          page: i.page
        }, {
          default: O(() => [
            D(Te, { name: "nav" }, {
              default: O(() => [
                D(fb)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["page"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), vb = _e({
  directives: { popover: Ls },
  components: { CalendarSlot: Te },
  props: {
    day: { type: Object, required: !0 }
  },
  setup(e) {
    const {
      locale: t,
      theme: a,
      attributeContext: n,
      dayPopoverId: s,
      onDayClick: r,
      onDayMouseenter: i,
      onDayMouseleave: l,
      onDayFocusin: u,
      onDayFocusout: c,
      onDayKeydown: d
    } = A0(), v = _(() => e.day), y = _(() => n.value.getCells(v.value)), m = _(
      () => y.value.map((W) => W.data)
    ), g = _(() => ({
      ...v.value,
      attributes: m.value,
      attributeCells: y.value
    }));
    function S({ data: W }, { popovers: te }) {
      const { key: le, customData: ye, popover: de } = W;
      if (!de)
        return;
      const k = $n(
        {
          key: le,
          customData: ye,
          attribute: W
        },
        { ...de },
        {
          visibility: de.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !de.label
        }
      );
      te.splice(0, 0, k);
    }
    const $ = _(() => {
      const W = {
        ...a.value.prepareRender({}),
        popovers: []
      };
      return y.value.forEach((te) => {
        a.value.render(te, W), S(te, W);
      }), W;
    }), b = _(() => $.value.highlights), Y = _(() => !!Qe(b.value)), V = _(() => $.value.content), L = _(() => $.value.dots), T = _(() => !!Qe(L.value)), j = _(() => $.value.bars), H = _(() => !!Qe(j.value)), U = _(() => $.value.popovers), G = _(
      () => U.value.map((W) => W.attribute)
    ), K = Es("day-content"), J = _(() => [
      "vc-day",
      ...v.value.classes,
      { "vc-day-box-center-center": !K },
      { "is-not-in-month": !e.day.inMonth }
    ]), N = _(() => {
      let W;
      v.value.isFocusable ? W = "0" : W = "-1";
      const te = [
        "vc-day-content vc-focusable vc-focus vc-attr",
        { "vc-disabled": v.value.isDisabled },
        S0(V0(b.value), "contentClass"),
        S0(V0(V.value), "class") || ""
      ], le = {
        ...S0(V0(b.value), "contentStyle"),
        ...S0(V0(V.value), "style")
      };
      return {
        class: te,
        style: le,
        tabindex: W,
        "aria-label": v.value.ariaLabel,
        "aria-disabled": !!v.value.isDisabled,
        role: "button"
      };
    }), q = _(() => ({
      click(W) {
        r(g.value, W);
      },
      mouseenter(W) {
        i(g.value, W);
      },
      mouseleave(W) {
        l(g.value, W);
      },
      focusin(W) {
        u(g.value, W);
      },
      focusout(W) {
        c(g.value, W);
      },
      keydown(W) {
        d(g.value, W);
      }
    })), ae = _(() => Qe(U.value) ? $n(
      {
        id: s.value,
        data: { day: v, attributes: G.value }
      },
      ...U.value
    ) : null);
    return {
      attributes: m,
      attributeCells: y,
      bars: j,
      dayClasses: J,
      dayContentProps: N,
      dayContentEvents: q,
      dayPopover: ae,
      glyphs: $,
      dots: L,
      hasDots: T,
      hasBars: H,
      highlights: b,
      hasHighlights: Y,
      locale: t,
      popovers: U
    };
  }
}), pb = {
  key: 0,
  class: "vc-highlights vc-day-layer"
}, mb = {
  key: 1,
  class: "vc-day-layer vc-day-box-center-bottom"
}, yb = { class: "vc-dots" }, gb = {
  key: 2,
  class: "vc-day-layer vc-day-box-center-bottom"
}, bb = { class: "vc-bars" };
function _b(e, t, a, n, s, r) {
  const i = A("CalendarSlot"), l = j1("popover");
  return f(), p("div", {
    class: z(e.dayClasses)
  }, [
    e.hasHighlights ? (f(), p("div", pb, [
      (f(!0), p(X, null, oe(e.highlights, ({ key: u, wrapperClass: c, class: d, style: v }) => (f(), p("div", {
        key: u,
        class: z(c)
      }, [
        o("div", {
          class: z(d),
          style: e0(v)
        }, null, 6)
      ], 2))), 128))
    ])) : E("", !0),
    D(i, {
      name: "day-content",
      day: e.day,
      attributes: e.attributes,
      "attribute-cells": e.attributeCells,
      dayProps: e.dayContentProps,
      dayEvents: e.dayContentEvents,
      locale: e.locale
    }, {
      default: O(() => [
        k0((f(), p("div", y0(e.dayContentProps, O1(e.dayContentEvents, !0)), [
          he(F(e.day.label), 1)
        ], 16)), [
          [l, e.dayPopover]
        ])
      ]),
      _: 1
    }, 8, ["day", "attributes", "attribute-cells", "dayProps", "dayEvents", "locale"]),
    e.hasDots ? (f(), p("div", mb, [
      o("div", yb, [
        (f(!0), p(X, null, oe(e.dots, ({ key: u, class: c, style: d }) => (f(), p("span", {
          key: u,
          class: z(c),
          style: e0(d)
        }, null, 6))), 128))
      ])
    ])) : E("", !0),
    e.hasBars ? (f(), p("div", gb, [
      o("div", bb, [
        (f(!0), p(X, null, oe(e.bars, ({ key: u, class: c, style: d }) => (f(), p("span", {
          key: u,
          class: z(c),
          style: e0(d)
        }, null, 6))), 128))
      ])
    ])) : E("", !0)
  ], 2);
}
const $b = /* @__PURE__ */ _0(vb, [["render", _b]]), wb = { class: "vc-weekdays" }, Cb = ["onClick"], xb = {
  inheritAttrs: !1
}, Mb = /* @__PURE__ */ _e({
  ...xb,
  __name: "CalendarPage",
  setup(e) {
    const { page: t } = Rs(), { onWeeknumberClick: a } = A0();
    return (n, s) => (f(), p("div", {
      class: z([
        "vc-pane",
        `row-${C(t).row}`,
        `row-from-end-${C(t).rowFromEnd}`,
        `column-${C(t).column}`,
        `column-from-end-${C(t).columnFromEnd}`
      ]),
      ref: "pane"
    }, [
      D(Vs, {
        page: C(t),
        "is-lg": "",
        "hide-arrows": ""
      }, null, 8, ["page"]),
      o("div", {
        class: z(["vc-weeks", {
          [`vc-show-weeknumbers-${C(t).weeknumberPosition}`]: C(t).weeknumberPosition
        }])
      }, [
        o("div", wb, [
          (f(!0), p(X, null, oe(C(t).weekdays, ({ weekday: r, label: i }, l) => (f(), p("div", {
            key: l,
            class: z(`vc-weekday vc-weekday-${r}`)
          }, F(i), 3))), 128))
        ]),
        (f(!0), p(X, null, oe(C(t).viewWeeks, (r) => (f(), p("div", {
          key: `weeknumber-${r.weeknumber}`,
          class: "vc-week"
        }, [
          C(t).weeknumberPosition ? (f(), p("div", {
            key: 0,
            class: z(["vc-weeknumber", `is-${C(t).weeknumberPosition}`])
          }, [
            o("span", {
              class: z(["vc-weeknumber-content"]),
              onClick: (i) => C(a)(r, i)
            }, F(r.weeknumberDisplay), 9, Cb)
          ], 2)) : E("", !0),
          (f(!0), p(X, null, oe(r.days, (i) => (f(), P($b, {
            key: i.id,
            day: i
          }, null, 8, ["day"]))), 128))
        ]))), 128))
      ], 2)
    ], 2));
  }
}), Sb = _e({
  components: {
    CalendarHeader: Vs,
    CalendarPage: Mb,
    CalendarNavPopover: hb,
    CalendarDayPopover: Ig,
    CalendarPageProvider: Fs,
    CalendarSlot: Te
  },
  props: bg,
  emit: _g,
  setup(e, { emit: t, slots: a }) {
    return $g(e, { emit: t, slots: a });
  }
}), Db = { class: "vc-pane-header-wrapper" };
function kb(e, t, a, n, s, r) {
  const i = A("CalendarHeader"), l = A("CalendarPage"), u = A("CalendarSlot"), c = A("CalendarPageProvider"), d = A("CalendarDayPopover"), v = A("CalendarNavPopover");
  return f(), p(X, null, [
    o("div", y0({ "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year" }, e.$attrs, {
      class: [
        "vc-container",
        `vc-${e.view}`,
        `vc-${e.color}`,
        `vc-${e.displayMode}`,
        {
          "vc-expanded": e.expanded,
          "vc-bordered": !e.borderless,
          "vc-transparent": e.transparent
        }
      ],
      onMouseup: t[0] || (t[0] = L1(() => {
      }, ["prevent"])),
      ref: "containerRef"
    }), [
      o("div", {
        class: z(["vc-pane-container", { "in-transition": e.inTransition }])
      }, [
        o("div", Db, [
          e.firstPage ? (f(), P(i, {
            key: 0,
            page: e.firstPage,
            "is-lg": "",
            "hide-title": ""
          }, null, 8, ["page"])) : E("", !0)
        ]),
        D(U1, {
          name: `vc-${e.transitionName}`,
          onBeforeEnter: e.onTransitionBeforeEnter,
          onAfterEnter: e.onTransitionAfterEnter
        }, {
          default: O(() => [
            (f(), p("div", {
              key: e.pages[0].id,
              class: "vc-pane-layout",
              style: e0({
                gridTemplateColumns: `repeat(${e.columns}, 1fr)`
              })
            }, [
              (f(!0), p(X, null, oe(e.pages, (y) => (f(), P(c, {
                key: y.id,
                page: y
              }, {
                default: O(() => [
                  D(u, {
                    name: "page",
                    page: y
                  }, {
                    default: O(() => [
                      D(l)
                    ]),
                    _: 2
                  }, 1032, ["page"])
                ]),
                _: 2
              }, 1032, ["page"]))), 128))
            ], 4))
          ]),
          _: 1
        }, 8, ["name", "onBeforeEnter", "onAfterEnter"]),
        D(u, { name: "footer" })
      ], 2)
    ], 16),
    D(d),
    D(v)
  ], 64);
}
const Bs = /* @__PURE__ */ _0(Sb, [["render", kb]]), Ws = Symbol("__vc_date_picker_context__"), Lb = {
  ...zs,
  mode: { type: String, default: "date" },
  modelValue: {
    type: [Number, String, Date, Object]
  },
  modelModifiers: {
    type: Object,
    default: () => ({})
  },
  rules: [String, Object],
  is24hr: Boolean,
  hideTimeHeader: Boolean,
  timeAccuracy: { type: Number, default: 2 },
  isRequired: Boolean,
  isRange: Boolean,
  updateOnInput: {
    type: Boolean,
    default: () => g0("datePicker.updateOnInput")
  },
  inputDebounce: {
    type: Number,
    default: () => g0("datePicker.inputDebounce")
  },
  popover: {
    type: [Boolean, Object],
    default: !0
  },
  dragAttribute: Object,
  selectAttribute: Object,
  attributes: [Object, Array]
}, Ib = [
  "update:modelValue",
  "drag",
  "dayclick",
  "daykeydown",
  "popover-will-show",
  "popover-did-show",
  "popover-will-hide",
  "popover-did-hide"
];
function Ob(e, { emit: t, slots: a }) {
  Ts(a, { footer: "dp-footer" });
  const n = As(e), { locale: s, masks: r, disabledAttribute: i } = n, l = se(!1), u = se(Symbol()), c = se(null), d = se(null), v = se(["", ""]), y = se(null), m = se(null);
  let g, S, $ = !0;
  const b = _(() => e.isRange || e.modelModifiers.range === !0), Y = _(
    () => b.value && c.value != null ? c.value.start : null
  ), V = _(
    () => b.value && c.value != null ? c.value.end : null
  ), L = _(() => e.mode.toLowerCase() === "date"), T = _(
    () => e.mode.toLowerCase() === "datetime"
  ), j = _(() => e.mode.toLowerCase() === "time"), H = _(() => !!d.value), U = _(() => {
    let h = "date";
    e.modelModifiers.number && (h = "number"), e.modelModifiers.string && (h = "string");
    const w = r.value.modelValue || "iso";
    return ve({ type: h, mask: w });
  }), G = _(
    () => C0(d.value ?? c.value)
  ), K = _(() => j.value ? e.is24hr ? r.value.inputTime24hr : r.value.inputTime : T.value ? e.is24hr ? r.value.inputDateTime24hr : r.value.inputDateTime : r.value.input), J = _(() => /[Hh]/g.test(K.value)), N = _(
    () => /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(K.value)
  ), q = _(() => {
    if (J.value && N.value)
      return "dateTime";
    if (N.value)
      return "date";
    if (J.value)
      return "time";
  }), ae = _(() => {
    var h;
    const w = ((h = y.value) == null ? void 0 : h.$el.previousElementSibling) ?? void 0;
    return Z0({}, e.popover, g0("datePicker.popover"), {
      target: w
    });
  }), W = _(
    () => ks({
      ...ae.value,
      id: u.value
    })
  ), te = _(() => b.value ? {
    start: v.value[0],
    end: v.value[1]
  } : v.value[0]), le = _(() => {
    const h = ["start", "end"].map((w) => ({
      input: je(w),
      change: $0(w),
      keyup: w0,
      ...e.popover && W.value
    }));
    return b.value ? {
      start: h[0],
      end: h[1]
    } : h[0];
  }), ye = _(() => {
    if (!me(c.value))
      return null;
    const h = {
      key: "select-drag",
      ...e.selectAttribute,
      dates: c.value,
      pinPage: !0
    }, { dot: w, bar: I, highlight: Z, content: fe } = h;
    return !w && !I && !Z && !fe && (h.highlight = !0), h;
  }), de = _(() => {
    if (!b.value || !me(d.value))
      return null;
    const h = {
      key: "select-drag",
      ...e.dragAttribute,
      dates: d.value
    }, { dot: w, bar: I, highlight: Z, content: fe } = h;
    return !w && !I && !Z && !fe && (h.highlight = {
      startEnd: {
        fillMode: "outline"
      }
    }), h;
  }), k = _(() => {
    const h = Ye(e.attributes) ? [...e.attributes] : [];
    return de.value ? h.unshift(de.value) : ye.value && h.unshift(ye.value), h;
  }), ee = _(() => ve(
    e.rules === "auto" ? B() : e.rules ?? {}
  ));
  function B() {
    const h = {
      ms: [0, 999],
      sec: [0, 59],
      min: [0, 59],
      hr: [0, 23]
    }, w = L.value ? 0 : e.timeAccuracy;
    return [0, 1].map((I) => {
      switch (w) {
        case 0:
          return {
            hours: h.hr[I],
            minutes: h.min[I],
            seconds: h.sec[I],
            milliseconds: h.ms[I]
          };
        case 1:
          return {
            minutes: h.min[I],
            seconds: h.sec[I],
            milliseconds: h.ms[I]
          };
        case 3:
          return { milliseconds: h.ms[I] };
        case 4:
          return {};
        default:
          return { seconds: h.sec[I], milliseconds: h.ms[I] };
      }
    });
  }
  function ve(h) {
    return Ye(h) ? h.length === 1 ? [h[0], h[0]] : h : [h, h];
  }
  function ne(h) {
    return ve(h).map(
      (w, I) => ({
        ...w,
        rules: ee.value[I]
      })
    );
  }
  function pe(h) {
    return h == null ? !1 : Fe(h) ? !isNaN(h) : N0(h) ? !isNaN(h.getTime()) : Ue(h) ? h !== "" : xa(h);
  }
  function ge(h) {
    return a0(h) && "start" in h && "end" in h && pe(h.start ?? null) && pe(h.end ?? null);
  }
  function me(h) {
    return ge(h) || pe(h);
  }
  function be(h, w) {
    if (h == null && w == null)
      return !0;
    if (h == null || w == null)
      return !1;
    const I = N0(h), Z = N0(w);
    return I && Z ? h.getTime() === w.getTime() : I || Z ? !1 : be(h.start, w.start) && be(h.end, w.end);
  }
  function Ie(h) {
    return !me(h) || !i.value ? !1 : i.value.intersectsRange(s.value.range(h));
  }
  function Je(h, w, I, Z) {
    if (!me(h))
      return null;
    if (ge(h)) {
      const fe = s.value.toDate(h.start, {
        ...w[0],
        fillDate: Y.value ?? void 0,
        patch: I
      }), Ce = s.value.toDate(h.end, {
        ...w[1],
        fillDate: V.value ?? void 0,
        patch: I
      });
      return It({ start: fe, end: Ce }, Z);
    }
    return s.value.toDateOrNull(h, {
      ...w[0],
      fillDate: c.value,
      patch: I
    });
  }
  function Ne(h, w) {
    return ge(h) ? {
      start: s.value.fromDate(h.start, w[0]),
      end: s.value.fromDate(h.end, w[1])
    } : b.value ? null : s.value.fromDate(h, w[0]);
  }
  function Ae(h, w = {}) {
    return clearTimeout(g), new Promise((I) => {
      const { debounce: Z = 0, ...fe } = w;
      Z > 0 ? g = window.setTimeout(() => {
        I(Pe(h, fe));
      }, Z) : I(Pe(h, fe));
    });
  }
  function Pe(h, {
    config: w = U.value,
    patch: I = "dateTime",
    clearIfEqual: Z = !1,
    formatInput: fe = !0,
    hidePopover: Ce = !1,
    dragging: Oe = H.value,
    targetPriority: E0,
    moveToValue: Y0 = !1
  } = {}) {
    const y1 = ne(w);
    let De = Je(
      h,
      y1,
      I,
      E0
    );
    if (Ie(De)) {
      if (Oe)
        return null;
      De = c.value, Ce = !1;
    } else De == null && e.isRequired ? De = c.value : (
      // Clear value if same value was passed
      De != null && be(c.value, De) && Z && (De = null)
    );
    const Pt = Oe ? d : c, ot = !be(Pt.value, De);
    Pt.value = De, Oe || (d.value = null);
    const it = Ne(
      De,
      U.value
    );
    return ot && ($ = !1, t(Oe ? "drag" : "update:modelValue", it), ht(() => $ = !0)), Ce && !Oe && st(), fe && o0(), Y0 && ht(() => zt(E0 ?? "start")), it;
  }
  function o0() {
    ht(() => {
      const h = ne({
        type: "string",
        mask: K.value
      }), w = Ne(
        d.value ?? c.value,
        h
      );
      b.value ? v.value = [w && w.start, w && w.end] : v.value = [w, ""];
    });
  }
  function P0(h, w, I) {
    v.value.splice(w === "start" ? 0 : 1, 1, h);
    const Z = b.value ? {
      start: v.value[0],
      end: v.value[1] || v.value[0]
    } : h, fe = {
      type: "string",
      mask: K.value
    };
    Ae(Z, {
      ...I,
      config: fe,
      patch: q.value,
      targetPriority: w,
      moveToValue: !0
    });
  }
  function je(h) {
    return (w) => {
      e.updateOnInput && P0(w.currentTarget.value, h, {
        formatInput: !1,
        hidePopover: !1,
        debounce: e.inputDebounce
      });
    };
  }
  function $0(h) {
    return (w) => {
      P0(w.currentTarget.value, h, {
        formatInput: !0,
        hidePopover: !1
      });
    };
  }
  function w0(h) {
    h.key === "Escape" && Ae(c.value, {
      formatInput: !0,
      hidePopover: !0
    });
  }
  function C0(h) {
    return b.value ? [
      h && h.start ? s.value.getDateParts(h.start) : null,
      h && h.end ? s.value.getDateParts(h.end) : null
    ] : [h ? s.value.getDateParts(h) : null];
  }
  function Re() {
    d.value = null, o0();
  }
  function i0(h) {
    t("popover-will-show", h);
  }
  function l0(h) {
    t("popover-did-show", h);
  }
  function u0(h) {
    Re(), t("popover-will-hide", h);
  }
  function c0(h) {
    t("popover-did-hide", h);
  }
  function d0(h) {
    const w = {
      patch: "date",
      formatInput: !0,
      hidePopover: !0
    };
    if (b.value) {
      const I = !H.value;
      I ? S = { start: h.startDate, end: h.endDate } : S != null && (S.end = h.date), Ae(S, {
        ...w,
        dragging: I
      });
    } else
      Ae(h.date, {
        ...w,
        clearIfEqual: !e.isRequired
      });
  }
  function f0(h, w) {
    d0(h), t("dayclick", h, w);
  }
  function x0(h, w) {
    switch (w.key) {
      case " ":
      case "Enter": {
        d0(h), w.preventDefault();
        break;
      }
      case "Escape":
        st();
    }
    t("daykeydown", h, w);
  }
  function T0(h, w) {
    !H.value || S == null || (S.end = h.date, Ae(It(S), {
      patch: "date",
      formatInput: !0
    }));
  }
  function v1(h = {}) {
    F1({
      ...ae.value,
      ...h,
      isInteractive: !0,
      id: u.value
    });
  }
  function st(h = {}) {
    wt({
      hideDelay: 10,
      force: !0,
      ...ae.value,
      ...h,
      id: u.value
    });
  }
  function p1(h) {
    Ds({
      ...ae.value,
      ...h,
      isInteractive: !0,
      id: u.value
    });
  }
  function It(h, w) {
    const { start: I, end: Z } = h;
    if (I > Z)
      switch (w) {
        case "start":
          return { start: I, end: I };
        case "end":
          return { start: Z, end: Z };
        default:
          return { start: Z, end: I };
      }
    return { start: I, end: Z };
  }
  async function Ot(h, w = {}) {
    return m.value == null ? !1 : m.value.move(h, w);
  }
  async function m1(h, w = {}) {
    return m.value == null ? !1 : m.value.moveBy(h, w);
  }
  async function zt(h, w = {}) {
    const I = c.value;
    if (m.value == null || !me(I))
      return !1;
    const Z = h !== "end", fe = Z ? 1 : -1, Ce = ge(I) ? Z ? I.start : I.end : I, Oe = ds(Ce, "monthly", s.value);
    return m.value.move(Oe, { position: fe, ...w });
  }
  xe(
    () => e.isRange,
    (h) => {
      h && console.warn(
        "The `is-range` prop will be deprecated in future releases. Please use the `range` modifier."
      );
    },
    { immediate: !0 }
  ), xe(
    () => b.value,
    () => {
      Pe(null, { formatInput: !0 });
    }
  ), xe(
    () => K.value,
    () => o0()
  ), xe(
    () => e.modelValue,
    (h) => {
      $ && Pe(h, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), xe(
    () => ee.value,
    () => {
      a0(e.rules) && Pe(e.modelValue, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), xe(
    () => e.timezone,
    () => {
      Pe(c.value, { formatInput: !0 });
    }
  );
  const At = ve(U.value);
  c.value = Je(
    e.modelValue ?? null,
    At,
    "dateTime"
  ), n1(() => {
    Pe(e.modelValue, {
      formatInput: !0,
      hidePopover: !1
    });
  }), ht(() => l.value = !0);
  const M = {
    ...n,
    showCalendar: l,
    datePickerPopoverId: u,
    popoverRef: y,
    popoverEvents: W,
    calendarRef: m,
    isRange: b,
    isTimeMode: j,
    isDateTimeMode: T,
    is24hr: Vt(e, "is24hr"),
    hideTimeHeader: Vt(e, "hideTimeHeader"),
    timeAccuracy: Vt(e, "timeAccuracy"),
    isDragging: H,
    inputValue: te,
    inputEvents: le,
    dateParts: G,
    attributes: k,
    rules: ee,
    move: Ot,
    moveBy: m1,
    moveToValue: zt,
    updateValue: Ae,
    showPopover: v1,
    hidePopover: st,
    togglePopover: p1,
    onDayClick: f0,
    onDayKeydown: x0,
    onDayMouseEnter: T0,
    onPopoverBeforeShow: i0,
    onPopoverAfterShow: l0,
    onPopoverBeforeHide: u0,
    onPopoverAfterHide: c0
  };
  return Mt(Ws, M), M;
}
function ka() {
  const e = xt(Ws);
  if (e)
    return e;
  throw new Error(
    "DatePicker context missing. Please verify this component is nested within a valid context provider."
  );
}
const zb = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], Ab = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
];
function Pb(e) {
  const t = ka(), {
    locale: a,
    isRange: n,
    isTimeMode: s,
    dateParts: r,
    rules: i,
    is24hr: l,
    hideTimeHeader: u,
    timeAccuracy: c,
    updateValue: d
  } = t;
  function v(N) {
    N = Object.assign(m.value, N);
    let q = null;
    if (n.value) {
      const ae = y.value ? N : r.value[0], W = y.value ? r.value[1] : N;
      q = { start: ae, end: W };
    } else
      q = N;
    d(q, {
      patch: "time",
      targetPriority: y.value ? "start" : "end",
      moveToValue: !0
    });
  }
  const y = _(() => e.position === 0), m = _(
    () => r.value[e.position] || { isValid: !1 }
  ), g = _(() => xa(m.value)), S = _(() => !!m.value.isValid), $ = _(() => !u.value && S.value), b = _(() => {
    if (!g.value)
      return null;
    let N = a.value.toDate(m.value);
    return m.value.hours === 24 && (N = new Date(N.getTime() - 1)), N;
  }), Y = _({
    get() {
      return m.value.hours;
    },
    set(N) {
      v({ hours: N });
    }
  }), V = _({
    get() {
      return m.value.minutes;
    },
    set(N) {
      v({ minutes: N });
    }
  }), L = _({
    get() {
      return m.value.seconds;
    },
    set(N) {
      v({ seconds: N });
    }
  }), T = _({
    get() {
      return m.value.milliseconds;
    },
    set(N) {
      v({ milliseconds: N });
    }
  }), j = _({
    get() {
      return m.value.hours < 12;
    },
    set(N) {
      N = String(N).toLowerCase() == "true";
      let q = Y.value;
      N && q >= 12 ? q -= 12 : !N && q < 12 && (q += 12), v({ hours: q });
    }
  }), H = _(
    () => eg(m.value, i.value[e.position])
  ), U = _(() => zb.filter(
    (N) => H.value.hours.some((q) => q.value === N.value)
  )), G = _(() => Ab.filter(
    (N) => H.value.hours.some((q) => q.value === N.value)
  )), K = _(() => l.value ? H.value.hours : j.value ? U.value : G.value), J = _(() => {
    const N = [];
    return Qe(U.value) && N.push({ value: !0, label: "AM" }), Qe(G.value) && N.push({ value: !1, label: "PM" }), N;
  });
  return {
    ...t,
    showHeader: $,
    timeAccuracy: c,
    parts: m,
    isValid: S,
    date: b,
    hours: Y,
    minutes: V,
    seconds: L,
    milliseconds: T,
    options: H,
    hourOptions: K,
    isAM: j,
    isAMOptions: J,
    is24hr: l
  };
}
const Tb = ["value"], Eb = ["value", "disabled"], Yb = {
  key: 1,
  class: "vc-base-sizer",
  "aria-hidden": "true"
}, Hb = {
  inheritAttrs: !1
}, ft = /* @__PURE__ */ _e({
  ...Hb,
  __name: "BaseSelect",
  props: {
    options: null,
    modelValue: null,
    alignRight: { type: Boolean },
    alignLeft: { type: Boolean },
    showIcon: { type: Boolean },
    fitContent: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, a = _(() => {
      const n = t.options.find((s) => s.value === t.modelValue);
      return n == null ? void 0 : n.label;
    });
    return (n, s) => (f(), p("div", {
      class: z(["vc-base-select", {
        "vc-fit-content": e.fitContent,
        "vc-has-icon": e.showIcon
      }])
    }, [
      o("select", y0(n.$attrs, {
        value: e.modelValue,
        class: ["vc-focus", {
          "vc-align-right": e.alignRight,
          "vc-align-left": e.alignLeft
        }],
        onChange: s[0] || (s[0] = (r) => n.$emit("update:modelValue", r.target.value))
      }), [
        (f(!0), p(X, null, oe(e.options, (r) => (f(), p("option", {
          key: r.value,
          value: r.value,
          disabled: r.disabled
        }, F(r.label), 9, Eb))), 128))
      ], 16, Tb),
      e.showIcon ? (f(), P(G0, {
        key: 0,
        name: "ChevronDown",
        size: "18"
      })) : E("", !0),
      e.fitContent ? (f(), p("div", Yb, F(C(a)), 1)) : E("", !0)
    ], 2));
  }
}), Vb = {
  key: 0,
  class: "vc-time-header"
}, Nb = { class: "vc-time-weekday" }, Rb = { class: "vc-time-month" }, Fb = { class: "vc-time-day" }, Bb = { class: "vc-time-year" }, Wb = { class: "vc-time-select-group" }, jb = /* @__PURE__ */ o("span", { class: "vc-time-colon" }, ":", -1), Ub = /* @__PURE__ */ o("span", { class: "vc-time-colon" }, ":", -1), qb = /* @__PURE__ */ o("span", { class: "vc-time-decimal" }, ".", -1), Kn = /* @__PURE__ */ _e({
  __name: "TimePicker",
  props: {
    position: null
  },
  setup(e, { expose: t }) {
    const n = Pb(e);
    t(n);
    const {
      locale: s,
      isValid: r,
      date: i,
      hours: l,
      minutes: u,
      seconds: c,
      milliseconds: d,
      options: v,
      hourOptions: y,
      isTimeMode: m,
      isAM: g,
      isAMOptions: S,
      is24hr: $,
      showHeader: b,
      timeAccuracy: Y
    } = n;
    return (V, L) => (f(), p("div", {
      class: z(["vc-time-picker", [{ "vc-invalid": !C(r), "vc-attached": !C(m) }]])
    }, [
      D(Te, { name: "time-header" }, {
        default: O(() => [
          C(b) && C(i) ? (f(), p("div", Vb, [
            o("span", Nb, F(C(s).formatDate(C(i), "WWW")), 1),
            o("span", Rb, F(C(s).formatDate(C(i), "MMM")), 1),
            o("span", Fb, F(C(s).formatDate(C(i), "D")), 1),
            o("span", Bb, F(C(s).formatDate(C(i), "YYYY")), 1)
          ])) : E("", !0)
        ]),
        _: 1
      }),
      o("div", Wb, [
        D(G0, {
          name: "Clock",
          size: "17"
        }),
        D(ft, {
          modelValue: C(l),
          "onUpdate:modelValue": L[0] || (L[0] = (T) => lt(l) ? l.value = T : null),
          modelModifiers: { number: !0 },
          options: C(y),
          class: "vc-time-select-hours",
          "align-right": ""
        }, null, 8, ["modelValue", "options"]),
        C(Y) > 1 ? (f(), p(X, { key: 0 }, [
          jb,
          D(ft, {
            modelValue: C(u),
            "onUpdate:modelValue": L[1] || (L[1] = (T) => lt(u) ? u.value = T : null),
            modelModifiers: { number: !0 },
            options: C(v).minutes,
            class: "vc-time-select-minutes",
            "align-left": C(Y) === 2
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : E("", !0),
        C(Y) > 2 ? (f(), p(X, { key: 1 }, [
          Ub,
          D(ft, {
            modelValue: C(c),
            "onUpdate:modelValue": L[2] || (L[2] = (T) => lt(c) ? c.value = T : null),
            modelModifiers: { number: !0 },
            options: C(v).seconds,
            class: "vc-time-select-seconds",
            "align-left": C(Y) === 3
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : E("", !0),
        C(Y) > 3 ? (f(), p(X, { key: 2 }, [
          qb,
          D(ft, {
            modelValue: C(d),
            "onUpdate:modelValue": L[3] || (L[3] = (T) => lt(d) ? d.value = T : null),
            modelModifiers: { number: !0 },
            options: C(v).milliseconds,
            class: "vc-time-select-milliseconds",
            "align-left": ""
          }, null, 8, ["modelValue", "options"])
        ], 64)) : E("", !0),
        C($) ? E("", !0) : (f(), P(ft, {
          key: 3,
          modelValue: C(g),
          "onUpdate:modelValue": L[4] || (L[4] = (T) => lt(g) ? g.value = T : null),
          options: C(S)
        }, null, 8, ["modelValue", "options"]))
      ])
    ], 2));
  }
}), js = /* @__PURE__ */ _e({
  __name: "DatePickerBase",
  setup(e) {
    const {
      attributes: t,
      calendarRef: a,
      color: n,
      displayMode: s,
      isDateTimeMode: r,
      isTimeMode: i,
      isRange: l,
      onDayClick: u,
      onDayMouseEnter: c,
      onDayKeydown: d
    } = ka(), v = l.value ? [0, 1] : [0];
    return (y, m) => C(i) ? (f(), p("div", {
      key: 0,
      class: z(`vc-container vc-bordered vc-${C(n)} vc-${C(s)}`)
    }, [
      (f(!0), p(X, null, oe(C(v), (g) => (f(), P(Kn, {
        key: g,
        position: g
      }, null, 8, ["position"]))), 128))
    ], 2)) : (f(), P(Bs, {
      key: 1,
      attributes: C(t),
      ref_key: "calendarRef",
      ref: a,
      onDayclick: C(u),
      onDaymouseenter: C(c),
      onDaykeydown: C(d)
    }, {
      footer: O(() => [
        C(r) ? (f(!0), p(X, { key: 0 }, oe(C(v), (g) => (f(), P(Kn, {
          key: g,
          position: g
        }, null, 8, ["position"]))), 128)) : E("", !0),
        D(Te, { name: "dp-footer" })
      ]),
      _: 1
    }, 8, ["attributes", "onDayclick", "onDaymouseenter", "onDaykeydown"]));
  }
}), Zb = {
  inheritAttrs: !1
}, Gb = /* @__PURE__ */ _e({
  ...Zb,
  __name: "DatePickerPopover",
  setup(e) {
    const {
      datePickerPopoverId: t,
      color: a,
      displayMode: n,
      popoverRef: s,
      onPopoverBeforeShow: r,
      onPopoverAfterShow: i,
      onPopoverBeforeHide: l,
      onPopoverAfterHide: u
    } = ka();
    return (c, d) => (f(), P(f1, {
      id: C(t),
      placement: "bottom-start",
      class: z(`vc-date-picker-content vc-${C(a)} vc-${C(n)}`),
      ref_key: "popoverRef",
      ref: s,
      onBeforeShow: C(r),
      onAfterShow: C(i),
      onBeforeHide: C(l),
      onAfterHide: C(u)
    }, {
      default: O(() => [
        D(js, mt(I1(c.$attrs)), null, 16)
      ]),
      _: 1
    }, 8, ["id", "class", "onBeforeShow", "onAfterShow", "onBeforeHide", "onAfterHide"]));
  }
}), Kb = _e({
  inheritAttrs: !1,
  emits: Ib,
  props: Lb,
  components: { DatePickerBase: js, DatePickerPopover: Gb },
  setup(e, t) {
    const a = Ob(e, t), n = a1(is(a, "calendarRef", "popoverRef"));
    return { ...a, slotCtx: n };
  }
});
function Xb(e, t, a, n, s, r) {
  const i = A("DatePickerPopover"), l = A("DatePickerBase");
  return e.$slots.default ? (f(), p(X, { key: 0 }, [
    ie(e.$slots, "default", mt(I1(e.slotCtx))),
    D(i, mt(I1(e.$attrs)), null, 16)
  ], 64)) : (f(), P(l, mt(y0({ key: 1 }, e.$attrs)), null, 16));
}
const B1 = /* @__PURE__ */ _0(Kb, [["render", Xb]]), Xn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Calendar: Bs,
  DatePicker: B1,
  Popover: f1,
  PopoverRow: Hs
}, Symbol.toStringTag, { value: "Module" })), Jb = (e, t = {}) => {
  e.use(Cy, t);
  const a = e.config.globalProperties.$VCalendar.componentPrefix;
  for (const n in Xn) {
    const s = Xn[n];
    e.component(`${a}${n}`, s);
  }
}, Qb = { install: Jb }, e_ = /* @__PURE__ */ Object.assign({ name: "LuxDatePicker" }, {
  __name: "LuxDatePicker",
  props: {
    /**
     * Allows for a single date or a date range to be selected. Possible values are: `single, range`.
     */
    mode: {
      type: String,
      default: "single",
      validator: (e) => e.match(/(single|range)/)
    },
    /**
     * The label of the form input field.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Unique identifier of the form input field.
     */
    id: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The name attribute for the form input field.
     */
    name: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The width of the form input field.
     * `auto, expand`
     */
    width: {
      type: String,
      default: "auto",
      validator: (e) => e.match(/(auto|expand)/)
    },
    /**
     * Sets the size of the input area `small, medium, large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Placeholder text to display
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * defaultDate offers a way to add data that may already exist for the field when `mode='single'`.
     * It takes the form of a Javascript Date object.
     * Example: `:defaultDate="new Date(2019, 05, 01)"`
     */
    defaultDate: {
      type: Date,
      default: null,
      required: !1
    },
    /**
     * defaultDates offer a way to add data that may already exist for the field when `mode='range'`.
     * It takes the form of an Object containing two properties (start and,
     * optionally, end date) with values that are Javascript date objects.
     * Example: `:defaultDates="{ start: new Date(2019, 05, 01), end: new Date(2019, 05, 02)}"`
     */
    defaultDates: {
      type: Object,
      default: null,
      required: !1
    },
    /**
     * Disable dates using the date object or date range format. This example makes the
     * month of June 2019 selectable, but nothing else: `[{ start: null, end: new Date(2019, 05, 01)}, { start: new Date(2019, 05, 30), end: null }]`
     * Note: In Javascript, months start at zero, which is why 05 = June.
     */
    disabledDates: {
      type: Array,
      default: null,
      required: !1
    },
    /**
     * Highlight PUL holidays using an array of strings in YYYY-MM-DD format. Example: ["2019-11-28","2019-11-29"]
     */
    holidays: {
      type: Array,
      default: null,
      required: !1
    },
    /**
     * The helper text a user should get.
     */
    helper: {
      type: String,
      default: ""
    }
  },
  emits: ["updateInput", "updateRangeInput"],
  setup(e, { emit: t }) {
    const a = e, n = t, s = se(a.defaultDate), r = se(a.defaultDates), i = se([
      {
        bar: {
          color: "red",
          class: "lux-holiday-highlight"
        },
        dates: a.holidays,
        popover: {
          label: "Official PUL Holiday"
        }
      }
    ]), l = _({
      get() {
        return r.value ? `${v()} - ${d()}` : "";
      },
      set($) {
        m($);
      }
    });
    function u($) {
      if (s.value && g(s.value.toLocaleDateString("en-US"))) {
        let b = s.value.toLocaleDateString("en-US");
        n("updateInput", b);
      }
    }
    function c($) {
      if (r.value && g(r.value.start.toLocaleDateString("en-US")) && g(r.value.end.toLocaleDateString("en-US"))) {
        let b = v() + " - " + d();
        n("updateRangeInput", b);
      }
    }
    function d() {
      if (r.value.hasOwnProperty("end"))
        return r.value.end.toLocaleDateString("en-US");
    }
    function v() {
      if (r.value.hasOwnProperty("start"))
        return r.value.start.toLocaleDateString("en-US");
    }
    function y($) {
      if ($.includes("/")) {
        let b = $.split("/");
        return /* @__PURE__ */ new Date(b[2] + "-" + b[0] + "-" + b[1]);
      }
    }
    function m($) {
      if (S($)) {
        let b = $.split(" - ");
        g(b[0]) && g(b[1]) && (r.value || (r.value = {}), r.value = {
          start: y(b[0]),
          end: y(b[1])
        }, r.value.end = y(b[1]), n("updateRangeInput", $));
      }
    }
    function g($) {
      return $.trim().length === 0 ? !0 : /^\d{1,2}\/\d{1,2}\/\d{4}$/.test($);
    }
    function S($) {
      return $.includes(" - ") && !$.endsWith(" - ");
    }
    return ($, b) => {
      const Y = A("lux-input-text");
      return f(), p("div", {
        class: z(["lux-date-picker", e.size])
      }, [
        e.mode == "single" ? (f(), P(C(B1), {
          key: 0,
          mode: "single",
          "disabled-dates": e.disabledDates,
          "update-on-input": !0,
          attributes: i.value,
          modelValue: s.value,
          "onUpdate:modelValue": b[0] || (b[0] = (V) => s.value = V),
          onPopoverDidDisappear: b[1] || (b[1] = (V) => u())
        }, {
          default: O(({ inputValue: V, inputEvents: L }) => [
            D(Y, y0({
              id: e.id,
              label: e.label,
              name: e.name,
              required: e.required,
              width: e.width,
              size: e.size
            }, O1(L), {
              value: V,
              placeholder: e.placeholder,
              helper: e.helper
            }), null, 16, ["id", "label", "name", "required", "width", "size", "value", "placeholder", "helper"])
          ]),
          _: 1
        }, 8, ["disabled-dates", "attributes", "modelValue"])) : E("", !0),
        e.mode == "range" ? (f(), P(C(B1), {
          key: 1,
          "disabled-dates": e.disabledDates,
          "update-on-input": !0,
          attributes: i.value,
          modelValue: r.value,
          "onUpdate:modelValue": b[3] || (b[3] = (V) => r.value = V),
          modelModifiers: { range: !0 },
          onPopoverDidDisappear: b[4] || (b[4] = (V) => c())
        }, {
          default: O(({ inputEvents: V }) => [
            D(Y, y0({
              id: e.id,
              label: e.label,
              name: e.name,
              width: e.width,
              size: e.size,
              required: e.required
            }, O1(V.start), {
              value: l.value,
              "onUpdate:value": b[2] || (b[2] = (L) => l.value = L),
              placeholder: e.placeholder,
              helper: e.helper
            }), null, 16, ["id", "label", "name", "width", "size", "required", "value", "placeholder", "helper"])
          ]),
          _: 1
        }, 8, ["disabled-dates", "attributes", "modelValue"])) : E("", !0)
      ], 2);
    };
  }
}), t_ = {
  name: "LuxGridContainer",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the grid container.
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * Determines how the flexbox container is horizontally aligned. This value defaults to
     * having space between grid items. Options include `start`, `center`, and `end`.
     */
    horizontal: {
      type: String,
      default: ""
    }
  }
};
function a_(e, t, a, n, s, r) {
  return f(), P(Q(a.type), {
    class: z(["lux-flex-container", a.horizontal])
  }, {
    default: O(() => [
      ie(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["class"]);
}
const n_ = /* @__PURE__ */ x(t_, [["render", a_], ["__scopeId", "data-v-f541e93f"]]), r_ = {
  name: "LuxGridItem",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the container.
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * Sets the size of the column. Prefix with `sm-` or `lg-`. Based on a 12 column grid.
     * The inclusion of `auto` will set that grid item to have a width based on the width and height of the content.
     * The inclusion of `fill` will set the grid item to have a width based on the space available.
     */
    columns: {
      type: String,
      default: ""
    },
    /**
     * Sets the order to lay out an item in a grid container.
     */
    order: {
      type: String,
      default: ""
    },
    /**
     * Pushes grid items to the right side of the container.
     */
    offset: {
      type: Boolean,
      default: !1
    },
    /**
     * Sets the vertical alignment of the item. `start`, `center`, or `end`. For horizontal alignment, please look at the grid-container component.
     */
    vertical: {
      type: String,
      default: ""
    }
  }
};
function s_(e, t, a, n, s, r) {
  return f(), P(Q(a.type), {
    class: z(["lux-col", a.columns, a.vertical, { push: a.offset }, a.order])
  }, {
    default: O(() => [
      ie(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]);
}
const o_ = /* @__PURE__ */ x(r_, [["render", s_]]), i_ = {
  name: "LuxHeading",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The heading level used for the heading.
     * `h1, h2, h3, h4, h5, h6`
     */
    level: {
      type: String,
      default: "h1",
      validator: (e) => e.match(/(h1|h2|h3|h4|h5|h6)/)
    },
    /**
     * The size of the heading.
     * `h1, h2, h3, h4, h5, h6`
     */
    size: {
      type: String,
      default: "h1",
      validator: (e) => e.match(/(h1|h2|h3|h4|h5|h6)/)
    },
    /**
     * Whether the heading is visually hidden or not.
     * `true, false`
     */
    hidden: {
      type: Boolean,
      default: !1
    }
  }
};
function l_(e, t, a, n, s, r) {
  return f(), P(Q(a.level), {
    class: z(["lux-heading", [{ "lux-hidden": a.hidden }, a.size]])
  }, {
    default: O(() => [
      ie(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]);
}
const u_ = /* @__PURE__ */ x(i_, [["render", l_]]), c_ = {
  name: "LuxLoader",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * Sets the diameter of the circle. `x-small, small, medium, large, x-large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(x-small|small|medium|large|x-large)/)
    },
    /**
     * Determines whether the loader fills the entire screen (with overlay) or the container it's in (no overlay).
     */
    fullscreen: {
      type: Boolean,
      default: !1
    },
    /**
     * The html element name used for the wrapper.
     * `div, section`
     */
    wrapper: {
      type: String,
      default: "div",
      validator: (e) => e.match(/(div|span)/)
    }
  }
}, d_ = ["size"];
function f_(e, t, a, n, s, r) {
  return f(), P(Q(a.wrapper), {
    class: z(["lux-overlay", { "lux-fullscreen": a.fullscreen }])
  }, {
    default: O(() => [
      o("div", {
        class: "lux-loader",
        size: a.size
      }, null, 8, d_)
    ]),
    _: 1
  }, 8, ["class"]);
}
const h_ = /* @__PURE__ */ x(c_, [["render", f_], ["__scopeId", "data-v-83b50a20"]]), v_ = {
  name: "LuxLogoLibrary",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 440
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 97
    },
    /**
     * The color of the logo text.
     */
    color: {
      type: String,
      default: "#ffffff"
    }
  }
}, p_ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 440.06 97",
  preserveAspectRatio: "xMinYMid",
  "aria-labelledby": "lux-logo-library",
  role: "img"
};
function m_(e, t, a, n, s, r) {
  return f(), p("svg", p_, [
    t[1] || (t[1] = o("title", { id: "lux-logo-library" }, "Princeton University Library", -1)),
    o("g", null, [
      t[0] || (t[0] = Ct('<clipPath id="clip-path" data-v-d5f9d1c9><path d="M3 .91h90v90H3z" fill="none" data-v-d5f9d1c9></path></clipPath><rect width="96" height="97" rx="12.24" ry="12.24" fill="#ef7622" data-v-d5f9d1c9></rect><g class="pul-logo-c" data-v-d5f9d1c9><g class="pul-logo-c" data-v-d5f9d1c9><path class="pul-logo-d" d="M10.77 83.5V20.15a20.61 20.61 0 0 0 6.59-3.05v59.8h.41a16.4 16.4 0 0 0 3.53-.38 38 38 0 0 0 7.62-2.49c1.24-.54 2.45-1.13 3.67-1.71a17.37 17.37 0 0 1 5.72-1.71 11.78 11.78 0 0 1 6.16.85A7 7 0 0 1 46.74 73a4.24 4.24 0 0 1 1.11 2c0 .06 0 .11.06.2s.05-.07.05-.09A4.16 4.16 0 0 1 49.12 73a7.6 7.6 0 0 1 3.17-1.9 12 12 0 0 1 4.42-.55 16.49 16.49 0 0 1 6.44 1.73c2 1 4 1.89 6 2.66a33.85 33.85 0 0 0 6.22 1.74 14.33 14.33 0 0 0 2.69.23h.33V17.33a.51.51 0 0 1 0-.07v-.07A21.31 21.31 0 0 0 85 20v63.5z" data-v-d5f9d1c9></path><path class="pul-logo-d" d="M24.83 32.7A70.14 70.14 0 0 1 25 17l.41.2a17.26 17.26 0 0 0 4.85 1.69 13.45 13.45 0 0 0 8.91-1.44 19.27 19.27 0 0 0 5-3.93 25.37 25.37 0 0 0 3.55-4.83l.12-.19.21.35a24.49 24.49 0 0 0 5.68 6.73 15.38 15.38 0 0 0 6.35 3.2 13.73 13.73 0 0 0 7.33-.4 19 19 0 0 0 2.91-1.22l.25-.13h.12a70.13 70.13 0 0 1 .16 15.56H24.84M35.7 60.37a50.22 50.22 0 0 1-5.26-8.68l17.42-17.43 17.37 17.4A46.75 46.75 0 0 1 60 60.35l-6.05-6-6.07-6.07L35.7 60.37" data-v-d5f9d1c9></path></g></g>', 3)),
      o("path", {
        style: e0({ fill: a.color }),
        d: "M118.7 28.26h-3V3.93h8.63q4 0 6 2.2a7.41 7.41 0 0 1 1.92 5 7 7 0 0 1-2.09 5.19 7.5 7.5 0 0 1-5.48 2h-5.9zm0-12.4h5.6a4.75 4.75 0 0 0 3.48-1.29 4.56 4.56 0 0 0 1.32-3.41 5 5 0 0 0-1.18-3.24 4.16 4.16 0 0 0-3.4-1.43h-5.82zm21.15 12.4h-2.8v-18h2.46v4.21a9 9 0 0 1 2.61-3.86 4.75 4.75 0 0 1 2.68-.88 11.06 11.06 0 0 1 1.1.07v2.67h-.57a4.93 4.93 0 0 0-3.85 1.73 7 7 0 0 0-1.64 4.54zm13.36-24.33V7h-3V3.93zm-.09 6.33v18h-2.8v-18zm21.01 18h-2.62V16.69a4.67 4.67 0 0 0-1.09-3.51 3.72 3.72 0 0 0-2.64-1 4.53 4.53 0 0 0-3.59 1.71 6.73 6.73 0 0 0-1.45 4.51v9.87h-2.8v-18h2.6v3.32q2.19-3.81 5.69-3.81a5.63 5.63 0 0 1 3.43 1 5.54 5.54 0 0 1 1.94 2.34 14.25 14.25 0 0 1 .53 4.71zm17.47-6.31l2.53.45a8.06 8.06 0 0 1-2.37 4.67A7.16 7.16 0 0 1 181.51 26a11.29 11.29 0 0 1-2-6.71 11 11 0 0 1 2.06-6.82 6.66 6.66 0 0 1 5.61-2.72 6.41 6.41 0 0 1 4.71 1.76 7.86 7.86 0 0 1 2.2 4.54l-2.53.48q-.71-4.46-4.3-4.46a4 4 0 0 0-3.56 2 9.42 9.42 0 0 0-1.25 5.11 9.87 9.87 0 0 0 1.24 5.37 3.91 3.91 0 0 0 3.48 1.92q3.51-.03 4.43-4.52zm19.49.94l2.6.53a7.32 7.32 0 0 1-2.78 3.82 8 8 0 0 1-4.91 1.52 7.57 7.57 0 0 1-6-2.6 9.93 9.93 0 0 1-2.28-6.81 10 10 0 0 1 2.37-6.95 7.65 7.65 0 0 1 6-2.65 7.19 7.19 0 0 1 5.68 2.44q2.15 2.44 2.2 7.31h-13.05q0 4.08 1.71 5.51a5.57 5.57 0 0 0 3.62 1.43q3.44 0 4.84-3.55zm-.16-5.47a7.83 7.83 0 0 0-.5-2.69 4.6 4.6 0 0 0-1.57-2 4.3 4.3 0 0 0-2.66-.83 4.74 4.74 0 0 0-3.54 1.5 6.19 6.19 0 0 0-1.63 4zm16.5 8.93v2.21a19.86 19.86 0 0 1-2.57.2q-5.22 0-5.22-5.46V12.45h-3.19v-2.19h3.19l.13-4.53 2.6-.25v4.78h4v2.19h-4v11.31q0 2.78 2.89 2.78a13.69 13.69 0 0 0 2.17-.19zm10.2 2.41a6.84 6.84 0 0 1-5.78-2.76 11 11 0 0 1-2.08-6.81 9.82 9.82 0 0 1 2.33-6.87 7.53 7.53 0 0 1 5.81-2.57 7.1 7.1 0 0 1 5.87 2.7 10.51 10.51 0 0 1 2.15 6.75 10.11 10.11 0 0 1-2.32 6.88 7.56 7.56 0 0 1-5.98 2.68zm.21-2.32a4.45 4.45 0 0 0 3.58-1.76q1.44-1.77 1.44-5.49t-1.52-5.43a4.63 4.63 0 0 0-3.55-1.68 4.46 4.46 0 0 0-3.53 1.7q-1.44 1.7-1.45 5.39 0 3.9 1.45 5.59a4.51 4.51 0 0 0 3.59 1.68zm27.73 1.82H263V16.69a4.67 4.67 0 0 0-1.09-3.51 3.72 3.72 0 0 0-2.64-1 4.52 4.52 0 0 0-3.59 1.71 6.73 6.73 0 0 0-1.45 4.51v9.87h-2.8v-18H254v3.32q2.19-3.81 5.69-3.81a5.63 5.63 0 0 1 3.43 1 5.54 5.54 0 0 1 1.88 2.37 14.28 14.28 0 0 1 .53 4.71zm31.32-24.33h2.53v15.89q0 4.78-2.34 6.86a8.91 8.91 0 0 1-6.14 2.08q-4.22 0-6.26-2.14t-2-6.8V3.93h3v15.89a8.65 8.65 0 0 0 .66 4 3.93 3.93 0 0 0 2 1.71 7.24 7.24 0 0 0 2.8.55 5.75 5.75 0 0 0 4.28-1.48q1.46-1.48 1.46-4.78zm23.25 24.33h-2.62V16.69a4.67 4.67 0 0 0-1.09-3.51 3.72 3.72 0 0 0-2.64-1 4.52 4.52 0 0 0-3.59 1.71 6.73 6.73 0 0 0-1.45 4.51v9.87H306v-18h2.6v3.32q2.19-3.81 5.69-3.81a5.63 5.63 0 0 1 3.43 1 5.54 5.54 0 0 1 1.94 2.34 14.27 14.27 0 0 1 .53 4.71zm9.73-24.33V7h-3V3.93zm-.09 6.33v18H327v-18zm20.01 0l-6.22 18h-2.88l-6.45-18h3.11l5 14.63 5-14.63zm15.82 12.63l2.6.53a7.32 7.32 0 0 1-2.78 3.82 8 8 0 0 1-4.87 1.51 7.57 7.57 0 0 1-6-2.6 9.93 9.93 0 0 1-2.28-6.81 10 10 0 0 1 2.37-6.95 7.65 7.65 0 0 1 6-2.65 7.19 7.19 0 0 1 5.68 2.44q2.15 2.44 2.2 7.31h-13.1q0 4.08 1.71 5.51a5.57 5.57 0 0 0 3.62 1.43q3.44.01 4.85-3.54zm-.16-5.47a7.81 7.81 0 0 0-.5-2.69 4.61 4.61 0 0 0-1.57-2 4.31 4.31 0 0 0-2.66-.83 4.74 4.74 0 0 0-3.54 1.5 6.19 6.19 0 0 0-1.63 4zm11.31 10.84H374v-18h2.46v4.21a9 9 0 0 1 2.54-3.86 4.75 4.75 0 0 1 2.68-.88c.29 0 .65 0 1.11.07v2.67h-.57a4.93 4.93 0 0 0-3.85 1.73 7 7 0 0 0-1.64 4.54zm8.24-4.67l2.7-.59q.89 3.4 5.63 3.4a5.34 5.34 0 0 0 3-.78 2.49 2.49 0 0 0 1.21-2.21q0-2.12-3.08-2.69l-3.84-.72a6.93 6.93 0 0 1-3.55-1.68 4.33 4.33 0 0 1-1.32-3.3 4.76 4.76 0 0 1 1.8-3.79 7.25 7.25 0 0 1 4.85-1.52q5.86 0 7.23 4.58l-2.57.55q-1.1-2.82-4.54-2.82a5.11 5.11 0 0 0-2.81.7 2.21 2.21 0 0 0-1.1 2q0 2 2.8 2.51l3.51.63q5.51 1 5.51 5.34a4.77 4.77 0 0 1-2 4 8.92 8.92 0 0 1-5.46 1.53q-6.43.03-7.97-5.14zm23.5-19.66V7h-3V3.93zm-.09 6.33v18h-2.8v-18zm14.99 16.09v2.21a19.87 19.87 0 0 1-2.57.2q-5.22 0-5.22-5.46V12.45h-3.19v-2.19h3.19l.13-4.53 2.6-.25v4.78h4v2.19h-4v11.31q0 2.78 2.89 2.78a13.7 13.7 0 0 0 2.17-.19zm16.66-16.09l-7.22 20.11q-1.57 4.35-5 4.35a8.87 8.87 0 0 1-2.41-.37v-2.21a8.57 8.57 0 0 0 1.87.25 3.33 3.33 0 0 0 2.24-.77q.9-.77 1.79-3.74l-6.23-17.62h2.84l4.83 13.53 4.92-13.53zM116 43.11h7.42V84.2h22v6.51H116zm45.61 0H169v47.6h-7.35zm26.25 0h17.29c8.89 0 13.44 5.39 13.44 12a9 9 0 0 1-6.44 9.17c6.37 1.47 9.73 6 9.73 12.11 0 8.19-5.46 14.35-15.47 14.35h-18.55zm16.94 18.55c4.41 0 6.51-2.45 6.51-6s-2-6-6.65-6h-9.38v12zM206 84.2c5.74 0 8.47-3.36 8.47-8.12S211.53 68 205.65 68h-10.37v16.2zm64.68 6.51h-8.54l-8.54-12.53a38.3 38.3 0 0 1-4 .28h-4.48v12.25h-7.42v-47.6h11.9c13.16 0 20.51 6.86 20.51 17.78 0 7.35-3.29 12.39-9.52 15.12zm-21.36-18.62c9.45 0 13.23-4.13 13.23-11.2s-3.92-11.27-13.23-11.27h-4.2v22.47zm54.25-29.47h.84l20.86 48.09h-7.7L314.85 84h-21.78l-2.73 6.72h-7.14zm8.61 35.14l-6-14.84a71.79 71.79 0 0 1-2.38-7.07 64.14 64.14 0 0 1-2.31 7.07l-6 14.84zm61.04 12.95h-8.54l-8.54-12.53a38.3 38.3 0 0 1-4 .28h-4.48v12.25h-7.42v-47.6h11.9c13.16 0 20.51 6.86 20.51 17.78 0 7.35-3.29 12.39-9.52 15.12zm-21.35-18.62c9.45 0 13.23-4.13 13.23-11.2s-3.92-11.27-13.23-11.27h-4.2v22.47zm50.54 3.57l-18.06-32.55h8.19l10.78 19.6a50.68 50.68 0 0 1 2.87 6.86 63.32 63.32 0 0 1 2.87-6.86l10.43-19.6h7.63l-17.29 32.13v15.47h-7.42z"
      }, null, 4)
    ])
  ]);
}
const Us = /* @__PURE__ */ x(v_, [["render", m_], ["__scopeId", "data-v-d5f9d1c9"]]), y_ = {
  name: "LuxLibraryLogo",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * Whether the theme is dark or light.
     */
    theme: {
      type: String,
      default: "dark"
    }
  },
  components: {
    LuxLogoLibrary: Us
  }
}, g_ = { href: "https://library.princeton.edu" };
function b_(e, t, a, n, s, r) {
  const i = A("lux-logo-library");
  return f(), P(Q(a.type), {
    class: z(["lux-library-logo", a.theme])
  }, {
    default: O(() => [
      o("a", g_, [
        a.theme === "dark" ? (f(), P(i, {
          key: 0,
          class: "full-logo"
        })) : (f(), P(i, {
          key: 1,
          color: "#000000",
          class: "full-logo"
        }))
      ])
    ]),
    _: 1
  }, 8, ["class"]);
}
const La = /* @__PURE__ */ x(y_, [["render", b_], ["__scopeId", "data-v-0ced6934"]]), __ = {
  name: "LuxSpacer",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
};
function $_(e, t, a, n, s, r) {
  return f(), P(Q(a.type), { class: "lux-spacer" }, {
    default: O(() => [
      ie(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  });
}
const qs = /* @__PURE__ */ x(__, [["render", $_], ["__scopeId", "data-v-1ef72dfa"]]), w_ = {
  name: "LuxWrapper",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The maximum width of the wrapper. Default is set to 1440.
     */
    maxWidth: {
      type: [String, Number],
      default: 1440
    },
    /**
     * Determines whether the wrapper takes up 100% of the parent container.
     */
    fullWidth: {
      type: [String, Boolean],
      default: !1
    },
    /**
     * Determines how the flexbox wrapper is horizontally aligned. This value defaults to
     * having space between grid items. Options include `start`, `center`, and `end`.
     */
    horizontal: {
      type: String,
      default: ""
    }
  }
};
function C_(e, t, a, n, s, r) {
  return f(), P(Q(a.type), {
    class: z(["lux-wrapper", { "lux-full-width": a.fullWidth }, a.horizontal]),
    style: e0({ "max-width": a.maxWidth + "px" })
  }, {
    default: O(() => [
      ie(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["class", "style"]);
}
const h1 = /* @__PURE__ */ x(w_, [["render", C_], ["__scopeId", "data-v-49c06837"]]), x_ = {
  name: "LuxLibraryHeader",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  props: {
    /**
     * The html element name used for the container
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The name of the application or site
     */
    appName: {
      type: String,
      default: ""
    },
    /**
     * The abbreviation of the application or site's name
     */
    abbrName: {
      type: String,
      default: ""
    },
    /**
     * The URL of landing page for the application or site
     */
    appUrl: {
      type: String,
      default: ""
    },
    /**
     * The maximum width of the wrapper. Default is set to 1440.
     */
    maxWidth: {
      type: Number,
      default: 1440
    },
    /**
     * Whether the header is dark, shade, or light. Default is set to dark.
     */
    theme: {
      type: String,
      default: "dark"
    }
  },
  methods: {
    value: function(e) {
      return e == "light" ? "light" : "dark";
    }
  },
  components: {
    LuxSpacer: qs,
    LuxWrapper: h1,
    LuxLibraryLogo: La
  }
}, M_ = ["href", "title"], S_ = {
  id: "appName",
  class: "full-name"
}, D_ = { class: "abbr-name" };
function k_(e, t, a, n, s, r) {
  const i = A("lux-library-logo"), l = A("lux-spacer"), u = A("lux-wrapper");
  return f(), P(Q(a.type), {
    class: z(["lux-library-header", a.theme])
  }, {
    default: O(() => [
      D(u, {
        class: "lux-header-content",
        maxWidth: a.maxWidth
      }, {
        default: O(() => [
          ie(e.$slots, "logo", {}, () => [
            D(i, {
              theme: r.value(a.theme)
            }, null, 8, ["theme"])
          ], !0),
          a.appName ? (f(), p("a", {
            key: 0,
            class: "lux-app-name",
            href: a.appUrl,
            title: a.appName,
            "aria-labelledby": "appName"
          }, [
            o("span", S_, F(a.appName), 1),
            o("span", D_, F(a.abbrName), 1)
          ], 8, M_)) : E("", !0),
          D(l),
          ie(e.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["maxWidth"])
    ]),
    _: 3
  }, 8, ["class"]);
}
const L_ = /* @__PURE__ */ x(x_, [["render", k_], ["__scopeId", "data-v-784b67a5"]]), I_ = {
  name: "LuxLogoInstagram",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 24
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 24
    }
  }
}, O_ = ["width", "height"];
function z_(e, t, a, n, s, r) {
  return f(), p("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: a.width,
    height: a.height,
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "logo-instagram",
    role: "img",
    fill: "currentColor",
    class: "lux-logo-instagram"
  }, t[0] || (t[0] = [
    o("title", {
      id: "logo-instagram",
      lang: "en"
    }, "PUL Instagram", -1),
    o("g", null, [
      o("path", { d: "M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" })
    ], -1)
  ]), 8, O_);
}
const Zs = /* @__PURE__ */ x(I_, [["render", z_]]), A_ = {
  name: "LuxLogoUniversityWhite",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 263
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 72
    }
  }
}, P_ = ["width", "height"];
function T_(e, t, a, n, s, r) {
  return f(), p("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: a.width,
    height: a.height,
    viewBox: "0 0 194 54.892",
    "aria-labelledby": "logo-university-white",
    role: "img"
  }, t[0] || (t[0] = [
    Ct('<title id="logo-university-white" lang="en">Princeton University</title><g><path class="a" d="M193.689,9.9a.6.6,0,0,0-.059-.276h-.448c-.975,0-1.6.042-3.357.042-.6,0-1.5-.042-1.717-.042H187.6c-.059.042-.08.255-.08.332a.516.516,0,0,0,.1.332,8.36,8.36,0,0,1,2.01.566,3.813,3.813,0,0,1,.566,1.993c.018.29.038.584.038,1.385v4.077a7.637,7.637,0,0,1-.038.839c-.332-.371-.8-1.07-1.58-1.951l-6.521-7.22a1.354,1.354,0,0,0-.29-.255c-.157,0-.43-.018-.584-.018-1.252,0-3.514-.059-3.846-.059a.737.737,0,0,0-.08.273,3.348,3.348,0,0,0,.059.371,2.7,2.7,0,0,1,1.465.741,6.662,6.662,0,0,1,1.031,1.231,1.7,1.7,0,0,1,.081.626c0,1.014-.059,2.437-.059,3.8v3.962a8.61,8.61,0,0,1-.115,1.482,4.089,4.089,0,0,1-2.049,1,1.067,1.067,0,0,0-.077.35c0,.059.018.255.056.276h.371c.392,0,1.29-.059,1.874-.059.86,0,1.444.059,2.245.059h1.171c.077-.021.1-.255.1-.332a.915.915,0,0,0-.059-.315,3.738,3.738,0,0,1-2.343-1.21,11.051,11.051,0,0,1-.252-2.419c0-.622-.021-1.483-.021-2.633,0-1.545.021-2.892.038-3.573.119.136.255.311.353.43l9.017,10.129c.094.1.448.115.545.115a.474.474,0,0,0,.234-.038,2.215,2.215,0,0,0,.175-.878c0-.563-.021-1.15-.021-1.444V13.449c0-2.441,1.154-3.126,2.5-3.182a.841.841,0,0,0,.077-.371m-22.367,6.2c0,2.951-.818,5.546-1.93,6.462a3.165,3.165,0,0,1-2.07.7,2.918,2.918,0,0,1-2.594-1.308,10.377,10.377,0,0,1-1.154-5.073c0-2.713.7-4.839,1.951-5.874a3.116,3.116,0,0,1,2.032-.762,3.249,3.249,0,0,1,2.654,1.346,7.523,7.523,0,0,1,1.112,4.507m3.531.374a6.539,6.539,0,0,0-3.472-6.07,7.547,7.547,0,0,0-3.71-1,7.943,7.943,0,0,0-6.577,3.629,7.463,7.463,0,0,0-1.129,3.944,7.26,7.26,0,0,0,2.79,5.717,7.325,7.325,0,0,0,4.451,1.405,8.08,8.08,0,0,0,2.965-.566,7.008,7.008,0,0,0,2.713-1.853,7.539,7.539,0,0,0,1.969-5.21M157.7,14.012V10.033c0-.294-.115-.371-.409-.371-.587,0-3.668.077-6.79.077-2.423,0-4.433-.038-5.524-.038h-1.448c-.252,0-.329.056-.329.332V13.76a.558.558,0,0,0,.311.077,1.629,1.629,0,0,0,.43-.038,6.568,6.568,0,0,1,2.734-3.259c.584-.059,1.734-.077,2.045-.077.021.213.042.9.059,1.717.021,1.4.021,2.01.021,5.325,0,2.871-.021,4.161-.059,4.472-.077.545.021.955-2.322,1.052a1.121,1.121,0,0,0-.059.448,1.59,1.59,0,0,0,.021.315h.759c.724,0,2.419-.08,3.126-.08.563,0,2.381.059,3.57.059h.545a.979.979,0,0,0,.059-.409.732.732,0,0,0-.077-.35,4.044,4.044,0,0,1-2.01-.371,5.991,5.991,0,0,1-.178-1.465c-.018-2.109-.038-2.909-.038-4.315,0-1.815.021-3.042.021-6.42.273,0,.9-.021,1.482,0a3.8,3.8,0,0,1,2.322,1.482A9.658,9.658,0,0,1,157,14.054a1.089,1.089,0,0,0,.332.035.981.981,0,0,0,.371-.077m-16.822,6.343a4.241,4.241,0,0,0-.021-.563.435.435,0,0,0-.294-.059,1.641,1.641,0,0,0-.43.038,7.436,7.436,0,0,1-2.147,2.986,3.02,3.02,0,0,1-1.465.213h-1.6a6.842,6.842,0,0,1-1.287-.1c-.294-.056-.6-.524-.741-.835a2.05,2.05,0,0,1-.217-1.231V16.53h.724a3.1,3.1,0,0,1,1.189.276,1.771,1.771,0,0,1,.878.818,6.673,6.673,0,0,1,.332,1.619,1.319,1.319,0,0,0,.51.077.688.688,0,0,0,.388-.095c0-.528-.119-1.951-.119-2.734,0-.975.136-2.322.2-3.025a.847.847,0,0,0-.388-.077,1.424,1.424,0,0,0-.507.059c-.059.269-.276,1.091-.315,1.15a2.346,2.346,0,0,1-1.325,1.014,5.083,5.083,0,0,1-1.133.157H132.7V13.953c0-1.871.038-2.476.056-2.829.021-.234.059-.486.08-.661a7.709,7.709,0,0,1,1.171-.042c1.129,0,1.657.021,1.832.021a2.18,2.18,0,0,1,1.252.392,8.2,8.2,0,0,1,1.871,2.42,1.578,1.578,0,0,0,.413.038c.115,0,.136-.038.294-.119,0-1.189-.08-2.731-.119-3.22-.021-.2-.059-.252-.448-.252-.157,0-.9-.038-1.678-.038-1.112,0-1.563.018-3.262.018-.916,0-2.811.021-3.612.021-1.168,0-2.164-.038-2.671-.038h-.664a.636.636,0,0,0-.1.311.863.863,0,0,0,.1.388,9.948,9.948,0,0,1,1.427.217,1.6,1.6,0,0,1,.7,1.269c.042.409.059,1.542.059,2.441v4.018c0,.822-.018,2.01-.038,2.5a5.615,5.615,0,0,1-.427,1.853,5.138,5.138,0,0,1-1.759.294,1.129,1.129,0,0,0-.1.43.721.721,0,0,0,.1.35h.643c.626,0,2.927-.059,3.455-.059.489,0,1.427.038,2.556.038.626,0,2.462.119,6.4.119a1.658,1.658,0,0,0,.528-.038.582.582,0,0,0,.077-.315c.042-.388.042-1.542.042-3.122m-16.51.685a.651.651,0,0,0-.664-.468c-.042,0-.1.018-.136.018a4.609,4.609,0,0,1-3.927,2.283A4.27,4.27,0,0,1,115.7,20.3a10.659,10.659,0,0,1-.6-3.549,8.6,8.6,0,0,1,.584-3.416c.86-2.262,2.109-2.969,3.633-2.969a3.994,3.994,0,0,1,3.122,1.759,8.715,8.715,0,0,1,.993,2.364,2.07,2.07,0,0,0,.43.056.989.989,0,0,0,.468-.175c-.017-.217-.213-1.717-.213-2.185,0-.587.154-1.542.154-1.913a1.588,1.588,0,0,0-.759-.217,4.02,4.02,0,0,0-.664.8,6.436,6.436,0,0,0-4.332-1.385,6.676,6.676,0,0,0-4.9,1.93,7.422,7.422,0,0,0-2.087,5.5,7.138,7.138,0,0,0,2.752,5.836,7.762,7.762,0,0,0,4.549,1.311,6.049,6.049,0,0,0,5-2.091,4.066,4.066,0,0,0,.549-.916M109.182,9.9a.64.64,0,0,0-.059-.276h-.451c-.975,0-1.6.042-3.357.042-.6,0-1.5-.042-1.717-.042h-.507c-.059.042-.08.255-.08.332a.5.5,0,0,0,.1.332,8.451,8.451,0,0,1,2.011.566,3.847,3.847,0,0,1,.563,1.993c.021.29.042.584.042,1.385v4.077a6.64,6.64,0,0,1-.042.839c-.329-.371-.8-1.07-1.58-1.951l-6.514-7.22a1.358,1.358,0,0,0-.294-.255c-.157,0-.43-.018-.584-.018-1.252,0-3.514-.059-3.846-.059a.73.73,0,0,0-.077.273,3.328,3.328,0,0,0,.056.371,2.7,2.7,0,0,1,1.465.741,6.548,6.548,0,0,1,1.035,1.231,1.714,1.714,0,0,1,.077.626c0,1.014-.056,2.437-.056,3.8v3.962a8.542,8.542,0,0,1-.119,1.482,4.089,4.089,0,0,1-2.049,1,1.167,1.167,0,0,0-.077.35c0,.059.018.255.056.276h.371c.392,0,1.29-.059,1.874-.059.86,0,1.444.059,2.245.059h1.168c.077-.021.1-.255.1-.332a.911.911,0,0,0-.059-.315,3.731,3.731,0,0,1-2.339-1.21,11.278,11.278,0,0,1-.252-2.419c0-.622-.021-1.483-.021-2.633,0-1.545.021-2.892.038-3.573.119.136.255.311.353.43l9.014,10.129a1.1,1.1,0,0,0,.545.115.461.461,0,0,0,.234-.038,2.216,2.216,0,0,0,.175-.878c0-.563-.021-1.15-.021-1.444V13.449c0-2.441,1.154-3.126,2.5-3.182a.846.846,0,0,0,.08-.371m-19.3,13.524a1.277,1.277,0,0,0-.059-.392,13.548,13.548,0,0,1-1.444-.175,3.084,3.084,0,0,1-.664-1.5c-.017-.937-.038-2.871-.038-4.682v-4.8a1.527,1.527,0,0,1,.353-1.052,3.325,3.325,0,0,1,1.738-.507,1.254,1.254,0,0,0,.056-.371.577.577,0,0,0-.1-.315h-.566c-.818,0-2.731.1-3.4.1-.409,0-2.322-.056-3.182-.077h-.427a.476.476,0,0,0-.1.332,2.479,2.479,0,0,0,.038.371,4.119,4.119,0,0,1,1.521.273,2.156,2.156,0,0,1,.647,1.661c.018.371.035,1.171.056,2.965.021.976.038,2.343.038,3.472,0,.566-.038,1.836-.059,2.521a3.364,3.364,0,0,1-.269,1.171c-.234.192-.472.545-1.9.643a1.5,1.5,0,0,0-.059.409c0,.157.038.234.038.332h.332c.783,0,2.734-.1,3.748-.1.294,0,2.322.059,2.965.059H89.8a.782.782,0,0,0,.077-.332M74.227,13.233a3.041,3.041,0,0,1-1.773,2.832,6.754,6.754,0,0,1-1.6.154,4.809,4.809,0,0,1-.724-.038l-.021-1.661V10.928a.626.626,0,0,1,.119-.43,2,2,0,0,1,.822-.115c1.521,0,2.185.136,2.731,1.056a3.453,3.453,0,0,1,.448,1.794m5.661,10.21a.957.957,0,0,0-.1-.413,3.024,3.024,0,0,1-1.287-.252,4.287,4.287,0,0,1-.332-.489,20.966,20.966,0,0,0-.839-2.245,7.381,7.381,0,0,0-1.444-2.322,6,6,0,0,0-1.465-.643c-.311-.119-.566-.217-.8-.315a6.853,6.853,0,0,1,.8-.115,3.465,3.465,0,0,0,2.147-.724,3.073,3.073,0,0,0,1.21-2.535,3.747,3.747,0,0,0-2.441-3.552A9.513,9.513,0,0,0,73,9.621c-1.465,0-3.514.136-4.489.136-.294,0-1.993-.038-2.675-.038-.294,0-1.035-.038-1.15-.038a1.144,1.144,0,0,0-.1.371,2.043,2.043,0,0,0,.038.353c.332.038.937.115,1.248.175a2.276,2.276,0,0,1,.818,1.052,48.859,48.859,0,0,1,.119,4.979c0,1.989.021,4.294-.077,5.035a1.5,1.5,0,0,1-.8,1.308,11.056,11.056,0,0,1-1.112.136.95.95,0,0,0-.1.388,1.229,1.229,0,0,0,.077.315c.276,0,3.262-.059,3.885-.059,1.248,0,2.3.059,3.416.059a.851.851,0,0,0,.077-.294,1.183,1.183,0,0,0-.077-.409c-.392-.038-.878-.157-1.094-.2a1.467,1.467,0,0,1-.839-1.385L70.151,17a4.861,4.861,0,0,1,.507-.018,1.951,1.951,0,0,1,1.032.311,3.736,3.736,0,0,1,1.545,1.423,11.9,11.9,0,0,1,1.227,4.2c.059.409.213.759.587.8.154.021,1.189.059,1.93.059h2.794a.531.531,0,0,0,.115-.329M58.692,13.33a3.208,3.208,0,0,1-.993,2.441,3.2,3.2,0,0,1-2.031.524,6.351,6.351,0,0,1-.839-.038c-.157-.017-.255-.038-.255-.136l.021-5.717a8.316,8.316,0,0,1,1.133-.1c1.325,0,2.147.332,2.535,1.15a4.157,4.157,0,0,1,.43,1.874m3.493.077A3.738,3.738,0,0,0,60.1,10.012a9.751,9.751,0,0,0-3.493-.448c-1.5,0-3.846.115-4.878.115C51,9.68,49.909,9.6,49.3,9.6a.709.709,0,0,0-.1.311.948.948,0,0,0,.059.392c.371.115.975.213,1.367.311a1.673,1.673,0,0,1,.524,1.112c.059.685.1,1.542.1,3.025,0,4.119-.018,6.287-.077,6.755a1.663,1.663,0,0,1-1.112,1.385,10.841,10.841,0,0,1-1.133.2,2.264,2.264,0,0,0-.038.409.559.559,0,0,0,.056.273c.626,0,2.462-.077,3.164-.077,1.738,0,3.514.077,4.234.077h.49a.548.548,0,0,0,.059-.311.915.915,0,0,0-.042-.353,3.169,3.169,0,0,1-1.832-.622,1.669,1.669,0,0,1-.392-1.154l-.059-4.29c1.171.077,2.42.115,3.1.115a7.446,7.446,0,0,0,2.262-.35,3.584,3.584,0,0,0,2.245-3.4" transform="translate(0)"></path><path class="a" d="M194,31.665c0-.115-.077-.154-.115-.234-.8,0-1.853.059-2.266.059-.993,0-2.2-.08-2.731-.08-.059.119-.08.14-.08.238a.687.687,0,0,0,.042.234c.566.115,1.385.252,1.542.524a1.428,1.428,0,0,1,.175.762,1.872,1.872,0,0,1-.119.724c-.175.486-.545,1.248-1.07,2.322-.9,1.815-1.465,2.944-1.78,3.4-.507-.86-1.636-3.122-1.909-3.706l-1.095-2.381a1.824,1.824,0,0,1-.077-.528,1.286,1.286,0,0,1,.077-.507c.175-.353.78-.392,1.6-.49a.881.881,0,0,0,.056-.294c0-.136-.056-.1-.115-.192h-.35c-1.311,0-.92.056-3.164.056-.955,0-2.109-.056-2.262-.056-.08.136-.119.154-.119.29a.4.4,0,0,0,.08.234c1.3.315,1.7.545,1.832.8l3.416,6.7a7.629,7.629,0,0,1,.626,1.462,10.873,10.873,0,0,1,.157,2.343,1.657,1.657,0,0,1-.626,1.5,9.286,9.286,0,0,1-1.563.255.471.471,0,0,0-.1.273.766.766,0,0,0,.059.234c1,0,2.032-.021,2.615-.021.409,0,1.035.021,2.185.038.664.021,1.171.042,1.521.042a.562.562,0,0,0,.1-.255.431.431,0,0,0-.08-.255,4.656,4.656,0,0,1-1.7-.392,1.5,1.5,0,0,1-.51-1.245l-.154-2.93a1.144,1.144,0,0,1,.077-.468,3.122,3.122,0,0,1,.213-.545l3.007-5.955a4.038,4.038,0,0,1,1.248-1.3,5.365,5.365,0,0,1,1.269-.392.676.676,0,0,0,.077-.255m-15.766,4.021V31.9c0-.294-.119-.371-.413-.371-.584,0-3.28.077-6.4.077-2.42,0-4.039-.038-5.133-.038h-1.444c-.252,0-.332.059-.332.332v3.532a.348.348,0,0,0,.234.08.5.5,0,0,0,.234-.038c.762-1.7,1.15-2.6,2.462-3.262.584-.056,2.633-.077,2.944-.077.021.217.042.9.059,1.717.021,1.405.021,2.168.021,5.486,0,2.867-.021,4.353-.059,4.664-.077.545.021.955-2.322,1.052a.628.628,0,0,0-.059.332.875.875,0,0,0,.021.234h.759c.724,0,1.678-.077,2.381-.077.566,0,1.64.059,2.832.059h.545a.524.524,0,0,0,.059-.294.434.434,0,0,0-.08-.273,4.057,4.057,0,0,1-2.01-.371,6.016,6.016,0,0,1-.175-1.465c-.018-2.108-.038-3.1-.038-4.507,0-1.815.021-3.2.021-6.577.273,0,1.717-.021,2.3,0a3.508,3.508,0,0,1,2.2,1.482,6.211,6.211,0,0,1,.878,2.126.774.774,0,0,0,.294.038.376.376,0,0,0,.217-.077m-16.22,9.64a.638.638,0,0,0-.059-.273,13.7,13.7,0,0,1-1.444-.175,3.084,3.084,0,0,1-.664-1.5c-.017-.937-.038-3.063-.038-4.878V33.539a1.564,1.564,0,0,1,.35-1.052,3.335,3.335,0,0,1,1.738-.511.6.6,0,0,0,.06-.252.327.327,0,0,0-.1-.234h-.563c-.822,0-1.993.1-2.657.1-.409,0-1.58-.059-2.44-.077h-.43a.285.285,0,0,0-.094.252,1.261,1.261,0,0,0,.038.255,4.113,4.113,0,0,1,1.521.273,2.155,2.155,0,0,1,.647,1.661c.018.367.035,1.364.056,3.161.021.976.038,2.3.038,3.434,0,.566-.038,2.028-.059,2.713a3.339,3.339,0,0,1-.269,1.171c-.238.2-.472.545-1.895.643a.8.8,0,0,0-.059.294c0,.157.038.157.038.252h.332c.783,0,1.993-.094,3.007-.094.294,0,1.58.056,2.227.056h.64a.47.47,0,0,0,.081-.255m-9.643-3.591a3.621,3.621,0,0,0-2.206-3.434,10.651,10.651,0,0,0-2.164-.78,14.392,14.392,0,0,1-2.832-1.074,2.348,2.348,0,0,1-1.15-2.129,2.584,2.584,0,0,1,2.752-2.283,3.278,3.278,0,0,1,2.675,1.367,9.913,9.913,0,0,1,1.21,2.224.541.541,0,0,0,.626-.154,15.288,15.288,0,0,1-.157-1.759,10.123,10.123,0,0,1,.178-1.521.6.6,0,0,0-.587-.273,4.215,4.215,0,0,0-.762.7,4.887,4.887,0,0,0-3.318-1.213,3.819,3.819,0,0,0-4.116,3.731,3.932,3.932,0,0,0,.72,2.147,4.234,4.234,0,0,0,1.9,1.423c.563.234,3.1,1,3.451,1.133,1.563.6,2.15,1.133,2.15,2.518a3.052,3.052,0,0,1-.86,1.972,2.729,2.729,0,0,1-2.168.916,4.372,4.372,0,0,1-3.28-1.444,9.248,9.248,0,0,1-1.325-2.636.731.731,0,0,0-.273-.035.66.66,0,0,0-.371.115c0,.255.077,1.542.077,1.93a8.2,8.2,0,0,1-.213,1.741.744.744,0,0,0,.626.388,2.735,2.735,0,0,1,.975-.626.92.92,0,0,1,.465.178,5.661,5.661,0,0,0,3.262.975c2.752,0,4.72-1.388,4.72-4.1M135.1,35a3.155,3.155,0,0,1-2.143,2.909,10.881,10.881,0,0,1-2.031.154c-.234,0-.9,0-1.192-.038l-.018-1.717V32.623c0-.255.059-.392.136-.451a6.59,6.59,0,0,1,1.364-.115c1.836,0,2.675.175,3.339,1.129A3.076,3.076,0,0,1,135.1,35m4.1,10.343a.516.516,0,0,0-.095-.294,3.041,3.041,0,0,1-1.29-.252,4.792,4.792,0,0,1-.332-.49,24.478,24.478,0,0,0-.818-2.437,7.344,7.344,0,0,0-1.444-2.325,5.473,5.473,0,0,0-1.406-.643c-.311-.119-.566-.213-.8-.311a7.589,7.589,0,0,1,.8-.119,3.583,3.583,0,0,0,2.07-.72,3.11,3.11,0,0,0,1.287-2.517,3.727,3.727,0,0,0-2.44-3.535,9.585,9.585,0,0,0-2.343-.213c-1.462,0-2.556.136-3.532.136-.29,0-1.248-.038-1.93-.038-.294,0-1.035-.038-1.154-.038-.056.136-.1.175-.1.252a1.2,1.2,0,0,0,.042.273c.329.042.934.119,1.248.178a2.258,2.258,0,0,1,.818,1.052c.1.626.119,2.381.119,5.133,0,1.989.018,4.489-.08,5.231a1.481,1.481,0,0,1-.8,1.308,10.971,10.971,0,0,1-1.112.136.52.52,0,0,0-.1.273.711.711,0,0,0,.081.234c.273,0,2.517-.059,3.14-.059,1.252,0,1.563.059,2.675.059a.487.487,0,0,0,.08-.213.588.588,0,0,0-.08-.294c-.388-.038-.878-.157-1.094-.192a1.473,1.473,0,0,1-.836-1.388l-.021-4.878c.157-.021.72-.021.878-.021a3.6,3.6,0,0,1,1.559.273,4.392,4.392,0,0,1,1.916,1.58,12.311,12.311,0,0,1,1.231,4.255c.056.409.213.762.584.8a7.561,7.561,0,0,0,1.133.059h2.028a.334.334,0,0,0,.115-.255m-16.374-2.965a5.122,5.122,0,0,0-.018-.566.435.435,0,0,0-.294-.059.6.6,0,0,0-.255.038,5.15,5.15,0,0,1-2.011,2.986,3.649,3.649,0,0,1-1.657.217H116.4a9.206,9.206,0,0,1-1.29-.1c-.29-.059-.6-.528-.738-.839a2.54,2.54,0,0,1-.217-1.346V38.263h.626a3.858,3.858,0,0,1,1.657.273,2.335,2.335,0,0,1,1.052.839,6.55,6.55,0,0,1,.276,1.619.478.478,0,0,0,.311.08.466.466,0,0,0,.311-.1c0-.528-.115-1.951-.115-2.734,0-.975.136-2.164.192-2.867a.5.5,0,0,0-.311-.077.584.584,0,0,0-.311.056c-.059.273-.217,1.094-.252,1.154a2.841,2.841,0,0,1-1.5,1.035,6.408,6.408,0,0,1-1.6.154h-.311V35.784c0-1.874.038-2.633.056-2.986.021-.234.059-.486.08-.664.175-.018.741-.038,1.64-.038,1.129,0,1.969.021,2.147.021a2.2,2.2,0,0,1,1.248.388,4.973,4.973,0,0,1,1.738,2.423.578.578,0,0,0,.234.035c.115,0,.136-.035.29-.115,0-1.189-.077-2.535-.115-3.024-.021-.2-.059-.255-.451-.255-.154,0-.9-.038-1.675-.038-1.115,0-1.563.021-3.262.021-.916,0-2.535.018-3.336.018-1.171,0-1.427-.038-1.934-.038h-.664a.4.4,0,0,0-.1.234.456.456,0,0,0,.1.273,9.873,9.873,0,0,1,1.427.217c.273.234.525.294.7,1.227.038.413.059,1.738.059,2.636v4.021c0,.818-.021,2.168-.042,2.654a5.8,5.8,0,0,1-.43,1.892,5.1,5.1,0,0,1-1.755.294.647.647,0,0,0-.1.315.445.445,0,0,0,.1.269h.643c.626,0,2.189-.056,2.713-.056.49,0,1.15.038,2.283.038.626,0,2.458.119,6.4.119a1.668,1.668,0,0,0,.528-.042.568.568,0,0,0,.077-.311c.038-.388.038-1.346.038-2.927M108.381,31.725c0-.077-.021-.2-.1-.213h-.664c-.468,0-1.21.038-1.542.038-1.581,0-2.147-.1-2.381-.1h-.35c-.042.1-.1.154-.1.252,0,.077.042.136.042.217a7.007,7.007,0,0,1,1.346.29,1.842,1.842,0,0,1,.49,1.231,7.358,7.358,0,0,1-.472,1.776l-3.14,7.727-3.86-9.776a1.464,1.464,0,0,1,.64-1.094,8.718,8.718,0,0,1,1.269-.154.747.747,0,0,0,.077-.273c0-.08-.018-.2-.1-.217h-.489c-.6,0-1.517.08-2.552.08-.448,0-1.325-.042-2.185-.042h-.762a.443.443,0,0,0-.018.472,6.635,6.635,0,0,1,1.64.661,34.521,34.521,0,0,1,1.6,3.552l1.615,3.9c1.346,3.241,2.147,5.409,2.245,5.78.1.059,0,.115.175.115s.157-.038.2-.136l5.035-12.1a3.857,3.857,0,0,1,.7-1.112,3.129,3.129,0,0,1,1.559-.626.882.882,0,0,0,.081-.252m-17.095,13.6a.587.587,0,0,0-.059-.273,13.6,13.6,0,0,1-1.444-.175,3.115,3.115,0,0,1-.664-1.5c-.018-.937-.038-3.063-.038-4.878V33.539a1.526,1.526,0,0,1,.353-1.052,3.321,3.321,0,0,1,1.734-.511.552.552,0,0,0,.059-.252.327.327,0,0,0-.1-.234h-.567c-.818,0-1.989.1-2.654.1-.409,0-1.58-.059-2.437-.077h-.43a.276.276,0,0,0-.1.252,1.248,1.248,0,0,0,.038.255,4.134,4.134,0,0,1,1.521.273,2.155,2.155,0,0,1,.647,1.661c.018.367.038,1.364.056,3.161.021.976.042,2.3.042,3.434,0,.566-.042,2.028-.059,2.713a3.255,3.255,0,0,1-.276,1.171c-.231.2-.465.545-1.892.643a.8.8,0,0,0-.059.294c0,.157.042.157.042.252h.329c.783,0,1.993-.094,3.007-.094.294,0,1.58.056,2.224.056h.647a.462.462,0,0,0,.077-.255m-8.822-13.64a.333.333,0,0,0-.059-.2h-.448c-.975,0-1.406.038-3.161.038-.608,0-1.5-.038-1.717-.038H76.57c-.056.038-.077.175-.077.255a.251.251,0,0,0,.1.213,8.4,8.4,0,0,1,2.01.566,3.834,3.834,0,0,1,.566,1.99c.018.294.038.587.038,1.388V41.7a7.639,7.639,0,0,1-.038.839c-.332-.371-.9-1.091-1.661-1.989L70.053,31.84a1.291,1.291,0,0,0-.294-.252c-.157,0-.35-.021-.507-.021-1.248,0-2.342-.056-2.675-.056a.368.368,0,0,0-.056.192,1.471,1.471,0,0,0,.035.255,3.377,3.377,0,0,1,1.507.545,5.792,5.792,0,0,1,.955,1.154,1.681,1.681,0,0,1,.08.622c0,1.018-.059,2.867-.059,4.238v4.154a8.508,8.508,0,0,1-.119,1.482,4.06,4.06,0,0,1-2.049,1,.577.577,0,0,0-.077.234c0,.059.018.175.056.2h.371c.392,0,1.29-.056,1.878-.056.857,0,1.245.056,2.045.056h1.175c.077-.021.095-.175.095-.255a.363.363,0,0,0-.059-.2,3.742,3.742,0,0,1-2.339-1.206,11.515,11.515,0,0,1-.255-2.462c0-.622-.021-1.64-.021-2.79,0-1.542.021-3.668.042-4.353.115.136.294.353.427.507l9.252,10.836c.1.095.136.115.238.115s.035,0,.115-.038a3,3,0,0,0,.1-.878c0-.566-.021-1.154-.021-1.448V35.12c0-2.437,1.154-3.122,2.5-3.178a.467.467,0,0,0,.077-.255m-18.073.094a.406.406,0,0,0-.1-.252h-.563c-.608,0-1.427.038-2.129.038-.78,0-1.657-.038-2.227-.038h-.7a.476.476,0,0,0-.08.252.671.671,0,0,0,.059.255c.08,0,1.5.021,1.755.371a4.777,4.777,0,0,1,.762,1.444A12.741,12.741,0,0,1,61.329,36c0,1.661,0,2.773-.021,3.357a10.453,10.453,0,0,1-.353,2.6,3.564,3.564,0,0,1-3.822,2.538A5.405,5.405,0,0,1,54.846,44a3.292,3.292,0,0,1-1.892-2.462l-.1-5.853-.017-2.381c0-.448.563-.86.759-1.094a9.3,9.3,0,0,1,1.5-.192.588.588,0,0,0,.1-.273.341.341,0,0,0-.136-.255l-.741.021c-.724.018-1.678.038-2.283.038-.937,0-1.661-.021-2.245-.021h-.818a.335.335,0,0,0-.1.273.31.31,0,0,0,.081.234c.622.08,1.031.136,1.308.2a1.642,1.642,0,0,1,.682.86c.021.252.059.878.059,2.1v4.685a11.96,11.96,0,0,0,.2,2.615,3.857,3.857,0,0,0,1.7,2.4,6.394,6.394,0,0,0,3.573.937,6.752,6.752,0,0,0,3.357-.8,4,4,0,0,0,1.93-2.6,8.863,8.863,0,0,0,.315-2.322V36.368c0-.7.038-1.58.038-1.93a3.924,3.924,0,0,1,.587-2.147,7.816,7.816,0,0,1,1.619-.273.478.478,0,0,0,.077-.238" transform="translate(0)"></path><path class="a" d="M16.65,12.117a.307.307,0,0,0-.273.178L15.8,13.573a.113.113,0,0,1-.045.019c-.018,0-.038-.019-.052-.059s-.084-.224-.234-.572l-.185-.418c-.066-.154-.119-.255-.136-.287a.28.28,0,0,0-.241-.14.056.056,0,0,1-.011-.038.076.076,0,0,1,.007-.037H15c.108,0,.2.005.28.005s.252-.009.357-.009H15.7c.01,0,.014.025.014.033a.1.1,0,0,1-.007.042c-.07.007-.227,0-.227.1a.265.265,0,0,0,.014.086l.378.9.315-.743a.462.462,0,0,0,.042-.2c0-.084-.059-.121-.217-.14a.134.134,0,0,1-.01-.035.149.149,0,0,1,.01-.044h.045c.07,0,.14.009.3.009.028,0,.136-.005.189-.005h.108a.069.069,0,0,1,.014.033A.091.091,0,0,1,16.65,12.117Z" transform="translate(0)"></path><path class="a" d="M18.248,13.549c-.458,0-.706-.012-.769-.012l-.217,0c-.063,0-.21.01-.371.01l-.091,0a.058.058,0,0,1-.007-.033.188.188,0,0,1,0-.044.542.542,0,0,0,.231-.049.435.435,0,0,0,.049-.231c0-.07,0-.147,0-.225,0-.115,0-.255,0-.425V12.3c0-.166-.084-.166-.255-.185a.224.224,0,0,1-.007-.04c0-.009,0-.033.014-.038h.084c.056,0,.206,0,.493,0,.262,0,.518.005.573.005l.157,0c.035,0,.049,0,.049.035l.021.343c-.021.01-.025.014-.042.014a.105.105,0,0,1-.035,0,.7.7,0,0,0-.227-.262.258.258,0,0,0-.133-.038c-.021,0-.073,0-.2,0-.1,0-.157,0-.171.005s-.014,0-.021.058c0,.037-.007.1-.007.3v.2h.052a.744.744,0,0,0,.171-.017.281.281,0,0,0,.154-.108.624.624,0,0,0,.035-.126.093.093,0,0,1,.049-.01.059.059,0,0,1,.038.012c0,.061-.014.177-.014.323,0,.073.007.234.007.3a.055.055,0,0,1-.042.012.169.169,0,0,1-.042-.005c-.014-.129-.035-.217-.143-.262a.408.408,0,0,0-.168-.032.963.963,0,0,0-.1.007v.4a.491.491,0,0,0,.021.178c.011.026.045.079.091.084a.759.759,0,0,0,.14.01h.217A.431.431,0,0,0,18,13.428a.838.838,0,0,0,.241-.323.1.1,0,0,1,.045-.009.12.12,0,0,1,.045.011v.4C18.329,13.544,18.3,13.549,18.248,13.549Z" transform="translate(0)"></path><path class="a" d="M20.067,12.514c-.01,0-.024,0-.042-.005a.975.975,0,0,0-.112-.224.362.362,0,0,0-.28-.147c-.035,0-.119,0-.147,0l0,.666c0,.1,0,.229,0,.458,0,.177.08.177.262.2a.088.088,0,0,1,.014.044.074.074,0,0,1-.01.037h-.067c-.1,0-.315-.007-.381-.007-.045,0-.276.01-.385.01a.05.05,0,0,1-.014-.04.1.1,0,0,1,.011-.04c.241-.018.266-.063.273-.14.007-.049.007-.248.007-.451V12.32a.916.916,0,0,0-.014-.183,1.156,1.156,0,0,0-.234.016.605.605,0,0,0-.3.332.1.1,0,0,1-.038.005.042.042,0,0,1-.035-.016v-.388c0-.035,0-.044.045-.044l.164,0c.052,0,.273,0,.549,0,.364,0,.633-.009.7-.009.035,0,.059,0,.073.012a.283.283,0,0,1,0,.056v.388A.042.042,0,0,1,20.067,12.514Z" transform="translate(0)"></path><path class="a" d="M16.577,14.881c-.014,0-.025,0-.045-.005a.75.75,0,0,0-.112-.224.356.356,0,0,0-.28-.147c-.035,0-.119,0-.147,0l0,.666c0,.1,0,.229,0,.458,0,.177.084.177.266.2a.079.079,0,0,1,.01.044.069.069,0,0,1-.007.037H16.2c-.108,0-.318-.007-.381-.007-.045,0-.276.011-.388.011a.065.065,0,0,1-.01-.04.187.187,0,0,1,.007-.04c.241-.018.266-.063.276-.14,0-.049,0-.248,0-.451v-.552a.963.963,0,0,0-.01-.184,1.189,1.189,0,0,0-.238.016.6.6,0,0,0-.3.332.126.126,0,0,1-.042.005.046.046,0,0,1-.035-.016v-.388c0-.035.007-.044.045-.044l.164,0c.056,0,.276,0,.552,0,.36,0,.633-.009.7-.009.038,0,.063,0,.074.012s0,.035,0,.056v.388A.046.046,0,0,1,16.577,14.881Z" transform="translate(0)"></path><path class="a" d="M18.3,15.916c-.455,0-.706-.012-.766-.012l-.22,0c-.059,0-.21.011-.367.011l-.091,0a.061.061,0,0,1-.01-.033.1.1,0,0,1,.007-.044.5.5,0,0,0,.227-.049c.028-.03.042-.094.049-.231,0-.07.007-.147.007-.226,0-.115,0-.255,0-.425,0-.117,0-.187,0-.236,0-.166-.081-.166-.252-.185a.105.105,0,0,1-.01-.04c0-.009.007-.033.017-.038h.081c.059,0,.206,0,.493,0,.266,0,.517.005.577.005l.154,0c.038,0,.052,0,.052.035l.017.343a.066.066,0,0,1-.042.014.134.134,0,0,1-.035,0,.64.64,0,0,0-.227-.262.241.241,0,0,0-.129-.038c-.021,0-.073,0-.206,0-.1,0-.157,0-.168.005s-.018,0-.025.058c0,.037,0,.1,0,.3v.2h.049a.692.692,0,0,0,.171-.018.29.29,0,0,0,.157-.108.634.634,0,0,0,.031-.126.113.113,0,0,1,.049-.011.063.063,0,0,1,.042.012c0,.061-.017.177-.017.323,0,.073.01.234.01.3a.059.059,0,0,1-.042.012.2.2,0,0,1-.045-.005c-.014-.129-.032-.217-.143-.262a.4.4,0,0,0-.164-.032,1.014,1.014,0,0,0-.1.007v.4a.63.63,0,0,0,.017.178c.014.026.049.079.091.084a.77.77,0,0,0,.14.011h.22a.408.408,0,0,0,.161-.025.8.8,0,0,0,.245-.323.09.09,0,0,1,.045-.009.105.105,0,0,1,.042.01v.4C18.385,15.911,18.36,15.916,18.3,15.916Z" transform="translate(0)"></path><path class="a" d="M19.367,15.949a.858.858,0,0,1-.35-.091.161.161,0,0,0-.056-.012.3.3,0,0,0-.112.058.1.1,0,0,1-.088-.045c0-.032.028-.126.028-.185,0-.035-.01-.2-.014-.245a.081.081,0,0,1,.066-.031.108.108,0,0,1,.025,0c.032.061.095.226.14.292a.465.465,0,0,0,.336.159.334.334,0,0,0,.245-.073.216.216,0,0,0,.084-.184.2.2,0,0,0-.042-.136.363.363,0,0,0-.157-.112c-.066-.032-.3-.089-.385-.135a.59.59,0,0,1-.21-.149.46.46,0,0,1-.088-.275.43.43,0,0,1,.465-.423.557.557,0,0,1,.36.1,1.02,1.02,0,0,1,.087-.086.084.084,0,0,1,.08.04,1.8,1.8,0,0,0-.024.206c0,.04.024.2.024.224a.149.149,0,0,1-.059.021.113.113,0,0,1-.028-.007c-.042-.073-.08-.2-.126-.262a.341.341,0,0,0-.3-.129A.248.248,0,0,0,19,14.7a.256.256,0,0,0,.185.224c.063.025.14.054.227.081a1.99,1.99,0,0,1,.241.093.411.411,0,0,1,.248.4A.489.489,0,0,1,19.367,15.949Z" transform="translate(0)"></path><path class="a" d="M17.186,18.287c-.458,0-.706-.012-.769-.012l-.217,0c-.063,0-.21.011-.371.011l-.091,0a.057.057,0,0,1-.007-.033.2.2,0,0,1,0-.044.541.541,0,0,0,.231-.049.432.432,0,0,0,.049-.231c0-.07,0-.147,0-.226,0-.115,0-.255,0-.425v-.236c0-.166-.084-.166-.255-.185a.209.209,0,0,1-.007-.04c0-.009,0-.033.014-.038h.084c.056,0,.206,0,.493,0,.262,0,.517.005.573.005l.157,0c.035,0,.049,0,.049.035l.021.343c-.021.011-.024.014-.042.014a.1.1,0,0,1-.035,0,.7.7,0,0,0-.227-.262.257.257,0,0,0-.133-.038c-.021,0-.073,0-.2,0-.1,0-.157,0-.171.005s-.014,0-.021.058c0,.037-.007.1-.007.3v.2h.052a.744.744,0,0,0,.171-.017.281.281,0,0,0,.154-.108.624.624,0,0,0,.035-.126.093.093,0,0,1,.049-.011.06.06,0,0,1,.038.012c0,.061-.014.177-.014.323,0,.074.007.234.007.3a.055.055,0,0,1-.042.012.169.169,0,0,1-.042-.005c-.014-.129-.035-.217-.143-.262a.41.41,0,0,0-.168-.031.967.967,0,0,0-.1.007v.4a.491.491,0,0,0,.021.178c.011.026.045.079.091.084a.759.759,0,0,0,.14.01h.217a.427.427,0,0,0,.164-.025.834.834,0,0,0,.241-.323.1.1,0,0,1,.045-.009.118.118,0,0,1,.045.011v.4C17.266,18.281,17.241,18.287,17.186,18.287Z" transform="translate(0)"></path><path class="a" d="M19.388,16.85c-.154.005-.287.089-.287.334l0,.778c0,.03.014.25.014.334a.137.137,0,0,1-.063.025.085.085,0,0,1-.038-.025l-1.066-1.147.011.234,0,.423c0,.033.007.112.014.171a.191.191,0,0,0,.077.161.388.388,0,0,0,.2.066.073.073,0,0,1,.01.035.078.078,0,0,1-.014.038h-.115c-.1,0-.175,0-.276,0-.066,0-.161.007-.227.007h-.049a.128.128,0,0,1,0-.035.1.1,0,0,1,.007-.038.374.374,0,0,0,.241-.1.5.5,0,0,0,.025-.182v-.542c0-.087,0-.131-.007-.217A.264.264,0,0,0,17.79,17a.563.563,0,0,0-.074-.079.774.774,0,0,0-.171-.075.114.114,0,0,1-.01-.035.085.085,0,0,1,.01-.038h.038c.032,0,.2.009.322.009h.073a.148.148,0,0,1,.045.03l.79.864c.059.066.136.154.178.21V17.26a1.642,1.642,0,0,0-.007-.173.424.424,0,0,0-.045-.163c-.024-.038-.171-.059-.248-.075a.112.112,0,0,1-.007-.045.13.13,0,0,1,0-.033h.045c.073,0,.192.011.266.011.182,0,.238-.005.329-.005h.059a.075.075,0,0,1,.007.037A.079.079,0,0,1,19.388,16.85Z" transform="translate(0)"></path><path class="a" d="M24.371,12.112c-.15.005-.287.089-.287.334v.778c0,.03.01.25.01.334a.128.128,0,0,1-.059.025c-.01,0-.021-.009-.042-.025l-1.066-1.147.014.234,0,.423c0,.033.007.112.01.171a.212.212,0,0,0,.077.161.41.41,0,0,0,.2.066.073.073,0,0,1,.01.035.116.116,0,0,1-.01.038h-.119c-.095,0-.171,0-.276,0-.066,0-.157.007-.224.007h-.049a.158.158,0,0,1-.007-.035.069.069,0,0,1,.011-.038.372.372,0,0,0,.238-.1.439.439,0,0,0,.025-.182v-.542c0-.087,0-.131,0-.217a.286.286,0,0,0-.052-.164.685.685,0,0,0-.077-.079.707.707,0,0,0-.171-.075.309.309,0,0,1-.007-.035.167.167,0,0,1,.007-.038h.042c.028,0,.192.009.318.009h.073a.243.243,0,0,1,.049.03l.79.864c.059.066.136.154.178.21v-.622a1.38,1.38,0,0,0-.011-.173.369.369,0,0,0-.045-.163c-.024-.038-.171-.059-.245-.075a.12.12,0,0,1-.01-.045.066.066,0,0,1,.007-.033h.045c.073,0,.192.01.266.01.178,0,.238-.005.329-.005h.056a.084.084,0,0,1,.011.037A.092.092,0,0,1,24.371,12.112Z" transform="translate(0)"></path><path class="a" d="M25.941,13.358a.752.752,0,0,1-1.066.011.771.771,0,0,1-.227-.575.779.779,0,0,1,.227-.572A.757.757,0,0,1,25.406,12a.794.794,0,0,1,.4.112.786.786,0,0,1,.371.67A.838.838,0,0,1,25.941,13.358Zm-.245-1.1a.35.35,0,0,0-.3-.159.32.32,0,0,0-.28.159.867.867,0,0,0-.14.533.92.92,0,0,0,.133.53.336.336,0,0,0,.3.166.348.348,0,0,0,.329-.206.978.978,0,0,0,.1-.484A.874.874,0,0,0,25.7,12.255Z" transform="translate(0)"></path><path class="a" d="M28.088,12.117a.307.307,0,0,0-.269.178l-.573,1.278a.113.113,0,0,1-.045.019c-.018,0-.042-.019-.052-.059s-.084-.224-.238-.572l-.182-.418c-.066-.154-.119-.255-.136-.287a.285.285,0,0,0-.241-.14.046.046,0,0,1-.014-.038.054.054,0,0,1,.011-.037h.094c.1,0,.2.005.276.005s.252-.009.36-.009h.059c.014,0,.017.025.017.033a.1.1,0,0,1-.007.042c-.073.007-.227,0-.227.1a.2.2,0,0,0,.014.086l.374.9.318-.743a.506.506,0,0,0,.038-.2c0-.084-.059-.121-.217-.14a.12.12,0,0,1-.007-.035.15.15,0,0,1,.007-.044h.045c.07,0,.14.009.3.009.025,0,.136-.005.189-.005h.108a.064.064,0,0,1,0,.075Z" transform="translate(0)"></path><path class="a" d="M23.878,14.881c-.014,0-.024,0-.045-.005a.759.759,0,0,0-.112-.224.357.357,0,0,0-.28-.147c-.035,0-.119,0-.147,0l0,.666c0,.1,0,.229,0,.458,0,.177.084.177.266.2a.078.078,0,0,1,.011.044.069.069,0,0,1-.007.037H23.5c-.108,0-.318-.007-.381-.007-.045,0-.276.011-.388.011a.065.065,0,0,1-.011-.04.2.2,0,0,1,.007-.04c.241-.018.266-.063.276-.14,0-.049,0-.248,0-.451v-.552a.947.947,0,0,0-.011-.184,1.189,1.189,0,0,0-.238.016.6.6,0,0,0-.3.332.126.126,0,0,1-.042.005.046.046,0,0,1-.035-.016v-.388c0-.035.007-.044.045-.044l.164,0c.056,0,.276,0,.552,0,.36,0,.633-.009.7-.009.038,0,.063,0,.073.012s0,.035,0,.056v.388A.046.046,0,0,1,23.878,14.881Z" transform="translate(0)"></path><path class="a" d="M25.689,15.914H25.57c-.077,0-.164-.01-.255-.01-.143,0-.325.01-.4.01a.056.056,0,0,1-.011-.038.129.129,0,0,1,.007-.035c.147-.007.206-.032.206-.091a.519.519,0,0,0-.045-.2c-.045-.11-.07-.161-.081-.189-.007-.011-.01-.016-.042-.016h-.475a1.018,1.018,0,0,0-.112.288.328.328,0,0,0-.011.088c0,.049.045.1.213.108a.074.074,0,0,1,.01.042.129.129,0,0,1,0,.035h-.042c-.112,0-.143-.007-.262-.007-.077,0-.262.007-.325.007a.1.1,0,0,1-.007-.032.09.09,0,0,1,.007-.038.324.324,0,0,0,.217-.11,2.53,2.53,0,0,0,.192-.393c.084-.2.185-.456.231-.563.063-.131.084-.175.1-.22.032-.066.066-.133.08-.157a.082.082,0,0,1,.126,0,.461.461,0,0,1,.035.075c.087.208.157.393.266.652.056.131.084.213.143.35.042.086.066.15.108.229.056.114.147.115.238.138,0,.01.014.021.014.035S25.7,15.9,25.689,15.914Zm-.955-1.2h0c-.032.058-.087.189-.108.243-.081.2-.108.262-.122.29h.451C24.916,15.161,24.8,14.883,24.735,14.717Z" transform="translate(0)"></path><path class="a" d="M28.025,15.914l-.612-.007h-.168a.1.1,0,0,1-.011-.038.052.052,0,0,1,.014-.038.77.77,0,0,0,.15-.014c.063-.028.088-.089.088-.18V14.549h0l-.322.7c-.035.077-.077.161-.112.245a3.32,3.32,0,0,0-.133.343.045.045,0,0,1-.049.028c-.021,0-.035-.007-.045-.042-.042-.091-.07-.15-.084-.189l-.5-1.108h-.011v.283l.011.708c0,.215.112.317.283.317a.122.122,0,0,1,.014.037.085.085,0,0,1-.011.037c-.011,0-.045,0-.077,0s-.133-.01-.294-.01c-.045,0-.14,0-.213,0h-.1a.132.132,0,0,1-.007-.037.18.18,0,0,1,.007-.033.784.784,0,0,0,.22-.077c.032-.03.059-.094.059-.243v-.776c0-.124-.017-.171-.077-.213a.679.679,0,0,0-.2-.04.1.1,0,0,1-.01-.042.1.1,0,0,1,.01-.04c.06,0,.164.005.269.005h.367a.09.09,0,0,1,.032.038l.451,1.023.081-.2c.07-.164.171-.411.315-.678l.091-.175.573-.009a.072.072,0,0,1,.014.037.074.074,0,0,1-.011.038c-.063.011-.171.011-.224.1-.018.028-.028.056-.028.18v.729c0,.28.07.308.1.329a.537.537,0,0,0,.154.021.079.079,0,0,1,.01.038C28.035,15.9,28.028,15.9,28.025,15.914Z" transform="translate(0)"></path><path class="a" d="M23.843,17.252c-.014,0-.025,0-.045-.005a.757.757,0,0,0-.112-.224.356.356,0,0,0-.28-.147c-.035,0-.119,0-.147,0l0,.666c0,.1,0,.229,0,.458,0,.177.084.177.266.2a.079.079,0,0,1,.01.044.069.069,0,0,1-.007.037h-.066c-.108,0-.318-.007-.381-.007-.045,0-.276.011-.388.011a.065.065,0,0,1-.01-.04.189.189,0,0,1,.007-.04c.241-.018.266-.063.276-.14,0-.049,0-.248,0-.451v-.552a.961.961,0,0,0-.01-.183,1.189,1.189,0,0,0-.238.016.6.6,0,0,0-.3.332.126.126,0,0,1-.042.005.046.046,0,0,1-.035-.016v-.388c0-.035.007-.044.045-.044l.164,0c.056,0,.276,0,.552,0,.36,0,.633-.009.7-.009.038,0,.063,0,.073.012s0,.035,0,.056v.388A.046.046,0,0,1,23.843,17.252Z" transform="translate(0)"></path><path class="a" d="M25.72,16.855a.306.306,0,0,0-.269.178l-.574,1.278a.113.113,0,0,1-.045.019c-.017,0-.042-.019-.052-.059s-.084-.224-.238-.572l-.182-.418c-.066-.154-.119-.255-.136-.287a.285.285,0,0,0-.241-.14.046.046,0,0,1-.014-.038.054.054,0,0,1,.011-.037h.094c.1,0,.2.005.276.005s.252-.009.36-.009h.059c.014,0,.018.024.018.033a.1.1,0,0,1-.007.042c-.074.007-.227,0-.227.1a.2.2,0,0,0,.014.086l.374.9.318-.743a.5.5,0,0,0,.038-.2c0-.084-.059-.12-.217-.14a.127.127,0,0,1-.007-.035.156.156,0,0,1,.007-.044h.045c.07,0,.14.009.3.009.025,0,.136-.005.189-.005h.108a.062.062,0,0,1,.011.033A.064.064,0,0,1,25.72,16.855Z" transform="translate(0)"></path><path class="a" d="M28.056,18.285l-.608-.007h-.171a.085.085,0,0,1-.007-.038.05.05,0,0,1,.01-.038.821.821,0,0,0,.154-.014c.059-.028.084-.089.084-.18v-.883s0-.159,0-.2h-.007l-.318.7c-.038.077-.077.161-.115.245-.07.164-.112.278-.133.343-.007.028-.032.028-.049.028s-.031-.007-.045-.042c-.038-.091-.067-.15-.081-.189L26.266,16.9h-.01v.283l.01.708c0,.215.112.317.287.317a.1.1,0,0,1,.01.037.075.075,0,0,1-.007.037c-.014,0-.045,0-.08,0s-.129-.01-.29-.01c-.049,0-.143,0-.213,0h-.1a.073.073,0,0,1-.01-.037.086.086,0,0,1,.01-.033.827.827,0,0,0,.22-.077.355.355,0,0,0,.056-.243l0-.357,0-.42c0-.124-.014-.171-.077-.213a.678.678,0,0,0-.2-.04.07.07,0,0,1-.014-.042.073.073,0,0,1,.014-.04c.056,0,.164.005.266.005h.371a.085.085,0,0,1,.028.038l.451,1.023.084-.2a6.945,6.945,0,0,1,.315-.678c.028-.059.07-.135.091-.175l.57-.009c.007.012.018.023.018.037a.079.079,0,0,1-.014.038c-.059.01-.168.01-.22.1-.017.028-.031.056-.031.18v.729c0,.28.07.308.1.329a.5.5,0,0,0,.15.021.058.058,0,0,1,.014.038C28.07,18.269,28.063,18.271,28.056,18.285Z" transform="translate(0)"></path><path class="a" d="M42.539,8.818,42.476,8.1l-.685.208a17.6,17.6,0,0,1-5.136.762A17.312,17.312,0,0,1,21.86.827L21.364,0l-.5.827A17.31,17.31,0,0,1,6.07,9.073,17.56,17.56,0,0,1,.944,8.315L.257,8.107l-.063.715a50.482,50.482,0,0,0,.881,14.787,51.231,51.231,0,0,0,5.5,14.606,52.3,52.3,0,0,0,4.594,6.853A53.073,53.073,0,0,0,21,54.634l.348.259.348-.259A53,53,0,0,0,31.551,45.1a51.781,51.781,0,0,0,4.593-6.843,51.227,51.227,0,0,0,5.343-13.938l.143-.706A50.8,50.8,0,0,0,42.539,8.818ZM30.255,12.713h.857v1.675h-.857Zm0,4.385h.857v1.677h-.857Zm-8.671-6.159a1.585,1.585,0,0,1,1.451-.61l1.654.234,2.178.287a4.323,4.323,0,0,0,1.892-.309v9.1a5.217,5.217,0,0,1-1.892.281l-2.1-.28L23.035,19.4a2.165,2.165,0,0,0-1.451.458Zm-7.455-.381a4.067,4.067,0,0,0,1.815.3l2.182-.289,1.65-.236a1.587,1.587,0,0,1,1.451.61v8.925a2.175,2.175,0,0,0-1.465-.462l-1.731.243-2.087.278c-1.528,0-1.846-.369-1.85-.372S14.126,11.168,14.13,10.558Zm-1.245,1.107c.164-.033.65-.136.888-.187v8.18c.087.187.462.622,2.171.622l2.164-.285,1.654-.236a1.619,1.619,0,0,1,1.469.612l.049-.028h.255l.049.026a1.584,1.584,0,0,1,1.451-.61l1.654.234,2.178.287c1.734,0,2.164-.456,2.21-.507l.032-8.337.79.22v9.037a24.427,24.427,0,0,1-3.133.245,40.032,40.032,0,0,1-4.182-.294l-.2-.028v.612a3.059,3.059,0,0,1-1.014.185,2.755,2.755,0,0,1-.972-.183v-.614l-.2.028a39.99,39.99,0,0,1-4.171.294,24.39,24.39,0,0,1-3.14-.245Zm-1.2,1.049h.839v1.675h-.839Zm0,4.385h.839v1.677h-.839Zm9.664,36.3a52.013,52.013,0,0,1-9.269-9.056c-.011-.014-.021-.032-.032-.045l9.3-9.049,9.322,9.066c-.014.014-.025.035-.038.052A52,52,0,0,1,21.353,53.4Zm19-29.34A50.168,50.168,0,0,1,35.2,37.543L21.357,24.224,7.525,37.515A50.215,50.215,0,0,1,2.243,23.49H40.465Z" transform="translate(0)"></path></g>', 2)
  ]), 8, P_);
}
const Gs = /* @__PURE__ */ x(A_, [["render", T_]]), E_ = {
  name: "LuxUniversityFooter",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  components: {
    LuxLogoUniversityWhite: Gs,
    LuxUniversityCopyright: Q1,
    LuxUniversityPrivacyNotice: vr,
    LuxWrapper: h1
  },
  methods: {
    value: function(e) {
      return e == "light" || e == "shade" ? e : "dark";
    }
  },
  props: {
    /**
     * The html element name used for the container
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The maximum width of the wrapper. Default is set to 1440.
     */
    maxWidth: {
      type: Number,
      default: 1440
    },
    /**
     * Whether the header is dark, shade, or light. Default is set to dark.
     */
    theme: {
      type: String,
      default: "dark"
    },
    /**
     * Links are supplied via an array of objects containting `text` and `href` properties.  If no links are supplied then a default list is displayed.
     * To remove all links pass an empty array.
     */
    links: {
      required: !1,
      type: Array,
      default(e) {
        return [
          {
            text: "Copyright Policy",
            href: "https://library.princeton.edu/about/policies/copyright-and-permissions-policies"
          },
          { text: "Privacy Notice", href: "https://www.princeton.edu/privacy-notice" },
          { text: "Accessibility Help", href: "https://accessibility.princeton.edu/help" }
        ];
      }
    }
  }
}, Y_ = { class: "lux-footer-bottom bottom-layout" }, H_ = { class: "lux-university-links" }, V_ = ["href"], N_ = { class: "lux-university-links center-panel" }, R_ = { class: "lux-university-links pu-logo-white" }, F_ = { href: "https://www.princeton.edu" };
function B_(e, t, a, n, s, r) {
  const i = A("lux-university-copyright"), l = A("lux-logo-university-white"), u = A("lux-wrapper");
  return f(), P(Q(a.type), {
    class: z(["lux-university-footer", a.theme])
  }, {
    default: O(() => [
      D(u, {
        class: "lux-footer-content",
        maxWidth: a.maxWidth
      }, {
        default: O(() => [
          o("div", Y_, [
            o("div", H_, [
              (f(!0), p(X, null, oe(a.links, (c, d) => (f(), p("div", {
                class: "policy-links",
                key: d
              }, [
                o("a", {
                  href: c.href
                }, F(c.text), 9, V_)
              ]))), 128))
            ]),
            o("div", N_, [
              D(i, {
                type: "div",
                theme: r.value(a.theme)
              }, null, 8, ["theme"])
            ]),
            o("div", R_, [
              o("a", F_, [
                D(l, {
                  width: "200px",
                  height: "72px",
                  type: "div"
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["maxWidth"])
    ]),
    _: 1
  }, 8, ["class"]);
}
const Ks = /* @__PURE__ */ x(E_, [["render", B_], ["__scopeId", "data-v-712f0e00"]]), W_ = {
  name: "LuxLibraryFooter",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  components: {
    LuxLibraryContactInfo: fr,
    LuxLibraryLogo: La,
    LuxLogoFacebook: G1,
    LuxLogoFriends: J1,
    LuxLogoGovDocs: X1,
    LuxLogoInstagram: Zs,
    LuxLogoX: K1,
    LuxSubscribeNewsletter: cr,
    LuxWrapper: h1,
    LuxUniversityFooter: Ks
  },
  methods: {
    value: function(e) {
      return e == "light" || e == "shade" ? e : "dark";
    }
  },
  props: {
    /**
     * The html element name used for the container
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The maximum width of the wrapper. Default is set to 1440.
     */
    maxWidth: {
      type: Number,
      default: 1440
    },
    /**
     * Whether the header is dark, shade, or light. Default is set to dark.
     */
    theme: {
      type: String,
      default: "dark"
    }
  }
}, j_ = { class: "lux-footer-main" }, U_ = { class: "lux-library-links contact-info-layout" }, q_ = { class: "lux-library-links subscribe-layout" }, Z_ = { class: "social-pul-icons" }, G_ = { href: "https://x.com/PULibrary" }, K_ = { href: "http://www.facebook.com/PULibrary" }, X_ = { href: "https://www.instagram.com/PULibrary/" }, J_ = { href: "https://libguides.princeton.edu/usgovdocs" }, Q_ = { href: "https://fpul.princeton.edu/" };
function e$(e, t, a, n, s, r) {
  const i = A("lux-library-logo"), l = A("lux-library-contact-info"), u = A("lux-subscribe-newsletter"), c = A("lux-logo-x"), d = A("lux-logo-facebook"), v = A("lux-logo-instagram"), y = A("lux-logo-gov-docs"), m = A("lux-logo-friends"), g = A("lux-wrapper"), S = A("lux-university-footer");
  return f(), P(Q(a.type), {
    class: z(["lux-library-footer", a.theme])
  }, {
    default: O(() => [
      D(g, {
        class: "lux-footer-content",
        maxWidth: a.maxWidth
      }, {
        default: O(() => [
          o("div", j_, [
            o("div", U_, [
              o("div", null, [
                D(i, {
                  theme: r.value(a.theme)
                }, null, 8, ["theme"]),
                D(l, {
                  theme: r.value(a.theme)
                }, null, 8, ["theme"])
              ])
            ]),
            o("div", q_, [
              t[0] || (t[0] = o("h2", null, "Subscribe to our Newsletter", -1)),
              D(u, { type: "div" }),
              o("div", Z_, [
                o("a", G_, [
                  D(c, {
                    width: "24",
                    height: "24"
                  })
                ]),
                o("a", K_, [
                  D(d, {
                    width: "24",
                    height: "24"
                  })
                ]),
                o("a", X_, [
                  D(v, {
                    width: "24",
                    height: "24"
                  })
                ]),
                o("a", J_, [
                  D(y, {
                    width: "30",
                    height: "30"
                  })
                ]),
                o("a", Q_, [
                  D(m, {
                    width: "120",
                    height: "35"
                  })
                ])
              ])
            ]),
            t[1] || (t[1] = o("div", { class: "lux-library-links" }, [
              o("nav", {
                role: "navigation",
                "aria-label": "Library Staff"
              }, [
                o("ul", null, [
                  o("li", null, [
                    o("a", { href: "https://library.princeton.edu/library-staff" }, "For Library Staff")
                  ]),
                  o("li", null, [
                    o("a", { href: "https://library.princeton.edu/about/staff-directory" }, "Staff Directory")
                  ]),
                  o("li", null, [
                    o("a", { href: "https://library.princeton.edu/about/employment" }, "Library Jobs")
                  ])
                ])
              ])
            ], -1))
          ])
        ]),
        _: 1
      }, 8, ["maxWidth"]),
      D(S, {
        theme: r.value(a.theme)
      }, null, 8, ["theme"])
    ]),
    _: 1
  }, 8, ["class"]);
}
const t$ = /* @__PURE__ */ x(W_, [["render", e$], ["__scopeId", "data-v-fd75b6ae"]]), a$ = {
  name: "LuxSpecialCollectionsFooter",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  components: {
    LuxLibraryContactInfoOld: hr,
    LuxUniversityCopyright: Q1,
    LuxUniversityAccessibilityOld: dr
  },
  props: {
    /**
     * The html element name used for the container
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The maximum width of the wrapper. Default is set to 1170.
     */
    maxWidth: {
      type: Number,
      default: 1170
    }
  }
}, n$ = { class: "lux-library-links" };
function r$(e, t, a, n, s, r) {
  const i = A("lux-library-contact-info-old"), l = A("lux-logo-university"), u = A("lux-university-copyright-old"), c = A("lux-university-accessibility-old"), d = A("lux-wrapper");
  return f(), P(Q(a.type), {
    class: z(["lux-special-collections-footer"])
  }, {
    default: O(() => [
      D(d, {
        class: "lux-footer-content",
        maxWidth: a.maxWidth
      }, {
        default: O(() => [
          t[0] || (t[0] = o("div", { class: "lux-library-links" }, [
            o("nav", {
              role: "navigation",
              "aria-label": "About Archival Collections"
            }, [
              o("h2", null, [
                o("a", { href: "/research_help" }, "About Archival Collections")
              ]),
              o("ul", null, [
                o("li", null, [
                  o("a", { href: "/research_account" }, "Creating a Research Account")
                ]),
                o("li", null, [
                  o("a", { href: "/requesting_materials" }, "Requesting Materials")
                ]),
                o("li", null, [
                  o("a", { href: "/search_tips" }, "Search Tips")
                ]),
                o("li", null, [
                  o("a", { href: "/av_materials" }, "Statement on Audio Visual Materials")
                ]),
                o("li", null, [
                  o("a", { href: "/faq" }, "Frequently Asked Questions (FAQs)")
                ])
              ])
            ])
          ], -1)),
          t[1] || (t[1] = o("div", { class: "lux-library-links" }, [
            o("nav", {
              role: "navigation",
              "aria-label": "Library Services"
            }, [
              o("h2", null, [
                o("a", { href: "https://library.princeton.edu/services" }, "Library Services")
              ]),
              o("ul", null, [
                o("li", null, [
                  o("a", {
                    href: "https://library.princeton.edu/services/article-express",
                    title: "Use our Interlibrary Loan and Article Express Services"
                  }, "Article Express")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/borrowdirect" }, "Borrow Direct")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/access/circulation-policies" }, "Circulation")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/reserves" }, "Course Reserves")
                ]),
                o("li", null, [
                  o("a", {
                    href: "https://library.princeton.edu/services/interlibrary-services",
                    title: "Interlibrary Loan Services, Article Express"
                  }, "Interlibrary Loan (ILL)")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/access" }, "Library Access")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/study-spaces" }, "Study Spaces and Lockers")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/accounts" }, "Your Accounts")
                ])
              ])
            ])
          ], -1)),
          t[2] || (t[2] = o("div", { class: "lux-library-links" }, [
            o("nav", {
              role: "navigation",
              "aria-label": "About the Library"
            }, [
              o("h2", null, [
                o("a", { href: "https://library.princeton.edu/about" }, "About the Library")
              ]),
              o("ul", null, [
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/collections-and-collection-development" }, "Collections and Collecting")
                ]),
                o("li", null, [
                  o("a", { href: "https://rbsc.princeton.edu/exhibitions" }, "Exhibitions")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/about/locations" }, "Library Locations")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/alumni" }, "For Alumni")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/staff" }, "For Library Staff")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/staff/directory" }, "Staff Directory")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/about/friends" }, "Friends of the Library")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/technology/off-campus-access" }, "Using the Library Off-Campus")
                ])
              ])
            ])
          ], -1)),
          o("div", n$, [
            D(i),
            D(l, {
              width: "142",
              height: "40"
            }),
            D(u, { type: "div" }),
            D(c, { type: "span" })
          ])
        ]),
        _: 1,
        __: [0, 1, 2]
      }, 8, ["maxWidth"])
    ]),
    _: 1
  });
}
const s$ = /* @__PURE__ */ x(a$, [["render", r$], ["__scopeId", "data-v-894636f0"]]), o$ = {
  name: "LuxMediaImage",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  data: function() {
    return {
      source: this.src
    };
  },
  props: {
    /**
     * The image displayed
     */
    src: {
      type: String,
      default: null
    },
    /**
     * The alternative text describing the image. Do not include if image is decorative.
     */
    alt: {
      type: String,
      default: ""
    },
    /**
     * Manually define the height of the image for a card
     */
    height: {
      type: String,
      default: ""
    },
    /**
     * Whether the image fills the container maintaining aspect ratio and is cropped
     */
    cover: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the full image is contained within the container maintaining aspect ratio. Note that this property is not recommened for use when the `height` prop is used as it will show the background of the container.
     */
    contain: {
      type: Boolean,
      default: !1
    },
    components: {
      LuxIconBase: K0,
      LuxIconFile: rr
    }
  }
}, i$ = ["src", "alt"];
function l$(e, t, a, n, s, r) {
  const i = A("lux-icon-file"), l = A("lux-icon-base");
  return f(), p("div", {
    class: z(["lux-media-image", [a.height, { "lux-default-thumbnail": !e.source }]])
  }, [
    e.source ? (f(), p("img", {
      key: 0,
      onError: t[0] || (t[0] = (u) => e.source = null),
      src: e.source,
      alt: a.alt,
      class: z([{ "lux-cover": a.cover }, { "lux-contain": a.contain }])
    }, null, 42, i$)) : (f(), P(l, {
      key: 1,
      width: "50",
      height: "50",
      "icon-name": "file",
      "icon-color": "rgb(225,225,225)",
      "icon-hide": "true"
    }, {
      default: O(() => [
        D(i)
      ]),
      _: 1
    }))
  ], 2);
}
const u$ = /* @__PURE__ */ x(o$, [["render", l$], ["__scopeId", "data-v-9f00cd3d"]]), c$ = {
  name: "LuxMenuBar",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  model: {
    prop: "active"
  },
  data: function() {
    return {
      isVisible: !1,
      activeItem: ""
    };
  },
  props: {
    /**
     * The html element types used for the nav bar. Passing 'href' in menuItems
     * will only work if type = "links".
     * `links, buttons`
     */
    type: {
      type: String,
      default: "links",
      validator: (e) => e.match(/(links|buttons|main-menu)/)
    },
    /**
     * State which tab is active when initiated (using name of the component).
     */
    active: {
      required: !1,
      type: String
    },
    /**
     * Menu items are options to be displayed to the user.  They have several possible properties:
     * <dl><dt><code>name</code></dt><dd>The text that is displayed for this menu item</dd>
     * <dt><code>href</code></dt><dd>If the type is links or main-menu, the url that the menu item links to.</dd>
     * <dt><code>target</code></dt><dd>If the type is links or main-menu, where to display the linked URL (for example, <code>_blank</code> for a new tab).</dd>
     * <dt><code>children</code></dt><dd>An array of items that should display below the current item hierarchically.</dd>
     * <dt><code>disabled</code></dt><dd>If the type is buttons, whether or not the button should be disabled.</dd>
     * <dt><code>component</code></dt><dd>Optional. An identifier you can use in conjunction with the <code>active</code> prop.</dd>
     * <dt><code>unsafe_name</code></dt><dd>Optional. If you need to include some arbitrary HTML in the menu item text, you can here and it will override the label provided in <code>name</code>.  Don't bind the <code>unsafe_name</code> property to any user-provided value, since it does not have Cross-Site Scripting protections (<code>name</code> does have these protections).</dd>
     * <dt><code>method</code></dt><dd>Optional. For use in conjunction with Rails applications that use UJS to link to non-GET HTTP methods, like POST or DELETE.  To mimic a Rails link_to helper for an item, pass the HTTP method with a `method` property.</dd>
     * </dl>
     */
    menuItems: {
      required: !0,
      type: Array
    },
    /**
     * Whether the header is dark, shade, or light. Default is set to dark.
     */
    theme: {
      type: String,
      default: "dark",
      validator: (e) => e.match(/(dark|shade|light)/)
    }
  },
  computed: {
    localActive: {
      get() {
        return this.active;
      },
      set(e) {
        this.$emit("input", e);
      }
    }
  },
  methods: {
    menuItemClicked(e) {
      this.$emit("menu-item-clicked", e);
    },
    setActiveItem(e) {
      this.activeItem === e ? this.activeItem = "" : this.activeItem = e;
    },
    hide: function(e) {
      this.activeItem = "";
    },
    hideIfExitingMenu: function(e) {
      var n, s;
      const t = (n = e.currentTarget) == null ? void 0 : n.closest(".lux-has-children"), a = (s = e.relatedTarget) == null ? void 0 : s.closest(".lux-has-children");
      t !== a && this.hide(e);
    }
  },
  components: {
    "lux-hamburger": lr,
    "lux-menu-bar-label": ur
  },
  directives: {
    "click-outside": {
      beforeMount: function(e, t) {
        const a = t.modifiers.bubble, n = (s) => {
          e.ariaExpanded === "true" && (a || !e.contains(s.target) && e !== s.target) && t.value(s);
        };
        e.__vueClickOutside__ = n, document.addEventListener("click", n);
      },
      unmounted: function(e, t) {
        document.removeEventListener("click", e.__vueClickOutside__), e.__vueClickOutside__ = null;
      }
    }
  },
  emits: ["input", "menu-item-clicked"]
}, d$ = ["href", "title", "onClick"], f$ = {
  class: "lux-nav-children",
  "aria-label": "submenu"
}, h$ = ["href", "title", "target", "onClick"], v$ = ["href", "title", "onClick"], p$ = ["href", "disabled", "onClick"], m$ = ["aria-expanded"], y$ = ["aria-expanded", "data-method", "onClick", "onKeydown"], g$ = ["href", "title", "target", "data-method", "onClick"], b$ = ["title", "data-method", "onClick"], _$ = ["href", "title", "data-method", "onClick"];
function $$(e, t, a, n, s, r) {
  const i = A("lux-menu-bar-label"), l = A("lux-hamburger"), u = j1("click-outside");
  return a.type === "links" ? (f(), p("nav", {
    key: 0,
    class: z(["lux-nav", a.theme])
  }, [
    o("ul", null, [
      (f(!0), p(X, null, oe(a.menuItems, (c, d) => (f(), p("li", { key: d }, [
        c.children ? (f(), p(X, { key: 0 }, [
          (f(), p("a", {
            key: d,
            href: c.href,
            title: c.name,
            class: "lux-has-children lux-nav-item",
            "aria-haspopup": "true",
            onClick: (v) => r.menuItemClicked(v, c)
          }, [
            D(i, { item: c }, null, 8, ["item"])
          ], 8, d$)),
          o("ul", f$, [
            (f(!0), p(X, null, oe(c.children, ({ href: v, name: y, index: m, target: g }) => (f(), p("li", { key: m }, [
              o("a", {
                href: v,
                title: y,
                target: g,
                class: "lux-nav-item",
                onClick: (S) => r.menuItemClicked(S, c)
              }, F(y), 9, h$)
            ]))), 128))
          ])
        ], 64)) : (f(), p("a", {
          key: 1,
          href: c.href,
          title: c.name,
          class: "lux-nav-item",
          onClick: (v) => r.menuItemClicked(v, c)
        }, [
          D(i, { item: c }, null, 8, ["item"])
        ], 8, v$))
      ]))), 128))
    ])
  ], 2)) : a.type === "buttons" ? (f(), p("div", {
    key: 1,
    class: z(["lux-menu", a.theme])
  }, [
    o("ul", null, [
      (f(!0), p(X, null, oe(a.menuItems, (c, d) => (f(), p("li", { key: c }, [
        (f(), p("button", {
          key: d,
          href: c.href,
          class: z([
            "lux-menu-item",
            { "lux-active": r.localActive === c.component },
            { "lux-disabled": c.disabled },
            { "lux-is-child": c.hasOwnProperty("parent") === !0 }
          ]),
          disabled: c.disabled,
          onClick: (v) => r.menuItemClicked(v, c)
        }, [
          D(i, { item: c }, null, 8, ["item"])
        ], 10, p$))
      ]))), 128))
    ])
  ], 2)) : a.type === "main-menu" ? (f(), p("nav", {
    key: 2,
    class: z(["lux-main-menu", a.theme]),
    "aria-label": "Main Navigation"
  }, [
    o("button", {
      "aria-haspopup": "true",
      "aria-label": "Main Menu",
      "aria-expanded": e.isVisible ? "true" : "false",
      class: z(["lux-main-menu-toggle", { "is-active": e.isVisible }]),
      onClick: t[0] || (t[0] = (c) => e.isVisible = !e.isVisible)
    }, [
      D(l)
    ], 10, m$),
    o("ul", {
      class: z(["lux-main-menu-list", { "lux-show": e.isVisible }])
    }, [
      (f(!0), p(X, null, oe(a.menuItems, (c, d) => (f(), p("li", {
        key: d,
        class: z({ "lux-has-children": c.children })
      }, [
        c.children ? (f(), p(X, { key: 0 }, [
          k0((f(), p("button", {
            "aria-haspopup": "true",
            "aria-expanded": e.activeItem === d ? "true" : "false",
            class: "lux-submenu-toggle",
            "data-method": c.method,
            onClick: (v) => r.setActiveItem(d),
            onKeydown: v0((v) => r.setActiveItem(d), ["esc"]),
            onFocusout: t[1] || (t[1] = (...v) => r.hideIfExitingMenu && r.hideIfExitingMenu(...v))
          }, [
            D(i, { item: c }, null, 8, ["item"])
          ], 40, y$)), [
            [u, r.hide]
          ]),
          o("ul", {
            class: z({ "lux-show": d === e.activeItem })
          }, [
            (f(!0), p(X, null, oe(c.children, (v, y) => (f(), p("li", { key: y }, [
              v.href ? (f(), p("a", {
                key: y,
                href: v.href,
                title: v.name,
                target: v.target,
                "data-method": v.method,
                class: "lux-nav-item",
                onClick: (m) => r.menuItemClicked(v),
                onFocusout: t[2] || (t[2] = (...m) => r.hideIfExitingMenu && r.hideIfExitingMenu(...m))
              }, [
                D(i, { item: v }, null, 8, ["item"])
              ], 40, g$)) : (f(), p("button", {
                key: "{{ index }}-button",
                title: v.name,
                "data-method": v.method,
                class: "lux-nav-item",
                onClick: (m) => r.menuItemClicked(v),
                onFocusout: t[3] || (t[3] = (...m) => r.hideIfExitingMenu && r.hideIfExitingMenu(...m))
              }, [
                D(i, { item: v }, null, 8, ["item"])
              ], 40, b$))
            ]))), 128))
          ], 2)
        ], 64)) : (f(), p("a", {
          key: d,
          href: c.href,
          title: c.name,
          "data-method": c.method,
          class: "lux-nav-item",
          onClick: (v) => r.menuItemClicked(c)
        }, [
          D(i, { item: c }, null, 8, ["item"])
        ], 8, _$))
      ], 2))), 128))
    ], 2)
  ], 2)) : E("", !0);
}
const w$ = /* @__PURE__ */ x(c$, [["render", $$], ["__scopeId", "data-v-2516af9d"]]), C$ = {
  name: "LuxTextStyle",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the text
     */
    type: {
      type: String,
      default: "p"
    },
    /**
     * Style variation to give additional meaning.
     * `default, disabled, strong, positive, negative,small,uppercase`
     */
    variation: {
      type: String,
      default: "default",
      validator: (e) => e.match(/(default|disabled|strong|emphasis|positive|negative|small|uppercase)/)
    },
    color: {
      type: String,
      default: "var(--color-rich-black)",
      validator: (e) => e.match(/(var\(--color-rich-black\)|grey-dark|red|green|blue)/)
    }
  }
};
function x$(e, t, a, n, s, r) {
  return f(), P(Q(a.type), {
    class: z(["lux-text-style ", a.variation, a.color])
  }, {
    default: O(() => [
      ie(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]);
}
const M$ = /* @__PURE__ */ x(C$, [["render", x$]]), S$ = {
  name: "LuxLogoLibraryIcon",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 97
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 97
    },
    color: {
      type: String,
      default: "var(--color-princeton-orange-on-black)"
    }
  }
}, D$ = ["width", "height"];
function k$(e, t, a, n, s, r) {
  return f(), p("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: a.width,
    height: a.height,
    viewBox: "0 0 96 97",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "lux-logo-library-icon",
    role: "img"
  }, [
    t[2] || (t[2] = o("title", { id: "lux-logo-library-icon" }, "Princeton University Library", -1)),
    o("g", null, [
      o("path", {
        d: "M12.2 0h71.5A12.27 12.27 0 0196 12.2v72.5A12.29 12.29 0 0183.7 97H12.2A12.27 12.27 0 010 84.7V12.2A12.25 12.25 0 0112.2 0z",
        style: e0({ fill: a.color })
      }, null, 4),
      t[0] || (t[0] = o("path", {
        class: "cls-2",
        d: "M10.8 83.5V20.1a22 22 0 006.6-3v59.8h.4a13.42 13.42 0 003.5-.4 39.8 39.8 0 007.6-2.5c1.2-.5 2.4-1.1 3.7-1.7a16.34 16.34 0 015.7-1.7 12 12 0 016.2.8 9.13 9.13 0 012.3 1.5 4.9 4.9 0 011.1 2c0 .1 0 .1.1.2s0-.1 0-.1a4.45 4.45 0 011.2-2.1 8 8 0 013.2-1.9 10.87 10.87 0 014.4-.5 16 16 0 016.4 1.7q3 1.5 6 2.7a27.18 27.18 0 006.2 1.7 12.29 12.29 0 002.7.2h.3V17.1a20.23 20.23 0 006.6 2.8v63.5H10.8z"
      }, null, -1)),
      t[1] || (t[1] = o("path", {
        class: "cls-2",
        d: "M24.8 32.7A74.92 74.92 0 0125 17l.4.2a17.22 17.22 0 004.8 1.7 13.15 13.15 0 008.9-1.4 19.23 19.23 0 005-3.9 22.63 22.63 0 003.5-4.8l.1-.2.3.2a24.47 24.47 0 005.7 6.7 16.37 16.37 0 006.3 3.2 13.91 13.91 0 007.3-.4 14.76 14.76 0 002.9-1.2l.2-.1h.1a74 74 0 01.2 15.6h-46m11 27.8a54.59 54.59 0 01-5.3-8.7l17.4-17.4 17.4 17.4a47.68 47.68 0 01-5.2 8.7l-6-6-6.1-6.1-12.2 12.1"
      }, null, -1))
    ])
  ], 8, D$);
}
const L$ = /* @__PURE__ */ x(S$, [["render", k$], ["__scopeId", "data-v-42ec3b35"]]), I$ = {
  name: "LuxLogoUniversity",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 263
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 72
    }
  }
}, O$ = ["width", "height"];
function z$(e, t, a, n, s, r) {
  return f(), p("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: a.width,
    height: a.height,
    viewBox: "0 0 263 71.84",
    "aria-labelledby": "logo-university",
    role: "img"
  }, t[0] || (t[0] = [
    Ct('<title id="logo-university" lang="en" data-v-48a7eb4f>Princeton University</title><g data-v-48a7eb4f><path class="pu-logo-mc-a" d="M14.97 59.02a70.98 70.98 0 0 0 13.17 12.82 71.14 71.14 0 0 0 13.2-12.78L28.14 46.2z" data-v-48a7eb4f></path><path class="pu-logo-mc-a" d="M8.82 49.84l19.33-18.56L47.5 49.89a68.7 68.7 0 0 0 7.16-18.66l.19-.95H1.46a68.77 68.77 0 0 0 7.36 19.56z" data-v-48a7eb4f></path><path class="pu-logo-mc-a" d="M8.81 49.84a69.87 69.87 0 0 0 6.16 9.18l13.17-12.8 13.2 12.84a69.44 69.44 0 0 0 6.16-9.17L28.14 31.28z" data-v-48a7eb4f></path><path class="pu-logo-mc-b" d="M28.14 45.87L15 58.65a69.87 69.87 0 0 1-5.87-8.77l19.01-18.26L47.2 49.94a69.4 69.4 0 0 1-5.86 8.75z" data-v-48a7eb4f></path><path class="pu-logo-mc-b" d="M28.14 31.97l18.73 18.01a69.18 69.18 0 0 1-5.57 8.33L28.49 45.85l-.35-.33-.35.33-12.77 12.43a69.61 69.61 0 0 1-5.58-8.35l18.7-17.96m0-.7L8.8 49.85a69.87 69.87 0 0 0 6.16 9.18l13.17-12.8 13.2 12.84a69.44 69.44 0 0 0 6.16-9.17L28.14 31.28zM56.06 10.5a24.6 24.6 0 0 1-7.18 1.07A24.12 24.12 0 0 1 28.16 0 24.13 24.13 0 0 1 7.44 11.55 24.7 24.7 0 0 1 .26 10.5a67.64 67.64 0 0 0 1.18 19.8h53.4a68 68 0 0 0 1.22-19.8z" data-v-48a7eb4f></path><path d="M41.31 18.66v-2.27h-1.38v-1.6l-1.46-.4h-.1v-1.37s-.5.6-2.8.6c-2.18 0-3.46-.7-5.19-.7a2.36 2.36 0 0 0-2.18.95v.55h-.06v-.55a2.38 2.38 0 0 0-2.17-.96c-1.74 0-3.02.71-5.2.71-2.3 0-2.7-.6-2.7-.6v1.44h-.1l-1.57.33v1.6H15v2.27h1.4v3.67H15v2.27h1.4v2.82a33.88 33.88 0 0 0 4.5.37c2.55 0 4.02-.37 5.68-.4v.71a3.85 3.85 0 0 0 1.56.33 4.25 4.25 0 0 0 1.61-.33v-.71c1.66.03 3.13.4 5.7.4a33.84 33.84 0 0 0 4.48-.36V24.6h1.4v-2.27h-1.4v-3.67z" style="isolation:isolate;" fill="#fff" data-v-48a7eb4f></path><path class="pu-logo-mc-b" d="M38.59 14.23v-1.74l-.42.45s-.52.52-2.62.52l-2.85-.38-2.35-.33a2.78 2.78 0 0 0-2.2.84 2.8 2.8 0 0 0-2.21-.84l-2.34.33-2.85.38c-2.07 0-2.5-.5-2.51-.5l-.43-.52-.01.66v1.2l-1.69.35V27.7l.2.03a34.02 34.02 0 0 0 4.54.37 51.76 51.76 0 0 0 5.44-.38v.6l.13.07a4.1 4.1 0 0 0 1.67.35 4.46 4.46 0 0 0 1.72-.35l.14-.07v-.6a51.8 51.8 0 0 0 5.45.38 34.05 34.05 0 0 0 4.53-.38l.2-.02V14.66zm-10.2-.17a2.14 2.14 0 0 1 1.96-.83l2.24.32 2.96.4a5.88 5.88 0 0 0 2.57-.43v12.34a7.16 7.16 0 0 1-2.57.38l-2.85-.38-2.35-.33a2.94 2.94 0 0 0-1.96.62zm-10.1-.51a5.53 5.53 0 0 0 2.46.4l2.95-.39 2.24-.32a2.16 2.16 0 0 1 1.97.83v12.09a2.96 2.96 0 0 0-1.99-.63l-2.34.33-2.83.38c-2.07 0-2.5-.5-2.5-.5l.03-12.2zm21.37 13.73a33.04 33.04 0 0 1-4.25.33 53.52 53.52 0 0 1-5.67-.4l-.27-.03V28a4.07 4.07 0 0 1-1.37.26 3.81 3.81 0 0 1-1.32-.25v-.83l-.27.03a53.51 53.51 0 0 1-5.66.4 33.09 33.09 0 0 1-4.25-.33V15.04l1.2-.25v11.09c.12.25.63.84 2.95.84l2.93-.38 2.24-.33a2.18 2.18 0 0 1 1.99.83l.07-.03h.34l.07.03a2.14 2.14 0 0 1 1.96-.83l2.24.32 2.96.39c2.35 0 2.94-.62 3-.69l.04-11.3 1.07.3z" data-v-48a7eb4f></path><path class="pu-logo-mc-b" d="M21.72 15.72a.42.42 0 0 0-.37.24l-.78 1.73a.15.15 0 0 1-.06.03c-.03 0-.05-.03-.07-.08l-.32-.78-.25-.56a4.78 4.78 0 0 0-.19-.39.37.37 0 0 0-.32-.19.08.08 0 0 1-.02-.05.11.11 0 0 1 .01-.05h1.08l.02.04a.13.13 0 0 1-.01.06c-.1 0-.31 0-.31.14a.33.33 0 0 0 .02.11l.51 1.21.43-1a.63.63 0 0 0 .05-.26c0-.12-.08-.17-.3-.2a.18.18 0 0 1 0-.04.23.23 0 0 1 0-.06h.07l.4.01h.4l.02.04a.14.14 0 0 1-.01.05zm2.16 1.94c-.62 0-.95-.02-1.04-.02h-.3l-.5.02h-.12a.09.09 0 0 1 0-.05.26.26 0 0 1 0-.06.82.82 0 0 0 .3-.06.6.6 0 0 0 .07-.32v-1.2c0-.22-.11-.22-.34-.25a.24.24 0 0 1-.01-.05c0-.02 0-.05.02-.05h1.77c.05 0 .07 0 .07.04l.02.47-.05.02a.15.15 0 0 1-.05 0 .92.92 0 0 0-.3-.36.32.32 0 0 0-.19-.05h-.5c-.02 0-.02 0-.03.08l-.01.41v.27h.07a1 1 0 0 0 .23-.02.4.4 0 0 0 .2-.15.92.92 0 0 0 .06-.17.13.13 0 0 1 .06-.02.1.1 0 0 1 .05.02l-.01.44v.4a.07.07 0 0 1-.05.02.24.24 0 0 1-.06 0c-.02-.17-.05-.3-.2-.35a.55.55 0 0 0-.22-.05l-.14.01v.54a.67.67 0 0 0 .03.24.2.2 0 0 0 .12.11 1 1 0 0 0 .2.02h.29a.58.58 0 0 0 .22-.04 1.12 1.12 0 0 0 .33-.44.16.16 0 0 1 .06 0 .17.17 0 0 1 .06 0v.55c0 .04-.03.05-.1.05zm2.47-1.4h-.06a1.29 1.29 0 0 0-.15-.3.48.48 0 0 0-.38-.2h-.2v1.52c0 .24.1.24.35.27a.11.11 0 0 1 .02.06.1.1 0 0 1-.01.05h-.1l-.5-.01-.53.01a.07.07 0 0 1-.02-.05.12.12 0 0 1 .02-.06c.32-.02.36-.08.37-.18V16a1.27 1.27 0 0 0-.01-.25 1.4 1.4 0 0 0-.32.02.81.81 0 0 0-.41.45.2.2 0 0 1-.05 0 .06.06 0 0 1-.05-.02v-.53c0-.04 0-.06.06-.06h.97l.95-.01c.05 0 .08 0 .1.02a.4.4 0 0 1 0 .07v.53a.06.06 0 0 1-.05.02zm-4.73 3.2h-.06a1 1 0 0 0-.16-.3.48.48 0 0 0-.38-.2h-.2v1.52c0 .24.12.24.36.27a.1.1 0 0 1 .02.06.1.1 0 0 1-.01.05h-1.13a.1.1 0 0 1-.02-.05.25.25 0 0 1 .01-.05c.33-.03.36-.09.38-.2V19.2a1.3 1.3 0 0 0-.02-.25 1.45 1.45 0 0 0-.32.02.8.8 0 0 0-.4.45.25.25 0 0 1-.06 0 .06.06 0 0 1-.05-.02v-.52c0-.05 0-.06.06-.06h.97c.5 0 .86-.02.95-.02.05 0 .09 0 .1.02s0 .05 0 .08v.52a.06.06 0 0 1-.04.04zm2.34 1.4H22a.1.1 0 0 1-.02-.04.13.13 0 0 1 .02-.07.76.76 0 0 0 .3-.06c.05-.05.06-.13.07-.32l.01-.3v-.91c0-.22-.1-.22-.34-.25a.12.12 0 0 1-.01-.05c0-.02 0-.05.02-.06h1.77c.05 0 .07 0 .07.05l.02.47a.1.1 0 0 1-.05.02.17.17 0 0 1-.05 0 .85.85 0 0 0-.32-.35.3.3 0 0 0-.17-.05h-.51c-.02 0-.03 0-.03.08v.67h.06a.95.95 0 0 0 .23-.02.4.4 0 0 0 .22-.15.9.9 0 0 0 .04-.17.15.15 0 0 1 .06-.02.1.1 0 0 1 .06.02l-.02.44.01.4a.08.08 0 0 1-.06.02.27.27 0 0 1-.06 0c-.02-.17-.04-.3-.2-.35a.55.55 0 0 0-.21-.05 1.31 1.31 0 0 0-.14.01v.54a.84.84 0 0 0 .02.24c.02.03.07.1.12.11a1.07 1.07 0 0 0 .2.02h.3a.56.56 0 0 0 .21-.04 1.09 1.09 0 0 0 .33-.44.15.15 0 0 1 .07 0 .14.14 0 0 1 .05 0v.55c0 .05-.04.05-.11.05zm1.44.05a1.16 1.16 0 0 1-.47-.12.23.23 0 0 0-.08-.02.42.42 0 0 0-.15.08.13.13 0 0 1-.12-.06c0-.04.04-.17.04-.25l-.02-.33a.11.11 0 0 1 .09-.05h.03a4.29 4.29 0 0 0 .2.4.64.64 0 0 0 .45.22.44.44 0 0 0 .33-.1.29.29 0 0 0 .11-.25.26.26 0 0 0-.05-.19.5.5 0 0 0-.22-.15c-.09-.04-.4-.12-.52-.18a.82.82 0 0 1-.28-.2.63.63 0 0 1-.12-.38.58.58 0 0 1 .63-.57.76.76 0 0 1 .49.14 1.4 1.4 0 0 1 .12-.12.11.11 0 0 1 .1.06 2.24 2.24 0 0 0-.03.28l.04.3a.2.2 0 0 1-.09.03.14.14 0 0 1-.03-.01c-.06-.1-.11-.27-.17-.36a.46.46 0 0 0-.41-.17.34.34 0 0 0-.37.3c0 .17.14.25.25.3l.3.1a2.8 2.8 0 0 1 .33.13.56.56 0 0 1 .34.54.66.66 0 0 1-.72.63zm-2.96 3.17c-.62 0-.95-.02-1.04-.02h-.3l-.5.02h-.12a.09.09 0 0 1 0-.05.24.24 0 0 1 0-.06.83.83 0 0 0 .3-.06.6.6 0 0 0 .07-.32v-1.2c0-.22-.11-.22-.34-.25a.25.25 0 0 1-.01-.05c0-.02 0-.05.02-.05h1.77c.05 0 .07 0 .07.04l.02.47-.05.02a.14.14 0 0 1-.05 0 .92.92 0 0 0-.3-.36.32.32 0 0 0-.19-.05h-.5c-.02 0-.02 0-.03.08l-.01.41v.27h.07a1 1 0 0 0 .23-.03.4.4 0 0 0 .2-.14.9.9 0 0 0 .06-.17.13.13 0 0 1 .06-.02.1.1 0 0 1 .05.02l-.02.44.01.4a.07.07 0 0 1-.05.02.24.24 0 0 1-.06 0c-.02-.18-.05-.3-.2-.36a.55.55 0 0 0-.22-.04 1.3 1.3 0 0 0-.14 0v.54a.67.67 0 0 0 .03.25.2.2 0 0 0 .12.11 1.03 1.03 0 0 0 .2.01h.28a.58.58 0 0 0 .23-.03 1.13 1.13 0 0 0 .32-.44.17.17 0 0 1 .13 0v.54c0 .05-.03.06-.1.06zm2.99-1.95c-.21.01-.4.12-.4.46v1.05l.03.45a.22.22 0 0 1-.09.03.14.14 0 0 1-.05-.03l-1.44-1.55.01.32v.57c0 .04 0 .15.02.23a.26.26 0 0 0 .1.22.53.53 0 0 0 .27.09.1.1 0 0 1 .02.05.12.12 0 0 1-.02.05h-.91a.18.18 0 0 1 0-.04.13.13 0 0 1 .01-.05.5.5 0 0 0 .33-.14.68.68 0 0 0 .03-.25v-1.04a.36.36 0 0 0-.08-.22.74.74 0 0 0-.1-.1 1.18 1.18 0 0 0-.23-.1.16.16 0 0 1-.01-.05.1.1 0 0 1 .01-.06h.05l.44.01h.1a.2.2 0 0 1 .06.05l1.07 1.17.25.28v-.84l-.01-.24a.56.56 0 0 0-.07-.22c-.03-.05-.23-.08-.33-.1a.14.14 0 0 1-.01-.06.16.16 0 0 1 0-.04h.06l.36.01h.53a.11.11 0 0 1 0 .05.1.1 0 0 1 0 .04zm6.75-6.42c-.2 0-.39.12-.39.46v1.05l.01.45a.2.2 0 0 1-.08.03c-.01 0-.02 0-.05-.03l-1.45-1.55.02.32V17l.01.23a.29.29 0 0 0 .1.22.56.56 0 0 0 .28.09.1.1 0 0 1 .01.05.17.17 0 0 1-.01.05h-.9a.2.2 0 0 1-.01-.04.1.1 0 0 1 .01-.05.5.5 0 0 0 .33-.14.59.59 0 0 0 .03-.25v-1.04a.4.4 0 0 0-.07-.22.92.92 0 0 0-.1-.1 1.07 1.07 0 0 0-.24-.1.38.38 0 0 1 0-.05.2.2 0 0 1 0-.05h.59a.31.31 0 0 1 .07.05l1.07 1.17.24.28v-.84a2.03 2.03 0 0 0-.01-.24.5.5 0 0 0-.06-.22c-.04-.05-.24-.08-.34-.1a.15.15 0 0 1-.01-.06.09.09 0 0 1 0-.04h.07l.36.01h.52a.13.13 0 0 1 .01.04.1.1 0 0 1-.01.05zm2.13 1.69a1.02 1.02 0 0 1-1.45.01 1.13 1.13 0 0 1 0-1.55 1.02 1.02 0 0 1 .72-.3 1.1 1.1 0 0 1 .54.14 1.07 1.07 0 0 1 .5.91 1.14 1.14 0 0 1-.31.79zm-.34-1.5a.48.48 0 0 0-.4-.21.44.44 0 0 0-.38.21 1.18 1.18 0 0 0-.2.72 1.23 1.23 0 0 0 .19.72.45.45 0 0 0 .4.23.47.47 0 0 0 .44-.28 1.33 1.33 0 0 0 .14-.66 1.2 1.2 0 0 0-.19-.73zm3.25-.18a.41.41 0 0 0-.37.24l-.78 1.73a.15.15 0 0 1-.06.03c-.02 0-.06-.03-.07-.08l-.32-.78-.25-.56a4.78 4.78 0 0 0-.18-.4.38.38 0 0 0-.33-.18.07.07 0 0 1-.02-.05.08.08 0 0 1 .01-.06h.13l.38.01.49-.01h.08c.02 0 .02.03.02.05a.13.13 0 0 1 0 .05c-.1.01-.32 0-.32.14a.25.25 0 0 0 .02.12l.5 1.21.44-1a.69.69 0 0 0 .05-.27c0-.1-.08-.16-.3-.18a.17.17 0 0 1 0-.05.25.25 0 0 1 0-.06h.07l.4.01h.42a.1.1 0 0 1 0 .1zm-5.7 3.74h-.07a1 1 0 0 0-.15-.3.47.47 0 0 0-.38-.2h-.2v1.52c0 .24.11.24.36.27a.1.1 0 0 1 .01.06.1.1 0 0 1 0 .05h-1.15a.1.1 0 0 1-.01-.05.24.24 0 0 1 0-.05c.33-.03.37-.09.38-.2V19.2a1.32 1.32 0 0 0-.01-.25 1.45 1.45 0 0 0-.33.02.8.8 0 0 0-.4.45.24.24 0 0 1-.06 0 .06.06 0 0 1-.05-.02v-.52c0-.05.01-.06.07-.06h.97c.48 0 .85-.02.94-.02.06 0 .09 0 .1.02s0 .05 0 .08v.52a.06.06 0 0 1-.04.04zm2.45 1.4h-1.05a.08.08 0 0 1-.01-.05.17.17 0 0 1 0-.04c.2-.01.28-.05.28-.13a.7.7 0 0 0-.06-.26c-.06-.16-.1-.22-.1-.26-.02-.01-.02-.02-.06-.02h-.65a1.41 1.41 0 0 0-.15.39.45.45 0 0 0-.02.12c0 .06.07.14.3.14a.1.1 0 0 1 0 .06.17.17 0 0 1 0 .05h-.05l-.35-.01h-.45a.14.14 0 0 1 0-.03.12.12 0 0 1 0-.06.44.44 0 0 0 .3-.15 3.25 3.25 0 0 0 .26-.53l.31-.76.14-.3a4 4 0 0 1 .11-.21.13.13 0 0 1 .08-.04.12.12 0 0 1 .1.04.58.58 0 0 1 .04.1l.36.89.2.47.14.3c.08.16.2.16.32.2l.02.04-.01.05zm-1.3-1.62a3.76 3.76 0 0 0-.15.33 9.13 9.13 0 0 1-.16.4h.6c-.04-.13-.2-.5-.29-.73zm4.46 1.63l-.83-.01h-.23a.15.15 0 0 1-.01-.06.07.07 0 0 1 .02-.05 1.06 1.06 0 0 0 .2-.02c.08-.03.12-.12.12-.24V19l-.44.96-.15.33a4.29 4.29 0 0 0-.18.47.06.06 0 0 1-.07.03c-.03 0-.05 0-.06-.05-.06-.13-.1-.2-.11-.26l-.69-1.5h-.01v.38l.01.96c0 .3.16.43.39.43a.16.16 0 0 1 .02.05.12.12 0 0 1-.02.05H35l-.4-.01h-.42a.2.2 0 0 1-.01-.05.24.24 0 0 1 0-.05 1.06 1.06 0 0 0 .3-.1c.05-.04.09-.13.09-.33v-1.05c0-.16-.03-.23-.1-.29a1.02 1.02 0 0 0-.27-.05.14.14 0 0 1-.02-.05.17.17 0 0 1 .02-.06h.86a.12.12 0 0 1 .05.06l.6 1.38.12-.27c.1-.23.23-.56.42-.92l.12-.24.78-.01a.12.12 0 0 1 .02.05.1.1 0 0 1-.01.05c-.09.02-.24.02-.3.13-.03.04-.04.08-.04.25v.99c0 .38.1.41.14.44a.74.74 0 0 0 .2.03.1.1 0 0 1 .02.05l-.03.06zm-5.67 1.8h-.06a1 1 0 0 0-.15-.3.48.48 0 0 0-.38-.2h-.2v1.53c0 .24.11.24.36.27a.1.1 0 0 1 .01.06.1.1 0 0 1 0 .05h-.1l-.51-.01-.53.01a.1.1 0 0 1-.01-.05.25.25 0 0 1 0-.06c.33-.02.37-.08.38-.18v-1.36a1.3 1.3 0 0 0-.01-.26 1.45 1.45 0 0 0-.32.03.8.8 0 0 0-.41.45.24.24 0 0 1-.06 0 .06.06 0 0 1-.05-.02v-.53c0-.05.01-.06.07-.06h.97c.49 0 .85-.02.94-.02.06 0 .09 0 .1.02s0 .05 0 .08v.52a.06.06 0 0 1-.04.03zm2.55-.53a.41.41 0 0 0-.37.24l-.78 1.73a.15.15 0 0 1-.06.03c-.02 0-.05-.03-.07-.08l-.32-.78-.25-.56a4.69 4.69 0 0 0-.18-.4.38.38 0 0 0-.33-.18.07.07 0 0 1-.02-.05.08.08 0 0 1 .02-.06h.12l.38.01.49-.01h.08c.02 0 .02.03.02.05a.13.13 0 0 1 0 .05c-.1.01-.32 0-.32.14a.25.25 0 0 0 .02.12l.51 1.2.43-1a.69.69 0 0 0 .05-.26c0-.11-.08-.16-.29-.19a.17.17 0 0 1 0-.04.24.24 0 0 1 0-.07h.06c.1 0 .19.02.4.02l.26-.01h.15a.1.1 0 0 1 0 .1zm3.16 1.94l-.82-.01h-.23a.12.12 0 0 1-.01-.05.06.06 0 0 1 .01-.06 1.09 1.09 0 0 0 .2-.01c.09-.04.12-.13.12-.25v-1.48l-.44.96-.15.33a5.46 5.46 0 0 0-.18.46c-.01.04-.05.04-.07.04s-.04 0-.06-.06c-.05-.12-.1-.2-.11-.25l-.69-1.5h-.01v.38l.01.96c0 .3.16.43.4.43a.13.13 0 0 1 0 .05.11.11 0 0 1 0 .05h-.11l-.4-.01h-.42a.1.1 0 0 1-.02-.06.11.11 0 0 1 .02-.04 1.1 1.1 0 0 0 .3-.1.49.49 0 0 0 .07-.33v-1.05c0-.17-.02-.23-.1-.3a1.03 1.03 0 0 0-.26-.04.1.1 0 0 1-.02-.06.12.12 0 0 1 .02-.06l.36.01h.5a.12.12 0 0 1 .04.05l.6 1.39.12-.28a9.22 9.22 0 0 1 .43-.92l.12-.23.77-.02c.01.02.03.03.03.05a.12.12 0 0 1-.02.06c-.08 0-.23 0-.3.13-.03.04-.05.07-.05.24v.99c0 .38.1.42.15.45a.67.67 0 0 0 .2.02.08.08 0 0 1 .02.06c0 .03 0 .04-.02.06zm225.4-12.3a.83.83 0 0 0-.07-.37h-.6c-1.33 0-2.18.05-4.56.05-.82 0-2.04-.05-2.32-.05h-.7c-.07.05-.1.34-.1.45a.7.7 0 0 0 .13.45 11.1 11.1 0 0 1 2.73.76 5.15 5.15 0 0 1 .77 2.7c.02.4.05.8.05 1.88v5.53a10.62 10.62 0 0 1-.05 1.14c-.46-.5-1.09-1.46-2.15-2.65l-8.83-9.79a1.73 1.73 0 0 0-.4-.34l-.8-.02c-1.7 0-4.75-.08-5.2-.08a.97.97 0 0 0-.11.37 4.4 4.4 0 0 0 .08.5 3.63 3.63 0 0 1 1.98 1 8.9 8.9 0 0 1 1.4 1.67 2.3 2.3 0 0 1 .11.84c0 1.38-.08 3.31-.08 5.16v5.37a11.7 11.7 0 0 1-.16 2.01 5.5 5.5 0 0 1-2.77 1.35 1.54 1.54 0 0 0-.1.48c0 .08.02.34.07.36h.5c.53 0 1.75-.08 2.54-.08 1.17 0 1.96.08 3.04.08h1.6c.1-.02.12-.34.12-.45a1.22 1.22 0 0 0-.08-.42 5.09 5.09 0 0 1-3.17-1.64 15.06 15.06 0 0 1-.34-3.28c0-.84-.03-2-.03-3.57 0-2.09.03-3.91.06-4.83l.47.57 12.22 13.73a1.53 1.53 0 0 0 .74.16.63.63 0 0 0 .32-.05 3.05 3.05 0 0 0 .23-1.2l-.02-1.95V16.6c0-3.3 1.56-4.23 3.38-4.31a1.13 1.13 0 0 0 .1-.5m-30.3 8.4c0 4-1.11 7.52-2.62 8.76a4.29 4.29 0 0 1-2.8.96 3.96 3.96 0 0 1-3.51-1.78 14.08 14.08 0 0 1-1.56-6.87c0-3.68.95-6.56 2.64-7.96a4.21 4.21 0 0 1 2.75-1.03 4.4 4.4 0 0 1 3.6 1.82c1 1.38 1.5 3.36 1.5 6.1m4.8.5a8.87 8.87 0 0 0-4.71-8.22 10.22 10.22 0 0 0-5.03-1.35 10.77 10.77 0 0 0-8.91 4.93 10.1 10.1 0 0 0-1.53 5.34 9.86 9.86 0 0 0 3.78 7.75 9.92 9.92 0 0 0 6.03 1.9 10.95 10.95 0 0 0 4.02-.77 9.53 9.53 0 0 0 3.67-2.51 10.21 10.21 0 0 0 2.67-7.06m-23.24-3.33v-5.4c0-.4-.16-.5-.55-.5-.8 0-4.97.1-9.2.1-3.29 0-6.01-.05-7.49-.05h-1.96c-.34 0-.45.08-.45.45V17a.77.77 0 0 0 .43.1 2.02 2.02 0 0 0 .58-.05c1.19-2.4 2.3-3.7 3.7-4.42.79-.07 2.35-.1 2.77-.1.03.3.06 1.22.08 2.33.03 1.9.03 2.72.03 7.22 0 3.89-.03 5.63-.08 6.05-.1.74.02 1.3-3.15 1.44a1.5 1.5 0 0 0-.08.6 2.1 2.1 0 0 0 .03.42h1.02c.98 0 3.28-.1 4.24-.1.76 0 3.22.08 4.83.08h.74a1.33 1.33 0 0 0 .08-.55.99.99 0 0 0-.1-.48 5.48 5.48 0 0 1-2.72-.5 8.08 8.08 0 0 1-.24-1.98c-.03-2.86-.05-3.94-.05-5.85 0-2.45.02-4.12.02-8.7.37 0 1.22-.02 2.01 0a5.18 5.18 0 0 1 3.15 2.01 13.32 13.32 0 0 1 1.4 2.89 1.34 1.34 0 0 0 .45.05 1.42 1.42 0 0 0 .5-.1m-22.8 8.6a5.82 5.82 0 0 0-.02-.77.59.59 0 0 0-.4-.08 2.22 2.22 0 0 0-.58.05 10.1 10.1 0 0 1-2.91 4.03 4.03 4.03 0 0 1-1.99.3h-2.16a9.74 9.74 0 0 1-1.75-.14c-.4-.08-.82-.71-1-1.14a2.77 2.77 0 0 1-.29-1.66v-5.79h.98a4.17 4.17 0 0 1 1.61.37 2.44 2.44 0 0 1 1.2 1.11 9.1 9.1 0 0 1 .44 2.2 1.89 1.89 0 0 0 .7.1.94.94 0 0 0 .52-.14c0-.71-.16-2.64-.16-3.7 0-1.32.18-3.14.26-4.09a1.07 1.07 0 0 0-.52-.1 1.93 1.93 0 0 0-.69.07c-.08.37-.37 1.48-.43 1.56a3.2 3.2 0 0 1-1.8 1.38 7.12 7.12 0 0 1-1.53.2h-.56v-2.45c0-2.54.06-3.36.08-3.84l.1-.9a10.93 10.93 0 0 1 1.6-.05c1.53 0 2.24.02 2.48.02a3.02 3.02 0 0 1 1.7.53 11.22 11.22 0 0 1 2.53 3.28 2.11 2.11 0 0 0 .56.05c.16 0 .18-.05.4-.15 0-1.62-.11-3.7-.16-4.37-.03-.26-.08-.34-.6-.34-.22 0-1.23-.05-2.28-.05-1.5 0-2.12.02-4.42.02l-4.9.03c-1.58 0-2.93-.05-3.62-.05h-.9a.86.86 0 0 0-.13.42 1.19 1.19 0 0 0 .13.53 13.43 13.43 0 0 1 1.94.29 2.17 2.17 0 0 1 .95 1.72c.05.56.08 2.09.08 3.3v5.45c0 1.11-.03 2.73-.06 3.39a7.65 7.65 0 0 1-.58 2.51 6.99 6.99 0 0 1-2.38.4 1.6 1.6 0 0 0-.13.58 1.02 1.02 0 0 0 .13.48h.87c.85 0 3.97-.08 4.69-.08.66 0 1.93.05 3.46.05.85 0 3.33.16 8.67.16a2.25 2.25 0 0 0 .72-.06.8.8 0 0 0 .1-.42c.06-.53.06-2.09.06-4.23m-22.37.92a.88.88 0 0 0-.9-.63l-.19.03c-1.59 2.25-3.33 3.09-5.32 3.09a5.8 5.8 0 0 1-5.34-3.5 14.5 14.5 0 0 1-.82-4.8 11.67 11.67 0 0 1 .8-4.63c1.16-3.07 2.85-4.02 4.92-4.02a5.42 5.42 0 0 1 4.23 2.38 11.87 11.87 0 0 1 1.34 3.2 2.82 2.82 0 0 0 .59.07 1.29 1.29 0 0 0 .63-.23c-.02-.3-.29-2.33-.29-2.97 0-.79.21-2.08.21-2.59a2.1 2.1 0 0 0-1.03-.29 5.18 5.18 0 0 0-.9 1.09 8.7 8.7 0 0 0-5.87-1.88 9.02 9.02 0 0 0-6.64 2.62 10.04 10.04 0 0 0-2.83 7.45 9.67 9.67 0 0 0 3.73 7.91 10.54 10.54 0 0 0 6.16 1.77c3.23 0 5.59-1.21 6.77-2.82a5.54 5.54 0 0 0 .75-1.25m-20.59-15.1a.86.86 0 0 0-.08-.37h-.61c-1.32 0-2.17.05-4.55.05-.82 0-2.04-.05-2.33-.05h-.68c-.08.05-.11.35-.11.45a.69.69 0 0 0 .14.45 11.22 11.22 0 0 1 2.72.77 5.2 5.2 0 0 1 .76 2.7c.03.39.06.79.06 1.87v5.53a9.04 9.04 0 0 1-.06 1.14c-.44-.5-1.08-1.46-2.14-2.65l-8.82-9.78a1.75 1.75 0 0 0-.4-.34l-.79-.03c-1.7 0-4.76-.08-5.21-.08a.97.97 0 0 0-.1.37 4.37 4.37 0 0 0 .07.5 3.62 3.62 0 0 1 1.99 1 8.75 8.75 0 0 1 1.4 1.67 2.3 2.3 0 0 1 .1.84c0 1.38-.07 3.31-.07 5.16v5.37a11.62 11.62 0 0 1-.16 2.01 5.5 5.5 0 0 1-2.78 1.35 1.6 1.6 0 0 0-.1.48c0 .08.02.34.08.37h.5c.53 0 1.74-.09 2.54-.09 1.16 0 1.95.09 3.04.09h1.57c.1-.03.14-.35.14-.45a1.24 1.24 0 0 0-.08-.43 5.08 5.08 0 0 1-3.17-1.64 15.19 15.19 0 0 1-.34-3.28c0-.84-.03-2-.03-3.57 0-2.08.03-3.9.06-4.83.16.18.34.42.47.58l12.21 13.73a1.54 1.54 0 0 0 .74.16.62.62 0 0 0 .32-.05 3.05 3.05 0 0 0 .23-1.2c0-.76-.03-1.56-.03-1.95V16.59c0-3.3 1.57-4.23 3.4-4.31a1.13 1.13 0 0 0 .1-.5M121.91 30.1a1.77 1.77 0 0 0-.08-.53 19.7 19.7 0 0 1-1.95-.23 4.16 4.16 0 0 1-.9-2.04 362.9 362.9 0 0 1-.06-6.35v-6.5a2.1 2.1 0 0 1 .48-1.43 4.55 4.55 0 0 1 2.36-.69 1.66 1.66 0 0 0 .07-.5.78.78 0 0 0-.13-.42h-.77c-1.1 0-3.7.13-4.6.13-.55 0-3.14-.08-4.3-.1h-.58a.63.63 0 0 0-.14.45 3.24 3.24 0 0 0 .05.5 5.55 5.55 0 0 1 2.07.37 2.92 2.92 0 0 1 .87 2.24c.02.5.05 1.59.08 4.02.02 1.33.05 3.17.05 4.7 0 .77-.05 2.49-.08 3.41a4.53 4.53 0 0 1-.37 1.6c-.31.26-.63.73-2.57.86a2.04 2.04 0 0 0-.08.56c0 .21.06.32.06.45h.45c1.06 0 3.7-.14 5.07-.14.4 0 3.15.09 4.02.09h.88a1.06 1.06 0 0 0 .1-.45M100.7 16.3c0 1.64-1.11 3.52-2.4 3.83a8.86 8.86 0 0 1-2.17.22 5.97 5.97 0 0 1-.98-.06l-.03-2.25v-4.86a.84.84 0 0 1 .16-.58 2.64 2.64 0 0 1 1.12-.16c2.06 0 2.96.18 3.7 1.43a4.71 4.71 0 0 1 .6 2.43m7.67 13.83a1.29 1.29 0 0 0-.13-.56 4.04 4.04 0 0 1-1.75-.34 5.34 5.34 0 0 1-.45-.66 28.67 28.67 0 0 0-1.13-3.04 10 10 0 0 0-1.96-3.15 8.43 8.43 0 0 0-1.99-.87 27.45 27.45 0 0 1-1.08-.43 8.26 8.26 0 0 1 1.08-.15c1.96-.24 2.41-.58 2.91-.98a4.17 4.17 0 0 0 1.64-3.44 5.08 5.08 0 0 0-3.3-4.82 12.98 12.98 0 0 0-3.17-.28c-1.99 0-4.76.18-6.08.18-.4 0-2.7-.05-3.63-.05-.4 0-1.4-.05-1.56-.05a1.52 1.52 0 0 0-.13.5 2.94 2.94 0 0 0 .05.47c.45.05 1.27.16 1.7.24a3.13 3.13 0 0 1 1.1 1.43 67.13 67.13 0 0 1 .17 6.74c0 2.7.02 5.82-.1 6.83a2.01 2.01 0 0 1-1.09 1.77 13.67 13.67 0 0 1-1.5.18 1.3 1.3 0 0 0-.14.53 1.64 1.64 0 0 0 .1.42c.37 0 4.42-.07 5.26-.07 1.7 0 3.13.07 4.63.07a1.1 1.1 0 0 0 .1-.4 1.65 1.65 0 0 0-.1-.55c-.53-.05-1.19-.2-1.48-.27a1.98 1.98 0 0 1-1.14-1.87l-.02-6.11a5.52 5.52 0 0 1 .69-.03 2.7 2.7 0 0 1 1.4.42 5.12 5.12 0 0 1 2.09 1.94 16.1 16.1 0 0 1 1.66 5.68c.08.56.3 1.03.8 1.09.2.02 1.6.08 2.61.08h3.79a.73.73 0 0 0 .15-.45m-28.72-13.7a4.33 4.33 0 0 1-1.34 3.3 4.3 4.3 0 0 1-2.76.72 8.66 8.66 0 0 1-1.13-.05c-.21-.03-.35-.05-.35-.19l.03-7.75a12.09 12.09 0 0 1 1.53-.13c1.8 0 2.91.45 3.44 1.56a5.63 5.63 0 0 1 .58 2.54m4.73.1a5.06 5.06 0 0 0-2.82-4.6 13.08 13.08 0 0 0-4.74-.6c-2.03 0-5.2.16-6.6.16-.99 0-2.47-.11-3.29-.11a.97.97 0 0 0-.13.42 1.27 1.27 0 0 0 .08.53c.5.16 1.32.3 1.85.43a2.26 2.26 0 0 1 .71 1.5c.08.93.14 2.1.14 4.1 0 5.59-.03 8.52-.11 9.15a2.24 2.24 0 0 1-1.5 1.88 14.8 14.8 0 0 1-1.54.26 2.8 2.8 0 0 0-.06.56.74.74 0 0 0 .08.37c.85 0 3.34-.1 4.29-.1 2.35 0 4.76.1 5.73.1h.67a.76.76 0 0 0 .08-.42 1.28 1.28 0 0 0-.06-.48 4.3 4.3 0 0 1-2.48-.85 2.25 2.25 0 0 1-.53-1.56l-.08-5.81c1.58.1 3.28.15 4.2.15a9.93 9.93 0 0 0 3.07-.47 4.84 4.84 0 0 0 3.04-4.6M263 41.28c0-.16-.1-.22-.16-.32-1.08 0-2.51.08-3.07.08-1.34 0-2.98-.1-3.7-.1-.08.15-.1.18-.1.3a.94.94 0 0 0 .05.33c.77.15 1.88.34 2.09.71a1.9 1.9 0 0 1 .24 1.03 2.58 2.58 0 0 1-.16.98c-.24.66-.74 1.7-1.45 3.15a52.4 52.4 0 0 1-2.41 4.6 91.87 91.87 0 0 1-2.6-5.02l-1.47-3.23a2.45 2.45 0 0 1-.1-.72 1.76 1.76 0 0 1 .1-.68c.23-.48 1.05-.53 2.17-.67a1.16 1.16 0 0 0 .07-.39c0-.18-.08-.13-.16-.26h-.47c-1.77 0-1.25.08-4.29.08-1.3 0-2.85-.08-3.06-.08-.1.18-.16.2-.16.4a.57.57 0 0 0 .1.31c1.77.42 2.3.74 2.49 1.09l4.63 9.07a10.46 10.46 0 0 1 .84 1.98 14.71 14.71 0 0 1 .22 3.17 2.25 2.25 0 0 1-.85 2.04 12.68 12.68 0 0 1-2.12.34.63.63 0 0 0-.13.37 1.12 1.12 0 0 0 .08.32c1.35 0 2.75-.03 3.54-.03.56 0 1.4.03 2.97.06.9.02 1.58.05 2.06.05a.78.78 0 0 0 .13-.34.58.58 0 0 0-.1-.35 6.33 6.33 0 0 1-2.3-.53 2.03 2.03 0 0 1-.7-1.69l-.2-3.97a1.46 1.46 0 0 1 .1-.63 3.98 3.98 0 0 1 .29-.74l4.07-8.06a5.47 5.47 0 0 1 1.7-1.78 7.42 7.42 0 0 1 1.72-.53.97.97 0 0 0 .1-.34m-21.37 5.45v-5.14c0-.4-.16-.5-.55-.5-.8 0-4.45.1-8.68.1-3.28 0-5.47-.05-6.96-.05h-1.95c-.34 0-.45.08-.45.45v4.79a.47.47 0 0 0 .31.1.69.69 0 0 0 .32-.05c1.03-2.3 1.56-3.52 3.34-4.42.79-.08 3.56-.1 3.99-.1.02.29.05 1.21.08 2.33.03 1.9.03 2.93.03 7.43 0 3.89-.03 5.9-.09 6.32-.1.74.03 1.3-3.14 1.43a.84.84 0 0 0-.08.45 1.22 1.22 0 0 0 .03.31h1.03c.97 0 2.27-.1 3.22-.1.77 0 2.22.08 3.84.08h.74a.7.7 0 0 0 .08-.4.6.6 0 0 0-.11-.37 5.44 5.44 0 0 1-2.72-.5 8.07 8.07 0 0 1-.24-1.98c-.03-2.86-.05-4.2-.05-6.11 0-2.46.02-4.34.02-8.91.37 0 2.33-.03 3.13 0a4.76 4.76 0 0 1 2.98 2 8.48 8.48 0 0 1 1.19 2.89 1.05 1.05 0 0 0 .4.05.5.5 0 0 0 .3-.1M219.65 59.8a.85.85 0 0 0-.08-.37c-.4-.03-1.48-.14-1.96-.24a4.18 4.18 0 0 1-.9-2.04 398.46 398.46 0 0 1-.05-6.61v-6.71a2.12 2.12 0 0 1 .47-1.43 4.51 4.51 0 0 1 2.36-.69.78.78 0 0 0 .08-.34.45.45 0 0 0-.13-.32h-.76c-1.12 0-2.7.13-3.6.13-.56 0-2.15-.08-3.3-.1h-.59a.38.38 0 0 0-.13.34 1.82 1.82 0 0 0 .05.35 5.7 5.7 0 0 1 2.07.37 2.93 2.93 0 0 1 .87 2.25c.03.5.05 1.85.08 4.28.03 1.32.05 3.12.05 4.65 0 .77-.05 2.75-.08 3.68a4.5 4.5 0 0 1-.37 1.58c-.32.27-.63.74-2.56.88a1.06 1.06 0 0 0-.08.4c0 .2.05.2.05.34h.45c1.06 0 2.7-.13 4.07-.13.4 0 2.14.07 3.02.07h.87a.64.64 0 0 0 .1-.34m-13.06-4.86a4.9 4.9 0 0 0-2.99-4.66 14.79 14.79 0 0 0-2.93-1.06 19.17 19.17 0 0 1-3.84-1.45 3.17 3.17 0 0 1-1.56-2.88c0-1.7 1.72-3.1 3.73-3.1a4.43 4.43 0 0 1 3.62 1.85 13.49 13.49 0 0 1 1.64 3.02 1.05 1.05 0 0 0 .27.05.86.86 0 0 0 .58-.26 20.75 20.75 0 0 1-.21-2.38 13.8 13.8 0 0 1 .24-2.07.81.81 0 0 0-.8-.37 5.88 5.88 0 0 0-1.03.96 6.6 6.6 0 0 0-4.5-1.64c-3.25 0-5.58 2.17-5.58 5.05a5.3 5.3 0 0 0 .98 2.9 5.78 5.78 0 0 0 2.57 1.94c.76.31 4.2 1.35 4.68 1.53 2.11.82 2.9 1.53 2.9 3.41a4.13 4.13 0 0 1-1.16 2.67 3.69 3.69 0 0 1-2.93 1.25 5.93 5.93 0 0 1-4.45-1.96 12.6 12.6 0 0 1-1.8-3.57.9.9 0 0 0-.37-.05.94.94 0 0 0-.5.15c0 .35.1 2.1.1 2.62a11.04 11.04 0 0 1-.28 2.36 1 1 0 0 0 .85.53 3.73 3.73 0 0 1 1.32-.85 1.23 1.23 0 0 1 .63.24 7.63 7.63 0 0 0 4.42 1.32c3.73 0 6.4-1.88 6.4-5.55m-23.4-9.13a4.28 4.28 0 0 1-2.9 3.94 14.25 14.25 0 0 1-2.76.22 16.01 16.01 0 0 1-1.61-.06l-.03-2.33v-5c0-.34.08-.53.19-.6a8.55 8.55 0 0 1 1.85-.16c2.48 0 3.62.23 4.52 1.53a4.16 4.16 0 0 1 .74 2.46m5.55 14.01a.7.7 0 0 0-.13-.39 4.06 4.06 0 0 1-1.75-.34 5.94 5.94 0 0 1-.45-.66 33.85 33.85 0 0 0-1.1-3.3 9.87 9.87 0 0 0-1.96-3.16 7.06 7.06 0 0 0-1.9-.87 40.92 40.92 0 0 1-1.09-.42 10.45 10.45 0 0 1 1.09-.16 4.85 4.85 0 0 0 2.8-.98 4.2 4.2 0 0 0 1.74-3.41 5.04 5.04 0 0 0-3.3-4.79 13 13 0 0 0-3.17-.29c-1.99 0-3.47.18-4.8.18-.39 0-1.68-.05-2.6-.05-.4 0-1.4-.05-1.57-.05-.08.19-.13.24-.13.35a1.7 1.7 0 0 0 .05.37c.45.05 1.27.15 1.7.23a3.1 3.1 0 0 1 1.1 1.43c.14.85.16 3.23.16 6.96 0 2.7.03 6.08-.1 7.09a2 2 0 0 1-1.09 1.76 14.9 14.9 0 0 1-1.5.2.68.68 0 0 0-.14.36 1.07 1.07 0 0 0 .1.32c.38 0 3.42-.08 4.27-.08 1.69 0 2.11.08 3.62.08a.65.65 0 0 0 .1-.3.75.75 0 0 0-.1-.39c-.53-.05-1.2-.21-1.48-.26a1.98 1.98 0 0 1-1.14-1.88l-.02-6.61c.2-.03.97-.03 1.18-.03a4.9 4.9 0 0 1 2.12.37 5.93 5.93 0 0 1 2.6 2.14 16.6 16.6 0 0 1 1.66 5.77c.08.55.29 1.03.8 1.08a9.6 9.6 0 0 0 1.53.08h2.75a.45.45 0 0 0 .15-.34m-22.18-4.02a6.94 6.94 0 0 0-.03-.77.59.59 0 0 0-.4-.08.74.74 0 0 0-.34.06 7 7 0 0 1-2.73 4.04 4.98 4.98 0 0 1-2.24.3h-2.96a12.39 12.39 0 0 1-1.75-.14c-.4-.08-.82-.72-1-1.14a3.43 3.43 0 0 1-.3-1.82V50.2h.85a5.22 5.22 0 0 1 2.25.38 3.18 3.18 0 0 1 1.43 1.13 9.06 9.06 0 0 1 .37 2.2.66.66 0 0 0 .42.1.61.61 0 0 0 .43-.14c0-.7-.16-2.64-.16-3.7 0-1.32.18-2.93.26-3.89a.69.69 0 0 0-.42-.1.8.8 0 0 0-.43.08c-.07.37-.29 1.48-.34 1.56a3.85 3.85 0 0 1-2.03 1.4 8.42 8.42 0 0 1-2.17.22h-.43v-2.6c0-2.54.06-3.57.08-4.05l.1-.9c.25-.03 1-.05 2.23-.05 1.53 0 2.67.02 2.9.02a2.98 2.98 0 0 1 1.7.53 6.73 6.73 0 0 1 2.36 3.28.73.73 0 0 0 .31.05c.16 0 .19-.05.4-.15a59 59 0 0 0-.16-4.1c-.03-.27-.08-.34-.6-.34-.22 0-1.22-.06-2.28-.06-1.51 0-2.12.03-4.42.03l-4.52.03c-1.59 0-1.93-.06-2.62-.06h-.9a.54.54 0 0 0-.14.32.63.63 0 0 0 .14.37 13.4 13.4 0 0 1 1.94.3c.37.3.71.4.95 1.66.05.55.08 2.35.08 3.57v5.44c0 1.11-.03 2.94-.05 3.6a8 8 0 0 1-.59 2.57 6.99 6.99 0 0 1-2.39.4.88.88 0 0 0-.13.42.63.63 0 0 0 .13.37h.88c.85 0 2.97-.08 3.68-.08.66 0 1.56.05 3.1.05.85 0 3.33.16 8.68.16a2.24 2.24 0 0 0 .7-.05.8.8 0 0 0 .12-.42c.05-.53.05-1.83.05-3.97m-19.6-14.43c0-.11-.03-.27-.14-.3h-.9c-.63 0-1.64.06-2.09.06-2.14 0-2.9-.14-3.22-.14h-.48c-.05.14-.13.22-.13.35 0 .1.05.18.05.29a9.85 9.85 0 0 1 1.83.4 2.49 2.49 0 0 1 .66 1.66 10.03 10.03 0 0 1-.64 2.41l-4.25 10.47-5.23-13.25a1.99 1.99 0 0 1 .87-1.48 11.6 11.6 0 0 1 1.71-.21.97.97 0 0 0 .1-.37c0-.1-.02-.26-.13-.29h-.66c-.81 0-2.06.1-3.46.1-.6 0-1.8-.05-2.96-.05h-1.03a.55.55 0 0 0-.1.32.57.57 0 0 0 .08.31 9.18 9.18 0 0 1 2.22.9 47.23 47.23 0 0 1 2.17 4.82l2.19 5.3c1.82 4.38 2.9 7.31 3.04 7.82.13.08 0 .15.23.15s.22-.04.27-.18l6.82-16.4a5.26 5.26 0 0 1 .95-1.5 4.2 4.2 0 0 1 2.12-.85 1.25 1.25 0 0 0 .1-.34m-23.15 18.43a.82.82 0 0 0-.08-.37c-.4-.03-1.48-.13-1.96-.24a4.22 4.22 0 0 1-.9-2.04c-.02-1.27-.05-4.15-.05-6.6v-6.72a2.1 2.1 0 0 1 .48-1.44 4.5 4.5 0 0 1 2.35-.68.78.78 0 0 0 .08-.34.43.43 0 0 0-.14-.32h-.76c-1.11 0-2.7.13-3.6.13-.55 0-2.14-.08-3.3-.1h-.58a.37.37 0 0 0-.14.34 1.84 1.84 0 0 0 .05.34 5.68 5.68 0 0 1 2.07.37 2.91 2.91 0 0 1 .87 2.25c.03.5.05 1.86.08 4.29.03 1.32.06 3.12.06 4.65 0 .77-.06 2.75-.09 3.67a4.44 4.44 0 0 1-.37 1.6c-.31.26-.63.73-2.56.87a1.01 1.01 0 0 0-.08.4c0 .2.05.2.05.34h.45c1.06 0 2.7-.14 4.07-.14.4 0 2.14.08 3.02.08h.87a.61.61 0 0 0 .1-.34M111.86 41.3a.42.42 0 0 0-.08-.26h-.6c-1.33 0-1.9.05-4.29.05-.82 0-2.03-.05-2.32-.05h-.7c-.07.05-.1.24-.1.34a.34.34 0 0 0 .14.29 11.36 11.36 0 0 1 2.72.77 5.23 5.23 0 0 1 .77 2.7c.02.39.05.79.05 1.87v7.86a10.42 10.42 0 0 1-.05 1.13c-.45-.5-1.22-1.48-2.25-2.7l-10.1-11.79a1.75 1.75 0 0 0-.4-.34l-.68-.03c-1.7 0-3.18-.08-3.63-.08a.53.53 0 0 0-.07.27 1.99 1.99 0 0 0 .05.34 4.63 4.63 0 0 1 2.04.74 7.7 7.7 0 0 1 1.29 1.56 2.3 2.3 0 0 1 .1.85c0 1.37-.07 3.88-.07 5.73v5.64a11.9 11.9 0 0 1-.16 2 5.55 5.55 0 0 1-2.78 1.36.76.76 0 0 0-.1.32c0 .08.02.23.08.26h.5c.52 0 1.74-.08 2.54-.08 1.16 0 1.69.08 2.77.08h1.6c.1-.03.12-.24.12-.34a.5.5 0 0 0-.08-.27A5.09 5.09 0 0 1 95 57.88a15.54 15.54 0 0 1-.35-3.33l-.02-3.78c0-2.09.02-4.97.05-5.9l.58.69 12.54 14.67a.37.37 0 0 0 .32.16c.13 0 .05 0 .15-.05a4.05 4.05 0 0 0 .14-1.2c0-.76-.03-1.55-.03-1.95V45.96c0-3.3 1.56-4.24 3.39-4.31a.6.6 0 0 0 .1-.35m-24.5.13a.55.55 0 0 0-.12-.34h-.77c-.82 0-1.93.06-2.88.06-1.06 0-2.25-.06-3.02-.06h-.95a.62.62 0 0 0-.1.34.93.93 0 0 0 .07.35c.11 0 2.04.02 2.38.5a6.51 6.51 0 0 1 1.03 1.96 17.27 17.27 0 0 1 .22 2.9c0 2.25 0 3.76-.03 4.55a14.24 14.24 0 0 1-.48 3.52c-.74 2.3-2.45 3.44-5.18 3.44a7.24 7.24 0 0 1-3.1-.66 4.45 4.45 0 0 1-2.56-3.33l-.14-7.94-.02-3.22c0-.61.77-1.17 1.03-1.48a12.54 12.54 0 0 1 2.04-.27.76.76 0 0 0 .13-.37.44.44 0 0 0-.18-.34l-1 .03c-.99.02-2.28.05-3.1.05-1.27 0-2.25-.03-3.04-.03h-1.11a.45.45 0 0 0-.14.37.42.42 0 0 0 .1.32c.85.1 1.4.19 1.78.26a2.23 2.23 0 0 1 .93 1.17c.02.34.07 1.19.07 2.85v6.35a16.25 16.25 0 0 0 .27 3.54 5.22 5.22 0 0 0 2.3 3.25 8.66 8.66 0 0 0 4.84 1.27 9.1 9.1 0 0 0 4.55-1.08 5.42 5.42 0 0 0 2.61-3.52 12.12 12.12 0 0 0 .42-3.14v-5.08c0-.95.06-2.14.06-2.62a5.33 5.33 0 0 1 .8-2.91 10.94 10.94 0 0 1 2.19-.37.65.65 0 0 0 .1-.32" data-v-48a7eb4f></path></g>', 2)
  ]), 8, O$);
}
const A$ = /* @__PURE__ */ x(I$, [["render", z$], ["__scopeId", "data-v-48a7eb4f"]]), P$ = {
  name: "LuxSearchBox",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  props: {
    /**
     * The html element name used for the container
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The name of the input, which will be part of
     * the URL after the search is submitted.
     */
    name: {
      type: String,
      default: "query"
    },
    /**
     * Whether the corners should be rounded (default)
     * or square.
     */
    corners: {
      type: String,
      default: "rounded",
      validator: (e) => ["rounded", "square"].includes(e)
    },
    modelValue: {
      type: String
    }
  },
  emits: ["update:modelValue"],
  components: {
    LuxInputButton: St,
    LuxInputText: q1
  }
};
function T$(e, t, a, n, s, r) {
  const i = A("lux-input-text"), l = A("lux-input-button");
  return f(), P(Q(a.type), {
    class: z({ "lux-search-box": !0, rounded: a.corners === "rounded" })
  }, {
    default: O(() => [
      ie(e.$slots, "default", {}, () => [
        D(i, {
          id: "searchbox",
          name: a.name,
          label: "Search",
          "hide-label": !0,
          size: "large",
          class: "default-input",
          value: a.modelValue,
          onInput: t[0] || (t[0] = (u) => e.$emit("update:modelValue", u.target.value))
        }, null, 8, ["name", "value"]),
        D(l, {
          type: "submit",
          variation: "icon",
          size: "medium",
          icon: "search",
          class: "default-button"
        })
      ], !0)
    ]),
    _: 3
  }, 8, ["class"]);
}
const E$ = /* @__PURE__ */ x(P$, [["render", T$], ["__scopeId", "data-v-e0be4757"]]), Y$ = {
  name: "LuxAlert",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  metaInfo: {
    title: "Global alert message to user.",
    htmlAttrs: {
      lang: "en"
    }
  },
  data: function() {
    return {
      alertMessage: "Something happened, but we're not sure what.",
      show: !0
    };
  },
  computed: {
    isSuccess() {
      return this.status === "success";
    },
    isInfo() {
      return this.status === "info";
    },
    isWarning() {
      return this.status === "warning";
    },
    isError() {
      return this.status === "error";
    },
    isFullScreen() {
      return this.type === "alert";
    }
  },
  props: {
    /**
     * The intent of the message. Valid options: `alert, indicator`. Alerts are full page and indicators are “inline”.
     */
    type: {
      type: String,
      default: "indicator",
      validator: (e) => e.match(/(alert|indicator)/)
    },
    /**
     * Severity of the message. Valid options: `info, warning, success, error`
     */
    status: {
      type: String,
      default: "info",
      validator: (e) => e.match(/(info|warning|success|error)/)
    },
    /**
     * Automatically hides the notification after 2 seconds.
     */
    autoclear: {
      type: Boolean,
      default: !1
    },
    /**
     * The number of seconds to wait before autoclearing the
     * notification.  This prop has no effect if autoclear
     * is not true.
     */
    autoclearSeconds: {
      type: Number,
      default: 2
    },
    /**
     * User can manually hide the notification.  This emits a dismissed
     * event that you can bind to if needed (for example, if you want to
     * record that the user hid the notification in a database or localStorage)
     */
    dismissible: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    hideAlert() {
      this.show = !1, this.$emit("dismissed");
    }
  },
  mounted() {
    this.autoclear && setTimeout(() => {
      this.show = !1;
    }, this.autoclearSeconds * 1e3);
  },
  emits: ["dismissed"]
};
function H$(e, t, a, n, s, r) {
  return f(), P(U1, { name: "fade" }, {
    default: O(() => [
      e.show ? (f(), p("div", {
        key: 0,
        class: z(["lux-alert", {
          "lux-alert-dismissible": a.dismissible,
          "lux-alert-success": r.isSuccess,
          "lux-alert-warning": r.isWarning,
          "lux-alert-error": r.isError,
          "lux-alert-info": r.isInfo,
          "lux-alert-fullscreen": r.isFullScreen
        }]),
        role: "alert"
      }, [
        o("span", null, [
          ie(e.$slots, "default", {}, () => [
            he(F(e.alertMessage), 1)
          ])
        ]),
        a.dismissible ? (f(), p("button", {
          key: 0,
          type: "button",
          class: "lux-close",
          "data-dismiss": "alert",
          "aria-label": "Close",
          onClick: t[0] || (t[0] = (i) => r.hideAlert())
        }, t[1] || (t[1] = [
          o("span", { "aria-hidden": "true" }, "×", -1)
        ]))) : E("", !0)
      ], 2)) : E("", !0)
    ]),
    _: 3
  });
}
const V$ = /* @__PURE__ */ x(Y$, [["render", H$]]), N$ = {
  name: "LuxBadge",
  status: "ready",
  release: "6.8.0",
  type: "Element",
  props: {
    /**
     * Sets the color for the badge.
     */
    color: {
      type: String,
      default: "green"
    }
  },
  // Calculates the class to apply correct colors
  computed: {
    badgeClass() {
      return `lux-badge lux-badge-${this.color}`;
    }
  }
};
function R$(e, t, a, n, s, r) {
  return f(), p("span", {
    class: z(r.badgeClass)
  }, [
    ie(e.$slots, "default")
  ], 2);
}
const F$ = /* @__PURE__ */ x(N$, [["render", R$]]), B$ = {
  name: "LuxDropdownMenu",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  emits: ["button-clicked", "menu-item-clicked"],
  data: function() {
    return {
      isVisible: !1
    };
  },
  props: {
    element: {
      type: String,
      default: "div"
    },
    /**
     * The menu items in the dropdown
     */
    buttonLabel: {
      type: String,
      default: "Dropdown"
    },
    /**
     * Whether the dropdown includes links or buttons as menu items
     * `links, buttons`
     */
    type: {
      type: String,
      default: "buttons",
      validator: (e) => e.match(/(links|buttons)/)
    },
    /**
     * An array of item (and sub-item) options for the DropdownMenu. Properties
     * for menuItems are described in the LuxMenuBar pattern.
     */
    menuItems: {
      type: Array,
      default() {
        return ["div"];
      }
    },
    /**
     * Alignment of menu items (not currently working)
     * `left, right`
     */
    align: {
      type: String,
      default: "left",
      validator: (e) => e.match(/(left|right)/)
    },
    /**
     * Sets the size of the dropdown menu area `small, medium, large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    }
  },
  methods: {
    hide: function(e) {
      this.isVisible = !1;
    },
    buttonClicked(e) {
      this.isVisible = !this.isVisible, this.$emit("button-clicked", e);
    },
    menuItemClicked(e) {
      this.isVisible = !1, this.$emit("menu-item-clicked", e);
    }
  },
  directives: {
    "click-outside": {
      beforeMount: function(e, t) {
        const a = t.modifiers.bubble, n = (s) => {
          (a || !e.contains(s.target) && e !== s.target) && t.value(s);
        };
        e.__vueClickOutside__ = n, document.addEventListener("click", n);
      },
      unmounted: function(e, t) {
        document.removeEventListener("click", e.__vueClickOutside__), e.__vueClickOutside__ = null;
      }
    }
  }
};
function W$(e, t, a, n, s, r) {
  const i = A("lux-input-button"), l = A("lux-menu-bar"), u = j1("click-outside");
  return k0((f(), P(Q(a.element), {
    class: z(["lux-dropdown-menu", a.size])
  }, {
    default: O(() => [
      D(i, {
        onButtonClicked: t[0] || (t[0] = (c) => r.buttonClicked(c)),
        class: "lux-dropdown-button",
        variation: "dropdown",
        size: a.size
      }, {
        default: O(() => [
          he(F(a.buttonLabel), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      D(l, {
        class: z({ "lux-show": e.isVisible }),
        onMenuItemClicked: t[1] || (t[1] = (c) => r.menuItemClicked(c)),
        type: a.type,
        active: "All",
        "menu-items": a.menuItems
      }, null, 8, ["class", "type", "menu-items"])
    ]),
    _: 1
  }, 8, ["class"])), [
    [u, r.hide]
  ]);
}
const j$ = /* @__PURE__ */ x(B$, [["render", W$], ["__scopeId", "data-v-c9da56f4"]]), U$ = { class: "lux-show-more" }, q$ = ["id"], Z$ = {
  key: 0,
  class: "lux-show-more-content"
}, G$ = /* @__PURE__ */ Object.assign({ name: "LuxShowMore" }, {
  __name: "LuxShowMore",
  props: {
    /**
     * A description of the action of showing the full content.
     */
    showLabel: {
      type: String,
      required: !0
    },
    /**
     * A description of the action of hiding the full content.
     */
    hideLabel: {
      type: String,
      required: !0
    },
    /**
     * Used for setting focus and aria-controls.  It must be unique in your page.
     */
    contentId: {
      type: String,
      required: !0
    },
    /**
     * The ID of an element in the DOM that provides further description of the full content.
     *
     * Use this prop if you have multiple disclosures in your page with the same `showLabel` or `hideLabel`.
     */
    descriptionId: {
      type: String
    },
    /**
     * How many characters to allow
     */
    characterLimit: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    t2();
    const t = e, a = se(!1), n = Qn("contentContainer");
    function s(c, d) {
      if (!d || d >= c.length)
        return c.length;
      const v = c.lastIndexOf(" ", d);
      return v < 1 ? c.length : v;
    }
    const r = _(() => {
      var c;
      return ((c = n.value) == null ? void 0 : c.textContent) || "";
    }), i = _(() => s(r.value, t.characterLimit) < r.value.length), l = _(() => i.value ? r.value.slice(0, s(r.value, t.characterLimit)) + "…" : r.value);
    function u() {
      a.value = !a.value, a.value === !0 && n.value !== null && setTimeout(() => {
        n.value.focus({ preventScroll: !0 });
      }, 350);
    }
    return (c, d) => (f(), p("div", U$, [
      k0(o("div", {
        id: e.contentId,
        ref_key: "contentContainer",
        ref: n,
        class: "lux-show-more-content",
        tabindex: "-1"
      }, [
        ie(c.$slots, "default")
      ], 8, q$), [
        [Jn, a.value]
      ]),
      a.value ? E("", !0) : (f(), p("div", Z$, F(l.value), 1)),
      i.value ? (f(), P(St, {
        key: 1,
        type: "button",
        variation: "text",
        onClick: d[0] || (d[0] = (v) => u()),
        "aria-expanded": a.value.toString(),
        "aria-controls": e.contentId,
        "aria-describedby": e.descriptionId
      }, {
        default: O(() => [
          he(F(a.value ? e.hideLabel : e.showLabel), 1)
        ]),
        _: 1
      }, 8, ["aria-expanded", "aria-controls", "aria-describedby"])) : E("", !0)
    ]));
  }
}), K$ = {
  name: "LuxTag",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The type of tag. The `filter` option includes
     * a remove icon inside the tag.
     */
    type: {
      type: String,
      default: "tag",
      validator: (e) => e.match(/(tag|filter)/)
    },
    /**
     * Tag items are tags to be displayed to the user.
     * You can pass a `name` and `href` in a tag-items array.
     */
    tagItems: {
      required: !0,
      type: Array
    },
    /**
     * Sets the horizontal alignment of the item. `start`, `center`, or `end`.
     */
    horizontal: {
      type: String,
      validator: (e) => e.match(/(start|center|end)/)
    },
    /**
     * Sets the size of the item.
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * Sets the label of the list.
     */
    label: {
      type: String,
      default: ""
    }
  },
  methods: {
    isPill(e) {
      return e === "pill";
    },
    componentType(e) {
      return e.hasOwnProperty("href") ? "a" : "span";
    }
  }
}, X$ = ["aria-label"], J$ = {
  key: 0,
  class: "prepend-icon"
}, Q$ = ["innerHTML"], ew = {
  key: 1,
  class: "append-icon"
};
function tw(e, t, a, n, s, r) {
  const i = A("lux-icon-alert"), l = A("lux-icon-approved"), u = A("lux-icon-denied"), c = A("lux-icon-clock"), d = A("lux-icon-refresh"), v = A("lux-icon-reported"), y = A("lux-icon-base");
  return f(), p("ul", {
    class: z(["lux-tag", [a.type, a.horizontal]]),
    "aria-label": a.label
  }, [
    (f(!0), p(X, null, oe(a.tagItems, (m, g) => (f(), p("li", { key: m }, [
      (f(), P(Q(r.componentType(m)), {
        key: g,
        href: m.href,
        class: z(["lux-tag-item", a.size, m.color, { pill: r.isPill(m.style) }])
      }, {
        default: O(() => [
          m.icon ? (f(), p("span", J$, [
            D(y, {
              width: "14",
              height: "14"
            }, {
              default: O(() => [
                m.icon === "alert" ? (f(), P(i, { key: 0 })) : E("", !0),
                m.icon === "approved" ? (f(), P(l, { key: 1 })) : E("", !0),
                m.icon === "denied" ? (f(), P(u, { key: 2 })) : E("", !0),
                m.icon === "clock" ? (f(), P(c, { key: 3 })) : E("", !0),
                m.icon === "refresh" ? (f(), P(d, { key: 4 })) : E("", !0),
                m.icon === "reported" ? (f(), P(v, { key: 5 })) : E("", !0)
              ]),
              _: 2
            }, 1024)
          ])) : E("", !0),
          o("span", {
            innerHTML: m.name
          }, null, 8, Q$),
          a.type === "filter" ? (f(), p("span", ew, [
            D(y, {
              width: "14",
              height: "14"
            }, {
              default: O(() => [
                D(u)
              ]),
              _: 1
            })
          ])) : E("", !0)
        ]),
        _: 2
      }, 1032, ["href", "class"]))
    ]))), 128))
  ], 10, X$);
}
const aw = /* @__PURE__ */ x(K$, [["render", tw]]), k1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LuxAlert: V$,
  LuxAutocompleteInput: ir,
  LuxBadge: F$,
  LuxBanner: Ku,
  LuxCard: ec,
  LuxDataTable: uc,
  LuxDatePicker: e_,
  LuxDropdownMenu: j$,
  LuxGridContainer: n_,
  LuxGridItem: o_,
  LuxHeading: u_,
  LuxHyperlink: Z1,
  LuxIconAdd: r2,
  LuxIconAlert: tr,
  LuxIconApproved: ar,
  LuxIconArrowDown: d2,
  LuxIconArrowRight: p2,
  LuxIconArrowUp: g2,
  LuxIconAscending: $2,
  LuxIconBase: K0,
  LuxIconBookmark: A2,
  LuxIconClock: E2,
  LuxIconClose: N2,
  LuxIconConsulting: B2,
  LuxIconDelivery: U2,
  LuxIconDenied: nr,
  LuxIconDerivativesHealthy: X2,
  LuxIconDerivativesUnhealthy: eo,
  LuxIconDescending: no,
  LuxIconEdit: oo,
  LuxIconExclamation: uo,
  LuxIconFile: rr,
  LuxIconFileHealthy: po,
  LuxIconFileUnhealthy: go,
  LuxIconFilter: $o,
  LuxIconFlower: xo,
  LuxIconGlobe: Do,
  LuxIconHospital: Io,
  LuxIconInfo: Po,
  LuxIconLockClose: Yo,
  LuxIconLockOpen: No,
  LuxIconNewTab: sr,
  LuxIconNote: jo,
  LuxIconPerson: Zo,
  LuxIconPicture: Xo,
  LuxIconQuestion: ei,
  LuxIconQuestionFilled: ni,
  LuxIconRefresh: oi,
  LuxIconRelax: ui,
  LuxIconReportHealthy: fi,
  LuxIconReportRemove: pi,
  LuxIconReportUnhealthy: gi,
  LuxIconReportUserHome: $i,
  LuxIconReported: xi,
  LuxIconResearch: Di,
  LuxIconScales: Ii,
  LuxIconSearch: or,
  LuxIconUnsorted: Ei,
  LuxIconVacation: Vi,
  LuxIconView: Fi,
  LuxInputButton: St,
  LuxInputCheckbox: tl,
  LuxInputMultiselect: wl,
  LuxInputRadio: Il,
  LuxInputSelect: Yl,
  LuxInputText: q1,
  LuxLibraryFooter: t$,
  LuxLibraryHeader: L_,
  LuxLibraryLogo: La,
  LuxLoader: h_,
  LuxLogoFacebook: G1,
  LuxLogoFriends: J1,
  LuxLogoGovDocs: X1,
  LuxLogoInstagram: Zs,
  LuxLogoLibrary: Us,
  LuxLogoLibraryIcon: L$,
  LuxLogoUniversity: A$,
  LuxLogoUniversityWhite: Gs,
  LuxLogoX: K1,
  LuxMediaImage: u$,
  LuxMenuBar: w$,
  LuxSearchBox: E$,
  LuxShowMore: G$,
  LuxSpacer: qs,
  LuxSpecialCollectionsFooter: s$,
  LuxTag: aw,
  LuxTextStyle: M$,
  LuxUniversityFooter: Ks,
  LuxWrapper: h1,
  _LuxCardContent: Zl,
  _LuxCardHeader: Xl,
  _LuxCardMedia: eu,
  _LuxHamburger: lr,
  _LuxLibraryContactInfo: fr,
  _LuxLibraryContactInfoOld: hr,
  _LuxMenuBarLabel: ur,
  _LuxSubscribeNewsletter: cr,
  _LuxUniversityAccessibility: vu,
  _LuxUniversityAccessibilityOld: dr,
  _LuxUniversityCopyright: Q1,
  _LuxUniversityCopyrightOld: Fu,
  _LuxUniversityPrivacyNotice: vr
}, Symbol.toStringTag, { value: "Module" })), ow = {
  // Vue plugins must expose an install() method, see
  // https://vuejs.org/guide/reusability/plugins.html
  install(e, t) {
    nw(e), rw(e);
  }
};
function nw(e) {
  e.use(Qb, {});
}
function rw(e) {
  for (const t in k1)
    e.component(k1[t].name, k1[t]);
}
export {
  V$ as LuxAlert,
  ir as LuxAutocompleteInput,
  F$ as LuxBadge,
  Ku as LuxBanner,
  ec as LuxCard,
  uc as LuxDataTable,
  e_ as LuxDatePicker,
  j$ as LuxDropdownMenu,
  n_ as LuxGridContainer,
  o_ as LuxGridItem,
  u_ as LuxHeading,
  Z1 as LuxHyperlink,
  r2 as LuxIconAdd,
  tr as LuxIconAlert,
  ar as LuxIconApproved,
  d2 as LuxIconArrowDown,
  p2 as LuxIconArrowRight,
  g2 as LuxIconArrowUp,
  $2 as LuxIconAscending,
  K0 as LuxIconBase,
  A2 as LuxIconBookmark,
  E2 as LuxIconClock,
  N2 as LuxIconClose,
  B2 as LuxIconConsulting,
  U2 as LuxIconDelivery,
  nr as LuxIconDenied,
  X2 as LuxIconDerivativesHealthy,
  eo as LuxIconDerivativesUnhealthy,
  no as LuxIconDescending,
  oo as LuxIconEdit,
  uo as LuxIconExclamation,
  rr as LuxIconFile,
  po as LuxIconFileHealthy,
  go as LuxIconFileUnhealthy,
  $o as LuxIconFilter,
  xo as LuxIconFlower,
  Do as LuxIconGlobe,
  Io as LuxIconHospital,
  Po as LuxIconInfo,
  Yo as LuxIconLockClose,
  No as LuxIconLockOpen,
  sr as LuxIconNewTab,
  jo as LuxIconNote,
  Zo as LuxIconPerson,
  Xo as LuxIconPicture,
  ei as LuxIconQuestion,
  ni as LuxIconQuestionFilled,
  oi as LuxIconRefresh,
  ui as LuxIconRelax,
  fi as LuxIconReportHealthy,
  pi as LuxIconReportRemove,
  gi as LuxIconReportUnhealthy,
  $i as LuxIconReportUserHome,
  xi as LuxIconReported,
  Di as LuxIconResearch,
  Ii as LuxIconScales,
  or as LuxIconSearch,
  Ei as LuxIconUnsorted,
  Vi as LuxIconVacation,
  Fi as LuxIconView,
  St as LuxInputButton,
  tl as LuxInputCheckbox,
  wl as LuxInputMultiselect,
  Il as LuxInputRadio,
  Yl as LuxInputSelect,
  q1 as LuxInputText,
  t$ as LuxLibraryFooter,
  L_ as LuxLibraryHeader,
  La as LuxLibraryLogo,
  h_ as LuxLoader,
  G1 as LuxLogoFacebook,
  J1 as LuxLogoFriends,
  X1 as LuxLogoGovDocs,
  Zs as LuxLogoInstagram,
  Us as LuxLogoLibrary,
  L$ as LuxLogoLibraryIcon,
  A$ as LuxLogoUniversity,
  Gs as LuxLogoUniversityWhite,
  K1 as LuxLogoX,
  u$ as LuxMediaImage,
  w$ as LuxMenuBar,
  E$ as LuxSearchBox,
  G$ as LuxShowMore,
  qs as LuxSpacer,
  s$ as LuxSpecialCollectionsFooter,
  aw as LuxTag,
  M$ as LuxTextStyle,
  Ks as LuxUniversityFooter,
  h1 as LuxWrapper,
  Zl as _LuxCardContent,
  Xl as _LuxCardHeader,
  eu as _LuxCardMedia,
  lr as _LuxHamburger,
  fr as _LuxLibraryContactInfo,
  hr as _LuxLibraryContactInfoOld,
  ur as _LuxMenuBarLabel,
  cr as _LuxSubscribeNewsletter,
  vu as _LuxUniversityAccessibility,
  dr as _LuxUniversityAccessibilityOld,
  Q1 as _LuxUniversityCopyright,
  Fu as _LuxUniversityCopyrightOld,
  vr as _LuxUniversityPrivacyNotice,
  ow as default
};
